interface Props {
  className?: string
  width?: number
  height?: number
  color?: string
}
export const IconDiscount = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={27}
      height={20}
      viewBox='0 0 29 22'
      fill='none'
    >
      <path
        d='M26.1934 21.6816H2.70968C1.21549 21.6816 0 20.5041 0 19.0566V14.6816C0 14.198 0.403969 13.8066 0.903228 13.8066C2.39742 13.8066 3.61291 12.6291 3.61291 11.1816C3.61291 9.73411 2.39742 8.5566 0.903228 8.5566C0.403969 8.55666 0 8.16532 0 7.68166V3.30665C0 1.85915 1.21549 0.681641 2.70968 0.681641H26.1935C27.6877 0.681641 28.9032 1.85915 28.9032 3.30665V7.68166C28.9032 8.16532 28.4992 8.55666 28 8.55666C26.5058 8.55666 25.2903 9.73417 25.2903 11.1817C25.2903 12.6292 26.5058 13.8067 28 13.8067C28.4992 13.8067 28.9032 14.198 28.9032 14.6817V19.0567C28.9031 20.5041 27.6877 21.6816 26.1934 21.6816ZM1.80646 15.4686V19.0566C1.80646 19.5394 2.21134 19.9316 2.70968 19.9316H26.1935C26.6918 19.9316 27.0967 19.5394 27.0967 19.0566V15.4686C25.038 15.0619 23.4838 13.2948 23.4838 11.1816C23.4838 9.06842 25.038 7.30139 27.0967 6.89461V3.30665C27.0967 2.82387 26.6918 2.43165 26.1935 2.43165H2.70968C2.21134 2.43165 1.80646 2.82387 1.80646 3.30665V6.89467C3.86516 7.30139 5.41937 9.06848 5.41937 11.1817C5.41937 13.2949 3.86516 15.0619 1.80646 15.4686Z'
        fill='black'
      />
      <path
        d='M10.897 17.8633L16.3144 3.86828L18.0058 4.48274L12.5884 18.4777L10.897 17.8633Z'
        fill='black'
      />
      <path
        d='M10.1784 11.4766C8.68424 11.4766 7.46875 10.2991 7.46875 8.85157C7.46875 7.40407 8.68424 6.22656 10.1784 6.22656C11.6726 6.22656 12.8881 7.40407 12.8881 8.85157C12.8881 10.2991 11.6726 11.4766 10.1784 11.4766ZM10.1784 7.97657C9.68009 7.97657 9.27521 8.3688 9.27521 8.85157C9.27521 9.33434 9.68009 9.72657 10.1784 9.72657C10.6768 9.72657 11.0817 9.33434 11.0817 8.85157C11.0817 8.3688 10.6768 7.97657 10.1784 7.97657Z'
        fill='black'
      />
      <path
        d='M19.5154 16.9024C18.0212 16.9024 16.8057 15.7248 16.8057 14.2774C16.8057 12.8299 18.0212 11.6523 19.5154 11.6523C21.0095 11.6523 22.225 12.8299 22.225 14.2774C22.225 15.7248 21.0095 16.9024 19.5154 16.9024ZM19.5154 13.4023C19.017 13.4023 18.6121 13.7946 18.6121 14.2774C18.6121 14.7601 19.017 15.1524 19.5154 15.1524C20.0137 15.1524 20.4186 14.7601 20.4186 14.2774C20.4186 13.7946 20.0137 13.4023 19.5154 13.4023Z'
        fill='black'
      />
    </svg>
  )
}
export const BookMark = () => {
  return (
    <svg
      width={24}
      height={33}
      viewBox='0 0 24 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.5 15H16.5M7.5 21H16.5M7.5 9H16.5M1.5 3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H21C21.3978 1.5 21.7794 1.65804 22.0607 1.93934C22.342 2.22064 22.5 2.60218 22.5 3V31.5L17.25 27.75L12 31.5L6.75 27.75L1.5 31.5V3Z'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const LogoIonahFull = ({ className }: Props) => {
  return (
    <svg
      className={className}
      width={94}
      height={27}
      viewBox='0 0 94 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.11636 26.6814C1.43261 26.6814 0.0712891 25.3366 0.0712891 23.6892V10.8476C0.0712891 9.19313 1.43978 7.85547 3.11636 7.85547C4.79294 7.85547 6.16143 9.20017 6.16143 10.8476V23.6892C6.16143 25.3437 4.8001 26.6814 3.11636 26.6814Z'
        fill='black'
      />
      <path
        d='M89.9539 26.6814C88.2702 26.6814 86.9088 25.3367 86.9088 23.6893V17.0995C86.9088 16.0857 86.5577 15.1634 85.9129 14.4875C85.1463 13.6849 84.2435 13.2907 83.1401 13.2907C82.0439 13.2907 81.1339 13.6779 80.3673 14.4875C79.7225 15.1634 79.3714 16.0857 79.3714 17.0995V23.6893C79.3714 25.3437 78.0029 26.6814 76.3263 26.6814C74.6426 26.6814 73.2812 25.3367 73.2812 23.6893V5.44771C73.2812 3.79323 74.6497 2.45557 76.3263 2.45557C78.0101 2.45557 79.3714 3.80027 79.3714 5.44771V8.0104C80.5321 7.54574 81.7931 7.30637 83.1401 7.30637C85.8556 7.30637 88.2057 8.25681 90.1187 10.1436C92.0317 12.0234 93.0061 14.3326 93.0061 17.0009V23.6963C92.999 25.3437 91.6305 26.6814 89.9539 26.6814Z'
        fill='#231F20'
      />
      <path
        d='M61.3387 26.5195C58.6232 26.5195 56.2731 25.569 54.3601 23.6822C52.4471 21.8025 51.4727 19.4932 51.4727 16.8249C51.4727 14.1566 52.4399 11.8474 54.3601 9.96763C56.2731 8.08786 58.6232 7.13037 61.3387 7.13037C64.0542 7.13037 66.4043 8.08082 68.3173 9.96763C70.2303 11.8474 71.2047 14.1566 71.2047 16.8249V23.8442C71.2047 24.3792 70.9396 25.1607 70.4237 25.6183C69.8434 26.1393 69.0338 26.428 68.1525 26.428C67.2425 26.428 66.4186 26.1252 65.8955 25.5972C65.8669 25.569 65.8382 25.5338 65.8024 25.4986C64.4554 26.1745 62.9579 26.5195 61.3387 26.5195ZM61.3387 13.1287C60.2066 13.1287 59.2752 13.5441 58.4942 14.396C57.9497 14.9944 57.6201 15.7689 57.5771 16.5644C57.5055 17.7965 57.9282 18.7962 58.8668 19.6199C59.4758 20.155 60.2568 20.4789 61.0736 20.5211C61.1596 20.5282 61.2527 20.5282 61.3387 20.5282C62.4707 20.5282 63.4022 20.1128 64.1831 19.2538C64.7277 18.6554 65.0573 17.888 65.1002 17.0854C65.1719 15.8534 64.7492 14.8536 63.8106 14.0299C63.2016 13.4948 62.4206 13.178 61.6038 13.1287C61.5178 13.1287 61.4247 13.1287 61.3387 13.1287Z'
        fill='#231F20'
      />
      <path
        d='M46.5364 26.625C44.7165 26.625 43.2334 25.1677 43.2334 23.3794V16.9164C43.2334 16.0716 42.9611 15.283 42.4667 14.6916C41.6571 13.713 40.6684 13.2343 39.4647 13.2343C39.3429 13.2343 39.2139 13.2413 39.0849 13.2484C38.3398 13.3047 37.609 13.6074 37.0358 14.1003C36.133 14.8747 35.6959 15.804 35.6959 16.9375V23.5766C35.6959 25.2592 34.2988 26.6321 32.5864 26.6321C30.9385 26.6321 29.5986 25.3155 29.5986 23.6962V16.9446C29.5986 14.2763 30.5659 11.967 32.4789 10.0873C34.3919 8.20749 36.742 7.25 39.4575 7.25C42.173 7.25 44.5231 8.20045 46.4361 10.0873C48.3491 11.967 49.3164 14.2763 49.3164 16.9446V23.8934C49.3235 25.393 48.0768 26.625 46.5364 26.625Z'
        fill='#231F20'
      />
      <path
        d='M25.7079 10.1366C23.7949 8.25682 21.4448 7.29933 18.7293 7.29933C17.497 7.29933 16.3506 7.49646 15.2759 7.89072C13.9504 8.3765 12.5031 8.42579 11.1847 7.9048L7.07208 6.27144C6.69951 6.14471 6.52039 6.36296 6.721 6.7009L8.64835 10.038C9.38633 11.3194 9.6586 12.8471 9.24304 14.2622C8.99227 15.1282 8.8633 16.0364 8.8633 17.0009C8.8633 19.6692 9.83056 21.9784 11.7507 23.8582C13.6638 25.738 16.0138 26.6955 18.7293 26.6955C21.4448 26.6955 23.7949 25.745 25.7079 23.8582C27.6209 21.9784 28.5953 19.6692 28.5953 17.0009C28.5882 14.3256 27.6209 12.0164 25.7079 10.1366ZM21.3947 19.6129C20.6495 20.3451 19.7826 20.6971 18.7293 20.6971C17.6833 20.6971 16.8091 20.3451 16.064 19.6129C15.3188 18.8807 14.9606 18.0288 14.9606 16.9939C14.9606 15.966 15.3188 15.1071 16.064 14.3749C16.8091 13.6427 17.6761 13.2907 18.7293 13.2907C19.7754 13.2907 20.6495 13.6427 21.3947 14.3749C22.1398 15.1071 22.498 15.959 22.498 16.9939C22.498 18.0218 22.1326 18.8807 21.3947 19.6129Z'
        fill='url(#paint0_radial_8_2547)'
      />
      <path
        d='M3.28867 0.681396C2.37157 0.681396 1.59777 0.998212 0.960092 1.6248C0.322419 2.25139 0 3.01175 0 3.91292C0 4.80704 0.322419 5.57444 0.960092 6.20103C1.59777 6.82762 2.37157 7.14444 3.28867 7.14444C4.19861 7.14444 4.97958 6.82762 5.61726 6.20103C6.25493 5.57444 6.57735 4.81408 6.57735 3.91292C6.57735 3.01879 6.25493 2.25139 5.61726 1.6248C4.97242 0.998212 4.19861 0.681396 3.28867 0.681396Z'
        fill='url(#paint1_radial_8_2547)'
      />
      <path
        d='M25.7079 10.1366C23.7949 8.25682 21.4448 7.29933 18.7293 7.29933C17.497 7.29933 16.3506 7.49646 15.2759 7.89072C13.9504 8.3765 12.5031 8.42579 11.1847 7.9048L7.07208 6.27144C6.69951 6.14471 6.52039 6.36296 6.721 6.7009L8.64835 10.038C9.38633 11.3194 9.6586 12.8471 9.24304 14.2622C8.99227 15.1282 8.8633 16.0364 8.8633 17.0009C8.8633 19.6692 9.83056 21.9784 11.7507 23.8582C13.6638 25.738 16.0138 26.6955 18.7293 26.6955C21.4448 26.6955 23.7949 25.745 25.7079 23.8582C27.6209 21.9784 28.5953 19.6692 28.5953 17.0009C28.5882 14.3256 27.6209 12.0164 25.7079 10.1366ZM21.3947 19.6129C20.6495 20.3451 19.7826 20.6971 18.7293 20.6971C17.6833 20.6971 16.8091 20.3451 16.064 19.6129C15.3188 18.8807 14.9606 18.0288 14.9606 16.9939C14.9606 15.966 15.3188 15.1071 16.064 14.3749C16.8091 13.6427 17.6761 13.2907 18.7293 13.2907C19.7754 13.2907 20.6495 13.6427 21.3947 14.3749C22.1398 15.1071 22.498 15.959 22.498 16.9939C22.498 18.0218 22.1326 18.8807 21.3947 19.6129Z'
        fill='url(#paint2_radial_8_2547)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_8_2547'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(2.68131 2.71057) scale(36.6228 35.9863)'
        >
          <stop stopColor='#004C93' />
          <stop offset='0.068' stopColor='#008398' />
          <stop offset='0.1316' stopColor='#00AF9C' />
          <stop offset='0.1882' stopColor='#00CF9F' />
          <stop offset='0.2359' stopColor='#00E2A0' />
          <stop offset='0.2688' stopColor='#00E9A1' />
          <stop offset='0.6341' stopColor='#00AE89' />
          <stop offset={1} stopColor='#1E248F' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_8_2547'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(2.79631 2.58173) scale(26.4874 26.027)'
        >
          <stop stopColor='#4FFFA1' />
          <stop offset='0.0428' stopColor='#3DE49C' />
          <stop offset='0.1168' stopColor='#23BC94' />
          <stop offset='0.1843' stopColor='#109E8E' />
          <stop offset='0.2424' stopColor='#048C8A' />
          <stop offset='0.2844' stopColor='#008689' />
          <stop offset='0.3542' stopColor='#00778C' />
          <stop offset='0.4891' stopColor='#005F90' />
          <stop offset='0.6149' stopColor='#005192' />
          <stop offset='0.7218' stopColor='#004C93' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_8_2547'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(2.68131 2.71057) scale(36.6228 35.9863)'
        >
          <stop stopColor='#00E9A1' />
          <stop offset='0.3946' stopColor='#00AEA3' />
          <stop offset='0.4002' stopColor='#00ADA4' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8252' stopColor='#0749EF' />
          <stop offset='0.9391' stopColor='#182ECB' />
          <stop offset={1} stopColor='#1E24BD' />
        </radialGradient>
      </defs>
    </svg>
  )
}
export const Polygon = ({ className }: Props) => {
  return (
    <svg
      width='9'
      className={className}
      height='7'
      viewBox='0 0 9 7'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M4.5 7L8.39711 0.25H0.602886L4.5 7Z' fill='#5B4194' />
    </svg>
  )
}

export const Bep = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1_10101)'>
        <path
          d='M23 8H19'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M16 23H4C2.343 23 1 21.657 1 20V8H19V20C19 21.657 17.657 23 16 23Z'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M1 13H19'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M10 4V1'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M5 4V1'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M15 4V1'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
      </g>
      <defs>
        <clipPath id='clip0_1_10101'>
          <rect width={24} height={24} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const RuaBat = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23 2H1V23H23V2Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 20C9.65685 20 11 18.6569 11 17C11 15.3431 9.65685 14 8 14C6.34315 14 5 15.3431 5 17C5 18.6569 6.34315 20 8 20Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 6H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 10H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 15H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 19H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const LogoIonah = () => {
  return (
    <svg
      width={127}
      height={36}
      viewBox='0 0 127 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.25505 36.4934C1.96394 36.4934 0.0957031 34.6311 0.0957031 32.3473V14.5675C0.0957031 12.2837 1.96394 10.4214 4.25505 10.4214C6.54616 10.4214 8.41439 12.2837 8.41439 14.5675V32.3473C8.41439 34.6311 6.54616 36.4934 4.25505 36.4934Z'
        fill='black'
      />
      <path
        d='M122.744 36.4935C120.452 36.4935 118.584 34.6312 118.584 32.3474V23.2248C118.584 21.828 118.105 20.5383 117.227 19.6072C116.186 18.4936 114.949 17.9525 113.447 17.9525C111.944 17.9525 110.707 18.4936 109.666 19.6072C108.789 20.5383 108.309 21.8218 108.309 23.2248V32.3474C108.309 34.6312 106.441 36.4935 104.15 36.4935C101.858 36.4935 99.9902 34.6312 99.9902 32.3474V7.09336C99.9902 4.80955 101.858 2.94727 104.15 2.94727C106.441 2.94727 108.309 4.80955 108.309 7.09336V10.6355C109.893 9.99374 111.61 9.66658 113.447 9.66658C117.151 9.66658 120.351 10.9878 122.964 13.5862C125.577 16.1909 126.897 19.3807 126.897 23.0738V32.3411C126.903 34.6312 125.035 36.4935 122.744 36.4935Z'
        fill='black'
      />
      <path
        d='M83.698 36.2607C79.9931 36.2607 76.7869 34.9394 74.1802 32.3411C71.5672 29.7364 70.248 26.5466 70.248 22.8535C70.248 19.1604 71.5735 15.9643 74.1865 13.3659C76.7995 10.7612 79.9995 9.44629 83.7044 9.44629C87.4093 9.44629 90.6156 10.7675 93.2222 13.3722C95.8352 15.9769 97.1607 19.1667 97.1607 22.8598V32.5738C97.1607 33.3099 96.7946 34.3921 96.094 35.0275C95.2988 35.751 94.1942 36.1537 92.9887 36.1537C91.7516 36.1537 90.6282 35.7322 89.9023 35.0086C89.8582 34.9646 89.8203 34.9206 89.7761 34.8765C87.9458 35.7888 85.9071 36.2607 83.698 36.2607ZM83.698 17.7259C82.1517 17.7259 80.8831 18.2984 79.8227 19.4875C79.078 20.318 78.6298 21.3813 78.573 22.4949C78.4784 24.1999 79.0527 25.584 80.3277 26.7227C81.1608 27.4651 82.2274 27.9055 83.3383 27.9685C83.4582 27.9748 83.5781 27.981 83.698 27.981C85.2444 27.981 86.513 27.4085 87.5797 26.2194C88.3244 25.3889 88.7663 24.3257 88.8294 23.2184C88.9241 21.5134 88.3497 20.1293 87.0748 18.9905C86.2416 18.2481 85.175 17.8077 84.0641 17.7448C83.9316 17.7322 83.8117 17.7259 83.698 17.7259Z'
        fill='black'
      />
      <path
        d='M63.4954 36.4056C61.0086 36.4056 58.9826 34.386 58.9826 31.9072V22.967C58.9826 21.7968 58.6102 20.702 57.9412 19.8841C56.8304 18.5315 55.4923 17.8709 53.845 17.8709C53.6746 17.8709 53.5042 17.8772 53.3274 17.8897C52.3049 17.9652 51.314 18.3868 50.5377 19.0662C49.3069 20.1421 48.7073 21.4256 48.7073 22.9921V32.1777C48.7073 34.5056 46.8076 36.4056 44.466 36.4056C42.219 36.4056 40.3887 34.5811 40.3887 32.3413V22.9984C40.3887 19.3053 41.7141 16.1092 44.3208 13.5109C46.9338 10.9062 50.1338 9.58496 53.8387 9.58496C57.5436 9.58496 60.7499 10.9062 63.3565 13.5046C65.9695 16.1092 67.2887 19.299 67.2887 22.9921V32.6118C67.3013 34.7069 65.5972 36.4056 63.4954 36.4056Z'
        fill='black'
      />
      <path
        d='M35.0736 13.5926C32.4606 10.9879 29.2606 9.67297 25.5557 9.67297C23.8768 9.67297 22.3053 9.9498 20.841 10.4909C19.0295 11.1578 17.054 11.2333 15.2615 10.5097L9.65052 8.2448C9.13928 8.06864 8.89313 8.36434 9.16453 8.8362L11.7965 13.4542C12.8063 15.2284 13.1724 17.336 12.6107 19.299C12.2698 20.4943 12.0994 21.7589 12.0994 23.0864C12.0994 26.7796 13.4249 29.9756 16.0315 32.574C18.6445 35.1787 21.8445 36.4999 25.5494 36.4999C29.2543 36.4999 32.4606 35.1787 35.0673 32.5803C37.6803 29.9756 39.0057 26.7858 39.0057 23.0927C39.012 19.387 37.6866 16.191 35.0736 13.5926ZM29.1912 26.7041C28.175 27.7107 26.9885 28.2014 25.5557 28.2014C24.123 28.2014 22.9364 27.7107 21.9203 26.7041C20.9041 25.6911 20.4118 24.5083 20.4118 23.0802C20.4118 21.652 20.9041 20.4692 21.9203 19.4562C22.9364 18.4496 24.123 17.9589 25.5557 17.9589C26.9885 17.9589 28.175 18.4496 29.1912 19.4625C30.2011 20.4692 30.6934 21.6583 30.6934 23.0864C30.6934 24.5083 30.2011 25.6911 29.1912 26.7041Z'
        fill='url(#paint0_radial_12683_44538)'
      />
      <path
        d='M4.48123 0.5C3.23785 0.5 2.1775 0.934113 1.3065 1.80234C0.4355 2.67057 0 3.72754 0 4.96696C0 6.20639 0.4355 7.26336 1.3065 8.13159C2.1775 8.99981 3.23785 9.43392 4.48123 9.43392C5.72462 9.43392 6.78497 8.99981 7.65597 8.13159C8.52697 7.26336 8.96247 6.20639 8.96247 4.96696C8.96247 3.72754 8.52697 2.67057 7.65597 1.80234C6.79128 0.934113 5.73093 0.5 4.48123 0.5Z'
        fill='url(#paint1_radial_12683_44538)'
      />
      <path
        d='M4.25505 36.4934C1.96394 36.4934 0.0957031 34.6311 0.0957031 32.3473V14.5675C0.0957031 12.2837 1.96394 10.4214 4.25505 10.4214C6.54616 10.4214 8.41439 12.2837 8.41439 14.5675V32.3473C8.41439 34.6311 6.54616 36.4934 4.25505 36.4934Z'
        fill='white'
      />
      <path
        d='M122.744 36.4935C120.452 36.4935 118.584 34.6312 118.584 32.3474V23.2248C118.584 21.8281 118.105 20.5383 117.227 19.6072C116.186 18.4936 114.949 17.9525 113.447 17.9525C111.944 17.9525 110.707 18.4936 109.666 19.6072C108.789 20.5383 108.309 21.8218 108.309 23.2248V32.3474C108.309 34.6312 106.441 36.4935 104.15 36.4935C101.858 36.4935 99.9902 34.6312 99.9902 32.3474V7.09336C99.9902 4.80955 101.858 2.94727 104.15 2.94727C106.441 2.94727 108.309 4.80955 108.309 7.09336V10.6355C109.893 9.99374 111.61 9.66658 113.447 9.66658C117.151 9.66658 120.351 10.9878 122.964 13.5862C125.577 16.1909 126.897 19.3807 126.897 23.0738V32.3411C126.903 34.6312 125.035 36.4935 122.744 36.4935Z'
        fill='white'
      />
      <path
        d='M83.698 36.2607C79.9931 36.2607 76.7869 34.9394 74.1802 32.3411C71.5672 29.7364 70.248 26.5466 70.248 22.8535C70.248 19.1604 71.5735 15.9643 74.1865 13.3659C76.7995 10.7612 79.9995 9.44629 83.7044 9.44629C87.4093 9.44629 90.6156 10.7675 93.2222 13.3722C95.8352 15.9769 97.1607 19.1667 97.1607 22.8598V32.5738C97.1607 33.3099 96.7946 34.3921 96.094 35.0275C95.2988 35.751 94.1942 36.1537 92.9887 36.1537C91.7516 36.1537 90.6282 35.7322 89.9023 35.0086C89.8582 34.9646 89.8203 34.9206 89.7761 34.8765C87.9458 35.7888 85.9071 36.2607 83.698 36.2607ZM83.698 17.7259C82.1517 17.7259 80.8831 18.2984 79.8227 19.4875C79.078 20.318 78.6298 21.3813 78.573 22.4949C78.4784 24.1999 79.0527 25.584 80.3277 26.7227C81.1608 27.4651 82.2274 27.9055 83.3383 27.9685C83.4582 27.9748 83.5781 27.981 83.698 27.981C85.2444 27.981 86.513 27.4085 87.5797 26.2194C88.3244 25.3889 88.7663 24.3257 88.8294 23.2184C88.9241 21.5134 88.3497 20.1293 87.0748 18.9905C86.2416 18.2481 85.175 17.8077 84.0641 17.7448C83.9316 17.7322 83.8117 17.7259 83.698 17.7259Z'
        fill='white'
      />
      <path
        d='M63.4954 36.4056C61.0086 36.4056 58.9826 34.386 58.9826 31.9072V22.967C58.9826 21.7968 58.6102 20.702 57.9412 19.8841C56.8304 18.5315 55.4923 17.8709 53.845 17.8709C53.6746 17.8709 53.5042 17.8772 53.3274 17.8897C52.3049 17.9652 51.314 18.3868 50.5377 19.0662C49.3069 20.1421 48.7073 21.4256 48.7073 22.9921V32.1777C48.7073 34.5056 46.8076 36.4056 44.466 36.4056C42.219 36.4056 40.3887 34.5811 40.3887 32.3413V22.9984C40.3887 19.3053 41.7141 16.1092 44.3208 13.5109C46.9338 10.9062 50.1338 9.58496 53.8387 9.58496C57.5436 9.58496 60.7499 10.9062 63.3565 13.5046C65.9695 16.1092 67.2887 19.299 67.2887 22.9921V32.6118C67.3013 34.7069 65.5972 36.4056 63.4954 36.4056Z'
        fill='white'
      />
      <path
        d='M35.0736 13.5926C32.4606 10.9879 29.2606 9.67297 25.5557 9.67297C23.8768 9.67297 22.3053 9.9498 20.841 10.4909C19.0295 11.1578 17.054 11.2333 15.2615 10.5097L9.65052 8.2448C9.13928 8.06864 8.89313 8.36434 9.16453 8.8362L11.7965 13.4542C12.8063 15.2284 13.1724 17.336 12.6107 19.299C12.2698 20.4943 12.0994 21.7589 12.0994 23.0864C12.0994 26.7796 13.4249 29.9756 16.0315 32.574C18.6445 35.1787 21.8445 36.4999 25.5494 36.4999C29.2543 36.4999 32.4606 35.1787 35.0673 32.5803C37.6803 29.9756 39.0057 26.7858 39.0057 23.0927C39.012 19.387 37.6866 16.191 35.0736 13.5926ZM29.1912 26.7041C28.175 27.7107 26.9885 28.2014 25.5557 28.2014C24.123 28.2014 22.9364 27.7107 21.9203 26.7041C20.9041 25.6911 20.4118 24.5083 20.4118 23.0802C20.4118 21.652 20.9041 20.4692 21.9203 19.4562C22.9364 18.4496 24.123 17.9589 25.5557 17.9589C26.9885 17.9589 28.175 18.4496 29.1912 19.4625C30.2011 20.4692 30.6934 21.6583 30.6934 23.0864C30.6934 24.5083 30.2011 25.6911 29.1912 26.7041Z'
        fill='url(#paint2_radial_12683_44538)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_12683_44538'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(3.65811 3.30874) scale(49.9707 49.8116)'
        >
          <stop stopColor='#004C96' />
          <stop offset='0.00278669' stopColor='#004E96' />
          <stop offset='0.0705' stopColor='#00869B' />
          <stop offset='0.1333' stopColor='#00B29F' />
          <stop offset='0.1893' stopColor='#00D2A2' />
          <stop offset='0.2363' stopColor='#00E5A3' />
          <stop offset='0.2688' stopColor='#00ECA4' />
          <stop offset='0.6341' stopColor='#00B18C' />
          <stop offset='1' stopColor='#1E2492' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_12683_44538'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(3.81549 3.13041) scale(36.1413 36.0262)'
        >
          <stop stopColor='#4FFFA4' />
          <stop offset='0.0389' stopColor='#3FE79F' />
          <stop offset='0.1141' stopColor='#24BF97' />
          <stop offset='0.1827' stopColor='#10A191' />
          <stop offset='0.2417' stopColor='#048F8D' />
          <stop offset='0.2844' stopColor='#00898C' />
          <stop offset='0.3647' stopColor='#00778F' />
          <stop offset='0.4957' stopColor='#005F93' />
          <stop offset='0.6179' stopColor='#005195' />
          <stop offset='0.7218' stopColor='#004C96' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_12683_44538'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(3.65811 3.30874) scale(49.9707 49.8116)'
        >
          <stop stopColor='#00ECA4' />
          <stop offset='0.3946' stopColor='#00B1A6' />
          <stop offset='0.4002' stopColor='#00B0A7' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8184' stopColor='#064BF2' />
          <stop offset='0.9368' stopColor='#172FCE' />
          <stop offset='1' stopColor='#1E24C0' />
        </radialGradient>
      </defs>
    </svg>
  )
}
export const AvatarDefault = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={66}
      height={66}
      viewBox='0 0 66 66'
      fill='none'
    >
      <path
        d='M32.996 65.7234C51.012 65.7234 65.6169 51.1185 65.6169 33.1025C65.6169 15.0864 51.012 0.481506 32.996 0.481506C14.9799 0.481506 0.375 15.0864 0.375 33.1025C0.375 51.1185 14.9799 65.7234 32.996 65.7234Z'
        fill='url(#paint0_radial_3416_8018)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_3416_8018'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(65.6169 5.78241) rotate(179.436) scale(82.7797 87.293)'
        >
          <stop stopColor='#00E9A1' />
          <stop offset='0.3945' stopColor='#00ADA4' />
          <stop offset='0.3946' stopColor='#00AEA3' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8252' stopColor='#0749EF' />
          <stop offset='0.9391' stopColor='#182ECB' />
          <stop offset={1} stopColor='#1E24BD' />
        </radialGradient>
      </defs>
    </svg>
  )
}
export const MiniLogo = () => {
  return (
    <svg
      width={30}
      height={28}
      viewBox='0 0 30 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M26.9708 9.82576C24.9638 7.87232 22.4982 6.8773 19.6493 6.8773C18.3564 6.8773 17.1537 7.08216 16.0262 7.49187C14.6356 7.99669 13.1172 8.04791 11.7341 7.5065L7.41941 5.80912C7.02853 5.67743 6.84061 5.90423 7.05108 6.25542L9.07312 9.72334C9.84735 11.0549 10.133 12.6425 9.69702 14.1131C9.43393 15.013 9.29862 15.9568 9.29862 16.9591C9.29862 19.732 10.3134 22.1318 12.3279 24.0852C14.3349 26.0387 16.8004 27.0337 19.6493 27.0337C22.4982 27.0337 24.9638 26.046 26.9708 24.0852C28.9778 22.1318 30 19.732 30 16.9591C29.9925 14.179 28.9778 11.7792 26.9708 9.82576ZM22.4456 19.6735C21.6639 20.4344 20.7543 20.8002 19.6493 20.8002C18.5519 20.8002 17.6348 20.4344 16.8531 19.6735C16.0713 18.9126 15.6955 18.0273 15.6955 16.9518C15.6955 15.8837 16.0713 14.9911 16.8531 14.2302C17.6348 13.4693 18.5444 13.1035 19.6493 13.1035C20.7468 13.1035 21.6639 13.4693 22.4456 14.2302C23.2274 14.9911 23.6032 15.8763 23.6032 16.9518C23.6032 18.02 23.2198 18.9126 22.4456 19.6735Z'
        fill='#004C93'
      />
      <path
        d='M3.45024 0C2.48808 0 1.67626 0.329233 1.00726 0.980383C0.338259 1.63153 0 2.42169 0 3.35818C0 4.28734 0.338259 5.08482 1.00726 5.73597C1.67626 6.38712 2.48808 6.71635 3.45024 6.71635C4.40488 6.71635 5.22422 6.38712 5.89322 5.73597C6.56222 5.08482 6.90047 4.29466 6.90047 3.35818C6.90047 2.42901 6.56222 1.63153 5.89322 0.980383C5.2167 0.329233 4.40488 0 3.45024 0Z'
        fill='url(#paint0_radial_2060_15718)'
      />
      <path
        d='M26.9708 9.82576C24.9638 7.87232 22.4982 6.8773 19.6493 6.8773C18.3564 6.8773 17.1537 7.08216 16.0262 7.49187C14.6356 7.99669 13.1172 8.04791 11.7341 7.5065L7.41941 5.80912C7.02853 5.67743 6.84061 5.90423 7.05108 6.25542L9.07312 9.72334C9.84735 11.0549 10.133 12.6425 9.69702 14.1131C9.43393 15.013 9.29862 15.9568 9.29862 16.9591C9.29862 19.732 10.3134 22.1318 12.3279 24.0852C14.3349 26.0387 16.8004 27.0337 19.6493 27.0337C22.4982 27.0337 24.9638 26.046 26.9708 24.0852C28.9778 22.1318 30 19.732 30 16.9591C29.9925 14.179 28.9778 11.7792 26.9708 9.82576ZM22.4456 19.6735C21.6639 20.4344 20.7543 20.8002 19.6493 20.8002C18.5519 20.8002 17.6348 20.4344 16.8531 19.6735C16.0713 18.9126 15.6955 18.0273 15.6955 16.9518C15.6955 15.8837 16.0713 14.9911 16.8531 14.2302C17.6348 13.4693 18.5444 13.1035 19.6493 13.1035C20.7468 13.1035 21.6639 13.4693 22.4456 14.2302C23.2274 14.9911 23.6032 15.8763 23.6032 16.9518C23.6032 18.02 23.2198 18.9126 22.4456 19.6735Z'
        fill='url(#paint1_radial_2060_15718)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_2060_15718'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(2.93368 1.97481) scale(27.7886 27.0471)'
        >
          <stop stopColor='#4FFFA1' />
          <stop offset='0.0428' stopColor='#3DE49C' />
          <stop offset='0.1168' stopColor='#23BC94' />
          <stop offset='0.1843' stopColor='#109E8E' />
          <stop offset='0.2424' stopColor='#048C8A' />
          <stop offset='0.2844' stopColor='#008689' />
          <stop offset='0.3542' stopColor='#00778C' />
          <stop offset='0.4891' stopColor='#005F90' />
          <stop offset='0.6149' stopColor='#005192' />
          <stop offset='0.7218' stopColor='#004C93' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_2060_15718'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(2.81293 2.10869) scale(38.422 37.3968)'
        >
          <stop stopColor='#00E9A1' />
          <stop offset='0.3946' stopColor='#00AEA3' />
          <stop offset='0.4002' stopColor='#00ADA4' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8252' stopColor='#0749EF' />
          <stop offset='0.9391' stopColor='#182ECB' />
          <stop offset={1} stopColor='#1E24BD' />
        </radialGradient>
      </defs>
    </svg>
  )
}
export const LogoIonahLight = () => {
  return (
    <svg viewBox='0 0 142 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_534_1186)'>
        <path
          d='M4.75884 40C2.18796 40 0.109375 37.9312 0.109375 35.3967V15.6404C0.109375 13.095 2.1989 11.0371 4.75884 11.0371C7.31877 11.0371 9.4083 13.1059 9.4083 15.6404V35.3967C9.4083 37.9421 7.32971 40 4.75884 40Z'
          fill='black'
        />
        <path
          d='M137.35 40C134.779 40 132.7 37.9312 132.7 35.3967V25.2586C132.7 23.6989 132.164 22.28 131.18 21.2402C130.009 20.0054 128.631 19.3989 126.946 19.3989C125.272 19.3989 123.883 19.9946 122.712 21.2402C121.728 22.28 121.191 23.6989 121.191 25.2586V35.3967C121.191 37.9421 119.102 40 116.542 40C113.971 40 111.893 37.9312 111.893 35.3967V7.3328C111.893 4.78744 113.982 2.72949 116.542 2.72949C119.113 2.72949 121.191 4.79827 121.191 7.3328V11.2754C122.964 10.5605 124.889 10.1923 126.946 10.1923C131.092 10.1923 134.68 11.6545 137.601 14.5573C140.522 17.4492 142.01 21.0019 142.01 25.107V35.4075C141.999 37.9421 139.91 40 137.35 40Z'
          fill='#231F20'
        />
        <path
          d='M93.6561 39.7509C89.5098 39.7509 85.9215 38.2887 83.0006 35.3859C80.0796 32.4939 78.5918 28.9412 78.5918 24.8362C78.5918 20.7311 80.0687 17.1785 83.0006 14.2865C85.9215 11.3945 89.5098 9.92148 93.6561 9.92148C97.8023 9.92148 101.391 11.3837 104.312 14.2865C107.232 17.1785 108.72 20.7311 108.72 24.8362V35.635C108.72 36.4582 108.316 37.6604 107.528 38.3645C106.642 39.166 105.406 39.6101 104.06 39.6101C102.671 39.6101 101.412 39.1443 100.614 38.332C100.57 38.2887 100.526 38.2345 100.472 38.1803C98.4149 39.2202 96.1285 39.7509 93.6561 39.7509ZM93.6561 19.1497C91.9276 19.1497 90.5054 19.7888 89.3129 21.0994C88.4815 22.02 87.9782 23.2115 87.9126 24.4354C87.8032 26.3309 88.4487 27.8689 89.8818 29.1362C90.8117 29.9594 92.0041 30.4576 93.2513 30.5226C93.3826 30.5334 93.5248 30.5334 93.6561 30.5334C95.3846 30.5334 96.8068 29.8944 97.9992 28.573C98.8306 27.6523 99.3339 26.4717 99.3995 25.2369C99.5089 23.3415 98.8635 21.8034 97.4303 20.5362C96.5004 19.713 95.308 19.2256 94.0608 19.1497C93.9296 19.1497 93.7873 19.1497 93.6561 19.1497Z'
          fill='#231F20'
        />
        <path
          d='M71.0553 39.9133C68.2766 39.9133 66.012 37.6713 66.012 34.9201V24.977C66.012 23.6772 65.5963 22.4641 64.8414 21.5543C63.6052 20.0487 62.0955 19.3122 60.2576 19.3122C60.0716 19.3122 59.8747 19.323 59.6778 19.3339C58.54 19.4205 57.4242 19.8863 56.549 20.6445C55.1706 21.8359 54.5032 23.2656 54.5032 25.0095V35.2234C54.5032 37.8121 52.3699 39.9242 49.7553 39.9242C47.2391 39.9242 45.1934 37.8987 45.1934 35.4075V25.0203C45.1934 20.9152 46.6702 17.3626 49.5912 14.4706C52.5122 11.5787 56.1004 10.1056 60.2467 10.1056C64.3929 10.1056 67.9812 11.5678 70.9021 14.4706C73.8231 17.3626 75.3 20.9152 75.3 25.0203V35.7108C75.3109 38.0179 73.4074 39.9133 71.0553 39.9133Z'
          fill='#231F20'
        />
        <path
          d='M39.2527 14.5464C36.3318 11.6545 32.7435 10.1814 28.5972 10.1814C26.7156 10.1814 24.9652 10.4847 23.3242 11.0913C21.3003 11.8386 19.0905 11.9144 17.0775 11.1129L10.798 8.60006C10.2291 8.40509 9.95565 8.74087 10.262 9.26077L13.2048 14.3948C14.3316 16.3661 14.7473 18.7165 14.1128 20.8936C13.7299 22.2258 13.533 23.6231 13.533 25.107C13.533 29.212 15.0099 32.7647 17.9418 35.6566C20.8627 38.5486 24.451 40.0217 28.5972 40.0217C32.7435 40.0217 36.3318 38.5594 39.2527 35.6566C42.1737 32.7647 43.6615 29.212 43.6615 25.107C43.6506 20.9911 42.1737 17.4384 39.2527 14.5464ZM32.6669 29.1254C31.5291 30.2518 30.2054 30.7934 28.5972 30.7934C27 30.7934 25.6654 30.2518 24.5276 29.1254C23.3899 27.9989 22.8429 26.6883 22.8429 25.0961C22.8429 23.5148 23.3899 22.1933 24.5276 21.0669C25.6654 19.9404 26.9891 19.3989 28.5972 19.3989C30.1945 19.3989 31.5291 19.9404 32.6669 21.0669C33.8046 22.1933 34.3516 23.5039 34.3516 25.0961C34.3516 26.6775 33.7937 27.9989 32.6669 29.1254Z'
          fill='url(#paint0_radial_534_1186)'
        />
        <path
          d='M5.02142 0C3.62111 0 2.4396 0.487409 1.46595 1.45139C0.492296 2.41538 0 3.58516 0 4.97157C0 6.34714 0.492296 7.52776 1.46595 8.49174C2.4396 9.45573 3.62111 9.94314 5.02142 9.94314C6.41079 9.94314 7.60324 9.45573 8.57689 8.49174C9.55054 7.52776 10.0428 6.35797 10.0428 4.97157C10.0428 3.59599 9.55054 2.41538 8.57689 1.45139C7.5923 0.487409 6.41079 0 5.02142 0Z'
          fill='url(#paint1_radial_534_1186)'
        />
        <path
          d='M4.75884 40C2.18796 40 0.109375 37.9312 0.109375 35.3967V15.6404C0.109375 13.095 2.1989 11.0371 4.75884 11.0371C7.31877 11.0371 9.4083 13.1059 9.4083 15.6404V35.3967C9.4083 37.9421 7.32971 40 4.75884 40Z'
          fill='#161616'
        />
        <path
          d='M137.35 40C134.779 40 132.7 37.9312 132.7 35.3967V25.2586C132.7 23.6989 132.164 22.28 131.18 21.2402C130.009 20.0054 128.631 19.3989 126.946 19.3989C125.272 19.3989 123.883 19.9946 122.712 21.2402C121.728 22.28 121.191 23.6989 121.191 25.2586V35.3967C121.191 37.9421 119.102 40 116.542 40C113.971 40 111.893 37.9312 111.893 35.3967V7.3328C111.893 4.78744 113.982 2.72949 116.542 2.72949C119.113 2.72949 121.191 4.79827 121.191 7.3328V11.2754C122.964 10.5605 124.889 10.1923 126.946 10.1923C131.092 10.1923 134.68 11.6545 137.601 14.5573C140.522 17.4492 142.01 21.0019 142.01 25.107V35.4075C141.999 37.9421 139.91 40 137.35 40Z'
          fill='#161616'
        />
        <path
          d='M93.6561 39.7509C89.5098 39.7509 85.9215 38.2887 83.0006 35.3859C80.0796 32.4939 78.5918 28.9412 78.5918 24.8362C78.5918 20.7311 80.0687 17.1785 83.0006 14.2865C85.9215 11.3945 89.5098 9.92148 93.6561 9.92148C97.8023 9.92148 101.391 11.3837 104.312 14.2865C107.232 17.1785 108.72 20.7311 108.72 24.8362V35.635C108.72 36.4582 108.316 37.6604 107.528 38.3645C106.642 39.166 105.406 39.6101 104.06 39.6101C102.671 39.6101 101.412 39.1443 100.614 38.332C100.57 38.2887 100.526 38.2345 100.472 38.1803C98.4149 39.2202 96.1285 39.7509 93.6561 39.7509ZM93.6561 19.1497C91.9276 19.1497 90.5054 19.7888 89.3129 21.0994C88.4815 22.02 87.9782 23.2115 87.9126 24.4354C87.8032 26.3309 88.4487 27.8689 89.8818 29.1362C90.8117 29.9594 92.0041 30.4576 93.2513 30.5226C93.3826 30.5334 93.5248 30.5334 93.6561 30.5334C95.3846 30.5334 96.8068 29.8944 97.9992 28.573C98.8306 27.6523 99.3339 26.4717 99.3995 25.2369C99.5089 23.3415 98.8635 21.8034 97.4303 20.5362C96.5004 19.713 95.308 19.2256 94.0608 19.1497C93.9296 19.1497 93.7873 19.1497 93.6561 19.1497Z'
          fill='#161616'
        />
        <path
          d='M71.0553 39.9133C68.2766 39.9133 66.012 37.6713 66.012 34.9201V24.977C66.012 23.6772 65.5963 22.4641 64.8414 21.5543C63.6052 20.0487 62.0955 19.3122 60.2576 19.3122C60.0716 19.3122 59.8747 19.323 59.6778 19.3339C58.54 19.4205 57.4242 19.8863 56.549 20.6445C55.1706 21.8359 54.5032 23.2656 54.5032 25.0095V35.2234C54.5032 37.8121 52.3699 39.9242 49.7553 39.9242C47.2391 39.9242 45.1934 37.8987 45.1934 35.4075V25.0203C45.1934 20.9152 46.6702 17.3626 49.5912 14.4706C52.5122 11.5787 56.1004 10.1056 60.2467 10.1056C64.3929 10.1056 67.9812 11.5678 70.9021 14.4706C73.8231 17.3626 75.3 20.9152 75.3 25.0203V35.7108C75.3109 38.0179 73.4074 39.9133 71.0553 39.9133Z'
          fill='#161616'
        />
        <path
          d='M39.2527 14.5464C36.3318 11.6545 32.7435 10.1814 28.5972 10.1814C26.7156 10.1814 24.9652 10.4847 23.3242 11.0913C21.3003 11.8386 19.0905 11.9144 17.0775 11.1129L10.798 8.60006C10.2291 8.40509 9.95565 8.74087 10.262 9.26077L13.2048 14.3948C14.3316 16.3661 14.7473 18.7165 14.1128 20.8936C13.7299 22.2258 13.533 23.6231 13.533 25.107C13.533 29.212 15.0099 32.7647 17.9418 35.6566C20.8627 38.5486 24.451 40.0217 28.5972 40.0217C32.7435 40.0217 36.3318 38.5594 39.2527 35.6566C42.1737 32.7647 43.6615 29.212 43.6615 25.107C43.6506 20.9911 42.1737 17.4384 39.2527 14.5464ZM32.6669 29.1254C31.5291 30.2518 30.2054 30.7934 28.5972 30.7934C27 30.7934 25.6654 30.2518 24.5276 29.1254C23.3899 27.9989 22.8429 26.6883 22.8429 25.0961C22.8429 23.5148 23.3899 22.1933 24.5276 21.0669C25.6654 19.9404 26.9891 19.3989 28.5972 19.3989C30.1945 19.3989 31.5291 19.9404 32.6669 21.0669C33.8046 22.1933 34.3516 23.5039 34.3516 25.0961C34.3516 26.6775 33.7937 27.9989 32.6669 29.1254Z'
          fill='url(#paint2_radial_534_1186)'
        />
      </g>
      <defs>
        <radialGradient
          id='paint0_radial_534_1186'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(4.09383 3.1218) scale(55.9187 55.3636)'
        >
          <stop stopColor='#004C93' />
          <stop offset='0.068' stopColor='#008398' />
          <stop offset='0.1316' stopColor='#00AF9C' />
          <stop offset='0.1882' stopColor='#00CF9F' />
          <stop offset='0.2359' stopColor='#00E2A0' />
          <stop offset='0.2688' stopColor='#00E9A1' />
          <stop offset='0.6341' stopColor='#00AE89' />
          <stop offset={1} stopColor='#1E248F' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_534_1186'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(4.26963 2.92359) scale(40.4431 40.0416)'
        >
          <stop stopColor='#4FFFA1' />
          <stop offset='0.0428' stopColor='#3DE49C' />
          <stop offset='0.1168' stopColor='#23BC94' />
          <stop offset='0.1843' stopColor='#109E8E' />
          <stop offset='0.2424' stopColor='#048C8A' />
          <stop offset='0.2844' stopColor='#008689' />
          <stop offset='0.3542' stopColor='#00778C' />
          <stop offset='0.4891' stopColor='#005F90' />
          <stop offset='0.6149' stopColor='#005192' />
          <stop offset='0.7218' stopColor='#004C93' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_534_1186'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(4.09383 3.1218) scale(55.9187 55.3636)'
        >
          <stop stopColor='#00E9A1' />
          <stop offset='0.3946' stopColor='#00AEA3' />
          <stop offset='0.4002' stopColor='#00ADA4' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8252' stopColor='#0749EF' />
          <stop offset='0.9391' stopColor='#182ECB' />
          <stop offset={1} stopColor='#1E24BD' />
        </radialGradient>
        <clipPath id='clip0_534_1186'>
          <rect width={142} height={40} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const Heart = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 32 29'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.423 3.79859C27.697 3.06987 26.8349 2.4918 25.8861 2.0974C24.9373 1.703 23.9203 1.5 22.8933 1.5C21.8663 1.5 20.8493 1.703 19.9005 2.0974C18.9517 2.4918 18.0896 3.06987 17.3636 3.79859L15.8568 5.31023L14.3499 3.79859C12.8834 2.32732 10.8943 1.50076 8.82022 1.50076C6.74617 1.50076 4.75706 2.32732 3.29049 3.79859C1.82391 5.26986 1 7.26534 1 9.34603C1 11.4267 1.82391 13.4222 3.29049 14.8935L4.7973 16.4051L15.8568 27.5L26.9162 16.4051L28.423 14.8935C29.1494 14.1651 29.7256 13.3003 30.1188 12.3484C30.5119 11.3966 30.7143 10.3764 30.7143 9.34603C30.7143 8.31571 30.5119 7.29548 30.1188 6.34363C29.7256 5.39178 29.1494 4.52697 28.423 3.79859Z'
        stroke='{stroke}'
        strokeWidth='{2}'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const Downs = () => {
  return (
    <svg
      width={8}
      height={6}
      viewBox='0 0 8 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.943 0.269C7.90079 0.187965 7.83717 0.120046 7.75907 0.0726213C7.68097 0.025197 7.59137 8.04183e-05 7.5 0H0.5C0.408544 7.81986e-05 0.318862 0.0252388 0.240712 0.0727439C0.162562 0.120249 0.0989375 0.188279 0.0567636 0.26943C0.0145897 0.350581 -0.0045187 0.441746 0.00151773 0.533002C0.00755416 0.624258 0.0385044 0.712111 0.091 0.787L3.591 5.787C3.63714 5.85261 3.69839 5.90616 3.76957 5.94313C3.84076 5.98009 3.91979 5.99939 4 5.99939C4.08021 5.99939 4.15924 5.98009 4.23043 5.94313C4.30161 5.90616 4.36286 5.85261 4.409 5.787L7.909 0.787C7.96154 0.712043 7.9925 0.6241 7.99849 0.532758C8.00449 0.441417 7.98529 0.350182 7.943 0.269Z'
        fill='#2f343733'
      />
    </svg>
  )
}
export const IconCartHome = () => {
  return (
    <svg
      width={32}
      height={32}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 31C9.65685 31 11 29.6569 11 28C11 26.3431 9.65685 25 8 25C6.34315 25 5 26.3431 5 28C5 29.6569 6.34315 31 8 31Z'
        stroke='#212121'
        strokeWidth='1.5'
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M27 31C28.6569 31 30 29.6569 30 28C30 26.3431 28.6569 25 27 25C25.3431 25 24 26.3431 24 28C24 29.6569 25.3431 31 27 31Z'
        stroke='#212121'
        strokeWidth='1.5'
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M5.706 7H30L27.508 18.629C27.212 20.012 25.989 21 24.575 21H9.715C8.174 21 6.883 19.832 6.73 18.299L5 1H1'
        stroke='#212121'
        strokeWidth='1.5'
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const IconsDownsLocate = ({ color = 'black' }: { color?: string }) => {
  return (
    <svg
      width='8'
      height='5'
      viewBox='0 0 8 5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M4 5L7.4641 0.714286H0.535898L4 5Z' fill={color} />
    </svg>
  )
}
export const SearchIcon = ({ className, color='#F00000' }: Props) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={17}
      viewBox='0 0 22 21'
      fill='none'
    >
      <g opacity='1' clipPath='url(#clip0_2555_8009)'>
        <path
          d='M20.1276 19.25L14.5098 13.699'
          stroke={color}
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M9.50035 15.75C13.4129 15.75 16.5847 12.616 16.5847 8.75C16.5847 4.88401 13.4129 1.75 9.50035 1.75C5.58778 1.75 2.41602 4.88401 2.41602 8.75C2.41602 12.616 5.58778 15.75 9.50035 15.75Z'
          stroke={color}
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
      </g>
      <defs>
        <clipPath id='clip0_2555_8009'>
          <rect
            width='20'
            height={20}
            fill='white'
            transform='translate(0.644531)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconDelivery = () => {
  return (
    <svg
      width={32}
      height={32}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect y={4} width={20} height='1.5' fill='black' />
      <rect
        x={20}
        y={4}
        width={21}
        height='1.5'
        transform='rotate(90 20 4)'
        fill='black'
      />
      <rect y={24} width={20} height='1.5' fill='black' />
      <path
        d='M19.25 9.75H24C28.0041 9.75 31.25 12.9959 31.25 17V24.75H19.25V9.75Z'
        stroke='black'
        strokeWidth='1.5'
      />
      <circle
        cx='9.25'
        cy='25.25'
        r='2.5'
        fill='white'
        stroke='black'
        strokeWidth='1.5'
      />
      <circle
        cx='25.25'
        cy='25.25'
        r='2.5'
        fill='white'
        stroke='black'
        strokeWidth='1.5'
      />
    </svg>
  )
}
export const IconDowns = () => {
  return (
    <svg
      width={12}
      height={12}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.97481 4.4709L6.12513 8.32058L2.48236 4.6778'
        stroke='white'
        strokeWidth={2}
        strokeLinecap='round'
      />
    </svg>
  )
}
export const IconLocation = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={18}
      height={22}
      viewBox='0 0 18 22'
      fill='none'
    >
      <path
        d='M9.36658 0C4.7481 0 0.990723 3.75737 0.990723 8.37684C0.990723 15.1389 8.71517 21.6112 9.04441 21.8837C9.231 22.0389 9.50359 22.0386 9.68973 21.8837C10.019 21.6112 17.7434 15.1389 17.7434 8.37684C17.7434 3.75737 13.986 0 9.36658 0ZM9.36658 20.8221C7.90678 19.5213 2.00377 13.9172 2.00377 8.37684C2.00377 4.31657 5.30731 1.01305 9.36658 1.01305C13.4279 1.01305 16.7304 4.31658 16.7304 8.37684C16.7304 13.9111 10.8274 19.5203 9.36658 20.8221Z'
        fill='black'
      />
      <path
        d='M12.683 11.6926C10.7716 13.6039 7.60575 13.5168 5.80789 11.4305C2.7797 7.90669 6.29116 2.57435 10.6665 3.87136C11.3106 4.06484 11.0127 5.02467 10.3764 4.84166C6.82149 3.78374 4.08752 8.3297 6.76693 10.9756C9.41482 13.6558 13.9597 10.9238 12.902 7.36723C12.8505 7.18588 12.8978 6.99032 13.0335 6.85926C13.304 6.5888 13.7664 6.70776 13.8719 7.0754C14.3273 8.66206 13.931 10.4446 12.683 11.6926Z'
        fill='black'
      />
      <path
        d='M12.6839 5.77635C12.226 6.24783 11.496 5.51784 11.9676 5.05998C12.4254 4.58852 13.1554 5.31854 12.6839 5.77635Z'
        fill='black'
      />
    </svg>
  )
}
export const IconSearch = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.5'>
        <path
          d='M22 22L15.656 15.656'
          stroke='#303538'
          strokeWidth='{2}'
          strokeMiterlimit='{10}'
          strokeLinecap='square'
        />
        <path
          d='M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z'
          stroke='#303538'
          strokeWidth='{2}'
          strokeMiterlimit='{10}'
          strokeLinecap='square'
        />
      </g>
    </svg>
  )
}
export const QRCodeIcon = ({ className = '' }) => {
  return (
    <svg
      className={`${className}`}
      xmlns='http://www.w3.org/2000/svg'
      width={19}
      height={18}
      viewBox='0 0 19 18'
      fill='none'
    >
      <path
        d='M1.63358 5.78571C1.80408 5.78571 1.96759 5.71799 2.08815 5.59743C2.20871 5.47687 2.27644 5.31335 2.27644 5.14286V1.92857C2.27644 1.75808 2.34417 1.59456 2.46473 1.474C2.58528 1.35344 2.7488 1.28571 2.91929 1.28571H6.45501C6.6255 1.28571 6.78902 1.21799 6.90958 1.09743C7.03014 0.976867 7.09787 0.813354 7.09787 0.642857C7.09787 0.472361 7.03014 0.308848 6.90958 0.188288C6.78902 0.0677294 6.6255 0 6.45501 0H2.91929C2.40781 0 1.91727 0.203188 1.55559 0.564866C1.19391 0.926543 0.990723 1.41708 0.990723 1.92857V5.14286C0.990723 5.31335 1.05845 5.47687 1.17901 5.59743C1.29957 5.71799 1.46308 5.78571 1.63358 5.78571Z'
        fill='#010103'
      />
      <path
        d='M17.0621 0H13.5264C13.3559 0 13.1924 0.0677294 13.0718 0.188288C12.9513 0.308848 12.8835 0.472361 12.8835 0.642857C12.8835 0.813354 12.9513 0.976867 13.0718 1.09743C13.1924 1.21799 13.3559 1.28571 13.5264 1.28571H17.0621C17.2326 1.28571 17.3961 1.35344 17.5167 1.474C17.6372 1.59456 17.705 1.75808 17.705 1.92857V5.14286C17.705 5.31335 17.7727 5.47687 17.8933 5.59743C18.0138 5.71799 18.1773 5.78571 18.3478 5.78571C18.5183 5.78571 18.6818 5.71799 18.8024 5.59743C18.923 5.47687 18.9907 5.31335 18.9907 5.14286V1.92857C18.9907 1.41708 18.7875 0.926543 18.4258 0.564866C18.0641 0.203188 17.5736 0 17.0621 0Z'
        fill='#010103'
      />
      <path
        d='M18.3478 12.2143C18.1773 12.2143 18.0138 12.282 17.8933 12.4026C17.7727 12.5231 17.705 12.6867 17.705 12.8572V16.0714C17.705 16.2419 17.6372 16.4054 17.5167 16.526C17.3961 16.6466 17.2326 16.7143 17.0621 16.7143H13.5264C13.3559 16.7143 13.1924 16.782 13.0718 16.9026C12.9513 17.0231 12.8835 17.1867 12.8835 17.3572C12.8835 17.5276 12.9513 17.6912 13.0718 17.8117C13.1924 17.9323 13.3559 18 13.5264 18H17.0621C17.5736 18 18.0641 17.7968 18.4258 17.4351C18.7875 17.0735 18.9907 16.5829 18.9907 16.0714V12.8572C18.9907 12.6867 18.923 12.5231 18.8024 12.4026C18.6818 12.282 18.5183 12.2143 18.3478 12.2143Z'
        fill='#010103'
      />
      <path
        d='M6.45501 16.7143H2.91929C2.7488 16.7143 2.58528 16.6466 2.46473 16.526C2.34417 16.4054 2.27644 16.2419 2.27644 16.0714V12.8572C2.27644 12.6867 2.20871 12.5231 2.08815 12.4026C1.96759 12.282 1.80408 12.2143 1.63358 12.2143C1.46308 12.2143 1.29957 12.282 1.17901 12.4026C1.05845 12.5231 0.990723 12.6867 0.990723 12.8572V16.0714C0.990723 16.5829 1.19391 17.0735 1.55559 17.4351C1.91727 17.7968 2.40781 18 2.91929 18H6.45501C6.6255 18 6.78902 17.9323 6.90958 17.8117C7.03014 17.6912 7.09787 17.5276 7.09787 17.3572C7.09787 17.1867 7.03014 17.0231 6.90958 16.9026C6.78902 16.782 6.6255 16.7143 6.45501 16.7143Z'
        fill='#010103'
      />
      <path
        d='M18.3479 8.35718H1.63358C1.46308 8.35718 1.29957 8.42491 1.17901 8.54547C1.05845 8.66603 0.990723 8.82954 0.990723 9.00003C0.990723 9.17053 1.05845 9.33404 1.17901 9.4546C1.29957 9.57516 1.46308 9.64289 1.63358 9.64289H18.3479C18.5184 9.64289 18.6819 9.57516 18.8024 9.4546C18.923 9.33404 18.9907 9.17053 18.9907 9.00003C18.9907 8.82954 18.923 8.66603 18.8024 8.54547C18.6819 8.42491 18.5184 8.35718 18.3479 8.35718Z'
        fill='#010103'
      />
    </svg>
  )
}

export const CloseSearchIcon = ({ className = '', color='#CFCFCF' }) => {
  return (
    <svg
      className={className}
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.1332 2.92858C15.7346 1.53015 13.9528 0.577847 12.013 0.192077C10.0732 -0.193692 8.06263 0.00440053 6.23543 0.761307C4.40823 1.51821 2.8465 2.79994 1.74773 4.44441C0.648964 6.08888 0.0625 8.02223 0.0625 10C0.0625 11.9778 0.648964 13.9111 1.74773 15.5556C2.8465 17.2001 4.40823 18.4818 6.23543 19.2387C8.06263 19.9956 10.0732 20.1937 12.013 19.8079C13.9528 19.4222 15.7346 18.4699 17.1332 17.0714C18.0619 16.1428 18.7986 15.0404 19.3012 13.8271C19.8038 12.6138 20.0625 11.3133 20.0625 10C20.0625 8.6867 19.8038 7.38626 19.3012 6.17294C18.7986 4.95961 18.0619 3.85718 17.1332 2.92858ZM13.6332 12.5286C13.7046 12.5954 13.7615 12.6761 13.8004 12.7658C13.8392 12.8555 13.8593 12.9522 13.8593 13.05C13.8593 13.1478 13.8392 13.2445 13.8004 13.3342C13.7615 13.4239 13.7046 13.5046 13.6332 13.5714C13.5665 13.6376 13.4873 13.69 13.4003 13.7256C13.3133 13.7611 13.2201 13.7791 13.1261 13.7786C12.9387 13.7778 12.7591 13.7034 12.6261 13.5714L10.0618 11.0071L7.53321 13.5714C7.40016 13.7034 7.22059 13.7778 7.03321 13.7786C6.9392 13.7791 6.84602 13.7611 6.75899 13.7256C6.67196 13.69 6.59281 13.6376 6.52606 13.5714C6.39303 13.4376 6.31836 13.2566 6.31836 13.0679C6.31836 12.8792 6.39303 12.6981 6.52606 12.5643L9.05464 10L6.52606 7.47143C6.40905 7.33479 6.3479 7.15902 6.35484 6.97925C6.36179 6.79948 6.43631 6.62896 6.56352 6.50175C6.69073 6.37454 6.86126 6.30001 7.04103 6.29307C7.22079 6.28612 7.39656 6.34727 7.53321 6.46429L10.0618 8.99286L12.5904 6.46429C12.6565 6.39582 12.7354 6.34104 12.8228 6.30308C12.9101 6.26513 13.004 6.24474 13.0992 6.24308C13.1943 6.24142 13.2889 6.25852 13.3775 6.29342C13.466 6.32831 13.5469 6.3803 13.6153 6.44643C13.6838 6.51256 13.7386 6.59153 13.7766 6.67883C13.8145 6.76613 13.8349 6.86005 13.8366 6.95524C13.8382 7.05042 13.8211 7.14499 13.7862 7.23356C13.7513 7.32213 13.6993 7.40296 13.6332 7.47143L11.0689 10L13.6332 12.5286Z'
        fill={color}
      />
    </svg>
  )
}
export const Notification = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={25}
      viewBox='0 0 24 25'
      fill='none'
    >
      <g clipPath='url(#clip0_325_9307)'>
        <path
          d='M13.5 5.14143C13.224 5.14143 13 4.91743 13 4.64143V2.96143C13 2.41043 12.551 1.96143 12 1.96143C11.449 1.96143 11 2.41043 11 2.96143V4.64143C11 4.91743 10.776 5.14143 10.5 5.14143C10.224 5.14143 10 4.91843 10 4.64143V2.96143C10 1.85843 10.897 0.961426 12 0.961426C13.103 0.961426 14 1.85843 14 2.96143V4.64143C14 4.91843 13.776 5.14143 13.5 5.14143Z'
          fill='black'
        />
        <path
          d='M12 24.9614C10.07 24.9614 8.5 23.3914 8.5 21.4614C8.5 21.1854 8.724 20.9614 9 20.9614C9.276 20.9614 9.5 21.1854 9.5 21.4614C9.5 22.8394 10.622 23.9614 12 23.9614C13.378 23.9614 14.5 22.8394 14.5 21.4614C14.5 21.1854 14.724 20.9614 15 20.9614C15.276 20.9614 15.5 21.1854 15.5 21.4614C15.5 23.3914 13.93 24.9614 12 24.9614Z'
          fill='black'
        />
        <path
          d='M20.5 21.9614H3.5C2.673 21.9614 2 21.2884 2 20.4614C2 20.0224 2.191 19.6074 2.525 19.3214C4.101 17.9894 5 16.0514 5 13.9994V10.9614C5 7.10143 8.14 3.96143 12 3.96143C15.86 3.96143 19 7.10143 19 10.9614V13.9994C19 16.0524 19.899 17.9894 21.467 19.3144C21.809 19.6074 22 20.0224 22 20.4614C22 21.2884 21.328 21.9614 20.5 21.9614ZM12 4.96143C8.691 4.96143 6 7.65243 6 10.9614V13.9994C6 16.3474 4.972 18.5624 3.179 20.0784C3.064 20.1764 3 20.3154 3 20.4614C3 20.7374 3.224 20.9614 3.5 20.9614H20.5C20.776 20.9614 21 20.7374 21 20.4614C21 20.3154 20.936 20.1764 20.825 20.0814C19.029 18.5624 18 16.3464 18 13.9994V10.9614C18 7.65243 15.309 4.96143 12 4.96143Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_325_9307'>
          <rect
            width={24}
            height={24}
            fill='white'
            transform='translate(0 0.961426)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const MenuHeader = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={19}
      height={18}
      viewBox='0 0 19 18'
      fill='none'
    >
      <path
        d='M1.63358 5.78571C1.80408 5.78571 1.96759 5.71799 2.08815 5.59743C2.20871 5.47687 2.27644 5.31335 2.27644 5.14286V1.92857C2.27644 1.75808 2.34417 1.59456 2.46473 1.474C2.58528 1.35344 2.7488 1.28571 2.91929 1.28571H6.45501C6.6255 1.28571 6.78902 1.21799 6.90958 1.09743C7.03014 0.976867 7.09787 0.813354 7.09787 0.642857C7.09787 0.472361 7.03014 0.308848 6.90958 0.188288C6.78902 0.0677294 6.6255 0 6.45501 0H2.91929C2.40781 0 1.91727 0.203188 1.55559 0.564866C1.19391 0.926543 0.990723 1.41708 0.990723 1.92857V5.14286C0.990723 5.31335 1.05845 5.47687 1.17901 5.59743C1.29957 5.71799 1.46308 5.78571 1.63358 5.78571Z'
        fill='#010103'
      />
      <path
        d='M17.0621 0H13.5264C13.3559 0 13.1924 0.0677294 13.0718 0.188288C12.9513 0.308848 12.8835 0.472361 12.8835 0.642857C12.8835 0.813354 12.9513 0.976867 13.0718 1.09743C13.1924 1.21799 13.3559 1.28571 13.5264 1.28571H17.0621C17.2326 1.28571 17.3961 1.35344 17.5167 1.474C17.6372 1.59456 17.705 1.75808 17.705 1.92857V5.14286C17.705 5.31335 17.7727 5.47687 17.8933 5.59743C18.0138 5.71799 18.1773 5.78571 18.3478 5.78571C18.5183 5.78571 18.6818 5.71799 18.8024 5.59743C18.923 5.47687 18.9907 5.31335 18.9907 5.14286V1.92857C18.9907 1.41708 18.7875 0.926543 18.4258 0.564866C18.0641 0.203188 17.5736 0 17.0621 0Z'
        fill='#010103'
      />
      <path
        d='M18.3478 12.2143C18.1773 12.2143 18.0138 12.282 17.8933 12.4026C17.7727 12.5231 17.705 12.6867 17.705 12.8572V16.0714C17.705 16.2419 17.6372 16.4054 17.5167 16.526C17.3961 16.6466 17.2326 16.7143 17.0621 16.7143H13.5264C13.3559 16.7143 13.1924 16.782 13.0718 16.9026C12.9513 17.0231 12.8835 17.1867 12.8835 17.3572C12.8835 17.5276 12.9513 17.6912 13.0718 17.8117C13.1924 17.9323 13.3559 18 13.5264 18H17.0621C17.5736 18 18.0641 17.7968 18.4258 17.4351C18.7875 17.0735 18.9907 16.5829 18.9907 16.0714V12.8572C18.9907 12.6867 18.923 12.5231 18.8024 12.4026C18.6818 12.282 18.5183 12.2143 18.3478 12.2143Z'
        fill='#010103'
      />
      <path
        d='M6.45501 16.7143H2.91929C2.7488 16.7143 2.58528 16.6466 2.46473 16.526C2.34417 16.4054 2.27644 16.2419 2.27644 16.0714V12.8572C2.27644 12.6867 2.20871 12.5231 2.08815 12.4026C1.96759 12.282 1.80408 12.2143 1.63358 12.2143C1.46308 12.2143 1.29957 12.282 1.17901 12.4026C1.05845 12.5231 0.990723 12.6867 0.990723 12.8572V16.0714C0.990723 16.5829 1.19391 17.0735 1.55559 17.4351C1.91727 17.7968 2.40781 18 2.91929 18H6.45501C6.6255 18 6.78902 17.9323 6.90958 17.8117C7.03014 17.6912 7.09787 17.5276 7.09787 17.3572C7.09787 17.1867 7.03014 17.0231 6.90958 16.9026C6.78902 16.782 6.6255 16.7143 6.45501 16.7143Z'
        fill='#010103'
      />
      <path
        d='M18.3479 8.35718H1.63358C1.46308 8.35718 1.29957 8.42491 1.17901 8.54547C1.05845 8.66603 0.990723 8.82954 0.990723 9.00003C0.990723 9.17053 1.05845 9.33404 1.17901 9.4546C1.29957 9.57516 1.46308 9.64289 1.63358 9.64289H18.3479C18.5184 9.64289 18.6819 9.57516 18.8024 9.4546C18.923 9.33404 18.9907 9.17053 18.9907 9.00003C18.9907 8.82954 18.923 8.66603 18.8024 8.54547C18.6819 8.42491 18.5184 8.35718 18.3479 8.35718Z'
        fill='#010103'
      />
    </svg>
  )
}
export const IconCartHomeMobi = () => {
  return (
    <svg
      width={24}
      height={23}
      viewBox='0 0 24 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 22C6.55228 22 7 21.5523 7 21C7 20.4477 6.55228 20 6 20C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22Z'
        fill='#303538'
      />
      <path
        d='M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z'
        fill='#303538'
      />
      <path
        d='M6 22C6.55228 22 7 21.5523 7 21C7 20.4477 6.55228 20 6 20C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22Z'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M4.8 6H22L20 16H6L4 1H1'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
////////////////////Delete Later/////////////////////
export const TiviIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7 22H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M23 2H1V18H23V2Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const AirCondIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 13H3C1.89543 13 1 13.8954 1 15V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V15C23 13.8954 22.1046 13 21 13Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 18H5'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M12 7V2'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M7 9V6'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M17 9V6'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const FridgeIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 1H3V23H21V1Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M21 10H3'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d='M7 5V6'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M7 14V17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const WashingIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 23V1L3 1V23H21Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M12 19C14.7614 19 17 16.7614 17 14C17 11.2386 14.7614 9 12 9C9.23858 9 7 11.2386 7 14C7 16.7614 9.23858 19 12 19Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M7 5H10'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M16 5H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const HobIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23 2H1V23H23V2Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 20C9.65685 20 11 18.6569 11 17C11 15.3431 9.65685 14 8 14C6.34315 14 5 15.3431 5 17C5 18.6569 6.34315 20 8 20Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 6H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 10H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 15H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 19H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const MicrowaveIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23 3H1V21H23V3Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M18 16H19'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M18 12H19'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M18 8H19'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M14 8H5V16H14V8Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const IconCart = () => {
  return (
    <svg
      width={26}
      height={23}
      viewBox='0 0 26 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23.5399 4.23026H6.6656C6.52414 4.23026 6.38878 4.23026 6.26146 4.22318C6.02972 4.21062 5.79739 4.21501 5.56629 4.23632C4.59526 1.78601 1.49926 0.13495 1.35173 0.057146C1.29368 0.0266875 1.23022 0.00796363 1.16493 0.00204185C1.09964 -0.00387993 1.0338 0.00310832 0.971217 0.022625C0.908632 0.0421416 0.850488 0.0737976 0.800138 0.115781C0.749788 0.157764 0.708229 0.209253 0.67778 0.267309C0.647322 0.325361 0.628567 0.388856 0.622645 0.454145C0.616723 0.519435 0.623727 0.585243 0.643244 0.647827C0.66276 0.710412 0.694447 0.76854 0.73643 0.818891C0.778414 0.869241 0.829902 0.91083 0.887959 0.941279C0.924335 0.960477 4.53964 2.88334 4.84177 5.36598C4.85067 5.43322 4.87341 5.4979 4.90849 5.55595L6.09673 15.9635C6.14223 16.4428 6.36702 16.8873 6.72616 17.2081C7.0853 17.5288 7.5523 17.7021 8.03373 17.6933H21.9334C22.4514 17.6264 22.9303 17.3823 23.2888 17.0023C23.6472 16.6223 23.8631 16.1299 23.8997 15.6088L25.3628 6.05409L25.3688 5.97931C25.3577 5.50503 25.1589 5.05452 24.816 4.72663C24.4732 4.39873 24.0142 4.22023 23.5399 4.23026ZM22.9094 15.4886L22.9033 15.5633C22.9033 15.9928 22.3618 16.692 21.9343 16.692H8.03478C7.81263 16.6987 7.59545 16.6252 7.42306 16.485C7.25067 16.3447 7.13459 16.147 7.09607 15.9281L5.87342 5.21745C5.98659 5.21745 6.12502 5.21745 6.2392 5.21745C6.3746 5.21745 6.51911 5.22452 6.66967 5.22452H23.544C23.7477 5.21517 23.9473 5.28404 24.1019 5.41703C24.2565 5.55003 24.3544 5.73708 24.3756 5.93991L22.9094 15.4886Z'
        fill='#070707'
      />
      <path
        d='M19.7952 6.74146H18.13C17.9976 6.74146 17.8707 6.79405 17.7771 6.88766C17.6835 6.98127 17.6309 7.10823 17.6309 7.24061C17.6309 7.373 17.6835 7.49997 17.7771 7.59358C17.8707 7.68719 17.9976 7.73977 18.13 7.73977H19.7952C20.0157 7.74004 20.2271 7.82775 20.383 7.98364C20.5389 8.13954 20.6266 8.35089 20.6268 8.57136V10.2164C20.6268 10.3487 20.6794 10.4757 20.773 10.5693C20.8666 10.6629 20.9936 10.7155 21.1259 10.7155C21.2583 10.7155 21.3853 10.6629 21.4789 10.5693C21.5725 10.4757 21.6251 10.3487 21.6251 10.2164V8.57136C21.6249 8.08612 21.432 7.62084 21.0889 7.27773C20.7458 6.93461 20.2805 6.74172 19.7952 6.74146Z'
        fill='#070707'
      />
      <path
        d='M9.42829 22.5548C10.0488 22.5548 10.5519 22.0518 10.5519 21.4312C10.5519 20.8107 10.0488 20.3076 9.42829 20.3076C8.80774 20.3076 8.30469 20.8107 8.30469 21.4312C8.30469 22.0518 8.80774 22.5548 9.42829 22.5548Z'
        fill='#070707'
      />
      <path
        d='M20.2125 22.5548C20.833 22.5548 21.3361 22.0518 21.3361 21.4312C21.3361 20.8107 20.833 20.3076 20.2125 20.3076C19.5919 20.3076 19.0889 20.8107 19.0889 21.4312C19.0889 22.0518 19.5919 22.5548 20.2125 22.5548Z'
        fill='#070707'
      />
    </svg>
  )
}
export const IconPromo = () => {
  return (
    <svg
      width={27}
      height={27}
      viewBox='0 0 27 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M25.5575 10.5382C25.0757 10.0406 24.8539 9.36229 24.9521 8.67452L25.0409 8.04696C25.3071 6.16747 24.052 4.43695 22.182 4.1105L21.5576 3.99956C20.8762 3.87912 20.2962 3.46076 19.9729 2.84905L19.675 2.29123C18.7844 0.614581 16.7527 -0.047836 15.0476 0.788901L14.4771 1.06464C13.8559 1.36891 13.1396 1.36891 12.5183 1.06464L11.951 0.785732C10.2458 -0.0478361 8.21422 0.611411 7.3236 2.28806L7.02567 2.84588C6.69921 3.45759 6.12237 3.87912 5.44094 3.99639L4.81656 4.10733C2.94657 4.43378 1.69147 6.16431 1.9577 8.04379L2.04645 8.67135C2.1447 9.35912 1.92284 10.0374 1.44108 10.535L1.00053 10.9882C-0.321139 12.3511 -0.321139 14.4905 1.00053 15.8533L1.44108 16.3097C1.92284 16.8074 2.1447 17.4856 2.04645 18.1734L1.9577 18.8009C1.69147 20.6804 2.94657 22.411 4.81656 22.7374L5.44094 22.8483C6.12237 22.9688 6.70238 23.3871 7.02567 23.9989L7.3236 24.5567C7.95432 25.7421 9.15238 26.4203 10.4075 26.4203C10.9241 26.4203 11.4534 26.3031 11.951 26.059L12.5183 25.7864C13.1396 25.4822 13.8559 25.4822 14.4771 25.7864L15.0444 26.0653C16.7496 26.8989 18.7812 26.2397 19.6718 24.563L19.9697 24.0052C20.2962 23.3935 20.873 22.972 21.5545 22.8547L22.1789 22.7437C24.0488 22.4173 25.3039 20.6868 25.0377 18.8073L24.949 18.1797C24.8507 17.492 25.0726 16.8137 25.5543 16.3161L25.9949 15.8629C27.3166 14.5 27.3166 12.3606 25.9949 10.9977L25.5575 10.5382ZM25.0853 14.9786L24.6447 15.4318C23.8904 16.2115 23.5417 17.2796 23.6939 18.354L23.7826 18.9816C23.9538 20.1797 23.1519 21.2826 21.9602 21.4918L21.3358 21.6027C20.2645 21.7897 19.358 22.449 18.8509 23.4093L18.553 23.9672C17.9857 25.0353 16.6894 25.46 15.6022 24.9275L15.0349 24.6486C14.0587 24.17 12.9367 24.17 11.9605 24.6486L11.3932 24.9275C10.3061 25.46 9.00975 25.0384 8.44242 23.9672L8.14449 23.4093C7.63421 22.449 6.72774 21.7897 5.65963 21.6027L5.03525 21.4918C3.84353 21.2826 3.04166 20.1797 3.21281 18.9816L3.30155 18.354C3.45369 17.2764 3.10822 16.2115 2.35072 15.4318L1.91016 14.9754C1.06708 14.1038 1.06708 12.7441 1.91016 11.8725L2.35072 11.4193C3.10505 10.6396 3.45369 9.57147 3.30155 8.49703L3.21281 7.86947C3.04166 6.67142 3.84353 5.56845 5.03525 5.35926L5.65963 5.24833C6.73091 5.06133 7.63737 4.40209 8.14449 3.44174L8.44242 2.88391C8.84494 2.12641 9.60878 1.69537 10.4075 1.69537C10.7371 1.69537 11.0731 1.76826 11.3932 1.92357L11.9605 2.20248C12.9367 2.68107 14.0587 2.68107 15.0349 2.20248L15.6022 1.92357C16.6894 1.3911 17.9857 1.81264 18.553 2.88391L18.8509 3.44174C19.3612 4.40209 20.2677 5.06133 21.3358 5.24833L21.9602 5.35926C23.1519 5.56845 23.9538 6.67142 23.7826 7.86947L23.6939 8.49703C23.5417 9.57464 23.8872 10.6396 24.6447 11.4193L25.0853 11.8757C25.9283 12.7441 25.9283 14.107 25.0853 14.9786Z'
        fill='#E73F1D'
      />
      <path
        d='M18.5407 8.38292C18.2934 8.13571 17.8909 8.13571 17.6437 8.38292L8.45543 17.5712C8.20822 17.8184 8.20822 18.2209 8.45543 18.4681C8.57904 18.5918 8.74068 18.6551 8.90233 18.6551C9.06397 18.6551 9.22561 18.5918 9.34922 18.4681L18.5375 9.27988C18.7879 9.03266 18.7879 8.63014 18.5407 8.38292Z'
        fill='#E73F1D'
      />
      <path
        d='M10.9211 11.7487C11.612 11.7487 12.2998 11.4857 12.8259 10.9595C13.875 9.91046 13.875 8.19895 12.8259 7.14986C11.7768 6.10076 10.0653 6.10076 9.01625 7.14986C8.50596 7.65697 8.22705 8.33523 8.22705 9.0547C8.22705 9.77417 8.50596 10.4524 9.01625 10.9595C9.54238 11.4857 10.2301 11.7487 10.9211 11.7487ZM9.9132 8.04681C10.1921 7.7679 10.5566 7.62844 10.9211 7.62844C11.2856 7.62844 11.6501 7.7679 11.929 8.04681C12.4836 8.60147 12.4836 9.50793 11.929 10.0626C11.3712 10.6172 10.4679 10.6172 9.9132 10.0626C9.6438 9.79318 9.49483 9.43504 9.49483 9.0547C9.49483 8.67437 9.6438 8.31622 9.9132 8.04681Z'
        fill='#E73F1D'
      />
      <path
        d='M14.1701 15.8912C13.121 16.9403 13.121 18.6518 14.1701 19.7009C14.6962 20.2271 15.384 20.4901 16.075 20.4901C16.7659 20.4901 17.4537 20.2271 17.9798 19.7009C18.4901 19.1907 18.769 18.5156 18.769 17.7961C18.769 17.0766 18.4901 16.3984 17.9798 15.8912C16.9307 14.839 15.2224 14.839 14.1701 15.8912ZM17.0829 18.804C16.5282 19.3586 15.6217 19.3586 15.0671 18.804C14.5124 18.2493 14.5124 17.3429 15.0671 16.7882C15.346 16.5093 15.7105 16.3698 16.075 16.3698C16.4395 16.3698 16.8039 16.5093 17.0829 16.7882C17.3523 17.0576 17.5012 17.4158 17.5012 17.7961C17.5012 18.1764 17.3523 18.5346 17.0829 18.804Z'
        fill='#E73F1D'
      />
    </svg>
  )
}
export const IconPromoB2B = () => {
  return (
    <svg
      width={24}
      height={26}
      viewBox='0 0 24 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.85103 18.5865L1.85102 18.5865C1.51095 18.8414 1.25972 19.1969 1.13292 19.6026C1.00613 20.0083 1.0102 20.4435 1.14456 20.8468C1.27892 21.25 1.53675 21.6007 1.88153 21.8492C2.22631 22.0978 2.64055 22.2315 3.06557 22.2315H21.5522C21.9772 22.2316 22.3914 22.098 22.7363 21.8495C23.0811 21.601 23.3391 21.2503 23.4735 20.847C23.6079 20.4437 23.612 20.0084 23.4852 19.6027C23.3584 19.197 23.1071 18.8414 22.767 18.5865L22.7933 18.5514L22.767 18.5865L21.8347 17.8875C21.4736 17.6176 21.2313 17.2181 21.1588 16.7732L1.85103 18.5865ZM1.85103 18.5865L2.78301 17.8875L1.85103 18.5865ZM12.3097 4.12239C10.6977 4.11463 9.13688 4.68802 7.91325 5.73749C6.68967 6.78694 5.88522 8.24215 5.64731 9.83648C5.6473 9.8366 5.64728 9.83672 5.64726 9.83685L4.47713 16.9409L4.47712 16.9409C4.36179 17.6484 3.9765 18.2835 3.40235 18.7125L3.40228 18.7126L2.46996 19.4119C2.30313 19.537 2.17989 19.7114 2.1177 19.9103C2.05551 20.1093 2.05752 20.3228 2.12345 20.5206C2.18937 20.7184 2.31588 20.8904 2.48503 21.0123C2.65417 21.1342 2.85739 21.1997 3.06587 21.1997H21.5524C21.7608 21.1997 21.964 21.1341 22.1331 21.0123C22.3022 20.8904 22.4286 20.7184 22.4946 20.5207C22.5605 20.323 22.5625 20.1095 22.5004 19.9106C22.4382 19.7116 22.3151 19.5373 22.1483 19.4122L21.2157 18.7126L21.2156 18.7125C20.6415 18.2835 20.2562 17.6484 20.1409 16.9409L20.1409 16.9409L18.9712 9.84294C18.9712 9.84284 18.9712 9.84275 18.9712 9.84265C18.7345 8.24742 17.9307 6.79096 16.7072 5.74032C15.4837 4.68966 13.9224 4.11525 12.3097 4.12239ZM12.3097 4.12239C12.3098 4.12239 12.3099 4.1224 12.3099 4.1224L12.3097 4.17234L12.3095 4.1224C12.3096 4.12239 12.3096 4.12239 12.3097 4.12239ZM19.9902 9.68054L21.1588 16.7731L2.78308 17.8874C3.14418 17.6175 3.38646 17.2181 3.45888 16.7731L4.62827 9.67443L4.62834 9.67394C4.91202 7.8399 5.84265 6.16792 7.2519 4.96037C8.66115 3.75282 10.456 3.08943 12.3119 3.09016C14.1677 3.0909 15.962 3.75571 17.3703 4.96437C18.7786 6.17304 19.7079 7.84575 19.9902 9.68002L19.9902 9.68054Z'
        fill='black'
        stroke='white'
        strokeWidth='0.1'
      />
      <path
        d='M14.0068 4.32616C13.8699 4.32616 13.7387 4.27181 13.642 4.17506C13.5452 4.0783 13.4909 3.94708 13.4909 3.81025V3.04062C13.4909 2.72718 13.3664 2.42658 13.1447 2.20494C12.9231 1.98331 12.6225 1.8588 12.309 1.8588C11.9956 1.8588 11.695 1.98331 11.4734 2.20494C11.2517 2.42658 11.1272 2.72718 11.1272 3.04062V3.81025C11.1272 3.94708 11.0729 4.0783 10.9761 4.17506C10.8794 4.27181 10.7481 4.32616 10.6113 4.32616C10.4745 4.32616 10.3433 4.27181 10.2465 4.17506C10.1498 4.0783 10.0954 3.94708 10.0954 3.81025V3.04062C10.0954 2.45352 10.3286 1.89047 10.7438 1.47534C11.1589 1.0602 11.722 0.826978 12.309 0.826978C12.8961 0.826978 13.4592 1.0602 13.8743 1.47534C14.2895 1.89047 14.5227 2.45352 14.5227 3.04062V3.81025C14.5227 3.94708 14.4683 4.0783 14.3716 4.17506C14.2748 4.27181 14.1436 4.32616 14.0068 4.32616Z'
        fill='black'
        stroke='white'
        strokeWidth='0.1'
      />
      <path
        d='M12.3088 25.6271C11.2718 25.6259 10.2776 25.2134 9.54431 24.4802C8.81103 23.7469 8.39857 22.7527 8.39741 21.7156L8.34741 21.7157H8.39741C8.39741 21.5789 8.45177 21.4476 8.54852 21.3509C8.64527 21.2541 8.77649 21.1998 8.91332 21.1998C9.05015 21.1998 9.18137 21.2541 9.27813 21.3509C9.37488 21.4476 9.42923 21.5789 9.42923 21.7157C9.42923 22.4794 9.73261 23.2118 10.2726 23.7518C10.8127 24.2919 11.5451 24.5952 12.3088 24.5952C13.0725 24.5952 13.8049 24.2919 14.3449 23.7518C14.8849 23.2118 15.1883 22.4794 15.1883 21.7157C15.1883 21.5789 15.2427 21.4476 15.3394 21.3509C15.4362 21.2541 15.5674 21.1998 15.7042 21.1998C15.8411 21.1998 15.9723 21.2541 16.069 21.3509C16.1658 21.4476 16.2201 21.5788 16.2201 21.7156C16.219 22.7527 15.8065 23.7469 15.0732 24.4802C14.34 25.2134 13.3458 25.6259 12.3088 25.6271Z'
        fill='black'
        stroke='white'
        strokeWidth='0.1'
      />
    </svg>
  )
}
export const IconPhone = ({ className }: Props) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={27}
      height={26}
      viewBox='0 0 27 26'
      fill='none'
    >
      <path
        d='M17.7121 4.33887H9.09345C8.49845 4.33887 8.01611 4.82121 8.01611 5.4162V20.4989C8.01611 21.0939 8.49845 21.5762 9.09345 21.5762H17.7121C18.3071 21.5762 18.7894 21.0939 18.7894 20.4989V5.4162C18.7894 4.82121 18.3071 4.33887 17.7121 4.33887Z'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.3252 5.41602H14.4799'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.4028 18.3438V18.3548'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const IconLock = ({ className }: Props) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={20}
      viewBox='0 0 17 20'
      fill='none'
    >
      <path
        d='M13.5714 6.62143H5.1V4.82143C5.1 2.95 6.62143 1.42857 8.49286 1.42857C9.86429 1.42857 11.0857 2.24286 11.6214 3.5C11.7786 3.86429 12.1929 4.03571 12.5571 3.87857C12.9214 3.72857 13.0929 3.30714 12.9357 2.94286C12.1786 1.15714 10.4357 0 8.49286 0C5.83571 0 3.67143 2.16429 3.67143 4.82143V6.62143H3.35714C1.77857 6.62143 0.5 7.9 0.5 9.47857V17.1429C0.5 18.7214 1.77857 20 3.35714 20H13.5714C15.15 20 16.4286 18.7214 16.4286 17.1429V9.47857C16.4286 7.90714 15.15 6.62143 13.5714 6.62143ZM15 17.1429C15 17.9286 14.3571 18.5714 13.5714 18.5714H3.35714C2.57143 18.5714 1.92857 17.9286 1.92857 17.1429V9.47857C1.92857 8.69286 2.57143 8.05 3.35714 8.05H13.5714C14.3571 8.05 15 8.69286 15 9.47857V17.1429ZM9.75 13.1071C9.75 13.55 9.52143 13.95 9.17857 14.1786V15.9286C9.17857 16.3214 8.85714 16.6429 8.46428 16.6429C8.07143 16.6429 7.75 16.3214 7.75 15.9286V14.1786C7.40714 13.95 7.17857 13.55 7.17857 13.1071C7.17857 12.4 7.75714 11.8214 8.46428 11.8214C9.17143 11.8214 9.75 12.3929 9.75 13.1071Z'
        fill='black'
      />
    </svg>
  )
}
export const IconOrder = () => {
  return (
    <svg
      width={22}
      height={27}
      viewBox='0 0 22 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.7 11.7948V11.7956V21.3747C21.6983 22.7887 21.1483 24.1429 20.1726 25.1408C19.1972 26.1384 17.8761 26.6983 16.4996 26.7H5.50036C4.12385 26.6983 2.80278 26.1384 1.82734 25.1408C0.851717 24.143 0.301701 22.7888 0.3 21.3748V5.6252C0.301701 4.21126 0.851717 2.85706 1.82734 1.85926C2.80275 0.861685 4.12374 0.301758 5.50019 0.300026L10.4665 0.300027L10.4673 0.300025C11.4383 0.297469 12.4003 0.491782 13.2977 0.87191C14.1952 1.25204 15.0106 1.81055 15.6965 2.51548L15.6969 2.51595L19.5293 6.43769L19.53 6.43841C20.2197 7.1394 20.7668 7.97375 21.1394 8.89328C21.512 9.81283 21.7026 10.7991 21.7 11.7948ZM6.03668 19.6642L5.82218 19.4545L6.03668 19.6642C6.18725 19.5103 6.39002 19.425 6.59999 19.425H12.1C12.31 19.425 12.5127 19.5103 12.6633 19.6642C12.8141 19.8185 12.9 20.0291 12.9 20.25C12.9 20.471 12.8141 20.6815 12.6633 20.8358C12.5127 20.9898 12.31 21.075 12.1 21.075H6.59999C6.39002 21.075 6.18725 20.9898 6.03668 20.8358C5.88588 20.6815 5.79999 20.471 5.79999 20.25C5.79999 20.0291 5.88588 19.8185 6.03668 19.6642ZM14.5706 3.68735L14.5707 3.68732L14.5672 3.68389C14.2024 3.32248 13.7926 3.0114 13.3483 2.75874L12.9 2.50381V3.01952V7.87502C12.9 8.2508 13.0459 8.61252 13.3077 8.88025C13.5697 9.14821 13.9265 9.30002 14.3 9.30002H19.0476H19.5524L19.3111 8.85662C19.0643 8.40308 18.76 7.98461 18.4059 7.61209L18.406 7.61207L18.403 7.60909L14.5706 3.68735ZM20.0471 11.223L20.0223 10.95H19.7483H14.3C13.5065 10.95 12.7442 10.6277 12.181 10.0518C11.6177 9.47558 11.3 8.69271 11.3 7.87502V2.3029V2.02997L11.0283 2.00423C10.9721 1.99891 10.9195 1.99192 10.861 1.98414C10.8329 1.9804 10.8033 1.97647 10.7714 1.97247C10.6792 1.9609 10.5757 1.95002 10.4665 1.95002H5.49999C4.54301 1.95002 3.62663 2.33889 2.95204 3.0288C2.27768 3.71849 1.9 4.6525 1.9 5.62502V21.375C1.9 22.3475 2.27768 23.2815 2.95204 23.9712C3.62663 24.6611 4.54301 25.05 5.49999 25.05H16.5C17.457 25.05 18.3733 24.6611 19.0479 23.9712C19.7223 23.2815 20.1 22.3475 20.1 21.375V11.7956C20.1 11.6847 20.0895 11.5798 20.0782 11.4858C20.0743 11.4534 20.0705 11.4234 20.0668 11.3947C20.0592 11.3349 20.0523 11.2808 20.0471 11.223ZM16.2 15.75C16.2 15.971 16.1141 16.1815 15.9633 16.3358C15.8127 16.4898 15.61 16.575 15.4 16.575H6.59999C6.39002 16.575 6.18725 16.4898 6.03668 16.3358C5.88588 16.1815 5.79999 15.971 5.79999 15.75C5.79999 15.5291 5.88588 15.3185 6.03668 15.1643C6.18725 15.0103 6.39002 14.925 6.59999 14.925H15.4C15.61 14.925 15.8127 15.0103 15.9633 15.1643C16.1141 15.3185 16.2 15.5291 16.2 15.75Z'
        fill='black'
        stroke='white'
        strokeWidth='0.6'
      />
    </svg>
  )
}
export const IconCategory = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.01877 10.729H1.71327C1.25974 10.7285 0.824884 10.5484 0.503817 10.228C0.18275 9.90772 0.00158453 9.47329 0 9.01976V1.71425C0.000528191 1.25994 0.181201 0.824379 0.502354 0.50304C0.823506 0.1817 1.25896 0.000793018 1.71327 0H9.01877C9.47308 0.000793018 9.90853 0.1817 10.2297 0.50304C10.5508 0.824379 10.7315 1.25994 10.732 1.71425V9.01976C10.7305 9.47329 10.5493 9.90772 10.2282 10.228C9.90716 10.5484 9.4723 10.7285 9.01877 10.729ZM1.71327 0.931052C1.50687 0.931581 1.30909 1.01387 1.16324 1.15991C1.01738 1.30596 0.93534 1.50385 0.935077 1.71025V9.01976C0.93534 9.22616 1.01738 9.42406 1.16324 9.5701C1.30909 9.71614 1.50687 9.79843 1.71327 9.79896H9.01877C9.22535 9.7987 9.4234 9.71652 9.56947 9.57045C9.71555 9.42438 9.79774 9.22634 9.798 9.01976V1.71425C9.79774 1.50767 9.71555 1.30963 9.56947 1.16356C9.4234 1.01749 9.22535 0.93531 9.01877 0.935046L1.71327 0.931052Z'
        fill='black'
      />
      <path
        d='M9.01877 23.3267H1.71327C1.25896 23.3259 0.823506 23.1451 0.502354 22.8237C0.181201 22.5024 0.000528191 22.0668 0 21.6125V14.307C0.000528776 13.8528 0.181234 13.4173 0.502415 13.0961C0.823595 12.7749 1.25905 12.5943 1.71327 12.5938H9.01877C9.47299 12.5943 9.90844 12.7749 10.2296 13.0961C10.5508 13.4173 10.7315 13.8528 10.732 14.307V21.6085C10.7326 22.0635 10.5524 22.5001 10.2311 22.8223C9.90982 23.1445 9.47377 23.3259 9.01877 23.3267ZM1.71327 13.5278C1.50687 13.5283 1.30909 13.6106 1.16324 13.7567C1.01738 13.9027 0.93534 14.1006 0.935076 14.307V21.6085C0.93534 21.8149 1.01738 22.0128 1.16324 22.1588C1.30909 22.3049 1.50687 22.3872 1.71327 22.3877H9.01877C9.22534 22.3874 9.4234 22.3053 9.56947 22.1592C9.71554 22.0131 9.79773 21.8151 9.798 21.6085V14.303C9.79773 14.0964 9.71554 13.8984 9.56947 13.7523C9.4234 13.6062 9.22534 13.5241 9.01877 13.5238L1.71327 13.5278Z'
        fill='black'
      />
      <path
        d='M17.9632 23.3267C16.5404 23.3251 15.1763 22.7593 14.1703 21.7532C13.1642 20.7471 12.5983 19.383 12.5967 17.9602C12.5983 16.5374 13.1642 15.1734 14.1703 14.1673C15.1763 13.1612 16.5404 12.5953 17.9632 12.5938C19.386 12.5953 20.75 13.1612 21.7561 14.1673C22.7622 15.1734 23.3281 16.5374 23.3297 17.9602C23.3278 19.383 22.7618 20.7469 21.7558 21.7529C20.7498 22.7589 19.3859 23.3249 17.9632 23.3267ZM17.9632 13.5278C16.7881 13.5288 15.6615 13.996 14.8305 14.8268C13.9995 15.6576 13.532 16.7842 13.5307 17.9592C13.532 19.1344 13.9995 20.261 14.8304 21.092C15.6614 21.923 16.788 22.3904 17.9632 22.3917C19.1382 22.3901 20.2645 21.9226 21.0953 21.0916C21.926 20.2607 22.3933 19.1342 22.3946 17.9592C22.3933 16.7843 21.926 15.658 21.0952 14.8272C20.2645 13.9964 19.1381 13.5291 17.9632 13.5278Z'
        fill='black'
      />
      <path
        d='M21.6204 10.729H14.3149C13.8606 10.7298 13.4244 10.5503 13.1023 10.2298C12.7801 9.90935 12.5983 9.47415 12.5967 9.01976V1.71425C12.5972 1.25994 12.7779 0.824379 13.099 0.50304C13.4202 0.1817 13.8556 0.000793018 14.31 0H21.6154C22.0699 0.000528777 22.5057 0.181305 22.827 0.502674C23.1484 0.824042 23.3292 1.25976 23.3297 1.71425V9.01976C23.3279 9.47251 23.1472 9.9062 22.827 10.2263C22.5069 10.5465 22.0732 10.7272 21.6204 10.729ZM14.3149 0.931052C14.1084 0.931317 13.9103 1.01349 13.7642 1.15956C13.6182 1.30563 13.536 1.50368 13.5357 1.71025V9.01976C13.536 9.22633 13.6182 9.42438 13.7642 9.57045C13.9103 9.71652 14.1084 9.79869 14.3149 9.79896H21.6204C21.827 9.79869 22.0251 9.71652 22.1712 9.57045C22.3172 9.42438 22.3994 9.22633 22.3996 9.01976V1.71425C22.3994 1.50767 22.3172 1.30963 22.1712 1.16356C22.0251 1.01748 21.827 0.93531 21.6204 0.935046L14.3149 0.931052Z'
        fill='black'
      />
    </svg>
  )
}
export const IconCartActive = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M26.6673 16V29.3333H5.33398V16'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M29.3327 9.33301H2.66602V15.9997H29.3327V9.33301Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16 29.333V9.33301'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.9993 9.33366H9.99935C9.11529 9.33366 8.26745 8.98247 7.64233 8.35735C7.01721 7.73223 6.66602 6.88438 6.66602 6.00033C6.66602 5.11627 7.01721 4.26842 7.64233 3.6433C8.26745 3.01818 9.11529 2.66699 9.99935 2.66699C14.666 2.66699 15.9993 9.33366 15.9993 9.33366Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16 9.33366H22C22.8841 9.33366 23.7319 8.98247 24.357 8.35735C24.9821 7.73223 25.3333 6.88438 25.3333 6.00033C25.3333 5.11627 24.9821 4.26842 24.357 3.6433C23.7319 3.01818 22.8841 2.66699 22 2.66699C17.3333 2.66699 16 9.33366 16 9.33366Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const IconUserActive = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.3333 4H4V13.3333H13.3333V4Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27.9993 4H18.666V13.3333H27.9993V4Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27.9993 18.667H18.666V28.0003H27.9993V18.667Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.3333 18.667H4V28.0003H13.3333V18.667Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const IconUser = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={19}
      height={19}
      viewBox='0 0 19 19'
      fill='none'
    >
      <g clipPath='url(#clip0_3639_8376)'>
        <path
          d='M16.2175 2.78248C14.4232 0.988182 12.0375 0 9.5 0C6.9625 0 4.57677 0.988182 2.78248 2.78248C0.988182 4.57677 0 6.9625 0 9.5C0 12.0375 0.988182 14.4232 2.78248 16.2175C4.57677 18.0118 6.9625 19 9.5 19C12.0375 19 14.4232 18.0118 16.2175 16.2175C18.0118 14.4232 19 12.0375 19 9.5C19 6.9625 18.0118 4.57677 16.2175 2.78248ZM4.12305 15.9309C4.43674 13.2318 6.75739 11.1479 9.5 11.1479C10.9458 11.1479 12.3054 11.7112 13.3281 12.7337C14.192 13.5978 14.7369 14.726 14.8771 15.9308C13.4203 17.1509 11.5445 17.8867 9.5 17.8867C7.45551 17.8867 5.57989 17.1511 4.12305 15.9309ZM9.5 10.0013C7.90908 10.0013 6.6146 8.70679 6.6146 7.11587C6.6146 5.5248 7.90908 4.23047 9.5 4.23047C11.0909 4.23047 12.3854 5.5248 12.3854 7.11587C12.3854 8.70679 11.0909 10.0013 9.5 10.0013ZM15.8353 14.9897C15.5516 13.846 14.96 12.7914 14.1152 11.9466C13.431 11.2624 12.6215 10.7491 11.7387 10.4274C12.8 9.70773 13.4987 8.49181 13.4987 7.11587C13.4987 4.91105 11.7048 3.11719 9.5 3.11719C7.29518 3.11719 5.50132 4.91105 5.50132 7.11587C5.50132 8.49254 6.2006 9.70889 7.26271 10.4285C6.45051 10.7245 5.6989 11.1821 5.05224 11.7845C4.11581 12.6566 3.46552 13.7686 3.16401 14.9889C1.88707 13.5168 1.11328 11.5971 1.11328 9.5C1.11328 4.87553 4.87553 1.11328 9.5 1.11328C14.1245 1.11328 17.8867 4.87553 17.8867 9.5C17.8867 11.5975 17.1126 13.5177 15.8353 14.9897Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_3639_8376'>
          <rect width={19} height={19} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconMenu = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M26.6673 28V25.3333C26.6673 23.9188 26.1054 22.5623 25.1052 21.5621C24.105 20.5619 22.7485 20 21.334 20H10.6673C9.25283 20 7.89628 20.5619 6.89608 21.5621C5.89589 22.5623 5.33398 23.9188 5.33398 25.3333V28'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.9993 14.6667C18.9449 14.6667 21.3327 12.2789 21.3327 9.33333C21.3327 6.38781 18.9449 4 15.9993 4C13.0538 4 10.666 6.38781 10.666 9.33333C10.666 12.2789 13.0538 14.6667 15.9993 14.6667Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const IconListOrder = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={26}
      height={25}
      viewBox='0 0 26 25'
      fill='none'
    >
      <path
        d='M22.4937 18.875C22.4937 20.8836 20.7899 22.525 18.6875 22.525H7.75C5.64756 22.525 3.94375 20.8836 3.94375 18.875V5.375C3.94375 3.36641 5.64756 1.725 7.75 1.725H18.6875C20.7899 1.725 22.4937 3.36641 22.4937 5.375V18.875ZM7.75 3.025C6.40624 3.025 5.30625 4.07524 5.30625 5.375V18.875C5.30625 20.1748 6.40624 21.225 7.75 21.225H18.6875C20.0313 21.225 21.1313 20.1748 21.1313 18.875V5.375C21.1313 4.07524 20.0313 3.025 18.6875 3.025H7.75Z'
        fill='black'
        stroke='white'
        strokeWidth='0.2'
      />
      <path
        d='M11.6562 12.875H17.9062C18.3381 12.875 18.6875 12.5392 18.6875 12.125C18.6875 11.7108 18.3381 11.375 17.9062 11.375H11.6562C11.2244 11.375 10.875 11.7108 10.875 12.125C10.875 12.5392 11.2244 12.875 11.6562 12.875Z'
        fill='black'
      />
      <path
        d='M11.6562 9.125H17.9062C18.3381 9.125 18.6875 8.78918 18.6875 8.375C18.6875 7.96082 18.3381 7.625 17.9062 7.625H11.6562C11.2244 7.625 10.875 7.96082 10.875 8.375C10.875 8.78918 11.2244 9.125 11.6562 9.125Z'
        fill='black'
      />
      <path
        d='M11.6562 16.625H17.9062C18.3381 16.625 18.6875 16.2892 18.6875 15.875C18.6875 15.4608 18.3381 15.125 17.9062 15.125H11.6562C11.2244 15.125 10.875 15.4608 10.875 15.875C10.875 16.2892 11.2244 16.625 11.6562 16.625Z'
        fill='black'
      />
      <path
        d='M8.54654 9.125C8.97836 9.125 9.32779 8.78918 9.32779 8.375C9.32779 7.96082 8.97836 7.625 8.54654 7.625H8.53891C8.10785 7.625 7.76147 7.96082 7.76147 8.375C7.76147 8.78918 8.11548 9.125 8.54654 9.125Z'
        fill='black'
      />
      <path
        d='M8.54654 12.875C8.97836 12.875 9.32779 12.5392 9.32779 12.125C9.32779 11.7108 8.97836 11.375 8.54654 11.375H8.53891C8.10785 11.375 7.76147 11.7108 7.76147 12.125C7.76147 12.5392 8.11548 12.875 8.54654 12.875Z'
        fill='black'
      />
      <path
        d='M8.54654 16.625C8.97836 16.625 9.32779 16.2892 9.32779 15.875C9.32779 15.4608 8.97836 15.125 8.54654 15.125H8.53891C8.10785 15.125 7.76147 15.4608 7.76147 15.875C7.76147 16.2892 8.11548 16.625 8.54654 16.625Z'
        fill='black'
      />
    </svg>
  )
}
export const IconFaq = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={21}
      viewBox='0 0 17 21'
      fill='none'
    >
      <path
        d='M16.5673 5.64962C16.5576 5.10965 16.5484 4.59955 16.5484 4.10606C16.5484 3.71945 16.2526 3.40601 15.8876 3.40601C13.0616 3.40601 10.9099 2.5456 9.11645 0.698219C8.85988 0.43388 8.4516 0.433974 8.19512 0.698219C6.40182 2.5456 4.25053 3.40601 1.42471 3.40601C1.05978 3.40601 0.76392 3.71945 0.76392 4.10606C0.76392 4.59964 0.754757 5.10993 0.744977 5.64999C0.654404 10.675 0.530352 17.5571 8.43935 20.4614C8.50949 20.4871 8.58261 20.5 8.65574 20.5C8.72887 20.5 8.80208 20.4871 8.87213 20.4614C16.7817 17.557 16.6579 10.6748 16.5673 5.64962ZM8.65583 19.0571C1.87282 16.4466 1.97538 10.7282 2.06639 5.67669C2.07185 5.37352 2.07714 5.07969 2.08084 4.79164C4.72754 4.67329 6.84402 3.82361 8.65583 2.15152C10.4678 3.82361 12.5846 4.67338 15.2315 4.79164C15.2352 5.07959 15.2405 5.37324 15.246 5.67622C15.3369 10.7279 15.4394 16.4465 8.65583 19.0571Z'
        fill='#010103'
      />
      <path
        d='M10.9308 8.06828L7.74141 11.4469L6.38044 10.0051C6.12238 9.73178 5.70396 9.73178 5.44599 10.0051C5.18793 10.2786 5.18793 10.7217 5.44599 10.9951L7.27419 12.9319C7.40317 13.0686 7.57234 13.1369 7.74141 13.1369C7.91049 13.1369 8.07965 13.0686 8.20864 12.9319L11.8651 9.05834C12.1233 8.78494 12.1233 8.34167 11.8652 8.06837C11.6072 7.79498 11.1888 7.79489 10.9308 8.06828Z'
        fill='#010103'
      />
    </svg>
  )
}
export const IconRate = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={18}
      viewBox='0 0 17 18'
      fill='none'
    >
      <g clipPath='url(#clip0_3639_8392)'>
        <path
          d='M15.1683 0.65H1.83172C0.766485 0.65 -0.1 1.51645 -0.1 2.58168V13.7844C-0.1 14.8497 0.766482 15.7161 1.83172 15.7161H6.11842L8.07707 17.6748C8.18922 17.787 8.34132 17.85 8.49997 17.85C8.65857 17.85 8.81068 17.787 8.92286 17.6748L10.8815 15.7161H15.1683C16.2335 15.7161 17.1 14.8497 17.1 13.7844V2.58168C17.1 1.51645 16.2335 0.65 15.1683 0.65ZM15.9039 13.7844C15.9039 14.1899 15.5738 14.52 15.1683 14.52H10.6338C10.4752 14.52 10.3231 14.583 10.211 14.6952C10.211 14.6952 10.211 14.6952 10.2109 14.6953L8.49997 16.4062L6.78903 14.6952C6.67688 14.5831 6.52478 14.52 6.36613 14.52H1.83172C1.42619 14.52 1.09609 14.1899 1.09609 13.7844V2.58168C1.09609 2.17616 1.42618 1.84609 1.83172 1.84609H15.1683C15.5738 1.84609 15.9039 2.17616 15.9039 2.58168V13.7844Z'
          fill='black'
          stroke='black'
          strokeWidth='0.2'
        />
        <path
          d='M3.77175 6.80224L3.77175 6.80224C3.83623 6.60381 4.00774 6.45923 4.21417 6.42924L6.83587 6.04819L8.00849 3.67247C8.10082 3.48541 8.29132 3.36699 8.49991 3.36699C8.70853 3.36699 8.89903 3.48541 8.99136 3.67244L10.1641 6.0482L12.7856 6.42924C12.9921 6.45923 13.1636 6.60381 13.228 6.80227C13.228 6.80227 13.228 6.80228 13.228 6.80228L3.77175 6.80224ZM3.77175 6.80224C3.7073 7.00064 3.76108 7.21843 3.91044 7.36402L3.91044 7.36403L5.80764 9.21325M3.77175 6.80224L5.80764 9.21325M5.80764 9.21325L5.35985 11.8244C5.32459 12.03 5.40911 12.2377 5.57786 12.3604L5.57788 12.3604C5.74666 12.483 5.97041 12.4992 6.15503 12.4021L6.13177 12.3579L6.15503 12.4021L8.49991 11.1693L10.845 12.4021L10.8683 12.3579L10.845 12.4021C10.9252 12.4442 11.0128 12.4651 11.1 12.4651H11.102H11.1022C11.4042 12.4643 11.6488 12.2192 11.6488 11.917C11.6488 11.8755 11.6441 11.835 11.6354 11.796L11.1922 9.21325L5.80764 9.21325ZM6.77906 8.62947C6.90823 8.75535 6.96715 8.93675 6.93668 9.11453L6.93668 9.11453L6.62789 10.9152L8.24489 10.0651L8.24489 10.0651C8.40455 9.98113 8.59527 9.98113 8.75494 10.0651L10.3721 10.9151L10.0631 9.11457C10.0326 8.93679 10.0915 8.75534 10.2207 8.62944L11.5291 7.35423L9.72134 7.09146C9.54282 7.06552 9.38856 6.95342 9.30873 6.79171L8.49995 5.15326L7.69126 6.79167C7.61143 6.95342 7.45714 7.06552 7.27866 7.09146L5.47076 7.35423L6.77906 8.62947ZM6.77906 8.62947L6.77906 8.62947L6.74416 8.66528L6.77906 8.62947Z'
          fill='black'
          stroke='black'
          strokeWidth='0.1'
        />
      </g>
      <defs>
        <clipPath id='clip0_3639_8392'>
          <rect
            width={17}
            height={17}
            fill='white'
            transform='translate(0 0.75)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconSetting = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={19}
      height={19}
      viewBox='0 0 19 19'
      fill='none'
    >
      <mask
        id='mask0_3639_8396'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={19}
        height={19}
      >
        <path d='M0 5.72205e-06H19V19H0V5.72205e-06Z' fill='white' />
      </mask>
      <g mask='url(#mask0_3639_8396)'>
        <path
          d='M11.2887 2.57098C11.9448 2.74031 12.5646 3.00026 13.1337 3.33684C13.1337 3.33684 13.4079 3.06257 13.7159 2.7546C13.9395 2.53075 14.2429 2.40521 14.5593 2.40521C14.8752 2.40521 15.1787 2.53075 15.4023 2.7546C15.6736 3.0259 15.9741 3.32638 16.2454 3.59768C16.4692 3.82127 16.5948 4.12475 16.5948 4.44074C16.5948 4.75706 16.4692 5.0605 16.2454 5.28408C15.9374 5.59205 15.6632 5.86629 15.6632 5.86629C15.9997 6.4354 16.2597 7.05516 16.429 7.71133H17.2509C17.9094 7.71133 18.4434 8.24526 18.4434 8.90377V10.0962C18.4434 10.7547 17.9094 11.2887 17.2509 11.2887H16.429C16.2597 11.9448 15.9997 12.5646 15.6632 13.1337C15.6632 13.1337 15.9374 13.408 16.2454 13.7159C16.4692 13.9395 16.5948 14.243 16.5948 14.5593C16.5948 14.8753 16.4692 15.1787 16.2454 15.4023C15.9741 15.6736 15.6736 15.9741 15.4023 16.2454C15.1787 16.4693 14.8752 16.5948 14.5593 16.5948C14.2429 16.5948 13.9395 16.4693 13.7159 16.2454C13.4079 15.9374 13.1337 15.6632 13.1337 15.6632C12.5646 15.9997 11.9448 16.2597 11.2887 16.429V17.2509C11.2887 17.9094 10.7547 18.4434 10.0962 18.4434H8.90376C8.24522 18.4434 7.71133 17.9094 7.71133 17.2509V16.429C7.0552 16.2597 6.4354 15.9997 5.86629 15.6632C5.86629 15.6632 5.59205 15.9374 5.28408 16.2454C5.06049 16.4693 4.75701 16.5948 4.44073 16.5948C4.12474 16.5948 3.82123 16.4693 3.59768 16.2454C3.32641 15.9741 3.0259 15.6736 2.75459 15.4023C2.53075 15.1787 2.40521 14.8753 2.40521 14.5593C2.40521 14.243 2.53075 13.9395 2.75459 13.7159C3.06256 13.408 3.33684 13.1337 3.33684 13.1337C3.00026 12.5646 2.74034 11.9448 2.57097 11.2887H1.74911C1.09057 11.2887 0.556641 10.7547 0.556641 10.0962V8.90377C0.556641 8.24526 1.09057 7.71133 1.74911 7.71133H2.57097C2.74034 7.05516 3.00026 6.4354 3.33684 5.86629C3.33684 5.86629 3.06256 5.59205 2.75459 5.28408C2.53075 5.0605 2.40521 4.75706 2.40521 4.44074C2.40521 4.12475 2.53075 3.82127 2.75459 3.59768C3.0259 3.32638 3.32641 3.0259 3.59768 2.7546C3.82123 2.53075 4.12474 2.40521 4.44073 2.40521C4.75701 2.40521 5.06049 2.53075 5.28408 2.7546C5.59205 3.06257 5.86629 3.33684 5.86629 3.33684C6.4354 3.00026 7.0552 2.74031 7.71133 2.57098V1.74908C7.71133 1.09054 8.24522 0.556646 8.90376 0.556646H10.0962C10.7547 0.556646 11.2887 1.09054 11.2887 1.74908V2.57098Z'
          stroke='black'
          strokeWidth='1.5'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.49995 5.92246C11.4744 5.92246 13.0773 7.5254 13.0773 9.49981C13.0773 11.4742 11.4744 13.0771 9.49995 13.0771C7.52555 13.0771 5.92261 11.4742 5.92261 9.49981C5.92261 7.5254 7.52555 5.92246 9.49995 5.92246Z'
          stroke='black'
          strokeWidth='1.5'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
export const IconHome = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 12.0003L16 2.66699L28 12.0003V26.667C28 27.3742 27.719 28.0525 27.219 28.5526C26.7189 29.0527 26.0406 29.3337 25.3333 29.3337H6.66667C5.95942 29.3337 5.28115 29.0527 4.78105 28.5526C4.28095 28.0525 4 27.3742 4 26.667V12.0003Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 29.3333V16H20V29.3333'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const LogoIcon = ({ width, height }: Props) => {
  return (
    <svg
      width={width || 74}
      height={height || 74}
      viewBox='0 0 72 72'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M36 72C55.8822 72 72 55.8822 72 36C72 16.1178 55.8822 0 36 0C16.1178 0 0 16.1178 0 36C0 55.8822 16.1178 72 36 72Z'
        fill='white'
        fillOpacity='0.5'
      />
      <path
        d='M36 69C54.2254 69 69 54.2254 69 36C69 17.7746 54.2254 3 36 3C17.7746 3 3 17.7746 3 36C3 54.2254 17.7746 69 36 69Z'
        fill='url(#paint0_radial_1_7220)'
      />
      <g clipPath='url(#clip0_1_7220)'>
        <path
          d='M10.8428 42C9.84708 42 9.04199 41.2242 9.04199 40.2738V32.8652C9.04199 31.9106 9.85131 31.1389 10.8428 31.1389C11.8344 31.1389 12.6437 31.9147 12.6437 32.8652V40.2738C12.6437 41.2283 11.8386 42 10.8428 42Z'
          fill='black'
        />
        <path
          d='M62.199 42C61.2033 42 60.3982 41.2242 60.3982 40.2738V36.472C60.3982 35.8871 60.1906 35.355 59.8092 34.9651C59.3558 34.502 58.8219 34.2746 58.1694 34.2746C57.5211 34.2746 56.9829 34.498 56.5295 34.9651C56.1482 35.355 55.9406 35.8871 55.9406 36.472V40.2738C55.9406 41.2283 55.1312 42 54.1397 42C53.144 42 52.3389 41.2242 52.3389 40.2738V29.7498C52.3389 28.7953 53.1482 28.0236 54.1397 28.0236C55.1355 28.0236 55.9406 28.7994 55.9406 29.7498V31.2283C56.627 30.9602 57.3728 30.8221 58.1694 30.8221C59.7753 30.8221 61.1651 31.3704 62.2965 32.459C63.4278 33.5435 64.0041 34.8757 64.0041 36.4151V40.2778C63.9999 41.2283 63.1906 42 62.199 42Z'
          fill='#231F20'
        />
        <path
          d='M45.2752 41.9066C43.6692 41.9066 42.2794 41.3583 41.1481 40.2697C40.0167 39.1852 39.4404 37.853 39.4404 36.3136C39.4404 34.7742 40.0125 33.4419 41.1481 32.3575C42.2794 31.273 43.6692 30.7206 45.2752 30.7206C46.8811 30.7206 48.2709 31.2689 49.4023 32.3575C50.5337 33.4419 51.1099 34.7742 51.1099 36.3136V40.3631C51.1099 40.6718 50.9531 41.1227 50.6481 41.3867C50.3048 41.6873 49.826 41.8538 49.3048 41.8538C48.7667 41.8538 48.2794 41.6792 47.9701 41.3745C47.9531 41.3583 47.9362 41.338 47.915 41.3177C47.1184 41.7076 46.2328 41.9066 45.2752 41.9066ZM45.2752 34.1812C44.6057 34.1812 44.0548 34.4208 43.593 34.9123C43.2709 35.2575 43.076 35.7043 43.0506 36.1633C43.0082 36.8741 43.2582 37.4509 43.8133 37.9261C44.1735 38.2348 44.6353 38.4216 45.1184 38.446C45.1692 38.4501 45.2243 38.4501 45.2752 38.4501C45.9447 38.4501 46.4955 38.2104 46.9574 37.7149C47.2794 37.3696 47.4743 36.9269 47.4998 36.4639C47.5421 35.7531 47.2921 35.1763 46.737 34.7011C46.3769 34.3924 45.915 34.2096 45.432 34.1812C45.3811 34.1812 45.326 34.1812 45.2752 34.1812Z'
          fill='#231F20'
        />
        <path
          d='M36.5218 41.9675C35.4456 41.9675 34.5684 41.1267 34.5684 40.0951V36.3664C34.5684 35.879 34.4074 35.4241 34.1151 35.0829C33.6362 34.5183 33.0515 34.2421 32.3396 34.2421C32.2676 34.2421 32.1913 34.2462 32.1151 34.2502C31.6744 34.2827 31.2422 34.4574 30.9032 34.7417C30.3693 35.1885 30.1108 35.7246 30.1108 36.3786V40.2088C30.1108 41.1795 29.2845 41.9716 28.2718 41.9716C27.2973 41.9716 26.5049 41.212 26.5049 40.2778V36.3826C26.5049 34.8432 27.0769 33.511 28.2083 32.4265C29.3396 31.342 30.7295 30.7896 32.3354 30.7896C33.9413 30.7896 35.3312 31.3379 36.4625 32.4265C37.5939 33.511 38.1659 34.8432 38.1659 36.3826V40.3916C38.1701 41.2567 37.4329 41.9675 36.5218 41.9675Z'
          fill='#231F20'
        />
        <path
          d='M24.2039 32.4549C23.0725 31.3704 21.6827 30.818 20.0767 30.818C19.3479 30.818 18.67 30.9318 18.0344 31.1592C17.2505 31.4395 16.3945 31.4679 15.6149 31.1673L13.1827 30.225C12.9623 30.1519 12.8564 30.2778 12.975 30.4728L14.1149 32.398C14.5513 33.1373 14.7123 34.0187 14.4666 34.8351C14.3183 35.3347 14.242 35.8586 14.242 36.4151C14.242 37.9545 14.814 39.2867 15.9496 40.3712C17.081 41.4557 18.4708 42.0081 20.0767 42.0081C21.6827 42.0081 23.0725 41.4598 24.2039 40.3712C25.3352 39.2867 25.9115 37.9545 25.9115 36.4151C25.9073 34.8716 25.3352 33.5394 24.2039 32.4549ZM21.653 37.922C21.2123 38.3444 20.6996 38.5475 20.0767 38.5475C19.4581 38.5475 18.9411 38.3444 18.5005 37.922C18.0598 37.4996 17.8479 37.0081 17.8479 36.411C17.8479 35.818 18.0598 35.3225 18.5005 34.9001C18.9411 34.4777 19.4539 34.2746 20.0767 34.2746C20.6954 34.2746 21.2123 34.4777 21.653 34.9001C22.0937 35.3225 22.3056 35.814 22.3056 36.411C22.3056 37.0041 22.0895 37.4996 21.653 37.922Z'
          fill='url(#paint1_radial_1_7220)'
        />
        <path
          d='M10.9449 27C10.4025 27 9.94492 27.1828 9.5678 27.5443C9.19068 27.9058 9 28.3444 9 28.8643C9 29.3802 9.19068 29.8229 9.5678 30.1844C9.94492 30.5459 10.4025 30.7287 10.9449 30.7287C11.4831 30.7287 11.9449 30.5459 12.322 30.1844C12.6992 29.8229 12.8898 29.3842 12.8898 28.8643C12.8898 28.3485 12.6992 27.9058 12.322 27.5443C11.9407 27.1828 11.4831 27 10.9449 27Z'
          fill='url(#paint2_radial_1_7220)'
        />
        <path
          d='M10.8428 42C9.84708 42 9.04199 41.2242 9.04199 40.2738V32.8652C9.04199 31.9106 9.85131 31.1389 10.8428 31.1389C11.8344 31.1389 12.6437 31.9147 12.6437 32.8652V40.2738C12.6437 41.2283 11.8386 42 10.8428 42Z'
          fill='white'
        />
        <path
          d='M62.199 42C61.2033 42 60.3982 41.2242 60.3982 40.2738V36.472C60.3982 35.8871 60.1906 35.355 59.8092 34.9651C59.3558 34.502 58.8219 34.2746 58.1694 34.2746C57.5211 34.2746 56.9829 34.498 56.5295 34.9651C56.1482 35.355 55.9406 35.8871 55.9406 36.472V40.2738C55.9406 41.2283 55.1312 42 54.1397 42C53.144 42 52.3389 41.2242 52.3389 40.2738V29.7498C52.3389 28.7953 53.1482 28.0236 54.1397 28.0236C55.1355 28.0236 55.9406 28.7994 55.9406 29.7498V31.2283C56.627 30.9602 57.3728 30.8221 58.1694 30.8221C59.7753 30.8221 61.1651 31.3704 62.2965 32.459C63.4278 33.5435 64.0041 34.8757 64.0041 36.4151V40.2778C63.9999 41.2283 63.1906 42 62.199 42Z'
          fill='white'
        />
        <path
          d='M45.2752 41.9066C43.6692 41.9066 42.2794 41.3583 41.1481 40.2697C40.0167 39.1852 39.4404 37.853 39.4404 36.3136C39.4404 34.7742 40.0125 33.4419 41.1481 32.3575C42.2794 31.273 43.6692 30.7206 45.2752 30.7206C46.8811 30.7206 48.2709 31.2689 49.4023 32.3575C50.5337 33.4419 51.1099 34.7742 51.1099 36.3136V40.3631C51.1099 40.6718 50.9531 41.1227 50.6481 41.3867C50.3048 41.6873 49.826 41.8538 49.3048 41.8538C48.7667 41.8538 48.2794 41.6792 47.9701 41.3745C47.9531 41.3583 47.9362 41.338 47.915 41.3177C47.1184 41.7076 46.2328 41.9066 45.2752 41.9066ZM45.2752 34.1812C44.6057 34.1812 44.0548 34.4208 43.593 34.9123C43.2709 35.2575 43.076 35.7043 43.0506 36.1633C43.0082 36.8741 43.2582 37.4509 43.8133 37.9261C44.1735 38.2348 44.6353 38.4216 45.1184 38.446C45.1692 38.4501 45.2243 38.4501 45.2752 38.4501C45.9447 38.4501 46.4955 38.2104 46.9574 37.7149C47.2794 37.3696 47.4743 36.9269 47.4998 36.4639C47.5421 35.7531 47.2921 35.1763 46.737 34.7011C46.3769 34.3924 45.915 34.2096 45.432 34.1812C45.3811 34.1812 45.326 34.1812 45.2752 34.1812Z'
          fill='white'
        />
        <path
          d='M36.5218 41.9675C35.4456 41.9675 34.5684 41.1267 34.5684 40.0951V36.3664C34.5684 35.879 34.4074 35.4241 34.1151 35.0829C33.6362 34.5183 33.0515 34.2421 32.3396 34.2421C32.2676 34.2421 32.1913 34.2462 32.1151 34.2502C31.6744 34.2827 31.2422 34.4574 30.9032 34.7417C30.3693 35.1885 30.1108 35.7246 30.1108 36.3786V40.2088C30.1108 41.1795 29.2845 41.9716 28.2718 41.9716C27.2973 41.9716 26.5049 41.212 26.5049 40.2778V36.3826C26.5049 34.8432 27.0769 33.511 28.2083 32.4265C29.3396 31.342 30.7295 30.7896 32.3354 30.7896C33.9413 30.7896 35.3312 31.3379 36.4625 32.4265C37.5939 33.511 38.1659 34.8432 38.1659 36.3826V40.3916C38.1701 41.2567 37.4329 41.9675 36.5218 41.9675Z'
          fill='white'
        />
        <path
          d='M24.2039 32.4549C23.0725 31.3704 21.6827 30.818 20.0767 30.818C19.3479 30.818 18.67 30.9318 18.0344 31.1592C17.2505 31.4395 16.3945 31.4679 15.6149 31.1673L13.1827 30.225C12.9623 30.1519 12.8564 30.2778 12.975 30.4728L14.1149 32.398C14.5513 33.1373 14.7123 34.0187 14.4666 34.8351C14.3183 35.3347 14.242 35.8586 14.242 36.4151C14.242 37.9545 14.814 39.2867 15.9496 40.3712C17.081 41.4557 18.4708 42.0081 20.0767 42.0081C21.6827 42.0081 23.0725 41.4598 24.2039 40.3712C25.3352 39.2867 25.9115 37.9545 25.9115 36.4151C25.9073 34.8716 25.3352 33.5394 24.2039 32.4549ZM21.653 37.922C21.2123 38.3444 20.6996 38.5475 20.0767 38.5475C19.4581 38.5475 18.9411 38.3444 18.5005 37.922C18.0598 37.4996 17.8479 37.0081 17.8479 36.411C17.8479 35.818 18.0598 35.3225 18.5005 34.9001C18.9411 34.4777 19.4539 34.2746 20.0767 34.2746C20.6954 34.2746 21.2123 34.4777 21.653 34.9001C22.0937 35.3225 22.3056 35.814 22.3056 36.411C22.3056 37.0041 22.0895 37.4996 21.653 37.922Z'
          fill='url(#paint3_radial_1_7220)'
        />
      </g>
      <defs>
        <radialGradient
          id='paint0_radial_1_7220'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(69 8.3625) rotate(179.436) scale(83.7416 88.3073)'
        >
          <stop stopColor='#00E9A1' />
          <stop offset='0.3945' stopColor='#00ADA4' />
          <stop offset='0.3946' stopColor='#00AEA3' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8252' stopColor='#0749EF' />
          <stop offset='0.9391' stopColor='#182ECB' />
          <stop offset={1} stopColor='#1E24BD' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_1_7220'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(10.586 28.1707) scale(21.6586 20.7613)'
        >
          <stop stopColor='#004C93' />
          <stop offset='0.068' stopColor='#008398' />
          <stop offset='0.1316' stopColor='#00AF9C' />
          <stop offset='0.1882' stopColor='#00CF9F' />
          <stop offset='0.2359' stopColor='#00E2A0' />
          <stop offset='0.2688' stopColor='#00E9A1' />
          <stop offset='0.6341' stopColor='#00AE89' />
          <stop offset={1} stopColor='#1E248F' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_1_7220'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(10.6537 28.0963) rotate(12.4789) scale(2.63939 2.53371)'
        >
          <stop stopColor='#EAFCF4' />
          <stop offset='0.328125' stopColor='#B0F3D8' />
          <stop offset='0.963542' stopColor='#85D8CB' />
        </radialGradient>
        <radialGradient
          id='paint3_radial_1_7220'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(10.586 28.1707) scale(21.6586 20.7613)'
        >
          <stop stopColor='#E4F9F0' />
          <stop offset='0.338542' stopColor='#C0F5E1' />
          <stop offset='0.979167' stopColor='#6ECDC3' />
        </radialGradient>
        <clipPath id='clip0_1_7220'>
          <rect
            width={55}
            height={15}
            fill='white'
            transform='translate(9 27)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LogoIconF = () => {
  return (
    <svg
      width='120'
      height='120'
      viewBox='0 0 66 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M33 66C51.2254 66 66 51.2254 66 33C66 14.7746 51.2254 0 33 0C14.7746 0 0 14.7746 0 33C0 51.2254 14.7746 66 33 66Z'
        fill='url(#paint0_linear_238_13755)'
      />
      <g clipPath='url(#clip0_238_13755)'>
        <path
          d='M14.7377 20.4044C15.0577 21.3111 14.5791 22.3042 13.6738 22.6224C12.7646 22.9419 11.7727 22.4653 11.4514 21.5587C11.1327 20.652 11.61 19.6602 12.5179 19.3407C13.4258 19.0212 14.4191 19.4965 14.7377 20.4044Z'
          fill='white'
        />
        <path
          d='M23.4689 17.1847C22.7223 16.7521 19.1186 14.6659 18.108 14.0868C17.932 13.9696 17.8747 14.1946 17.988 14.2825C20.1772 15.8907 21.753 18.6426 21.3277 22.0973C20.9211 25.399 18.4773 27.9311 15.9455 28.7872C13.6964 29.5474 12.7938 29.795 12.3992 29.9148C12.7058 30.7921 13.3778 33.0927 11.9886 35.6833C11.166 37.2184 9.43946 38.7121 7.30099 39.1528C7.213 39.1714 7.11035 39.1981 7.193 39.2421C7.29166 39.298 10.8047 41.3215 10.8047 41.3215C12.2352 42.1469 14.7163 41.8221 16.1802 40.9941C16.9721 40.5454 17.5534 40.0023 18.2067 39.2567C19.3999 37.896 19.7999 35.8418 19.6239 34.0712C20.2465 33.8288 23.2422 32.8678 24.6087 31.8345C25.8514 30.8946 27.5298 29.132 27.9311 25.825C28.407 21.9029 26.2859 18.8169 23.4689 17.1847Z'
          fill='white'
        />
        <path
          d='M28.0193 47.3059C28.0193 47.744 28.2939 48.0142 28.7005 48.0142H29.947C30.0831 48.0142 30.1017 48.0727 30.1017 48.1499V48.616C30.1017 48.7117 30.0831 48.7596 29.9271 48.7596C29.6552 48.7596 28.8658 48.7596 27.0367 48.7596C25.3249 48.7596 23.7703 48.7596 23.557 48.7596C23.4224 48.7596 23.3877 48.7104 23.3877 48.6346V48.1499C23.3877 48.05 23.4224 48.0142 23.5184 48.0142H24.3557C25.0422 48.0155 25.2648 47.7825 25.2648 47.3059C25.2648 47.1102 25.2648 36.4423 25.2648 36.2213C25.2648 35.8299 25.0223 35.6648 24.4969 35.6648H23.5077C23.4104 35.6648 23.3877 35.6262 23.3877 35.5104V35.0378C23.3877 34.9406 23.4037 34.9141 23.501 34.9141C23.7143 34.9141 24.4982 34.9141 26.3474 34.9141C26.6967 34.9141 28.154 34.9141 28.7965 34.9141C30.995 34.9141 32.0723 35.1149 33.1814 35.8725C34.0947 36.4942 34.6587 37.582 34.6587 38.6896C34.6587 41.1379 32.4203 42.6796 29.5791 42.6796C28.8578 42.6796 28.6419 42.6303 28.0193 42.5517C28.0193 42.5517 28.0193 47.033 28.0193 47.3059ZM28.0193 41.8036C28.2859 41.8807 28.6832 42.0592 29.2472 42.0592C30.1658 42.0592 30.867 41.5972 31.4256 40.7105C31.8017 40.1115 31.9763 39.4286 31.9763 38.7481C31.9763 36.2028 30.2165 35.5223 29.0685 35.5223C28.7379 35.5223 28.41 35.5223 28.0193 35.6595V41.8036Z'
          fill='white'
        />
        <path
          d='M34.9573 43.5693C34.9573 42.9328 35.0226 42.5029 34.3825 42.419C34.2453 42.4017 34.2079 42.3591 34.2079 42.2819V42.1074C34.2079 42.0489 34.248 42.0144 34.3427 41.9718C35.2025 41.5936 36.1277 41.0317 36.8957 40.4167C37.0317 40.3088 37.1076 40.281 37.2224 40.3009C37.2996 40.3155 37.3383 40.3808 37.3383 40.486C37.3383 40.8227 37.3383 47.0905 37.3383 47.305C37.3383 47.775 37.581 48.0118 37.8983 48.0158H38.5488C38.7035 48.0118 38.7435 48.0651 38.7435 48.1823V48.5776C38.7435 48.7135 38.7048 48.7627 38.5689 48.7627C38.4143 48.7627 37.2357 48.7627 36.4171 48.7627C35.2892 48.7627 33.8533 48.7627 33.64 48.7627C33.5427 48.7627 33.4854 48.7334 33.4854 48.6163V48.1623C33.4854 48.0452 33.5427 48.0078 33.68 48.0145H34.4212C34.7385 48.0118 34.9573 47.7803 34.9573 47.3024C34.9573 46.7165 34.9573 43.5693 34.9573 43.5693Z'
          fill='white'
        />
        <path
          d='M40.9234 44.0414C40.9207 45.0839 41.282 46.3033 41.7913 46.9358C42.4965 47.8131 43.2044 47.9808 43.8604 47.9808C44.5843 47.9808 45.0764 47.4057 45.5308 46.8598C45.5656 46.8185 45.6282 46.8026 45.6868 46.8598L46.1014 47.2765C46.1788 47.3538 46.1988 47.411 46.1014 47.5268C45.5416 48.1633 44.3563 48.8542 42.9911 48.8502C41.9659 48.8475 40.4446 48.6399 39.5554 47.5215C38.8395 46.5763 38.6543 45.9653 38.6036 45.0985C38.4182 41.9273 40.8833 40.4336 43.2604 40.4336C45.2695 40.4336 45.8881 41.5453 45.8881 41.9499C45.8695 42.3946 45.5788 42.6263 45.1735 42.6263C44.7283 42.6263 44.4003 42.3747 44.1097 41.8542C43.6843 41.0633 43.2792 40.9954 42.8151 40.9954C41.7152 40.9941 40.93 41.8714 40.9234 44.0414Z'
          fill='white'
        />
        <path
          d='M47.4148 47.5552C46.5256 46.4927 46.3389 45.8417 46.3097 44.4719C46.2869 43.4001 46.9203 42.1872 48.0615 41.298C49.0667 40.5258 50.5412 40.4459 51.1784 40.4326C52.3344 40.4087 53.769 40.8307 54.4783 41.5269C55.4088 42.4402 55.8195 43.3855 55.8195 44.6396C55.8195 46.7444 53.6743 48.7999 50.9265 48.8492C49.9985 48.8651 48.2268 48.5204 47.4148 47.5552ZM53.3743 44.4146C53.3743 42.2898 52.0092 40.9971 51.0225 40.9971C50.5012 40.9971 49.972 41.089 49.5333 41.6095C48.9573 42.2937 48.7268 43.468 48.7788 44.5691C48.8294 45.6501 49.0348 46.5526 49.512 47.2024C49.9693 47.8254 50.4279 48.2155 51.2519 48.1981C52.7196 48.1663 53.3743 46.4636 53.3743 44.4146Z'
          fill='white'
        />
        <path
          d='M56.1726 48.7614C55.9418 48.7614 55.7458 48.6802 55.5872 48.5232C55.4285 48.3634 55.3486 48.1677 55.3486 47.9373C55.3486 47.7031 55.4259 47.5073 55.5845 47.3516C55.7418 47.1932 55.9365 47.1172 56.1739 47.1172C56.4044 47.1172 56.6005 47.1958 56.7578 47.3569C56.9164 47.5166 56.9965 47.7084 56.9965 47.9373C56.9965 48.165 56.9164 48.3581 56.7578 48.5192C56.6018 48.6802 56.4058 48.7614 56.1726 48.7614ZM55.4858 47.9386C55.4858 48.1304 55.5511 48.2914 55.6832 48.4246C55.8152 48.5592 55.9792 48.627 56.1752 48.627C56.3644 48.627 56.5257 48.5605 56.6591 48.4299C56.7938 48.2981 56.8618 48.1343 56.8618 47.9399C56.8618 47.7669 56.7965 47.6072 56.6711 47.4674C56.5432 47.325 56.3765 47.2557 56.1726 47.2557C55.9819 47.2557 55.8192 47.3209 55.6872 47.4554C55.5526 47.586 55.4858 47.7497 55.4858 47.9386Z'
          fill='white'
        />
        <path
          d='M55.8164 47.4971H56.2151C56.2805 47.4971 56.3352 47.5065 56.3777 47.5278C56.4604 47.5638 56.5005 47.6342 56.5005 47.7368C56.5005 47.7887 56.4885 47.8313 56.4671 47.8673C56.4458 47.8992 56.4137 47.9259 56.375 47.9471C56.4111 47.9604 56.4352 47.9778 56.4538 48.003C56.4697 48.0231 56.4817 48.0615 56.4843 48.1148L56.4872 48.2321C56.4872 48.2679 56.4912 48.2933 56.4965 48.3092C56.5031 48.3359 56.5164 48.3545 56.535 48.3611V48.3825H56.3872C56.3845 48.3744 56.3804 48.3638 56.3777 48.3505C56.375 48.3386 56.3737 48.3145 56.3724 48.2813L56.3644 48.1322C56.3618 48.0737 56.3405 48.0377 56.3018 48.0178C56.2805 48.007 56.2445 48.003 56.1978 48.003H55.9352V48.3825H55.8164V47.4971ZM56.2018 47.9005C56.2564 47.9005 56.2991 47.8899 56.3297 47.8673C56.3631 47.8446 56.3777 47.8046 56.3777 47.7487C56.3777 47.6835 56.3551 47.6422 56.3111 47.6183C56.2872 47.609 56.2551 47.6022 56.2177 47.6022H55.9352V47.9005H56.2018Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_238_13755'
          x1='66'
          y1='62'
          x2='5.70083e-08'
          y2='4.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF0000' />
          <stop offset='1' stopColor='#BA0000' />
        </linearGradient>
        <clipPath id='clip0_238_13755'>
          <rect
            width='50'
            height='35'
            fill='white'
            transform='translate(7 14)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const HomePurple = () => {
  return (
    <svg
      width={67}
      height={66}
      viewBox='0 0 67 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M33.9746 66C52.2 66 66.9746 51.2254 66.9746 33C66.9746 14.7746 52.2 0 33.9746 0C15.7492 0 0.974609 14.7746 0.974609 33C0.974609 51.2254 15.7492 66 33.9746 66Z'
        fill='url(#paint0_radial_2878_11293)'
      />
      <g clipPath='url(#clip0_2878_11293)'>
        <path
          d='M8.81745 36C7.82169 36 7.0166 35.2242 7.0166 34.2738V26.8652C7.0166 25.9106 7.82592 25.1389 8.81745 25.1389C9.80897 25.1389 10.6183 25.9147 10.6183 26.8652V34.2738C10.6183 35.2283 9.81321 36 8.81745 36Z'
          fill='black'
        />
        <path
          d='M60.1736 36C59.1779 36 58.3728 35.2242 58.3728 34.2738V30.472C58.3728 29.8871 58.1652 29.355 57.7838 28.9651C57.3304 28.502 56.7965 28.2746 56.144 28.2746C55.4957 28.2746 54.9575 28.498 54.5042 28.9651C54.1228 29.355 53.9152 29.8871 53.9152 30.472V34.2738C53.9152 35.2283 53.1058 36 52.1143 36C51.1186 36 50.3135 35.2242 50.3135 34.2738V23.7498C50.3135 22.7953 51.1228 22.0236 52.1143 22.0236C53.1101 22.0236 53.9152 22.7994 53.9152 23.7498V25.2283C54.6016 24.9602 55.3474 24.8221 56.144 24.8221C57.7499 24.8221 59.1397 25.3704 60.2711 26.459C61.4025 27.5435 61.9787 28.8757 61.9787 30.4151V34.2778C61.9745 35.2283 61.1652 36 60.1736 36Z'
          fill='#231F20'
        />
        <path
          d='M43.2498 35.9066C41.6439 35.9066 40.254 35.3582 39.1227 34.2697C37.9913 33.1852 37.415 31.853 37.415 30.3136C37.415 28.7742 37.9871 27.4419 39.1227 26.3574C40.254 25.2729 41.6439 24.7206 43.2498 24.7206C44.8557 24.7206 46.2456 25.2689 47.3769 26.3574C48.5083 27.4419 49.0845 28.7742 49.0845 30.3136V34.3631C49.0845 34.6718 48.9278 35.1227 48.6227 35.3867C48.2795 35.6872 47.8006 35.8538 47.2795 35.8538C46.7413 35.8538 46.254 35.6791 45.9447 35.3745C45.9278 35.3582 45.9108 35.3379 45.8896 35.3176C45.093 35.7076 44.2074 35.9066 43.2498 35.9066ZM43.2498 28.1812C42.5803 28.1812 42.0294 28.4208 41.5676 28.9123C41.2455 29.2575 41.0506 29.7043 41.0252 30.1633C40.9828 30.8741 41.2328 31.4509 41.7879 31.9261C42.1481 32.2348 42.61 32.4216 43.093 32.446C43.1439 32.45 43.1989 32.45 43.2498 32.45C43.9193 32.45 44.4701 32.2104 44.932 31.7149C45.254 31.3696 45.4489 30.9269 45.4744 30.4638C45.5167 29.753 45.2667 29.1763 44.7117 28.7011C44.3515 28.3924 43.8896 28.2096 43.4066 28.1812C43.3557 28.1812 43.3006 28.1812 43.2498 28.1812Z'
          fill='#231F20'
        />
        <path
          d='M34.4964 35.9675C33.4202 35.9675 32.5431 35.1267 32.5431 34.095V30.3664C32.5431 29.879 32.382 29.424 32.0897 29.0829C31.6109 28.5183 31.0261 28.2421 30.3142 28.2421C30.2422 28.2421 30.1659 28.2461 30.0897 28.2502C29.649 28.2827 29.2168 28.4573 28.8778 28.7417C28.3439 29.1885 28.0854 29.7246 28.0854 30.3785V34.2088C28.0854 35.1795 27.2592 35.9716 26.2464 35.9716C25.2719 35.9716 24.4795 35.212 24.4795 34.2778V30.3826C24.4795 28.8432 25.0515 27.511 26.1829 26.4265C27.3142 25.342 28.7041 24.7896 30.31 24.7896C31.9159 24.7896 33.3058 25.3379 34.4371 26.4265C35.5685 27.511 36.1405 28.8432 36.1405 30.3826V34.3915C36.1448 35.2567 35.4075 35.9675 34.4964 35.9675Z'
          fill='#231F20'
        />
        <path
          d='M22.1785 26.4549C21.0471 25.3704 19.6573 24.818 18.0514 24.818C17.3225 24.818 16.6446 24.9318 16.009 25.1592C15.2251 25.4395 14.3691 25.4679 13.5895 25.1673L11.1573 24.225C10.9369 24.1519 10.831 24.2778 10.9497 24.4728L12.0895 26.3981C12.5259 27.1373 12.6869 28.0187 12.4412 28.8351C12.2929 29.3347 12.2166 29.8587 12.2166 30.4151C12.2166 31.9545 12.7886 33.2868 13.9242 34.3712C15.0556 35.4557 16.4454 36.0081 18.0514 36.0081C19.6573 36.0081 21.0471 35.4598 22.1785 34.3712C23.3098 33.2868 23.8861 31.9545 23.8861 30.4151C23.8819 28.8717 23.3098 27.5394 22.1785 26.4549ZM19.6276 31.922C19.1869 32.3444 18.6742 32.5475 18.0514 32.5475C17.4327 32.5475 16.9158 32.3444 16.4751 31.922C16.0344 31.4996 15.8225 31.0081 15.8225 30.4111C15.8225 29.818 16.0344 29.3225 16.4751 28.9001C16.9158 28.4777 17.4285 28.2746 18.0514 28.2746C18.67 28.2746 19.1869 28.4777 19.6276 28.9001C20.0683 29.3225 20.2802 29.814 20.2802 30.4111C20.2802 31.0041 20.0641 31.4996 19.6276 31.922Z'
          fill='url(#paint1_radial_2878_11293)'
        />
        <path
          d='M8.91952 21C8.37715 21 7.91952 21.1828 7.54241 21.5443C7.16529 21.9058 6.97461 22.3444 6.97461 22.8643C6.97461 23.3802 7.16529 23.8229 7.54241 24.1844C7.91952 24.5459 8.37715 24.7287 8.91952 24.7287C9.45766 24.7287 9.91952 24.5459 10.2966 24.1844C10.6738 23.8229 10.8644 23.3842 10.8644 22.8643C10.8644 22.3485 10.6738 21.9058 10.2966 21.5443C9.91529 21.1828 9.45766 21 8.91952 21Z'
          fill='url(#paint2_radial_2878_11293)'
        />
        <path
          d='M8.81745 36C7.82169 36 7.0166 35.2242 7.0166 34.2738V26.8652C7.0166 25.9106 7.82592 25.1389 8.81745 25.1389C9.80897 25.1389 10.6183 25.9147 10.6183 26.8652V34.2738C10.6183 35.2283 9.81321 36 8.81745 36Z'
          fill='white'
        />
        <path
          d='M60.1736 36C59.1779 36 58.3728 35.2242 58.3728 34.2738V30.472C58.3728 29.8871 58.1652 29.355 57.7838 28.9651C57.3304 28.502 56.7965 28.2746 56.144 28.2746C55.4957 28.2746 54.9575 28.498 54.5042 28.9651C54.1228 29.355 53.9152 29.8871 53.9152 30.472V34.2738C53.9152 35.2283 53.1058 36 52.1143 36C51.1186 36 50.3135 35.2242 50.3135 34.2738V23.7498C50.3135 22.7953 51.1228 22.0236 52.1143 22.0236C53.1101 22.0236 53.9152 22.7994 53.9152 23.7498V25.2283C54.6016 24.9602 55.3474 24.8221 56.144 24.8221C57.7499 24.8221 59.1397 25.3704 60.2711 26.459C61.4025 27.5435 61.9787 28.8757 61.9787 30.4151V34.2778C61.9745 35.2283 61.1652 36 60.1736 36Z'
          fill='white'
        />
        <path
          d='M43.2498 35.9066C41.6439 35.9066 40.254 35.3582 39.1227 34.2697C37.9913 33.1852 37.415 31.853 37.415 30.3136C37.415 28.7742 37.9871 27.4419 39.1227 26.3574C40.254 25.2729 41.6439 24.7206 43.2498 24.7206C44.8557 24.7206 46.2456 25.2689 47.3769 26.3574C48.5083 27.4419 49.0845 28.7742 49.0845 30.3136V34.3631C49.0845 34.6718 48.9278 35.1227 48.6227 35.3867C48.2795 35.6872 47.8006 35.8538 47.2795 35.8538C46.7413 35.8538 46.254 35.6791 45.9447 35.3745C45.9278 35.3582 45.9108 35.3379 45.8896 35.3176C45.093 35.7076 44.2074 35.9066 43.2498 35.9066ZM43.2498 28.1812C42.5803 28.1812 42.0294 28.4208 41.5676 28.9123C41.2455 29.2575 41.0506 29.7043 41.0252 30.1633C40.9828 30.8741 41.2328 31.4509 41.7879 31.9261C42.1481 32.2348 42.61 32.4216 43.093 32.446C43.1439 32.45 43.1989 32.45 43.2498 32.45C43.9193 32.45 44.4701 32.2104 44.932 31.7149C45.254 31.3696 45.4489 30.9269 45.4744 30.4638C45.5167 29.753 45.2667 29.1763 44.7117 28.7011C44.3515 28.3924 43.8896 28.2096 43.4066 28.1812C43.3557 28.1812 43.3006 28.1812 43.2498 28.1812Z'
          fill='white'
        />
        <path
          d='M34.4964 35.9675C33.4202 35.9675 32.5431 35.1267 32.5431 34.095V30.3664C32.5431 29.879 32.382 29.424 32.0897 29.0829C31.6109 28.5183 31.0261 28.2421 30.3142 28.2421C30.2422 28.2421 30.1659 28.2461 30.0897 28.2502C29.649 28.2827 29.2168 28.4573 28.8778 28.7417C28.3439 29.1885 28.0854 29.7246 28.0854 30.3785V34.2088C28.0854 35.1795 27.2592 35.9716 26.2464 35.9716C25.2719 35.9716 24.4795 35.212 24.4795 34.2778V30.3826C24.4795 28.8432 25.0515 27.511 26.1829 26.4265C27.3142 25.342 28.7041 24.7896 30.31 24.7896C31.9159 24.7896 33.3058 25.3379 34.4371 26.4265C35.5685 27.511 36.1405 28.8432 36.1405 30.3826V34.3915C36.1448 35.2567 35.4075 35.9675 34.4964 35.9675Z'
          fill='white'
        />
        <path
          d='M22.1785 26.4549C21.0471 25.3704 19.6573 24.818 18.0514 24.818C17.3225 24.818 16.6446 24.9318 16.009 25.1592C15.2251 25.4395 14.3691 25.4679 13.5895 25.1673L11.1573 24.225C10.9369 24.1519 10.831 24.2778 10.9497 24.4728L12.0895 26.3981C12.5259 27.1373 12.6869 28.0187 12.4412 28.8351C12.2929 29.3347 12.2166 29.8587 12.2166 30.4151C12.2166 31.9545 12.7886 33.2868 13.9242 34.3712C15.0556 35.4557 16.4454 36.0081 18.0514 36.0081C19.6573 36.0081 21.0471 35.4598 22.1785 34.3712C23.3098 33.2868 23.8861 31.9545 23.8861 30.4151C23.8819 28.8717 23.3098 27.5394 22.1785 26.4549ZM19.6276 31.922C19.1869 32.3444 18.6742 32.5475 18.0514 32.5475C17.4327 32.5475 16.9158 32.3444 16.4751 31.922C16.0344 31.4996 15.8225 31.0081 15.8225 30.4111C15.8225 29.818 16.0344 29.3225 16.4751 28.9001C16.9158 28.4777 17.4285 28.2746 18.0514 28.2746C18.67 28.2746 19.1869 28.4777 19.6276 28.9001C20.0683 29.3225 20.2802 29.814 20.2802 30.4111C20.2802 31.0041 20.0641 31.4996 19.6276 31.922Z'
          fill='url(#paint3_radial_2878_11293)'
        />
      </g>
      <path
        d='M8.26861 38.89H9.66161C10.0909 38.89 10.4736 38.9553 10.8096 39.086C11.1456 39.2167 11.4279 39.3963 11.6566 39.625C11.8899 39.8537 12.0649 40.1243 12.1816 40.437C12.3029 40.745 12.3636 41.081 12.3636 41.445C12.3636 41.809 12.2983 42.1473 12.1676 42.46C12.0369 42.7727 11.8526 43.0433 11.6146 43.272C11.3813 43.496 11.1013 43.6733 10.7746 43.804C10.4479 43.9347 10.0909 44 9.70361 44H8.26861V38.89ZM9.22061 39.772V43.118H9.59161C9.87161 43.118 10.1236 43.076 10.3476 42.992C10.5716 42.908 10.7606 42.7913 10.9146 42.642C11.0733 42.488 11.1946 42.3107 11.2786 42.11C11.3673 41.9047 11.4116 41.683 11.4116 41.445C11.4116 41.1977 11.3743 40.9737 11.2996 40.773C11.2249 40.5677 11.1106 40.3903 10.9566 40.241C10.8026 40.0917 10.6089 39.9773 10.3756 39.898C10.1423 39.814 9.86694 39.772 9.54961 39.772H9.22061ZM15.697 44.07C15.333 44.07 14.9924 44.0023 14.675 43.867C14.3577 43.727 14.08 43.5403 13.842 43.307C13.6087 43.069 13.4244 42.7913 13.289 42.474C13.1537 42.152 13.086 41.809 13.086 41.445C13.086 41.081 13.1537 40.7403 13.289 40.423C13.4244 40.1057 13.6087 39.828 13.842 39.59C14.08 39.352 14.3577 39.1653 14.675 39.03C14.9924 38.89 15.333 38.82 15.697 38.82C16.061 38.82 16.4017 38.89 16.719 39.03C17.0364 39.1653 17.314 39.352 17.552 39.59C17.79 39.828 17.9767 40.1057 18.112 40.423C18.2474 40.7403 18.315 41.081 18.315 41.445C18.315 41.809 18.2474 42.152 18.112 42.474C17.9767 42.7913 17.79 43.069 17.552 43.307C17.314 43.5403 17.0364 43.727 16.719 43.867C16.4017 44.0023 16.061 44.07 15.697 44.07ZM15.697 43.132C15.9304 43.132 16.1474 43.0877 16.348 42.999C16.5534 42.9103 16.7307 42.7913 16.88 42.642C17.034 42.488 17.153 42.3083 17.237 42.103C17.3257 41.8977 17.37 41.6783 17.37 41.445C17.37 41.2117 17.3257 40.9923 17.237 40.787C17.153 40.5817 17.034 40.4043 16.88 40.255C16.7307 40.101 16.5534 39.9797 16.348 39.891C16.1474 39.8023 15.9304 39.758 15.697 39.758C15.4637 39.758 15.2444 39.8023 15.039 39.891C14.8384 39.9797 14.6634 40.101 14.514 40.255C14.3647 40.4043 14.2457 40.5817 14.157 40.787C14.073 40.9923 14.031 41.2117 14.031 41.445C14.031 41.6783 14.073 41.8977 14.157 42.103C14.2457 42.3083 14.3647 42.488 14.514 42.642C14.6634 42.7913 14.8384 42.9103 15.039 42.999C15.2444 43.0877 15.4637 43.132 15.697 43.132ZM20.4229 38.89H21.3819L23.2019 44H22.2079L21.8929 43.09H19.9119L19.5969 44H18.6029L20.4229 38.89ZM20.2339 42.18H21.5779L20.9059 40.241L20.2339 42.18ZM23.9475 38.89H25.0255L27.2375 42.369V38.89H28.1895V44H27.1745L24.8995 40.409V44H23.9475V38.89ZM32.0425 41.893H30.0825V44H29.1305V38.89H30.0825V40.983H32.0425V38.89H32.9945V44H32.0425V41.893ZM35.9965 38.89H37.0745L39.2865 42.369V38.89H40.2385V44H39.2235L36.9485 40.409V44H35.9965V38.89ZM43.6925 44.07C43.2959 44.07 42.9342 44 42.6075 43.86C42.2809 43.72 42.0009 43.531 41.7675 43.293C41.5342 43.0503 41.3545 42.7703 41.2285 42.453C41.1025 42.1357 41.0395 41.7997 41.0395 41.445C41.0395 41.081 41.1049 40.7403 41.2355 40.423C41.3662 40.101 41.5459 39.8233 41.7745 39.59C42.0079 39.352 42.2832 39.1653 42.6005 39.03C42.9225 38.89 43.2725 38.82 43.6505 38.82C43.9165 38.82 44.1662 38.8527 44.3995 38.918C44.6329 38.9787 44.8475 39.0673 45.0435 39.184C45.2442 39.3007 45.4215 39.4407 45.5755 39.604C45.7342 39.7627 45.8672 39.9377 45.9745 40.129L45.1345 40.633C44.9759 40.339 44.7729 40.1173 44.5255 39.968C44.2829 39.8187 43.9935 39.744 43.6575 39.744C43.4195 39.744 43.1979 39.7907 42.9925 39.884C42.7919 39.9727 42.6145 40.094 42.4605 40.248C42.3112 40.402 42.1945 40.5817 42.1105 40.787C42.0265 40.9923 41.9845 41.2117 41.9845 41.445C41.9845 41.683 42.0265 41.9047 42.1105 42.11C42.1945 42.3153 42.3112 42.495 42.4605 42.649C42.6145 42.803 42.7965 42.9243 43.0065 43.013C43.2165 43.1017 43.4452 43.146 43.6925 43.146C44.0752 43.146 44.3925 43.0457 44.6445 42.845C44.9012 42.6443 45.0762 42.376 45.1695 42.04H43.5385V41.13H46.1915V41.508C46.1915 41.8533 46.1332 42.1823 46.0165 42.495C45.8999 42.803 45.7319 43.0737 45.5125 43.307C45.2979 43.5403 45.0365 43.727 44.7285 43.867C44.4205 44.0023 44.0752 44.07 43.6925 44.07ZM49.9035 41.893H47.9435V44H46.9915V38.89H47.9435V40.983H49.9035V38.89H50.8555V44H49.9035V41.893ZM51.8267 38.89H52.7787V44H51.8267V38.89ZM53.7549 38.89H56.7859V39.8H54.7069V40.976H56.7859V41.886H54.7069V43.09H56.7859V44H53.7549V38.89ZM54.9729 37.35H55.5609L56.3939 38.54H55.6799L55.2669 37.917L54.8539 38.54H54.1399L54.9729 37.35ZM54.6789 45.19C54.6789 45.0127 54.7326 44.868 54.8399 44.756C54.9473 44.6487 55.0919 44.595 55.2739 44.595C55.4606 44.595 55.6053 44.6487 55.7079 44.756C55.8153 44.868 55.8689 45.0127 55.8689 45.19C55.8689 45.3673 55.8153 45.5097 55.7079 45.617C55.6053 45.7243 55.4606 45.778 55.2739 45.778C55.0826 45.778 54.9356 45.7243 54.8329 45.617C54.7303 45.5097 54.6789 45.3673 54.6789 45.19ZM57.6665 38.89H59.4165C59.6825 38.89 59.9275 38.939 60.1515 39.037C60.3755 39.1303 60.5691 39.2587 60.7325 39.422C60.8958 39.5853 61.0241 39.779 61.1175 40.003C61.2108 40.2223 61.2575 40.458 61.2575 40.71C61.2575 40.962 61.2108 41.2 61.1175 41.424C61.0241 41.648 60.8958 41.8417 60.7325 42.005C60.5691 42.1683 60.3731 42.299 60.1445 42.397C59.9205 42.4903 59.6755 42.537 59.4095 42.537H58.6185V44H57.6665V38.89ZM58.6185 39.772V41.655H59.3465C59.4865 41.655 59.6148 41.6317 59.7315 41.585C59.8481 41.5337 59.9485 41.466 60.0325 41.382C60.1165 41.2933 60.1818 41.193 60.2285 41.081C60.2751 40.9643 60.2985 40.8407 60.2985 40.71C60.2985 40.5793 60.2751 40.458 60.2285 40.346C60.1818 40.2293 60.1165 40.129 60.0325 40.045C59.9485 39.961 59.8481 39.8957 59.7315 39.849C59.6148 39.7977 59.4865 39.772 59.3465 39.772H58.6185Z'
        fill='white'
      />
      <defs>
        <radialGradient
          id='paint0_radial_2878_11293'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(66.9746 5.3625) rotate(179.013) scale(66.0098 69.6088)'
        >
          <stop stopColor='#8252DD' />
          <stop offset={1} stopColor='#46179E' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_2878_11293'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(8.56059 22.1707) scale(21.6586 20.7613)'
        >
          <stop stopColor='#004C93' />
          <stop offset='0.068' stopColor='#008398' />
          <stop offset='0.1316' stopColor='#00AF9C' />
          <stop offset='0.1882' stopColor='#00CF9F' />
          <stop offset='0.2359' stopColor='#00E2A0' />
          <stop offset='0.2688' stopColor='#00E9A1' />
          <stop offset='0.6341' stopColor='#00AE89' />
          <stop offset={1} stopColor='#1E248F' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_2878_11293'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(8.62834 22.0963) rotate(12.4789) scale(2.63939 2.53371)'
        >
          <stop stopColor='#EAFCF4' />
          <stop offset='0.328125' stopColor='#B0F3D8' />
          <stop offset='0.963542' stopColor='#85D8CB' />
        </radialGradient>
        <radialGradient
          id='paint3_radial_2878_11293'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(8.56059 22.1707) scale(21.6586 20.7613)'
        >
          <stop stopColor='#E4F9F0' />
          <stop offset='0.338542' stopColor='#C0F5E1' />
          <stop offset='0.979167' stopColor='#6ECDC3' />
        </radialGradient>
        <clipPath id='clip0_2878_11293'>
          <rect
            width={55}
            height={15}
            fill='white'
            transform='translate(6.97461 21)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconRateStar = ({ className }: Props) => {
  return (
    <svg
      width={12}
      height={12}
      viewBox='0 0 20 19'
      fill='#9d9d9d'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M10.4004 0L13.3393 6.25266L19.911 7.25532L15.1557 12.1223L16.2782 18.9947L10.4004 15.75L4.52254 18.9947L5.64511 12.1223L0.889826 7.25532L7.46146 6.25266L10.4004 0Z' />
    </svg>
  )
}

export const IconInformation = () => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14 1.75C7.23516 1.75 1.75 7.23516 1.75 14C1.75 20.7648 7.23516 26.25 14 26.25C20.7648 26.25 26.25 20.7648 26.25 14C26.25 7.23516 20.7648 1.75 14 1.75ZM14 24.1719C8.38359 24.1719 3.82812 19.6164 3.82812 14C3.82812 8.38359 8.38359 3.82812 14 3.82812C19.6164 3.82812 24.1719 8.38359 24.1719 14C24.1719 19.6164 19.6164 24.1719 14 24.1719Z'
        fill='black'
      />
      <path
        d='M12.6875 9.1875C12.6875 9.5356 12.8258 9.86944 13.0719 10.1156C13.3181 10.3617 13.6519 10.5 14 10.5C14.3481 10.5 14.6819 10.3617 14.9281 10.1156C15.1742 9.86944 15.3125 9.5356 15.3125 9.1875C15.3125 8.8394 15.1742 8.50556 14.9281 8.25942C14.6819 8.01328 14.3481 7.875 14 7.875C13.6519 7.875 13.3181 8.01328 13.0719 8.25942C12.8258 8.50556 12.6875 8.8394 12.6875 9.1875ZM14.6562 12.25H13.3438C13.2234 12.25 13.125 12.3484 13.125 12.4688V19.9062C13.125 20.0266 13.2234 20.125 13.3438 20.125H14.6562C14.7766 20.125 14.875 20.0266 14.875 19.9062V12.4688C14.875 12.3484 14.7766 12.25 14.6562 12.25Z'
        fill='black'
      />
    </svg>
  )
}

export const IconFacebookColor = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 9.05025C0 13.5248 3.24975 17.2455 7.5 18V11.4998H5.25V9H7.5V6.99975C7.5 4.74975 8.94975 3.50025 11.0002 3.50025C11.6497 3.50025 12.3503 3.6 12.9998 3.69975V6H11.85C10.7498 6 10.5 6.54975 10.5 7.25025V9H12.9L12.5002 11.4998H10.5V18C14.7502 17.2455 18 13.5255 18 9.05025C18 4.0725 13.95 0 9 0C4.05 0 0 4.0725 0 9.05025Z'
        fill='#3341C1'
      />
    </svg>
  )
}

export const IconErrorMessage = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
        stroke='#F24D4D'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 8V12'
        stroke='#F24D4D'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 16H12.01'
        stroke='#F24D4D'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const IconNotCheckedTerm = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19 10V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H14'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const PaymentCOD = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='18'
      fill='none'
      viewBox='0 0 24 18'
    >
      <path
        stroke='#161616'
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M21 1H3a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V3a2 2 0 00-2-2z'
      />
      <path
        stroke='#1E24C0'
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M12 12a3 3 0 100-6 3 3 0 000 6z'
      />
    </svg>
  )
}
export const BankMethodIcon = () => {
  return (
    <svg
      width='52'
      height='35'
      viewBox='0 0 52 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_971_16719)'>
        <path
          d='M42.6486 15.791C43.9549 15.791 44.5002 14.4341 43.4391 13.8086L27.2948 4.31348C27.0642 4.1769 26.7859 4.10327 26.5 4.10327C26.2142 4.10327 25.9359 4.1769 25.7053 4.31348L9.56098 13.8086C8.49992 14.4307 9.04525 15.791 10.3557 15.791H12.9725V28.5742H9.92877C9.74276 28.5742 9.59058 28.6973 9.59058 28.8477V30.625C9.59058 30.7754 9.74276 30.8984 9.92877 30.8984H43.0713C43.2573 30.8984 43.4095 30.7754 43.4095 30.625V28.8477C43.4095 28.6973 43.2573 28.5742 43.0713 28.5742H40.0276V15.791H42.6486ZM20.9622 28.5742H16.0162V15.791H20.9622V28.5742ZM28.9519 28.5742H24.0059V15.791H28.9519V28.5742ZM36.9839 28.5742H31.9956V15.791H36.9839V28.5742Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_971_16719'>
          <rect width='35' height='35' fill='white' transform='translate(9)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconMess = () => {
  return (
    <svg
      width='33'
      height='32'
      viewBox='0 0 33 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24.5 10.666C24.5 8.54428 23.6571 6.50945 22.1569 5.00916C20.6566 3.50887 18.6217 2.66602 16.5 2.66602C14.3783 2.66602 12.3434 3.50887 10.8431 5.00916C9.34286 6.50945 8.5 8.54428 8.5 10.666C8.5 19.9993 4.5 22.666 4.5 22.666H28.5C28.5 22.666 24.5 19.9993 24.5 10.666Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.8067 28C18.5723 28.4041 18.2358 28.7395 17.831 28.9727C17.4262 29.2059 16.9672 29.3286 16.5 29.3286C16.0329 29.3286 15.5739 29.2059 15.1691 28.9727C14.7642 28.7395 14.4278 28.4041 14.1934 28'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='24.166' cy='8' r='5' fill='#EC4040' />
    </svg>
  )
}

export const IconMessActive = () => {
  return (
    <svg
      width='33'
      height='32'
      viewBox='0 0 33 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24.5 10.666C24.5 8.54428 23.6571 6.50945 22.1569 5.00916C20.6566 3.50887 18.6217 2.66602 16.5 2.66602C14.3783 2.66602 12.3434 3.50887 10.8431 5.00916C9.34286 6.50945 8.5 8.54428 8.5 10.666C8.5 19.9993 4.5 22.666 4.5 22.666H28.5C28.5 22.666 24.5 19.9993 24.5 10.666Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.8067 28C18.5723 28.4041 18.2358 28.7395 17.831 28.9727C17.4262 29.2059 16.9672 29.3286 16.5 29.3286C16.0329 29.3286 15.5739 29.2059 15.1691 28.9727C14.7642 28.7395 14.4278 28.4041 14.1934 28'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='24.166' cy='8' r='5' fill='#1E24C0' />
    </svg>
  )
}

export const IconClose = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={25}
      height={25}
      viewBox='0 0 25 25'
      fill='none'
    >
      <path
        d='M21.1831 3.69593C19.5048 2.01782 17.3666 0.875057 15.0389 0.412133C12.7111 -0.0507903 10.2984 0.186921 8.10576 1.09521C5.91312 2.0035 4.03904 3.54157 2.72052 5.51493C1.402 7.48829 0.698242 9.80832 0.698242 12.1816C0.698242 14.555 1.402 16.875 2.72052 18.8484C4.03904 20.8217 5.91312 22.3598 8.10576 23.2681C10.2984 24.1764 12.7111 24.4141 15.0389 23.9512C17.3666 23.4882 19.5048 22.3455 21.1831 20.6674C22.2975 19.553 23.1815 18.2301 23.7847 16.7741C24.3878 15.3181 24.6982 13.7576 24.6982 12.1816C24.6982 10.6057 24.3878 9.04515 23.7847 7.58916C23.1815 6.13318 22.2975 4.81025 21.1831 3.69593ZM16.9831 15.2159C17.0687 15.2961 17.137 15.393 17.1837 15.5006C17.2303 15.6083 17.2544 15.7243 17.2544 15.8416C17.2544 15.959 17.2303 16.075 17.1837 16.1827C17.137 16.2903 17.0687 16.3872 16.9831 16.4674C16.903 16.5468 16.808 16.6097 16.7036 16.6523C16.5991 16.695 16.4873 16.7166 16.3745 16.7159C16.1497 16.715 15.9342 16.6257 15.7745 16.4674L12.6974 13.3902L9.66309 16.4674C9.50344 16.6257 9.28795 16.715 9.06309 16.7159C8.95028 16.7166 8.83846 16.695 8.73403 16.6523C8.6296 16.6097 8.53461 16.5468 8.45452 16.4674C8.29488 16.3068 8.20527 16.0895 8.20527 15.8631C8.20527 15.6366 8.29488 15.4194 8.45452 15.2588L11.4888 12.1816L8.45452 9.14736C8.3141 8.98339 8.24072 8.77247 8.24905 8.55674C8.25738 8.34102 8.34681 8.13639 8.49947 7.98374C8.65212 7.83108 8.85675 7.74165 9.07247 7.73332C9.2882 7.72499 9.49912 7.79837 9.66309 7.93879L12.6974 10.9731L15.7317 7.93879C15.811 7.85662 15.9058 7.79088 16.0105 7.74534C16.1153 7.69979 16.228 7.67532 16.3422 7.67333C16.4564 7.67134 16.5699 7.69187 16.6762 7.73374C16.7825 7.77561 16.8795 7.838 16.9617 7.91736C17.0438 7.99672 17.1096 8.09148 17.1551 8.19624C17.2007 8.301 17.2251 8.41371 17.2271 8.52792C17.2291 8.64214 17.2086 8.75563 17.1667 8.86191C17.1248 8.96819 17.0624 9.06519 16.9831 9.14736L13.9059 12.1816L16.9831 15.2159Z'
        fill='black'
      />
    </svg>
  )
}

export const IconCloseWhiteCircle = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={22}
      height={22}
      viewBox='0 0 25 25'
      fill='none'
    >
      <path
        d='M21.1831 3.69593C19.5048 2.01782 17.3666 0.875057 15.0389 0.412133C12.7111 -0.0507903 10.2984 0.186921 8.10576 1.09521C5.91312 2.0035 4.03904 3.54157 2.72052 5.51493C1.402 7.48829 0.698242 9.80832 0.698242 12.1816C0.698242 14.555 1.402 16.875 2.72052 18.8484C4.03904 20.8217 5.91312 22.3598 8.10576 23.2681C10.2984 24.1764 12.7111 24.4141 15.0389 23.9512C17.3666 23.4882 19.5048 22.3455 21.1831 20.6674C22.2975 19.553 23.1815 18.2301 23.7847 16.7741C24.3878 15.3181 24.6982 13.7576 24.6982 12.1816C24.6982 10.6057 24.3878 9.04515 23.7847 7.58916C23.1815 6.13318 22.2975 4.81025 21.1831 3.69593ZM16.9831 15.2159C17.0687 15.2961 17.137 15.393 17.1837 15.5006C17.2303 15.6083 17.2544 15.7243 17.2544 15.8416C17.2544 15.959 17.2303 16.075 17.1837 16.1827C17.137 16.2903 17.0687 16.3872 16.9831 16.4674C16.903 16.5468 16.808 16.6097 16.7036 16.6523C16.5991 16.695 16.4873 16.7166 16.3745 16.7159C16.1497 16.715 15.9342 16.6257 15.7745 16.4674L12.6974 13.3902L9.66309 16.4674C9.50344 16.6257 9.28795 16.715 9.06309 16.7159C8.95028 16.7166 8.83846 16.695 8.73403 16.6523C8.6296 16.6097 8.53461 16.5468 8.45452 16.4674C8.29488 16.3068 8.20527 16.0895 8.20527 15.8631C8.20527 15.6366 8.29488 15.4194 8.45452 15.2588L11.4888 12.1816L8.45452 9.14736C8.3141 8.98339 8.24072 8.77247 8.24905 8.55674C8.25738 8.34102 8.34681 8.13639 8.49947 7.98374C8.65212 7.83108 8.85675 7.74165 9.07247 7.73332C9.2882 7.72499 9.49912 7.79837 9.66309 7.93879L12.6974 10.9731L15.7317 7.93879C15.811 7.85662 15.9058 7.79088 16.0105 7.74534C16.1153 7.69979 16.228 7.67532 16.3422 7.67333C16.4564 7.67134 16.5699 7.69187 16.6762 7.73374C16.7825 7.77561 16.8795 7.838 16.9617 7.91736C17.0438 7.99672 17.1096 8.09148 17.1551 8.19624C17.2007 8.301 17.2251 8.41371 17.2271 8.52792C17.2291 8.64214 17.2086 8.75563 17.1667 8.86191C17.1248 8.96819 17.0624 9.06519 16.9831 9.14736L13.9059 12.1816L16.9831 15.2159Z'
        fill='white'
      />
    </svg>
  )
}

export const Clear_X = () => {
  return (
    <svg
      width='13'
      height='13'
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.9375 1L1 11.9375M11.9375 11.9375L1 1L11.9375 11.9375Z'
        stroke='#282828'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const IconHeart = () => {
  return (
    <svg
      width='31'
      height='28'
      viewBox='0 0 31 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M27.797 3.35227C27.0989 2.65158 26.27 2.09574 25.3577 1.71651C24.4454 1.33728 23.4675 1.14209 22.48 1.14209C21.4924 1.14209 20.5146 1.33728 19.6023 1.71651C18.6899 2.09574 17.861 2.65158 17.1629 3.35227L15.7141 4.80577L14.2652 3.35227C12.855 1.93759 10.9424 1.14282 8.94815 1.14282C6.95387 1.14282 5.04127 1.93759 3.6311 3.35227C2.22094 4.76696 1.42871 6.68568 1.42871 8.68635C1.42871 10.687 2.22094 12.6057 3.6311 14.0204L5.07996 15.4739L15.7141 26.1421L26.3482 15.4739L27.797 14.0204C28.4955 13.3201 29.0495 12.4885 29.4275 11.5733C29.8056 10.658 30.0001 9.67705 30.0001 8.68635C30.0001 7.69565 29.8056 6.71467 29.4275 5.79943C29.0495 4.88419 28.4955 4.05263 27.797 3.35227Z'
        stroke='#4F4F4F'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const IconTag = () => {
  return (
    <svg
      width='23'
      height='33'
      viewBox='0 0 23 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.92969 15.1426H15.9297M6.92969 21.1426H15.9297M6.92969 9.14258H15.9297M0.929688 3.14258C0.929688 2.74475 1.08772 2.36322 1.36903 2.08192C1.65033 1.80061 2.03186 1.64258 2.42969 1.64258H20.4297C20.8275 1.64258 21.209 1.80061 21.4903 2.08192C21.7717 2.36322 21.9297 2.74475 21.9297 3.14258V31.6426L16.6797 27.8926L11.4297 31.6426L6.17969 27.8926L0.929688 31.6426V3.14258Z'
        stroke='#282828'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const IconCartMobile = () => {
  return (
    <svg
      width='39'
      height='28'
      viewBox='0 0 39 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M27.4006 20.1119H11.8886C11.6546 20.1124 11.4269 20.0374 11.2405 19.8983C11.0541 19.7592 10.9193 19.5639 10.8569 19.3422L6.1296 2.6266C6.07753 2.43787 5.97241 2.2674 5.82632 2.13472C5.68022 2.00204 5.49905 1.91252 5.30357 1.87643L1.40234 1.14258'
        stroke='#4F4F4F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M10.109 16.3936H26.1916C26.3561 16.3934 26.5165 16.3431 26.6507 16.2497C26.785 16.1562 26.8865 16.0242 26.9413 15.8717L30.5904 5.88476C30.6228 5.79527 30.6326 5.69934 30.6187 5.60531C30.6049 5.51128 30.568 5.42199 30.5111 5.34518C30.4542 5.26837 30.3791 5.20637 30.2924 5.16456C30.2056 5.12275 30.1098 5.10239 30.0132 5.10524L6.82812 4.88672'
        stroke='#4F4F4F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M14.6096 24.1047C14.6128 24.5053 14.495 24.8979 14.271 25.2327C14.047 25.5674 13.727 25.8291 13.3514 25.9847C12.9759 26.1403 12.5619 26.1826 12.1618 26.1065C11.7617 26.0303 11.3937 25.839 11.1044 25.5568C10.8151 25.2746 10.6176 24.9143 10.5368 24.5216C10.4561 24.1288 10.4959 23.7214 10.6511 23.3509C10.8062 22.9804 11.0698 22.6636 11.4084 22.4406C11.747 22.2177 12.1453 22.0986 12.5528 22.0986C13.0952 22.0995 13.6153 22.3106 14.0004 22.6861C14.3854 23.0617 14.6043 23.5714 14.6096 24.1047V24.1047Z'
        stroke='#4F4F4F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M27.3596 24.1038C27.3628 24.5037 27.2454 24.8957 27.0221 25.23C26.7989 25.5644 26.4798 25.8261 26.1052 25.9821C25.7307 26.1382 25.3175 26.1815 24.9179 26.1066C24.5183 26.0317 24.1502 25.842 23.8603 25.5615C23.5703 25.281 23.3715 24.9222 23.2889 24.5305C23.2063 24.1389 23.2437 23.732 23.3964 23.3612C23.549 22.9904 23.81 22.6725 24.1464 22.4476C24.4828 22.2227 24.8794 22.1009 25.2862 22.0977C25.8314 22.0942 26.3558 22.3034 26.7445 22.6794C27.1331 23.0555 27.3543 23.5677 27.3596 24.1038Z'
        stroke='#4F4F4F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
    </svg>
  )
}

export const IconIonah = () => {
  return (
    <svg
      width='143'
      height='40'
      viewBox='0 0 143 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_7585_6510)'>
        <path
          d='M4.76629 40C2.19139 40 0.109558 37.9312 0.109558 35.3967V15.6404C0.109558 13.0951 2.20235 11.0371 4.76629 11.0371C7.33024 11.0371 9.42303 13.1059 9.42303 15.6404V35.3967C9.42303 37.9421 7.3412 40 4.76629 40Z'
          fill='black'
        />
        <path
          d='M137.565 40C134.991 40 132.909 37.9312 132.909 35.3967V25.2586C132.909 23.6989 132.372 22.28 131.386 21.2402C130.213 20.0054 128.833 19.3989 127.145 19.3989C125.469 19.3989 124.077 19.9946 122.905 21.2402C121.919 22.28 121.382 23.6989 121.382 25.2586V35.3967C121.382 37.9421 119.289 40 116.725 40C114.15 40 112.068 37.9312 112.068 35.3967V7.3328C112.068 4.78744 114.161 2.72949 116.725 2.72949C119.3 2.72949 121.382 4.79827 121.382 7.3328V11.2754C123.157 10.5605 125.085 10.1923 127.145 10.1923C131.298 10.1923 134.892 11.6545 137.817 14.5573C140.743 17.4492 142.233 21.0019 142.233 25.107V35.4075C142.222 37.9421 140.129 40 137.565 40Z'
          fill='#231F20'
        />
        <path
          d='M93.8031 39.7513C89.6504 39.7513 86.0565 38.2891 83.131 35.3863C80.2054 32.4943 78.7153 28.9416 78.7153 24.8366C78.7153 20.7315 80.1945 17.1788 83.131 14.2869C86.0565 11.3949 89.6504 9.92188 93.8031 9.92188C97.9558 9.92188 101.55 11.3841 104.475 14.2869C107.401 17.1788 108.891 20.7315 108.891 24.8366V35.6354C108.891 36.4586 108.486 37.6608 107.697 38.3649C106.809 39.1664 105.571 39.6105 104.223 39.6105C102.832 39.6105 101.572 39.1447 100.772 38.3324C100.728 38.2891 100.684 38.2349 100.629 38.1807C98.5694 39.2205 96.2794 39.7513 93.8031 39.7513ZM93.8031 19.1501C92.0719 19.1501 90.6475 19.7892 89.4532 21.0998C88.6204 22.0204 88.1164 23.2119 88.0507 24.4358C87.9411 26.3313 88.5876 27.8693 90.0229 29.1366C90.9543 29.9598 92.1486 30.458 93.3977 30.523C93.5292 30.5338 93.6716 30.5338 93.8031 30.5338C95.5343 30.5338 96.9587 29.8948 98.1531 28.5734C98.9858 27.6527 99.4898 26.4721 99.5556 25.2373C99.6651 23.3419 99.0187 21.8038 97.5833 20.5366C96.6519 19.7134 95.4576 19.226 94.2085 19.1501C94.077 19.1501 93.9346 19.1501 93.8031 19.1501Z'
          fill='#231F20'
        />
        <path
          d='M71.1659 39.9132C68.3828 39.9132 66.1147 37.6711 66.1147 34.92V24.9768C66.1147 23.6771 65.6984 22.464 64.9423 21.5542C63.7042 20.0486 62.1921 19.3121 60.3513 19.3121C60.1651 19.3121 59.9678 19.3229 59.7706 19.3337C58.6311 19.4204 57.5134 19.8861 56.6369 20.6443C55.2563 21.8358 54.5879 23.2655 54.5879 25.0093V35.2233C54.5879 37.8119 52.4513 39.924 49.8326 39.924C47.3125 39.924 45.2635 37.8986 45.2635 35.4074V25.0202C45.2635 20.9151 46.7427 17.3624 49.6682 14.4705C52.5937 11.5785 56.1876 10.1055 60.3404 10.1055C64.4931 10.1055 68.087 11.5677 71.0125 14.4705C73.938 17.3624 75.4172 20.9151 75.4172 25.0202V35.7107C75.4282 38.0177 73.5217 39.9132 71.1659 39.9132Z'
          fill='#231F20'
        />
        <path
          d='M39.3138 14.5464C36.3883 11.6545 32.7944 10.1814 28.6416 10.1814C26.757 10.1814 25.0039 10.4847 23.3604 11.0912C21.3333 11.8386 19.12 11.9144 17.1039 11.1129L10.8146 8.60003C10.2448 8.40506 9.97087 8.74083 10.2777 9.26074L13.2251 14.3948C14.3537 16.3661 14.77 18.7165 14.1345 20.8936C13.751 22.2258 13.5538 23.623 13.5538 25.1069C13.5538 29.212 15.033 32.7647 17.9695 35.6566C20.895 38.5486 24.4889 40.0216 28.6416 40.0216C32.7944 40.0216 36.3883 38.5594 39.3138 35.6566C42.2393 32.7647 43.7295 29.212 43.7295 25.1069C43.7185 20.991 42.2393 17.4384 39.3138 14.5464ZM32.7177 29.1253C31.5781 30.2518 30.2523 30.7934 28.6416 30.7934C27.0419 30.7934 25.7052 30.2518 24.5656 29.1253C23.4261 27.9989 22.8782 26.6883 22.8782 25.0961C22.8782 23.5147 23.4261 22.1933 24.5656 21.0669C25.7052 19.9404 27.031 19.3988 28.6416 19.3988C30.2414 19.3988 31.5781 19.9404 32.7177 21.0669C33.8572 22.1933 34.405 23.5039 34.405 25.0961C34.405 26.6775 33.8462 27.9989 32.7177 29.1253Z'
          fill='url(#paint0_radial_7585_6510)'
        />
        <path
          d='M5.02928 0C3.62678 0 2.44342 0.487409 1.46824 1.45139C0.493066 2.41538 0 3.58516 0 4.97157C0 6.34714 0.493066 7.52776 1.46824 8.49174C2.44342 9.45573 3.62678 9.94314 5.02928 9.94314C6.42082 9.94314 7.61513 9.45573 8.59031 8.49174C9.56548 7.52776 10.0586 6.35797 10.0586 4.97157C10.0586 3.59599 9.56548 2.41538 8.59031 1.45139C7.60418 0.487409 6.42082 0 5.02928 0Z'
          fill='white'
        />
        <path
          d='M4.76629 40C2.19139 40 0.109558 37.9312 0.109558 35.3967V15.6404C0.109558 13.0951 2.20235 11.0371 4.76629 11.0371C7.33024 11.0371 9.42303 13.1059 9.42303 15.6404V35.3967C9.42303 37.9421 7.3412 40 4.76629 40Z'
          fill='white'
        />
        <path
          d='M137.565 40C134.991 40 132.909 37.9312 132.909 35.3967V25.2586C132.909 23.6989 132.372 22.28 131.386 21.2402C130.213 20.0054 128.833 19.3989 127.145 19.3989C125.469 19.3989 124.077 19.9946 122.905 21.2402C121.919 22.28 121.382 23.6989 121.382 25.2586V35.3967C121.382 37.9421 119.289 40 116.725 40C114.15 40 112.068 37.9312 112.068 35.3967V7.3328C112.068 4.78744 114.161 2.72949 116.725 2.72949C119.3 2.72949 121.382 4.79827 121.382 7.3328V11.2754C123.157 10.5605 125.085 10.1923 127.145 10.1923C131.298 10.1923 134.892 11.6545 137.817 14.5573C140.743 17.4492 142.233 21.0019 142.233 25.107V35.4075C142.222 37.9421 140.129 40 137.565 40Z'
          fill='white'
        />
        <path
          d='M93.8031 39.7513C89.6504 39.7513 86.0565 38.2891 83.131 35.3863C80.2054 32.4943 78.7153 28.9416 78.7153 24.8366C78.7153 20.7315 80.1945 17.1788 83.131 14.2869C86.0565 11.3949 89.6504 9.92188 93.8031 9.92188C97.9558 9.92188 101.55 11.3841 104.475 14.2869C107.401 17.1788 108.891 20.7315 108.891 24.8366V35.6354C108.891 36.4586 108.486 37.6608 107.697 38.3649C106.809 39.1664 105.571 39.6105 104.223 39.6105C102.832 39.6105 101.572 39.1447 100.772 38.3324C100.728 38.2891 100.684 38.2349 100.629 38.1807C98.5694 39.2205 96.2794 39.7513 93.8031 39.7513ZM93.8031 19.1501C92.0719 19.1501 90.6475 19.7892 89.4532 21.0998C88.6204 22.0204 88.1164 23.2119 88.0507 24.4358C87.9411 26.3313 88.5876 27.8693 90.0229 29.1366C90.9543 29.9598 92.1486 30.458 93.3977 30.523C93.5292 30.5338 93.6716 30.5338 93.8031 30.5338C95.5343 30.5338 96.9587 29.8948 98.1531 28.5734C98.9858 27.6527 99.4898 26.4721 99.5556 25.2373C99.6651 23.3419 99.0187 21.8038 97.5833 20.5366C96.6519 19.7134 95.4576 19.226 94.2085 19.1501C94.077 19.1501 93.9346 19.1501 93.8031 19.1501Z'
          fill='white'
        />
        <path
          d='M71.1659 39.9132C68.3828 39.9132 66.1147 37.6711 66.1147 34.92V24.9768C66.1147 23.6771 65.6984 22.464 64.9423 21.5542C63.7042 20.0486 62.1921 19.3121 60.3513 19.3121C60.1651 19.3121 59.9678 19.3229 59.7706 19.3337C58.6311 19.4204 57.5134 19.8861 56.6369 20.6443C55.2563 21.8358 54.5879 23.2655 54.5879 25.0093V35.2233C54.5879 37.8119 52.4513 39.924 49.8326 39.924C47.3125 39.924 45.2635 37.8986 45.2635 35.4074V25.0202C45.2635 20.9151 46.7427 17.3624 49.6682 14.4705C52.5937 11.5785 56.1876 10.1055 60.3404 10.1055C64.4931 10.1055 68.087 11.5677 71.0125 14.4705C73.938 17.3624 75.4172 20.9151 75.4172 25.0202V35.7107C75.4282 38.0177 73.5217 39.9132 71.1659 39.9132Z'
          fill='white'
        />
        <path
          d='M39.3138 14.5464C36.3883 11.6545 32.7944 10.1814 28.6416 10.1814C26.757 10.1814 25.0039 10.4847 23.3604 11.0912C21.3333 11.8386 19.12 11.9144 17.1039 11.1129L10.8146 8.60003C10.2448 8.40506 9.97087 8.74083 10.2777 9.26074L13.2251 14.3948C14.3537 16.3661 14.77 18.7165 14.1345 20.8936C13.751 22.2258 13.5538 23.623 13.5538 25.1069C13.5538 29.212 15.033 32.7647 17.9695 35.6566C20.895 38.5486 24.4889 40.0216 28.6416 40.0216C32.7944 40.0216 36.3883 38.5594 39.3138 35.6566C42.2393 32.7647 43.7295 29.212 43.7295 25.1069C43.7185 20.991 42.2393 17.4384 39.3138 14.5464ZM32.7177 29.1253C31.5781 30.2518 30.2523 30.7934 28.6416 30.7934C27.0419 30.7934 25.7052 30.2518 24.5656 29.1253C23.4261 27.9989 22.8782 26.6883 22.8782 25.0961C22.8782 23.5147 23.4261 22.1933 24.5656 21.0669C25.7052 19.9404 27.031 19.3988 28.6416 19.3988C30.2414 19.3988 31.5781 19.9404 32.7177 21.0669C33.8572 22.1933 34.405 23.5039 34.405 25.0961C34.405 26.6775 33.8462 27.9989 32.7177 29.1253Z'
          fill='white'
        />
      </g>
      <defs>
        <radialGradient
          id='paint0_radial_7585_6510'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(4.09988 3.12177) scale(56.0062 55.3636)'
        >
          <stop stopColor='#004C93' />
          <stop offset='0.068' stopColor='#008398' />
          <stop offset='0.1316' stopColor='#00AF9C' />
          <stop offset='0.1882' stopColor='#00CF9F' />
          <stop offset='0.2359' stopColor='#00E2A0' />
          <stop offset='0.2688' stopColor='#00E9A1' />
          <stop offset='0.6341' stopColor='#00AE89' />
          <stop offset='1' stopColor='#1E248F' />
        </radialGradient>
        <clipPath id='clip0_7585_6510'>
          <rect width='142.222' height='40' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconBack = ({ color = '#282828' }: { color?: string }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={12}
      height={20}
      viewBox='0 0 12 20'
      fill='none'
    >
      <path
        d='M12 2.91414L9.7166 0.681641L0 10.1816L9.7166 19.6816L12 17.4491L4.583 10.1816L12 2.91414Z'
        fill={color}
      />
    </svg>
  )
}

export const IconBackWhite = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={12}
      height={20}
      viewBox='0 0 12 20'
      fill='none'
    >
      <path
        d='M12 2.91414L9.7166 0.681641L0 10.1816L9.7166 19.6816L12 17.4491L4.583 10.1816L12 2.91414Z'
        fill='#ffffff'
      />
    </svg>
  )
}

export const IconBag = () => {
  return (
    <svg
      width='22'
      height='24'
      viewBox='0 0 22 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1 3V23H21V3'
        stroke='white'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M16 10C16 12.8 13.8 15 11 15C8.2 15 6 12.8 6 10'
        stroke='white'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M19 5H3C1.9 5 1 4.1 1 3C1 1.9 1.9 1 3 1H19C20.1 1 21 1.9 21 3C21 4.1 20.1 5 19 5Z'
        stroke='white'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}
export const IconNoti = () => {
  return (
    <svg
      width='22'
      height='24'
      viewBox='0 0 22 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18 11V8C18 6.14348 17.2625 4.36301 15.9497 3.05025C14.637 1.7375 12.8565 1 11 1C9.14348 1 7.36301 1.7375 6.05025 3.05025C4.7375 4.36301 4 6.14348 4 8V11C4 14.3 1 15.1 1 17C1 18.7 4.9 20 11 20C17.1 20 21 18.7 21 17C21 15.1 18 14.3 18 11Z'
        stroke='white'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M11 21.9999C9.98902 21.9999 9.03902 21.9659 8.14502 21.8999C8.33561 22.5079 8.71532 23.0391 9.22883 23.4163C9.74235 23.7935 10.3629 23.9969 11 23.9969C11.6372 23.9969 12.2577 23.7935 12.7712 23.4163C13.2847 23.0391 13.6644 22.5079 13.855 21.8999C12.961 21.9659 12.011 21.9999 11 21.9999Z'
        fill='white'
      />
    </svg>
  )
}
export const IconNotification = () => {
  return (
    <svg
      width={25}
      height={25}
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.0067 20.8333H3.99259C3.59177 20.8333 3.20111 20.7072 2.87595 20.4728C2.5508 20.2384 2.30765 19.9077 2.18094 19.5274C2.05423 19.1471 2.05039 18.7366 2.16996 18.3541C2.28954 17.9715 2.52646 17.6362 2.84717 17.3958L3.70499 16.7524C4.02781 16.5112 4.24441 16.1541 4.30915 15.7563L5.3854 9.22295C5.64817 7.52414 6.51018 5.97544 7.81552 4.85692C9.12087 3.73841 10.7834 3.12392 12.5024 3.1246C14.2214 3.12528 15.8834 3.74108 17.1879 4.86063C18.4924 5.98017 19.3531 7.52956 19.6146 9.22858L20.6901 15.7563C20.7548 16.1541 20.9714 16.5112 21.2943 16.7524L22.1523 17.3958C22.4731 17.6362 22.7101 17.9715 22.8297 18.3542C22.9492 18.7368 22.9454 19.1473 22.8186 19.5276C22.6918 19.9079 22.4486 20.2387 22.1234 20.473C21.7981 20.7074 21.4075 20.8334 21.0067 20.8333ZM12.5004 4.16665C11.0278 4.15951 9.60191 4.68329 8.4841 5.64201C7.36629 6.60074 6.63141 7.93018 6.41415 9.3867L5.33712 15.9256C5.22907 16.5884 4.86806 17.1835 4.33009 17.5855L3.47202 18.2292C3.32621 18.3384 3.2185 18.4908 3.16414 18.6648C3.10979 18.8387 3.11154 19.0253 3.16916 19.1982C3.22679 19.371 3.33735 19.5214 3.48519 19.6279C3.63302 19.7344 3.81064 19.7917 3.99285 19.7917H21.0069C21.1891 19.7917 21.3666 19.7344 21.5144 19.6279C21.6622 19.5214 21.7727 19.371 21.8303 19.1982C21.888 19.0254 21.8897 18.8389 21.8354 18.665C21.7811 18.4911 21.6735 18.3387 21.5277 18.2294L20.6694 17.5855C20.1314 17.1835 19.7704 16.5884 19.6624 15.9256L18.5858 9.39228C18.3696 7.93495 17.6354 6.6044 16.5176 5.6446C15.3999 4.6848 13.9737 4.16008 12.5004 4.16665Z'
        fill='black'
      />
      <path
        d='M14.0618 4.35416C13.9237 4.35416 13.7912 4.29928 13.6936 4.20161C13.5959 4.10393 13.541 3.97146 13.541 3.83332V3.12499C13.541 2.84872 13.4313 2.58377 13.2359 2.38842C13.0406 2.19307 12.7756 2.08332 12.4993 2.08332C12.2231 2.08332 11.9581 2.19307 11.7628 2.38842C11.5674 2.58377 11.4577 2.84872 11.4577 3.12499V3.83332C11.4577 3.97146 11.4028 4.10393 11.3051 4.20161C11.2075 4.29928 11.075 4.35416 10.9368 4.35416C10.7987 4.35416 10.6662 4.29928 10.5686 4.20161C10.4709 4.10393 10.416 3.97146 10.416 3.83332V3.12499C10.416 2.57246 10.6355 2.04255 11.0262 1.65185C11.4169 1.26115 11.9468 1.04166 12.4993 1.04166C13.0519 1.04166 13.5818 1.26115 13.9725 1.65185C14.3632 2.04255 14.5827 2.57246 14.5827 3.12499V3.83332C14.5827 3.97146 14.5278 4.10393 14.4301 4.20161C14.3325 4.29928 14.2 4.35416 14.0618 4.35416Z'
        fill='black'
      />
      <path
        d='M12.4993 23.9583C11.5327 23.9572 10.606 23.5728 9.92254 22.8893C9.23905 22.2058 8.85459 21.2791 8.85352 20.3125C8.85352 20.1744 8.90839 20.0419 9.00606 19.9442C9.10374 19.8465 9.23622 19.7917 9.37435 19.7917C9.51248 19.7917 9.64496 19.8465 9.74263 19.9442C9.84031 20.0419 9.89518 20.1744 9.89518 20.3125C9.89518 21.0032 10.1695 21.6655 10.6579 22.1539C11.1463 22.6423 11.8087 22.9167 12.4993 22.9167C13.19 22.9167 13.8524 22.6423 14.3408 22.1539C14.8291 21.6655 15.1035 21.0032 15.1035 20.3125C15.1035 20.1744 15.1584 20.0419 15.2561 19.9442C15.3537 19.8465 15.4862 19.7917 15.6243 19.7917C15.7625 19.7917 15.895 19.8465 15.9926 19.9442C16.0903 20.0419 16.1452 20.1744 16.1452 20.3125C16.1441 21.2791 15.7596 22.2058 15.0762 22.8893C14.3927 23.5728 13.466 23.9572 12.4993 23.9583Z'
        fill='black'
      />
    </svg>
  )
}
export const IconEndow = () => {
  return (
    <svg
      width='24'
      height='18'
      viewBox='0 0 24 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20 9C20 7.3 21.3 6 23 6V1H1V6C2.7 6 4 7.3 4 9C4 10.7 2.7 12 1 12V17H23V12C21.3 12 20 10.7 20 9Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M15 6L9 12'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M9.5 7C10.3284 7 11 6.32843 11 5.5C11 4.67157 10.3284 4 9.5 4C8.67157 4 8 4.67157 8 5.5C8 6.32843 8.67157 7 9.5 7Z'
        fill='#6F6F6F'
      />
      <path
        d='M14.5 14C15.3284 14 16 13.3284 16 12.5C16 11.6716 15.3284 11 14.5 11C13.6716 11 13 11.6716 13 12.5C13 13.3284 13.6716 14 14.5 14Z'
        fill='#6F6F6F'
      />
    </svg>
  )
}

export const IconImportGoods = () => {
  return (
    <svg
      width='24'
      height='23'
      viewBox='0 0 24 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 22C6.55228 22 7 21.5523 7 21C7 20.4477 6.55228 20 6 20C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22Z'
        fill='#6F6F6F'
      />
      <path
        d='M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z'
        fill='#6F6F6F'
      />
      <path
        d='M6 22C6.55228 22 7 21.5523 7 21C7 20.4477 6.55228 20 6 20C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M17 6H22L20 16H6L4 1H1'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M4.80005 6H9.00005'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M13 2V10'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M15 10L13 12L11 10H15Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export const IconFollow = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.9 7H18L19 11L23 13V19H17.829'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M9 10V19H1V6'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M15 23C16.6569 23 18 21.6569 18 20C18 18.3431 16.6569 17 15 17C13.3431 17 12 18.3431 12 20C12 21.6569 13.3431 23 15 23Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M6 4V6H8'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export const IconShop = () => {
  return (
    <svg
      width='24'
      height='22'
      viewBox='0 0 24 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 12V21H20V12'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M4.00001 1L1.00001 6C0.998497 6.67436 1.22485 7.32946 1.64235 7.85905C2.05985 8.38864 2.64402 8.76166 3.3001 8.9176C3.95619 9.07355 4.64572 9.00328 5.25686 8.71819C5.86801 8.43311 6.36492 7.94992 6.66701 7.347C6.91349 7.84349 7.29369 8.26131 7.76479 8.5534C8.2359 8.84549 8.7792 9.00025 9.33351 9.00025C9.88782 9.00025 10.4311 8.84549 10.9022 8.5534C11.3733 8.26131 11.7535 7.84349 12 7.347C12.2465 7.84349 12.6267 8.26131 13.0978 8.5534C13.5689 8.84549 14.1122 9.00025 14.6665 9.00025C15.2208 9.00025 15.7641 8.84549 16.2352 8.5534C16.7063 8.26131 17.0865 7.84349 17.333 7.347C17.6351 7.94992 18.132 8.43311 18.7432 8.71819C19.3543 9.00328 20.0438 9.07355 20.6999 8.9176C21.356 8.76166 21.9402 8.38864 22.3577 7.85905C22.7752 7.32946 23.0015 6.67436 23 6L20 1H4.00001Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M10 21V15H14V21'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
    </svg>
  )
}

export const IconTel = () => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.6391 13.4067L12.2841 15.7277C11.0563 14.987 9.91579 14.1105 8.88407 13.1147C7.89017 12.0816 7.01413 10.9412 6.27207 9.71467L8.59107 7.35967C8.73035 7.21726 8.82441 7.03685 8.86142 6.84112C8.89843 6.64539 8.87674 6.4431 8.79907 6.25967L6.38207 0.613666C6.28678 0.391851 6.11512 0.211554 5.89825 0.105501C5.68137 -0.000551127 5.43366 -0.0253289 5.20007 0.0356656L0.756074 1.20867C0.53403 1.26568 0.338085 1.39675 0.200625 1.58021C0.063164 1.76367 -0.00758388 1.98855 7.40542e-05 2.21767C0.282458 7.37822 2.42833 12.2609 6.03907 15.9587C9.73768 19.5709 14.6219 21.7175 19.7841 21.9997C20.0132 22.0068 20.2379 21.9359 20.4215 21.7985C20.605 21.6612 20.7364 21.4655 20.7941 21.2437L21.9661 16.8037C22.0282 16.5696 22.0041 16.3211 21.8982 16.1033C21.7922 15.8856 21.6116 15.7132 21.3891 15.6177L15.7481 13.1997C15.5636 13.1198 15.3595 13.0968 15.1619 13.1337C14.9644 13.1706 14.7823 13.2656 14.6391 13.4067Z'
        fill='#1E24C0'
      />
    </svg>
  )
}
export const IconInvent = () => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 1H1V8H8V1Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M21 1H14V8H21V1Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M8 14H1V21H8V14Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M21 14H14V21H21V14Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}
export const IconDebt = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M12 5V19'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M15.375 7.21876C13.754 6.32776 8.648 5.66276 8.648 8.73176C8.648 12.4058 15.132 11.1088 15.132 14.3508C15.132 17.5928 10.918 17.3488 8 16.2958'
        stroke='#6F6F6F'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}
export const SelectedIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
    >
      <circle cx={8} cy={8} r={8} fill='#E73F1D' />
      <path
        d='M7.00025 11.0002C6.74425 11.0002 6.48825 10.9022 6.29325 10.7072L4.29325 8.70725C3.90225 8.31625 3.90225 7.68425 4.29325 7.29325C4.68425 6.90225 5.31625 6.90225 5.70725 7.29325L7.00025 8.58625L10.2933 5.29325C10.6842 4.90225 11.3162 4.90225 11.7072 5.29325C12.0982 5.68425 12.0982 6.31625 11.7072 6.70725L7.70725 10.7072C7.51225 10.9022 7.25625 11.0002 7.00025 11.0002Z'
        fill='white'
      />
    </svg>
  )
}

export const CloseIcon = () => {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.7778 2.00644C14.1683 1.61592 14.1683 0.982754 13.7778 0.592229C13.3873 0.201705 12.7541 0.201705 12.3636 0.592229L7.18555 5.77024L2.00753 0.592229C1.61701 0.201705 0.983843 0.201704 0.593318 0.592229C0.202793 0.982754 0.202794 1.61592 0.593318 2.00644L5.77133 7.18446L0.592923 12.3629C0.202399 12.7534 0.202399 13.3866 0.592923 13.7771C0.983447 14.1676 1.61661 14.1676 2.00714 13.7771L7.18555 8.59867L12.364 13.7771C12.7545 14.1676 13.3876 14.1676 13.7782 13.7771C14.1687 13.3866 14.1687 12.7534 13.7782 12.3629L8.59976 7.18446L13.7778 2.00644Z'
        fill='black'
      />
    </svg>
  )
}

export const IconShowPasswordMobile = () => {
  return (
    <svg
      width='24'
      height='16'
      viewBox='0 0 24 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23.847 7.468C23.655 7.163 19.071 0 12 0C4.92901 0 0.345012 7.163 0.153012 7.468C0.0528771 7.62738 -0.000244141 7.81178 -0.000244141 8C-0.000244141 8.18822 0.0528771 8.37262 0.153012 8.532C0.345012 8.837 4.92901 16 12 16C19.071 16 23.655 8.837 23.847 8.532C23.9471 8.37262 24.0003 8.18822 24.0003 8C24.0003 7.81178 23.9471 7.62738 23.847 7.468ZM12 14C7.06301 14 3.36301 9.558 2.21801 8C3.74786 5.87324 5.7571 4.13669 8.08301 2.931C7.38628 3.80262 7.00463 4.88415 7.00001 6C7.00001 7.32608 7.5268 8.59785 8.46448 9.53553C9.40216 10.4732 10.6739 11 12 11C13.3261 11 14.5979 10.4732 15.5355 9.53553C16.4732 8.59785 17 7.32608 17 6C16.9953 4.88731 16.6159 3.80864 15.923 2.938C18.2437 4.14585 20.25 5.87926 21.782 8C20.641 9.561 16.953 14 12 14Z'
        fill='#6F6F6F'
      />
    </svg>
  )
}

export const IconHidePasswordMobile = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_7970_10407)'>
        <path
          d='M20.565 7.67773L19.131 9.11073C20.1111 9.98094 20.9997 10.949 21.783 11.9997C20.641 13.5597 16.954 17.9997 12 17.9997C11.4627 17.9972 10.9269 17.943 10.4 17.8377L8.76001 19.4777C9.80666 19.8176 10.8996 19.9937 12 19.9997C19.071 19.9997 23.655 12.8367 23.847 12.5317C23.9471 12.3724 24.0003 12.188 24.0003 11.9997C24.0003 11.8115 23.9471 11.6271 23.847 11.4677C22.9178 10.0706 21.815 8.7971 20.565 7.67773Z'
          fill='#6F6F6F'
        />
        <path
          d='M22.707 1.29279C22.5195 1.10532 22.2652 1 22 1C21.7348 1 21.4805 1.10532 21.293 1.29279L17.235 5.35079C15.6255 4.48236 13.8288 4.01869 12 3.99979C4.92901 3.99979 0.345012 11.1628 0.153012 11.4678C0.0528771 11.6272 -0.000244141 11.8116 -0.000244141 11.9998C-0.000244141 12.188 0.0528771 12.3724 0.153012 12.5318C1.46248 14.486 3.10752 16.193 5.01201 17.5738L2.29301 20.2928C2.1975 20.385 2.12132 20.4954 2.06891 20.6174C2.0165 20.7394 1.98891 20.8706 1.98776 21.0034C1.98661 21.1362 2.01191 21.2678 2.06219 21.3907C2.11247 21.5136 2.18672 21.6253 2.28062 21.7192C2.37451 21.8131 2.48616 21.8873 2.60906 21.9376C2.73195 21.9879 2.86363 22.0132 2.99641 22.012C3.12919 22.0109 3.26041 21.9833 3.38242 21.9309C3.50442 21.8785 3.61476 21.8023 3.70701 21.7068L22.707 2.70679C22.8945 2.51926 22.9998 2.26495 22.9998 1.99979C22.9998 1.73462 22.8945 1.48031 22.707 1.29279ZM2.21701 11.9998C3.74764 9.87336 5.75712 8.13691 8.08301 6.93079C7.27323 7.93722 6.89362 9.2227 7.02677 10.5076C7.15993 11.7925 7.79506 12.9728 8.79401 13.7918L6.45601 16.1298C4.82664 14.9942 3.39462 13.599 2.21701 11.9998Z'
          fill='#6F6F6F'
        />
      </g>
      <defs>
        <clipPath id='clip0_7970_10407'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconElementActive = () => {
  return (
    <svg
      width='45'
      height='51'
      viewBox='0 0 45 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7565)'>
        <path
          d='M45 46.2323V1.96902C45 1.45872 44.7983 0.969318 44.4393 0.608478C44.0803 0.247639 43.5933 0.0449219 43.0856 0.0449219L1.91443 0.0449219C1.40669 0.0449219 0.919751 0.247639 0.560727 0.608478C0.201703 0.969318 5.10589e-06 1.45872 5.10589e-06 1.96902V46.2323C-0.000576368 46.4853 0.0485126 46.736 0.144461 46.97C0.240409 47.2039 0.381333 47.4165 0.559161 47.5957C0.73699 47.7748 0.94823 47.917 1.18079 48.0139C1.41334 48.1109 1.66265 48.1608 1.91443 48.1608H2.85174V50.0449H7.07409V48.1608H38.1116V50.0449H42.3428V48.1608H43.0812C43.3333 48.1614 43.5831 48.1119 43.8162 48.0152C44.0492 47.9185 44.261 47.7765 44.4393 47.5973C44.6176 47.4181 44.7589 47.2052 44.8551 46.971C44.9514 46.7367 45.0006 46.4857 45 46.2323ZM33.3897 2.71111C33.7683 2.71111 34.1384 2.82396 34.4533 3.03538C34.7681 3.24681 35.0135 3.54731 35.1584 3.89889C35.3033 4.25048 35.3412 4.63735 35.2673 5.01059C35.1934 5.38383 35.0111 5.72667 34.7434 5.99576C34.4756 6.26485 34.1345 6.44811 33.7632 6.52235C33.3918 6.59659 33.0069 6.55849 32.6571 6.41286C32.3072 6.26723 32.0082 6.02061 31.7979 5.70419C31.5875 5.38777 31.4752 5.01577 31.4752 4.63522C31.4752 4.12491 31.6769 3.63551 32.036 3.27467C32.395 2.91383 32.8819 2.71111 33.3897 2.71111ZM24.7593 2.71111C25.1379 2.71111 25.5081 2.82396 25.8229 3.03538C26.1377 3.24681 26.3831 3.54731 26.528 3.89889C26.6729 4.25048 26.7108 4.63735 26.6369 5.01059C26.5631 5.38383 26.3807 5.72667 26.113 5.99576C25.8453 6.26485 25.5041 6.44811 25.1328 6.52235C24.7614 6.59659 24.3765 6.55849 24.0267 6.41286C23.6769 6.26723 23.3779 6.02061 23.1675 5.70419C22.9571 5.38777 22.8449 5.01577 22.8449 4.63522C22.8449 4.12491 23.0466 3.63551 23.4056 3.27467C23.7646 2.91383 24.2516 2.71111 24.7593 2.71111ZM7.27747 3.8798C7.27747 3.75016 7.32871 3.62583 7.41991 3.53416C7.51112 3.44249 7.63482 3.39099 7.76381 3.39099H9.47043C9.5343 3.39099 9.59754 3.40364 9.65655 3.4282C9.71555 3.45277 9.76917 3.48877 9.81433 3.53416C9.85949 3.57955 9.89531 3.63344 9.91975 3.69274C9.94419 3.75204 9.95677 3.81561 9.95677 3.8798V5.5906C9.95677 5.65479 9.94419 5.71836 9.91975 5.77766C9.89531 5.83696 9.85949 5.89085 9.81433 5.93624C9.76917 5.98163 9.71555 6.01763 9.65655 6.0422C9.59754 6.06676 9.5343 6.0794 9.47043 6.0794H7.76381C7.63482 6.0794 7.51112 6.02791 7.41991 5.93624C7.32871 5.84457 7.27747 5.72024 7.27747 5.5906V3.8798ZM3.47073 9.18552H41.5293V10.9896H3.47073V9.18552ZM39.973 42.2596H5.04471V17.0863H39.973V42.2596Z'
          fill='#1E24C0'
        />
        <path
          d='M12.5343 33.6126C12.4331 33.8453 12.3804 34.0963 12.3796 34.3503C12.3808 34.8004 12.5477 35.2341 12.8482 35.5678C11.6103 35.8878 10.7437 36.6299 10.7437 37.5008H17.6497C17.6497 36.6121 16.7655 35.8878 15.5408 35.5678C15.7802 35.31 15.9379 34.9864 15.9938 34.6382C16.0497 34.2901 16.0013 33.9331 15.8547 33.6126C17.5436 32.595 18.7374 30.0844 18.7374 27.1427C18.7446 25.9808 18.547 24.8269 18.1538 23.7344H10.2352C9.84095 24.8297 9.64334 25.9867 9.65162 27.1515C9.65162 30.0844 10.8498 32.5995 12.5343 33.6126Z'
          fill='#1E24C0'
        />
        <path
          d='M27.7122 35.4746L30.8071 27.6005C31.1853 26.6167 31.1614 25.5225 30.7407 24.5563C30.3201 23.59 29.5367 22.8299 28.5611 22.4414L22.5791 37.7187C23.5563 38.0995 24.6435 38.0774 25.6046 37.6572C26.5657 37.237 27.3231 36.4527 27.7122 35.4746Z'
          fill='#1E24C0'
        />
        <path
          d='M34.8929 35.4746L37.9878 27.6005C38.3679 26.6211 38.3491 25.5307 37.9354 24.5652C37.5216 23.5997 36.7463 22.8367 35.7772 22.4414L29.7598 37.7187C30.737 38.0995 31.8242 38.0774 32.7853 37.6572C33.7464 37.237 34.5038 36.4527 34.8929 35.4746Z'
          fill='#1E24C0'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7565'>
          <rect
            width='45'
            height='50'
            fill='white'
            transform='translate(0 0.0449219)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconNCDD = () => {
  return (
    <svg
      width='54'
      height='48'
      viewBox='0 0 54 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M38.0963 18.0816C39.3332 16.3749 40.8961 14.9174 42.2481 14.9174C44.1754 14.9522 46.0932 14.6404 47.9101 13.9969C54.7228 11.3121 47.3876 4.81592 42.2481 3.40641C39.7713 2.75843 37.2237 2.42025 34.6636 2.39962C32.0398 2.34837 29.4194 2.61234 26.8586 3.18588C21.1965 4.48033 16.6756 7.36167 16.4502 11.8635V11.9833L16.4215 12.1032L8.58287 42.307L14.0339 42.7001C14.479 42.7313 14.8934 42.9379 15.1861 43.2746C15.4787 43.6113 15.6256 44.0505 15.5945 44.4956C15.5633 44.9406 15.3566 45.355 15.0199 45.6477C14.6832 45.9403 14.244 46.0872 13.799 46.0561L1.81339 45.1835C1.36836 45.1517 0.954182 44.9445 0.661975 44.6073C0.369769 44.2701 0.223467 43.8307 0.255255 43.3857C0.287043 42.9407 0.494316 42.5265 0.831478 42.2343C1.16864 41.9421 1.60807 41.7958 2.0531 41.8276L6.22889 42.1344L14.125 11.6238C14.475 5.94257 19.7535 2.40442 26.3312 0.894226C29.0752 0.284218 31.8818 0.000986587 34.6924 0.0504371C37.4439 0.0765334 40.1815 0.443698 42.8426 1.14353C50.5613 3.2482 57.9397 12.573 48.8019 16.1831C46.7068 16.9288 44.4957 17.2957 42.2721 17.2666C41.6632 17.2666 40.7907 18.2254 40.0044 19.4048L38.0963 18.0816ZM37.0416 31.75C35.7141 31.75 34.4164 32.1437 33.3126 32.8812C32.2088 33.6187 31.3485 34.667 30.8405 35.8934C30.3325 37.1199 30.1996 38.4694 30.4586 39.7714C30.7176 41.0734 31.3568 42.2694 32.2955 43.2081C33.2342 44.1467 34.4301 44.786 35.7321 45.045C37.0341 45.304 38.3837 45.171 39.6101 44.663C40.8366 44.155 41.8848 43.2947 42.6223 42.1909C43.3599 41.0872 43.7535 39.7895 43.7535 38.462C43.7535 36.6819 43.0464 34.9747 41.7876 33.7159C40.5289 32.4572 38.8217 31.75 37.0416 31.75ZM43.8734 33.2602C42.8162 31.867 41.3589 30.8297 39.6964 30.2868C38.0339 29.7438 36.2453 29.7212 34.5696 30.222C32.8939 30.7227 31.411 31.7229 30.3189 33.089C29.2269 34.455 28.5777 36.1218 28.4582 37.8666C28.3387 39.6115 28.7546 41.3512 29.6502 42.8534C30.5459 44.3555 31.8787 45.5486 33.4704 46.2731C35.0622 46.9976 36.8372 47.219 38.5582 46.9078C40.2792 46.5966 41.8642 45.7676 43.1015 44.5315C44.5792 43.0682 45.4728 41.1164 45.6149 39.0416C45.757 36.9668 45.1378 34.9113 43.8734 33.2602ZM33.3787 34.804C32.6559 35.5258 32.1634 36.4458 31.9635 37.4476C31.7637 38.4494 31.8655 39.488 32.2561 40.4319C32.6467 41.3759 33.3085 42.1827 34.1578 42.7504C35.007 43.3181 36.0056 43.6211 37.0272 43.6211C38.0487 43.6211 39.0473 43.3181 39.8966 42.7504C40.7459 42.1827 41.4077 41.3759 41.7983 40.4319C42.1888 39.488 42.2907 38.4494 42.0908 37.4476C41.891 36.4458 41.3985 35.5258 40.6756 34.804C40.1969 34.3242 39.6282 33.9435 39.0021 33.6838C38.3761 33.424 37.705 33.2903 37.0272 33.2903C36.3494 33.2903 35.6782 33.424 35.0522 33.6838C34.4261 33.9435 33.8575 34.3242 33.3787 34.804Z'
        fill='#282828'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M33.1587 19.9994C33.3505 19.9994 34.1751 19.9994 34.9997 19.9994C35.2495 19.6518 35.5786 19.3687 35.9596 19.1737C36.3406 18.9786 36.7626 18.8771 37.1907 18.8775C37.3088 18.8702 37.4273 18.8702 37.5454 18.8775L39.4967 20.1864C39.766 20.6173 39.9058 21.1165 39.8994 21.6247C39.8989 21.896 39.8586 22.1657 39.7796 22.4253C41.0788 24.3142 41.9466 27.1285 42.3589 30.2255C40.2412 28.9039 37.6993 28.4393 35.2511 28.9265C32.8028 29.4137 30.6324 30.8159 29.182 32.8476C27.7316 34.8792 27.1104 37.3874 27.4448 39.8612C27.7793 42.3349 29.0443 44.5881 30.9821 46.1616H26.1879C11.1243 45.6726 22.6257 20.2966 33.1587 19.9994Z'
        fill='#282828'
      />
    </svg>
  )
}

export const IconLDSK = () => {
  return (
    <svg
      width='45'
      height='46'
      viewBox='0 0 45 46'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7525)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0.786033 10.6084C1.20044 -4.08104 22.0592 -0.426859 28.5977 7.23834C28.8217 7.50756 29.1027 7.72319 29.4202 7.86951C29.7377 8.01583 30.0836 8.08916 30.4329 8.08415H34.7349C34.9233 8.08415 35.104 8.15934 35.2372 8.29318C35.3705 8.42702 35.4453 8.60854 35.4453 8.79781V14.7449C35.4453 14.9342 35.3705 15.1157 35.2372 15.2496C35.104 15.3834 34.9233 15.4586 34.7349 15.4586H29.7291C29.1392 15.4524 28.5685 15.6694 28.1306 16.0665C25.6113 18.3132 21.4408 20.1899 17.1125 21.0225C16.0236 21.2333 15.059 21.8615 14.4231 22.7742C13.7871 23.6869 13.5296 24.8123 13.7052 25.9123L14.5471 31.126C14.6063 31.4525 14.541 31.7893 14.3643 32.0697C14.1876 32.35 13.9124 32.5533 13.5933 32.6392L13.2776 32.7119L13.3697 33.082C13.4084 33.2791 13.3679 33.4836 13.257 33.6507C13.146 33.8179 12.9737 33.9342 12.7777 33.974C12.9092 34.3705 13.0605 34.7604 13.2052 35.1238C14.0472 37.2912 14.6787 38.8969 11.6265 40.5489C9.4229 41.7449 8.75195 42.3661 8.93613 42.7163C9.17951 43.1657 10.4556 43.5952 11.962 44.0908L12.929 44.4212L12.554 45.5181L11.6002 45.2009C9.85704 44.6194 8.38358 44.1304 7.91655 43.2648C7.38373 42.267 8.12046 41.1304 11.0805 39.5247C13.225 38.3683 12.7579 37.159 12.1264 35.5599C11.9686 35.1568 11.7975 34.7273 11.6463 34.2383C11.4744 34.2601 11.3005 34.2204 11.1549 34.1261C11.0094 34.0319 10.9015 33.8891 10.8503 33.7229L10.7385 33.2802L10.3109 33.3793C9.98473 33.4523 9.64305 33.3924 9.3607 33.2128C9.07836 33.0333 8.87838 32.7486 8.80457 32.4212L6.32468 21.485C6.24395 21.117 6.08909 20.7694 5.86962 20.4637C5.65016 20.158 5.37073 19.9007 5.04855 19.7075C2.38448 18.0357 0.667629 15.148 0.786033 10.6084ZM15.3431 14.9432C15.902 14.1407 16.2792 13.225 16.4482 12.2604C16.4583 12.1988 16.4553 12.1357 16.4394 12.0754C16.4235 12.015 16.3951 11.9587 16.3561 11.9101C16.316 11.8618 16.2656 11.8231 16.2087 11.7968C16.1518 11.7705 16.0898 11.7573 16.0272 11.7582H12.5014C12.4167 11.7581 12.334 11.7832 12.2636 11.8304C12.1932 11.8776 12.1383 11.9447 12.1059 12.0232C12.0735 12.1018 12.065 12.1882 12.0816 12.2716C12.0981 12.355 12.1389 12.4316 12.1988 12.4916L14.6984 14.996C14.7412 15.0412 14.7936 15.076 14.8517 15.0978C14.9099 15.1195 14.9722 15.1277 15.0339 15.1216C15.0962 15.1165 15.1567 15.0978 15.2112 15.0671C15.2657 15.0363 15.3129 14.994 15.3496 14.9432H15.3431ZM16.4482 9.96741C16.2792 9.00281 15.902 8.08709 15.3431 7.2846C15.3063 7.23377 15.2591 7.19152 15.2046 7.16072C15.1501 7.12993 15.0896 7.11133 15.0273 7.10618C14.9656 7.1001 14.9033 7.10825 14.8451 7.13C14.787 7.15176 14.7346 7.18655 14.6918 7.23173L12.1922 9.73614C12.1363 9.79719 12.0992 9.8732 12.0854 9.95498C12.0715 10.0368 12.0816 10.1208 12.1143 10.197C12.147 10.2732 12.2009 10.3382 12.2696 10.3842C12.3383 10.4303 12.4188 10.4553 12.5014 10.4564H16.0338C16.0964 10.4572 16.1584 10.444 16.2153 10.4177C16.2722 10.3914 16.3225 10.3527 16.3627 10.3044C16.4021 10.2561 16.4307 10.1998 16.4466 10.1394C16.4625 10.0789 16.4653 10.0158 16.4547 9.9542L16.4482 9.96741ZM13.7315 5.66565C12.9458 5.10664 12.0476 4.72768 11.1003 4.55552C11.039 4.54201 10.9755 4.54335 10.9148 4.55944C10.8542 4.57553 10.7983 4.6059 10.7516 4.64803C10.7036 4.68833 10.665 4.7389 10.6388 4.79606C10.6127 4.85322 10.5995 4.91552 10.6004 4.97843V8.52028C10.5985 8.60547 10.6228 8.68917 10.6699 8.76007C10.7169 8.83097 10.7845 8.88566 10.8635 8.91675C10.9404 8.95088 11.0259 8.96031 11.1083 8.94375C11.1907 8.92719 11.266 8.88545 11.3239 8.82424L13.8236 6.31984C13.8667 6.27449 13.8997 6.22032 13.9201 6.16102C13.9405 6.10172 13.948 6.03868 13.942 5.97623C13.9356 5.91412 13.9158 5.85416 13.884 5.80053C13.8522 5.74689 13.8091 5.70086 13.7578 5.66565H13.7315ZM8.78484 4.55552C7.8237 4.72209 6.91146 5.10129 6.11418 5.66565C6.06276 5.70017 6.01996 5.74616 5.98916 5.80003C5.95835 5.85391 5.94035 5.91421 5.93658 5.97623C5.92781 6.03828 5.93334 6.10152 5.95272 6.16109C5.97211 6.22066 6.00484 6.27497 6.0484 6.31984L8.54803 8.82424C8.60594 8.88545 8.68125 8.92719 8.76368 8.94375C8.8461 8.96031 8.9316 8.95088 9.00849 8.91675C9.08747 8.88566 9.15505 8.83097 9.2021 8.76007C9.24915 8.68917 9.27341 8.60547 9.27161 8.52028V4.97843C9.27244 4.91552 9.25929 4.85322 9.23312 4.79606C9.20695 4.7389 9.16841 4.68833 9.12031 4.64803C9.0747 4.60645 9.01989 4.57637 8.96041 4.56029C8.90093 4.5442 8.83849 4.54257 8.77826 4.55552H8.78484ZM4.496 7.2846C3.94638 8.08937 3.57822 9.00495 3.41722 9.96741C3.40669 10.029 3.40947 10.0922 3.42536 10.1526C3.44125 10.213 3.46988 10.2693 3.50931 10.3176C3.54943 10.3659 3.59977 10.4047 3.65667 10.431C3.71356 10.4572 3.77558 10.4705 3.83821 10.4696H7.364C7.4488 10.4714 7.53212 10.4471 7.6027 10.3998C7.67329 10.3525 7.72773 10.2846 7.75867 10.2053C7.79134 10.1267 7.80003 10.0402 7.78363 9.95665C7.76724 9.87312 7.7265 9.79636 7.66658 9.73614L5.16696 7.23173C5.12453 7.18614 5.07214 7.15108 5.01393 7.12929C4.95571 7.1075 4.89326 7.09959 4.83148 7.10618C4.76917 7.11133 4.70869 7.12993 4.6542 7.16072C4.5997 7.19152 4.55247 7.23377 4.51574 7.2846H4.496ZM3.41722 12.2604C3.58617 13.225 3.96337 14.1407 4.52232 14.9432C4.55905 14.994 4.60628 15.0363 4.66078 15.0671C4.71527 15.0978 4.77574 15.1165 4.83806 15.1216C4.8998 15.1277 4.96211 15.1195 5.02024 15.0978C5.07838 15.076 5.13081 15.0412 5.17353 14.996L7.67316 12.4916C7.73307 12.4314 7.77382 12.3547 7.79021 12.2711C7.80661 12.1876 7.79792 12.101 7.76525 12.0225C7.73081 11.9458 7.67403 11.8813 7.6024 11.8377C7.53076 11.794 7.44764 11.7732 7.364 11.778H3.8119C3.74927 11.7771 3.68725 11.7904 3.63035 11.8167C3.57346 11.8429 3.52311 11.8817 3.483 11.93C3.44394 11.9785 3.41554 12.0348 3.39967 12.0952C3.38379 12.1555 3.38081 12.2186 3.39091 12.2802L3.41722 12.2604ZM6.11418 16.5621C6.91146 17.1265 7.8237 17.5057 8.78484 17.6723C8.84507 17.6852 8.90751 17.6836 8.96698 17.6675C9.02646 17.6514 9.08128 17.6213 9.12689 17.5798C9.17413 17.5402 9.21215 17.4907 9.23829 17.4347C9.26443 17.3788 9.27805 17.3178 9.27818 17.256V13.7075C9.2802 13.6224 9.25661 13.5387 9.2105 13.4673C9.16439 13.3959 9.0979 13.3401 9.01973 13.3073C8.94157 13.2744 8.85536 13.2661 8.77237 13.2832C8.68939 13.3004 8.61349 13.3423 8.55461 13.4035L6.0484 15.9079C6.00367 15.9522 5.96971 16.0062 5.94918 16.0658C5.92864 16.1254 5.92208 16.189 5.93 16.2516C5.93377 16.3136 5.95177 16.3739 5.98258 16.4277C6.01339 16.4816 6.05618 16.5276 6.10761 16.5621H6.11418ZM11.0674 17.6723C12.0148 17.5001 12.913 17.1211 13.6986 16.5621C13.7499 16.5269 13.793 16.4809 13.8248 16.4273C13.8566 16.3736 13.8764 16.3137 13.8828 16.2516C13.8879 16.1886 13.8794 16.1253 13.8579 16.0659C13.8363 16.0066 13.8021 15.9527 13.7578 15.9079L11.3108 13.4035C11.2519 13.3423 11.176 13.3004 11.093 13.2832C11.01 13.2661 10.9238 13.2744 10.8456 13.3073C10.7675 13.3401 10.701 13.3959 10.6549 13.4673C10.6088 13.5387 10.5852 13.6224 10.5872 13.7075V17.256C10.5873 17.3178 10.601 17.3788 10.6271 17.4347C10.6532 17.4907 10.6913 17.5402 10.7385 17.5798C10.7829 17.6189 10.8355 17.6476 10.8925 17.6636C10.9494 17.6796 11.0092 17.6826 11.0674 17.6723Z'
          fill='#282828'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M36.9648 7.37717C37.1424 7.2384 37.32 7.09964 37.5042 6.97408C38.8021 6.03168 40.3247 5.4504 41.918 5.28906C43.4178 5.28906 44.1151 6.26043 44.4637 7.60845C44.7368 8.98264 44.8472 10.3844 44.7926 11.7847C44.8472 13.1849 44.7368 14.5867 44.4637 15.9609C44.1151 17.2825 43.4178 18.2803 41.918 18.2803C40.3247 18.1189 38.8021 17.5376 37.5042 16.5952L36.9648 16.1921C36.8469 16.0998 36.7518 15.9815 36.6868 15.8462C36.6217 15.711 36.5886 15.5626 36.5899 15.4124V8.14369C36.5906 7.99575 36.6247 7.84991 36.6897 7.71714C36.7546 7.58437 36.8487 7.46813 36.9648 7.37717Z'
          fill='#282828'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7525'>
          <rect
            width='44'
            height='45'
            fill='white'
            transform='translate(0.786133 0.544922)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconXEPC = () => {
  return (
    <svg
      width='26'
      height='52'
      viewBox='0 0 26 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7532)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.1407 29.2602L18.1463 6.07284H3.47119L6.47679 29.2602H15.1407ZM4.86447 30.981L1.31738 4.53516H20.3123L19.138 12.4982L20.58 12.5531C23.0137 12.6507 24.3157 14.1945 24.9545 16.5499C25.5021 18.5635 25.5143 21.1812 25.3074 23.9271C25.1066 26.5509 23.6038 27.7164 22.0645 28.9185C21.8516 29.0833 21.6325 29.248 21.4561 29.4189C21.2141 29.6139 20.9047 29.7045 20.596 29.6707C20.2874 29.6369 20.0048 29.4816 19.8103 29.2389C19.6159 28.9961 19.5256 28.6858 19.5592 28.3763C19.5929 28.0667 19.7478 27.7833 19.9898 27.5883L20.6652 27.0513C21.7968 26.1726 22.892 25.3245 23.0137 23.7258C23.2023 21.2057 23.2084 18.8442 22.746 17.1357C22.3322 15.8115 21.6691 14.9268 20.507 14.8779L18.8521 14.8108L16.7408 30.981H4.86447Z'
          fill='#282828'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.0933 3.41914H1.53652C1.42849 3.42064 1.32171 3.3959 1.2253 3.34702C1.12888 3.29814 1.0457 3.22658 0.982854 3.13845C0.920548 3.05125 0.879784 2.95046 0.863917 2.84438C0.848051 2.73829 0.857535 2.62994 0.891591 2.52825C0.990043 2.22549 1.16151 1.95178 1.39077 1.73144C1.62002 1.51109 1.89998 1.35092 2.20578 1.26515C7.83113 -0.357916 13.7987 -0.357916 19.4241 1.26515C19.7296 1.35141 20.0093 1.51175 20.2385 1.73203C20.4677 1.9523 20.6393 2.22575 20.7383 2.52825C20.7739 2.62971 20.7841 2.73836 20.7682 2.84472C20.7523 2.95109 20.7107 3.05193 20.647 3.13845C20.5842 3.22658 20.501 3.29814 20.4046 3.34702C20.3081 3.3959 20.2014 3.42064 20.0933 3.41914Z'
          fill='#282828'
        />
        <path
          d='M20.3971 48.4639H1.18924C0.76921 48.4639 0.428711 48.8054 0.428711 49.2266V50.2822C0.428711 50.7035 0.76921 51.045 1.18924 51.045H20.3971C20.8171 51.045 21.1576 50.7035 21.1576 50.2822V49.2266C21.1576 48.8054 20.8171 48.4639 20.3971 48.4639Z'
          fill='#282828'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.3891 34.1794C18.3803 33.6342 18.1646 33.1129 17.7859 32.7217C17.4072 32.3306 16.8939 32.099 16.3509 32.0742H5.24717C4.70507 32.1019 4.1935 32.3343 3.81536 32.7249C3.43722 33.1154 3.22057 33.6351 3.20897 34.1794L2.12598 47.3474H19.4781L18.3891 34.1794ZM10.8021 43.8449C9.98619 43.8449 9.18864 43.6022 8.51028 43.1476C7.83191 42.693 7.30318 42.0469 6.99097 41.2909C6.67875 40.535 6.59706 39.7032 6.75623 38.9006C6.91539 38.0981 7.30827 37.3609 7.88517 36.7824C8.46208 36.2038 9.1971 35.8098 9.99729 35.6501C10.7975 35.4905 11.6269 35.5724 12.3807 35.8855C13.1344 36.1987 13.7787 36.7289 14.2319 37.4093C14.6852 38.0896 14.9271 38.8895 14.9271 39.7077C14.9255 40.8045 14.4904 41.8558 13.7172 42.6313C12.9439 43.4068 11.8956 43.8432 10.8021 43.8449Z'
          fill='#282828'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.8023 42.4781C11.3486 42.4781 11.8826 42.3156 12.3369 42.0112C12.7911 41.7068 13.1452 41.2741 13.3542 40.7679C13.5633 40.2617 13.618 39.7047 13.5114 39.1673C13.4048 38.6299 13.1418 38.1363 12.7555 37.7489C12.3692 37.3615 11.877 37.0976 11.3412 36.9907C10.8053 36.8838 10.2499 36.9387 9.74521 37.1484C9.24048 37.3581 8.80908 37.7131 8.50556 38.1687C8.20204 38.6243 8.04004 39.1599 8.04004 39.7078C8.04004 40.0716 8.11149 40.4318 8.2503 40.7679C8.38912 41.104 8.59258 41.4094 8.84908 41.6667C9.10557 41.9239 9.41008 42.128 9.74521 42.2672C10.0803 42.4064 10.4395 42.4781 10.8023 42.4781Z'
          fill='#282828'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7532'>
          <rect
            width='25'
            height='51'
            fill='white'
            transform='translate(0.428711 0.0449219)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconCSMB = () => {
  return (
    <svg
      width='51'
      height='51'
      viewBox='0 0 51 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7542)'>
        <path
          d='M10.5957 50.5545L10.7849 50.3923C12.3348 48.8379 12.0329 45.9185 10.2398 43.3099L21.8365 31.7042L18.9125 28.7803L7.31584 40.377C4.70275 38.5748 1.78781 38.282 0.23348 39.8318C0.174911 39.8904 0.125353 39.958 0.0712891 40.021C1.00056 40.3289 1.84464 40.8505 2.5357 41.5438C4.04498 43.0576 4.62616 45.04 4.11706 46.4997C5.55876 45.9906 7.54561 46.5673 9.07291 48.0811C9.76868 48.7737 10.2905 49.6213 10.5957 50.5545Z'
          fill='#282828'
        />
        <path
          d='M39.8708 2.07249C38.7895 4.44679 39.3662 5.16764 36.5639 6.96526C33.7616 8.76288 30.0177 11.0651 25.7512 16.1696C21.4846 21.2741 19.5879 27.6807 19.5879 27.6807L21.2458 29.3792L22.9218 31.0507C22.9218 31.0507 29.3554 29.0864 34.4464 24.8424C39.5374 20.5983 41.8532 16.8589 43.6508 14.0611C45.4484 11.2633 46.1693 11.831 48.5436 10.7542C50.9179 9.67746 50.6791 7.85731 46.7414 3.90165C42.8038 -0.0540211 40.9476 -0.301814 39.8708 2.07249ZM38.1678 16.6202C37.5731 17.2149 36.1675 16.7733 35.0141 15.6335C33.8607 14.4936 33.4327 13.088 34.0274 12.4798C34.6221 11.8716 36.0278 12.3266 37.1812 13.4664C38.3345 14.6063 38.7625 16.0255 38.1678 16.6202ZM42.1685 12.6194C41.5738 13.2141 40.1682 12.7726 39.0148 11.6328C37.8615 10.4929 37.4334 9.08727 38.0236 8.47905C38.6138 7.87083 40.024 8.33037 41.1774 9.47022C42.3307 10.6101 42.7632 12.0292 42.1685 12.6194Z'
          fill='#282828'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7542'>
          <rect
            width='50'
            height='50'
            fill='white'
            transform='translate(0.0712891 0.544922)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconDCBA = () => {
  return (
    <svg
      width='51'
      height='34'
      viewBox='0 0 51 34'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7557)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.09001 0.544922H47.91C48.729 0.54647 49.5141 0.869656 50.0932 1.44371C50.6724 2.01777 50.9984 2.79591 51 3.60774V30.4821C50.9984 31.2939 50.6724 32.0721 50.0932 32.6461C49.5141 33.2202 48.729 33.5434 47.91 33.5449H3.09001C2.27097 33.5434 1.48592 33.2202 0.906769 32.6461C0.327617 32.0721 0.00156157 31.2939 0 30.4821V3.60774C0.00156157 2.79591 0.327617 2.01777 0.906769 1.44371C1.48592 0.869656 2.27097 0.54647 3.09001 0.544922V0.544922ZM48.0754 29.1469C48.2811 29.1469 48.4821 29.0864 48.6531 28.9732C48.8241 28.8599 48.9574 28.6989 49.0361 28.5106C49.1148 28.3223 49.1354 28.115 49.0953 27.9151C49.0552 27.7152 48.9561 27.5315 48.8107 27.3874C48.6653 27.2432 48.48 27.145 48.2783 27.1053C48.0766 27.0655 47.8675 27.0859 47.6775 27.1639C47.4875 27.2419 47.3251 27.3741 47.2108 27.5435C47.0966 27.713 47.0356 27.9123 47.0356 28.1162C47.0356 28.2515 47.0625 28.3856 47.1147 28.5106C47.167 28.6357 47.2436 28.7493 47.3401 28.845C47.4367 28.9407 47.5513 29.0166 47.6775 29.0684C47.8036 29.1202 47.9389 29.1469 48.0754 29.1469ZM45.1567 29.0473C45.3622 29.0462 45.5626 28.9847 45.7328 28.8708C45.9031 28.7568 46.0354 28.5954 46.1132 28.407C46.191 28.2186 46.2108 28.0115 46.17 27.812C46.1292 27.6124 46.0297 27.4293 45.884 27.2858C45.7384 27.1422 45.5531 27.0446 45.3515 27.0053C45.15 26.966 44.9412 26.9868 44.7515 27.0649C44.5619 27.1431 44.3998 27.2752 44.2858 27.4446C44.1718 27.614 44.111 27.813 44.111 28.0166C44.111 28.1525 44.1381 28.287 44.1907 28.4124C44.2433 28.5378 44.3204 28.6517 44.4176 28.7475C44.5148 28.8433 44.6301 28.9191 44.757 28.9705C44.8838 29.022 45.0197 29.0481 45.1567 29.0473ZM42.2381 29.0473C42.4435 29.0462 42.6439 28.9847 42.8142 28.8708C42.9844 28.7568 43.1167 28.5954 43.1945 28.407C43.2723 28.2186 43.2921 28.0115 43.2513 27.812C43.2105 27.6124 43.111 27.4293 42.9654 27.2858C42.8197 27.1422 42.6344 27.0446 42.4329 27.0053C42.2313 26.966 42.0225 26.9868 41.8329 27.0649C41.6432 27.1431 41.4812 27.2752 41.3671 27.4446C41.2532 27.614 41.1923 27.813 41.1923 28.0166C41.1923 28.1525 41.2194 28.287 41.272 28.4124C41.3246 28.5378 41.4018 28.6517 41.499 28.7475C41.5961 28.8433 41.7115 28.9191 41.8383 28.9705C41.9652 29.022 42.101 29.0481 42.2381 29.0473ZM40.1406 5.14208V9.01307H49.1094V5.14208H40.1406ZM45.7535 21.727C46.7413 21.7239 47.6877 21.3336 48.3862 20.6413C49.0847 19.9489 49.4785 19.0108 49.4816 18.0317C49.4785 17.0531 49.0845 16.1156 48.3858 15.4242C47.6872 14.7328 46.7407 14.3438 45.7535 14.3423C44.7662 14.3454 43.8204 14.7359 43.1228 15.4284C42.4253 16.1209 42.0328 17.059 42.0313 18.0376C42.0344 19.0167 42.4282 19.9548 43.1267 20.6471C43.8251 21.3395 44.7716 21.7298 45.7594 21.7329L45.7535 21.727ZM45.7535 20.1458C46.3187 20.1443 46.8603 19.921 47.2599 19.5249C47.6596 19.1288 47.8848 18.5919 47.8864 18.0317C47.8832 17.4725 47.6573 16.9372 47.2579 16.5423C46.8584 16.1474 46.3177 15.925 45.7535 15.9234C45.1884 15.9256 44.647 16.1486 44.2469 16.5442C43.8586 16.945 43.6461 17.4819 43.656 18.0376C43.6576 18.5978 43.8828 19.1346 44.2825 19.5308C44.6821 19.9269 45.2237 20.1501 45.7889 20.1517L45.7535 20.1458ZM38.1614 26.5877H39.1953C39.6395 26.562 40.0553 26.3625 40.3511 26.0331C40.647 25.7036 40.7986 25.2711 40.7728 24.8308V13.0656C40.7971 12.6257 40.6448 12.1941 40.3493 11.865C40.0538 11.5358 39.639 11.3359 39.1953 11.3087H36.832C36.1171 11.3087 35.5263 12.0935 35.5263 13.0656V24.8718C35.5263 25.8322 36.1171 26.6287 36.832 26.6287L38.1614 26.5877ZM38.1614 11.3029V4.79071H6.59361C5.99184 4.79843 5.41754 5.0416 4.99589 5.46722C4.57423 5.89285 4.33939 6.46642 4.34256 7.06293V27.0269C4.33938 27.624 4.57402 28.1982 4.99552 28.6247C5.41701 29.0513 5.9913 29.2957 6.59361 29.305H38.1614V11.3263V11.3029Z'
          fill='#282828'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M45.7597 20.5091C46.2494 20.5091 46.728 20.3652 47.1351 20.0956C47.5422 19.8259 47.8595 19.4427 48.0468 18.9944C48.2342 18.546 48.2832 18.0526 48.1877 17.5766C48.0922 17.1006 47.8564 16.6634 47.5102 16.3203C47.164 15.9771 46.7229 15.7434 46.2427 15.6487C45.7625 15.554 45.2647 15.6026 44.8124 15.7883C44.36 15.9741 43.9734 16.2886 43.7014 16.6921C43.4294 17.0956 43.2842 17.57 43.2842 18.0553C43.2857 18.7056 43.5471 19.3289 44.011 19.7887C44.4749 20.2485 45.1037 20.5076 45.7597 20.5091Z'
          fill='#282828'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7557'>
          <rect
            width='51'
            height='33'
            fill='white'
            transform='translate(0 0.544922)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconDCSC = () => {
  return (
    <svg
      width='49'
      height='36'
      viewBox='0 0 49 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7512)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M47.941 2.64849V6.54984C48.4695 10.1913 48.5008 13.8872 48.034 17.537C47.7058 20.6659 47.068 23.7549 46.1301 26.7588H43.536V35.0492H41.8034V26.7588H38.573C38.2011 26.7588 37.8976 26.2419 37.8976 25.6177C37.8976 24.9935 38.2011 24.4766 38.573 24.4766H39.2583C39.704 22.7085 40.0537 20.9178 40.3057 19.1122L40.4427 18.0686L40.4917 17.5224C40.6777 15.8643 40.7804 14.2696 40.8049 12.7676H33.3996C29.812 12.7676 26.0579 11.5582 25.079 8.59805H22.4605C22.3549 8.59299 22.2555 8.54661 22.1841 8.469C22.1126 8.39138 22.0747 8.2888 22.0787 8.18353V7.96408H17.7324V3.60432H22.0787V3.38487C22.0747 3.2796 22.1126 3.17702 22.1841 3.09941C22.2555 3.02179 22.3549 2.97541 22.4605 2.97035H24.8588C26.0285 -1.12607 47.941 -0.628646 47.941 2.64849Z'
          fill='#282828'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.0329 6.61802H15.0408C14.5954 5.67682 13.7976 5.472 12.4125 5.23792C12.3586 5.23792 13.9298 5.72559 13.9102 6.61802H11.6392C11.1938 5.67682 10.396 5.472 9.01083 5.23792C8.96189 5.23792 10.533 5.72559 10.5085 6.61802H8.2473C7.8019 5.67682 7.0041 5.472 5.61408 5.23792C5.56513 5.23792 7.13625 5.72559 7.11668 6.61802H5.03653C4.59113 5.67682 3.78355 5.472 2.40331 5.23792C2.35436 5.23792 3.92549 5.72559 3.90591 6.61802H1.98238C1.82937 6.30367 1.60114 6.03161 1.31777 5.82582C1.03441 5.62002 0.704616 5.48679 0.357422 5.43786L0.357422 4.9502H17.0329V6.61802Z'
          fill='#282828'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M39.8262 18.8641H38.2208C38.0551 18.8641 37.8909 18.8313 37.7379 18.7676C37.5849 18.704 37.4462 18.6107 37.3296 18.4932C37.2131 18.3758 37.1211 18.2364 37.059 18.0832C36.9969 17.9301 36.9659 17.7662 36.9679 17.601V13.2607H40.2423C40.2423 14.7628 40.115 16.3623 39.929 18.0155L39.8703 18.5763L39.8262 18.8641Z'
          fill='#282828'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7512'>
          <rect
            width='48'
            height='35'
            fill='white'
            transform='translate(0.357422 0.0449219)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconBVTP = () => {
  return (
    <svg
      width='51'
      height='34'
      viewBox='0 0 51 34'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7557)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.09001 0.544922H47.91C48.729 0.54647 49.5141 0.869656 50.0932 1.44371C50.6724 2.01777 50.9984 2.79591 51 3.60774V30.4821C50.9984 31.2939 50.6724 32.0721 50.0932 32.6461C49.5141 33.2202 48.729 33.5434 47.91 33.5449H3.09001C2.27097 33.5434 1.48592 33.2202 0.906769 32.6461C0.327617 32.0721 0.00156157 31.2939 0 30.4821V3.60774C0.00156157 2.79591 0.327617 2.01777 0.906769 1.44371C1.48592 0.869656 2.27097 0.54647 3.09001 0.544922V0.544922ZM48.0754 29.1469C48.2811 29.1469 48.4821 29.0864 48.6531 28.9732C48.8241 28.8599 48.9574 28.6989 49.0361 28.5106C49.1148 28.3223 49.1354 28.115 49.0953 27.9151C49.0552 27.7152 48.9561 27.5315 48.8107 27.3874C48.6653 27.2432 48.48 27.145 48.2783 27.1053C48.0766 27.0655 47.8675 27.0859 47.6775 27.1639C47.4875 27.2419 47.3251 27.3741 47.2108 27.5435C47.0966 27.713 47.0356 27.9123 47.0356 28.1162C47.0356 28.2515 47.0625 28.3856 47.1147 28.5106C47.167 28.6357 47.2436 28.7493 47.3401 28.845C47.4367 28.9407 47.5513 29.0166 47.6775 29.0684C47.8036 29.1202 47.9389 29.1469 48.0754 29.1469ZM45.1567 29.0473C45.3622 29.0462 45.5626 28.9847 45.7328 28.8708C45.9031 28.7568 46.0354 28.5954 46.1132 28.407C46.191 28.2186 46.2108 28.0115 46.17 27.812C46.1292 27.6124 46.0297 27.4293 45.884 27.2858C45.7384 27.1422 45.5531 27.0446 45.3515 27.0053C45.15 26.966 44.9412 26.9868 44.7515 27.0649C44.5619 27.1431 44.3998 27.2752 44.2858 27.4446C44.1718 27.614 44.111 27.813 44.111 28.0166C44.111 28.1525 44.1381 28.287 44.1907 28.4124C44.2433 28.5378 44.3204 28.6517 44.4176 28.7475C44.5148 28.8433 44.6301 28.9191 44.757 28.9705C44.8838 29.022 45.0197 29.0481 45.1567 29.0473ZM42.2381 29.0473C42.4435 29.0462 42.6439 28.9847 42.8142 28.8708C42.9844 28.7568 43.1167 28.5954 43.1945 28.407C43.2723 28.2186 43.2921 28.0115 43.2513 27.812C43.2105 27.6124 43.111 27.4293 42.9654 27.2858C42.8197 27.1422 42.6344 27.0446 42.4329 27.0053C42.2313 26.966 42.0225 26.9868 41.8329 27.0649C41.6432 27.1431 41.4812 27.2752 41.3671 27.4446C41.2532 27.614 41.1923 27.813 41.1923 28.0166C41.1923 28.1525 41.2194 28.287 41.272 28.4124C41.3246 28.5378 41.4018 28.6517 41.499 28.7475C41.5961 28.8433 41.7115 28.9191 41.8383 28.9705C41.9652 29.022 42.101 29.0481 42.2381 29.0473ZM40.1406 5.14208V9.01307H49.1094V5.14208H40.1406ZM45.7535 21.727C46.7413 21.7239 47.6877 21.3336 48.3862 20.6413C49.0847 19.9489 49.4785 19.0108 49.4816 18.0317C49.4785 17.0531 49.0845 16.1156 48.3858 15.4242C47.6872 14.7328 46.7407 14.3438 45.7535 14.3423C44.7662 14.3454 43.8204 14.7359 43.1228 15.4284C42.4253 16.1209 42.0328 17.059 42.0313 18.0376C42.0344 19.0167 42.4282 19.9548 43.1267 20.6471C43.8251 21.3395 44.7716 21.7298 45.7594 21.7329L45.7535 21.727ZM45.7535 20.1458C46.3187 20.1443 46.8603 19.921 47.2599 19.5249C47.6596 19.1288 47.8848 18.5919 47.8864 18.0317C47.8832 17.4725 47.6573 16.9372 47.2579 16.5423C46.8584 16.1474 46.3177 15.925 45.7535 15.9234C45.1884 15.9256 44.647 16.1486 44.2469 16.5442C43.8586 16.945 43.6461 17.4819 43.656 18.0376C43.6576 18.5978 43.8828 19.1346 44.2825 19.5308C44.6821 19.9269 45.2237 20.1501 45.7889 20.1517L45.7535 20.1458ZM38.1614 26.5877H39.1953C39.6395 26.562 40.0553 26.3625 40.3511 26.0331C40.647 25.7036 40.7986 25.2711 40.7728 24.8308V13.0656C40.7971 12.6257 40.6448 12.1941 40.3493 11.865C40.0538 11.5358 39.639 11.3359 39.1953 11.3087H36.832C36.1171 11.3087 35.5263 12.0935 35.5263 13.0656V24.8718C35.5263 25.8322 36.1171 26.6287 36.832 26.6287L38.1614 26.5877ZM38.1614 11.3029V4.79071H6.59361C5.99184 4.79843 5.41754 5.0416 4.99589 5.46722C4.57423 5.89285 4.33939 6.46642 4.34256 7.06293V27.0269C4.33938 27.624 4.57402 28.1982 4.99552 28.6247C5.41701 29.0513 5.9913 29.2957 6.59361 29.305H38.1614V11.3263V11.3029Z'
          fill='#282828'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M45.7597 20.5091C46.2494 20.5091 46.728 20.3652 47.1351 20.0956C47.5422 19.8259 47.8595 19.4427 48.0468 18.9944C48.2342 18.546 48.2832 18.0526 48.1877 17.5766C48.0922 17.1006 47.8564 16.6634 47.5102 16.3203C47.164 15.9771 46.7229 15.7434 46.2427 15.6487C45.7625 15.554 45.2647 15.6026 44.8124 15.7883C44.36 15.9741 43.9734 16.2886 43.7014 16.6921C43.4294 17.0956 43.2842 17.57 43.2842 18.0553C43.2857 18.7056 43.5471 19.3289 44.011 19.7887C44.4749 20.2485 45.1037 20.5076 45.7597 20.5091Z'
          fill='#282828'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7557'>
          <rect
            width='51'
            height='33'
            fill='white'
            transform='translate(0 0.544922)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconElement = () => {
  return (
    <svg
      width='45'
      height='51'
      viewBox='0 0 45 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7565)'>
        <path
          d='M45 46.2323V1.96902C45 1.45872 44.7983 0.969318 44.4393 0.608478C44.0803 0.247639 43.5933 0.0449219 43.0856 0.0449219L1.91443 0.0449219C1.40669 0.0449219 0.919751 0.247639 0.560727 0.608478C0.201703 0.969318 5.10589e-06 1.45872 5.10589e-06 1.96902V46.2323C-0.000576368 46.4853 0.0485126 46.736 0.144461 46.97C0.240409 47.2039 0.381333 47.4165 0.559161 47.5957C0.73699 47.7748 0.94823 47.917 1.18079 48.0139C1.41334 48.1109 1.66265 48.1608 1.91443 48.1608H2.85174V50.0449H7.07409V48.1608H38.1116V50.0449H42.3428V48.1608H43.0812C43.3333 48.1614 43.5831 48.1119 43.8162 48.0152C44.0492 47.9185 44.261 47.7765 44.4393 47.5973C44.6176 47.4181 44.7589 47.2052 44.8551 46.971C44.9514 46.7367 45.0006 46.4857 45 46.2323ZM33.3897 2.71111C33.7683 2.71111 34.1384 2.82396 34.4533 3.03538C34.7681 3.24681 35.0135 3.54731 35.1584 3.89889C35.3033 4.25048 35.3412 4.63735 35.2673 5.01059C35.1934 5.38383 35.0111 5.72667 34.7434 5.99576C34.4756 6.26485 34.1345 6.44811 33.7632 6.52235C33.3918 6.59659 33.0069 6.55849 32.6571 6.41286C32.3072 6.26723 32.0082 6.02061 31.7979 5.70419C31.5875 5.38777 31.4752 5.01577 31.4752 4.63522C31.4752 4.12491 31.6769 3.63551 32.036 3.27467C32.395 2.91383 32.8819 2.71111 33.3897 2.71111ZM24.7593 2.71111C25.1379 2.71111 25.5081 2.82396 25.8229 3.03538C26.1377 3.24681 26.3831 3.54731 26.528 3.89889C26.6729 4.25048 26.7108 4.63735 26.6369 5.01059C26.5631 5.38383 26.3807 5.72667 26.113 5.99576C25.8453 6.26485 25.5041 6.44811 25.1328 6.52235C24.7614 6.59659 24.3765 6.55849 24.0267 6.41286C23.6769 6.26723 23.3779 6.02061 23.1675 5.70419C22.9571 5.38777 22.8449 5.01577 22.8449 4.63522C22.8449 4.12491 23.0466 3.63551 23.4056 3.27467C23.7646 2.91383 24.2516 2.71111 24.7593 2.71111ZM7.27747 3.8798C7.27747 3.75016 7.32871 3.62583 7.41991 3.53416C7.51112 3.44249 7.63482 3.39099 7.76381 3.39099H9.47043C9.5343 3.39099 9.59754 3.40364 9.65655 3.4282C9.71555 3.45277 9.76917 3.48877 9.81433 3.53416C9.85949 3.57955 9.89531 3.63344 9.91975 3.69274C9.94419 3.75204 9.95677 3.81561 9.95677 3.8798V5.5906C9.95677 5.65479 9.94419 5.71836 9.91975 5.77766C9.89531 5.83696 9.85949 5.89085 9.81433 5.93624C9.76917 5.98163 9.71555 6.01763 9.65655 6.0422C9.59754 6.06676 9.5343 6.0794 9.47043 6.0794H7.76381C7.63482 6.0794 7.51112 6.02791 7.41991 5.93624C7.32871 5.84457 7.27747 5.72024 7.27747 5.5906V3.8798ZM3.47073 9.18552H41.5293V10.9896H3.47073V9.18552ZM39.973 42.2596H5.04471V17.0863H39.973V42.2596Z'
          fill='#282828'
        />
        <path
          d='M12.5343 33.6126C12.4331 33.8453 12.3804 34.0963 12.3796 34.3503C12.3808 34.8004 12.5477 35.2341 12.8482 35.5678C11.6103 35.8878 10.7437 36.6299 10.7437 37.5008H17.6497C17.6497 36.6121 16.7655 35.8878 15.5408 35.5678C15.7802 35.31 15.9379 34.9864 15.9938 34.6382C16.0497 34.2901 16.0013 33.9331 15.8547 33.6126C17.5436 32.595 18.7374 30.0844 18.7374 27.1427C18.7446 25.9808 18.547 24.8269 18.1538 23.7344H10.2352C9.84095 24.8297 9.64334 25.9867 9.65162 27.1515C9.65162 30.0844 10.8498 32.5995 12.5343 33.6126Z'
          fill='#282828'
        />
        <path
          d='M27.7122 35.4746L30.8071 27.6005C31.1853 26.6167 31.1614 25.5225 30.7407 24.5563C30.3201 23.59 29.5367 22.8299 28.5611 22.4414L22.5791 37.7187C23.5563 38.0995 24.6435 38.0774 25.6046 37.6572C26.5657 37.237 27.3231 36.4527 27.7122 35.4746Z'
          fill='#282828'
        />
        <path
          d='M34.8929 35.4746L37.9878 27.6005C38.3679 26.6211 38.3491 25.5307 37.9354 24.5652C37.5216 23.5997 36.7463 22.8367 35.7772 22.4414L29.7598 37.7187C30.737 38.0995 31.8242 38.0774 32.7853 37.6572C33.7464 37.237 34.5038 36.4527 34.8929 35.4746Z'
          fill='#282828'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7565'>
          <rect
            width='45'
            height='50'
            fill='white'
            transform='translate(0 0.0449219)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconNCDDActive = () => {
  return (
    <svg
      width='54'
      height='48'
      viewBox='0 0 54 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M38.0963 18.0816C39.3332 16.3749 40.8961 14.9174 42.2481 14.9174C44.1754 14.9522 46.0932 14.6404 47.9101 13.9969C54.7228 11.3121 47.3876 4.81592 42.2481 3.40641C39.7713 2.75843 37.2237 2.42025 34.6636 2.39962C32.0398 2.34837 29.4194 2.61234 26.8586 3.18588C21.1965 4.48033 16.6756 7.36167 16.4502 11.8635V11.9833L16.4215 12.1032L8.58287 42.307L14.0339 42.7001C14.479 42.7313 14.8934 42.9379 15.1861 43.2746C15.4787 43.6113 15.6256 44.0505 15.5945 44.4956C15.5633 44.9406 15.3566 45.355 15.0199 45.6477C14.6832 45.9403 14.244 46.0872 13.799 46.0561L1.81339 45.1835C1.36836 45.1517 0.954182 44.9445 0.661975 44.6073C0.369769 44.2701 0.223467 43.8307 0.255255 43.3857C0.287043 42.9407 0.494316 42.5265 0.831478 42.2343C1.16864 41.9421 1.60807 41.7958 2.0531 41.8276L6.22889 42.1344L14.125 11.6238C14.475 5.94257 19.7535 2.40442 26.3312 0.894226C29.0752 0.284218 31.8818 0.000986587 34.6924 0.0504371C37.4439 0.0765334 40.1815 0.443698 42.8426 1.14353C50.5613 3.2482 57.9397 12.573 48.8019 16.1831C46.7068 16.9288 44.4957 17.2957 42.2721 17.2666C41.6632 17.2666 40.7907 18.2254 40.0044 19.4048L38.0963 18.0816ZM37.0416 31.75C35.7141 31.75 34.4164 32.1437 33.3126 32.8812C32.2088 33.6187 31.3485 34.667 30.8405 35.8934C30.3325 37.1199 30.1996 38.4694 30.4586 39.7714C30.7176 41.0734 31.3568 42.2694 32.2955 43.2081C33.2342 44.1467 34.4301 44.786 35.7321 45.045C37.0341 45.304 38.3837 45.171 39.6101 44.663C40.8366 44.155 41.8848 43.2947 42.6223 42.1909C43.3599 41.0872 43.7535 39.7895 43.7535 38.462C43.7535 36.6819 43.0464 34.9747 41.7876 33.7159C40.5289 32.4572 38.8217 31.75 37.0416 31.75ZM43.8734 33.2602C42.8162 31.867 41.3589 30.8297 39.6964 30.2868C38.0339 29.7438 36.2453 29.7212 34.5696 30.222C32.8939 30.7227 31.411 31.7229 30.3189 33.089C29.2269 34.455 28.5777 36.1218 28.4582 37.8666C28.3387 39.6115 28.7546 41.3512 29.6502 42.8534C30.5459 44.3555 31.8787 45.5486 33.4704 46.2731C35.0622 46.9976 36.8372 47.219 38.5582 46.9078C40.2792 46.5966 41.8642 45.7676 43.1015 44.5315C44.5792 43.0682 45.4728 41.1164 45.6149 39.0416C45.757 36.9668 45.1378 34.9113 43.8734 33.2602ZM33.3787 34.804C32.6559 35.5258 32.1634 36.4458 31.9635 37.4476C31.7637 38.4494 31.8655 39.488 32.2561 40.4319C32.6467 41.3759 33.3085 42.1827 34.1578 42.7504C35.007 43.3181 36.0056 43.6211 37.0272 43.6211C38.0487 43.6211 39.0473 43.3181 39.8966 42.7504C40.7459 42.1827 41.4077 41.3759 41.7983 40.4319C42.1888 39.488 42.2907 38.4494 42.0908 37.4476C41.891 36.4458 41.3985 35.5258 40.6756 34.804C40.1969 34.3242 39.6282 33.9435 39.0021 33.6838C38.3761 33.424 37.705 33.2903 37.0272 33.2903C36.3494 33.2903 35.6782 33.424 35.0522 33.6838C34.4261 33.9435 33.8575 34.3242 33.3787 34.804Z'
        fill='#1E24C0'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M33.1587 19.9994C33.3505 19.9994 34.1751 19.9994 34.9997 19.9994C35.2495 19.6518 35.5786 19.3687 35.9596 19.1737C36.3406 18.9786 36.7626 18.8771 37.1907 18.8775C37.3088 18.8702 37.4273 18.8702 37.5454 18.8775L39.4967 20.1864C39.766 20.6173 39.9058 21.1165 39.8994 21.6247C39.8989 21.896 39.8586 22.1657 39.7796 22.4253C41.0788 24.3142 41.9466 27.1285 42.3589 30.2255C40.2412 28.9039 37.6993 28.4393 35.2511 28.9265C32.8028 29.4137 30.6324 30.8159 29.182 32.8476C27.7316 34.8792 27.1104 37.3874 27.4448 39.8612C27.7793 42.3349 29.0443 44.5881 30.9821 46.1616H26.1879C11.1243 45.6726 22.6257 20.2966 33.1587 19.9994Z'
        fill='#1E24C0'
      />
    </svg>
  )
}

export const IconLDSKActive = () => {
  return (
    <svg
      width='45'
      height='46'
      viewBox='0 0 45 46'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7525)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0.786033 10.6084C1.20044 -4.08104 22.0592 -0.426859 28.5977 7.23834C28.8217 7.50756 29.1027 7.72319 29.4202 7.86951C29.7377 8.01583 30.0836 8.08916 30.4329 8.08415H34.7349C34.9233 8.08415 35.104 8.15934 35.2372 8.29318C35.3705 8.42702 35.4453 8.60854 35.4453 8.79781V14.7449C35.4453 14.9342 35.3705 15.1157 35.2372 15.2496C35.104 15.3834 34.9233 15.4586 34.7349 15.4586H29.7291C29.1392 15.4524 28.5685 15.6694 28.1306 16.0665C25.6113 18.3132 21.4408 20.1899 17.1125 21.0225C16.0236 21.2333 15.059 21.8615 14.4231 22.7742C13.7871 23.6869 13.5296 24.8123 13.7052 25.9123L14.5471 31.126C14.6063 31.4525 14.541 31.7893 14.3643 32.0697C14.1876 32.35 13.9124 32.5533 13.5933 32.6392L13.2776 32.7119L13.3697 33.082C13.4084 33.2791 13.3679 33.4836 13.257 33.6507C13.146 33.8179 12.9737 33.9342 12.7777 33.974C12.9092 34.3705 13.0605 34.7604 13.2052 35.1238C14.0472 37.2912 14.6787 38.8969 11.6265 40.5489C9.4229 41.7449 8.75195 42.3661 8.93613 42.7163C9.17951 43.1657 10.4556 43.5952 11.962 44.0908L12.929 44.4212L12.554 45.5181L11.6002 45.2009C9.85704 44.6194 8.38358 44.1304 7.91655 43.2648C7.38373 42.267 8.12046 41.1304 11.0805 39.5247C13.225 38.3683 12.7579 37.159 12.1264 35.5599C11.9686 35.1568 11.7975 34.7273 11.6463 34.2383C11.4744 34.2601 11.3005 34.2204 11.1549 34.1261C11.0094 34.0319 10.9015 33.8891 10.8503 33.7229L10.7385 33.2802L10.3109 33.3793C9.98473 33.4523 9.64305 33.3924 9.3607 33.2128C9.07836 33.0333 8.87838 32.7486 8.80457 32.4212L6.32468 21.485C6.24395 21.117 6.08909 20.7694 5.86962 20.4637C5.65016 20.158 5.37073 19.9007 5.04855 19.7075C2.38448 18.0357 0.667629 15.148 0.786033 10.6084ZM15.3431 14.9432C15.902 14.1407 16.2792 13.225 16.4482 12.2604C16.4583 12.1988 16.4553 12.1357 16.4394 12.0754C16.4235 12.015 16.3951 11.9587 16.3561 11.9101C16.316 11.8618 16.2656 11.8231 16.2087 11.7968C16.1518 11.7705 16.0898 11.7573 16.0272 11.7582H12.5014C12.4167 11.7581 12.334 11.7832 12.2636 11.8304C12.1932 11.8776 12.1383 11.9447 12.1059 12.0232C12.0735 12.1018 12.065 12.1882 12.0816 12.2716C12.0981 12.355 12.1389 12.4316 12.1988 12.4916L14.6984 14.996C14.7412 15.0412 14.7936 15.076 14.8517 15.0978C14.9099 15.1195 14.9722 15.1277 15.0339 15.1216C15.0962 15.1165 15.1567 15.0978 15.2112 15.0671C15.2657 15.0363 15.3129 14.994 15.3496 14.9432H15.3431ZM16.4482 9.96741C16.2792 9.00281 15.902 8.08709 15.3431 7.2846C15.3063 7.23377 15.2591 7.19152 15.2046 7.16072C15.1501 7.12993 15.0896 7.11133 15.0273 7.10618C14.9656 7.1001 14.9033 7.10825 14.8451 7.13C14.787 7.15176 14.7346 7.18655 14.6918 7.23173L12.1922 9.73614C12.1363 9.79719 12.0992 9.8732 12.0854 9.95498C12.0715 10.0368 12.0816 10.1208 12.1143 10.197C12.147 10.2732 12.2009 10.3382 12.2696 10.3842C12.3383 10.4303 12.4188 10.4553 12.5014 10.4564H16.0338C16.0964 10.4572 16.1584 10.444 16.2153 10.4177C16.2722 10.3914 16.3225 10.3527 16.3627 10.3044C16.4021 10.2561 16.4307 10.1998 16.4466 10.1394C16.4625 10.0789 16.4653 10.0158 16.4547 9.9542L16.4482 9.96741ZM13.7315 5.66565C12.9458 5.10664 12.0476 4.72768 11.1003 4.55552C11.039 4.54201 10.9755 4.54335 10.9148 4.55944C10.8542 4.57553 10.7983 4.6059 10.7516 4.64803C10.7036 4.68833 10.665 4.7389 10.6388 4.79606C10.6127 4.85322 10.5995 4.91552 10.6004 4.97843V8.52028C10.5985 8.60547 10.6228 8.68917 10.6699 8.76007C10.7169 8.83097 10.7845 8.88566 10.8635 8.91675C10.9404 8.95088 11.0259 8.96031 11.1083 8.94375C11.1907 8.92719 11.266 8.88545 11.3239 8.82424L13.8236 6.31984C13.8667 6.27449 13.8997 6.22032 13.9201 6.16102C13.9405 6.10172 13.948 6.03868 13.942 5.97623C13.9356 5.91412 13.9158 5.85416 13.884 5.80053C13.8522 5.74689 13.8091 5.70086 13.7578 5.66565H13.7315ZM8.78484 4.55552C7.8237 4.72209 6.91146 5.10129 6.11418 5.66565C6.06276 5.70017 6.01996 5.74616 5.98916 5.80003C5.95835 5.85391 5.94035 5.91421 5.93658 5.97623C5.92781 6.03828 5.93334 6.10152 5.95272 6.16109C5.97211 6.22066 6.00484 6.27497 6.0484 6.31984L8.54803 8.82424C8.60594 8.88545 8.68125 8.92719 8.76368 8.94375C8.8461 8.96031 8.9316 8.95088 9.00849 8.91675C9.08747 8.88566 9.15505 8.83097 9.2021 8.76007C9.24915 8.68917 9.27341 8.60547 9.27161 8.52028V4.97843C9.27244 4.91552 9.25929 4.85322 9.23312 4.79606C9.20695 4.7389 9.16841 4.68833 9.12031 4.64803C9.0747 4.60645 9.01989 4.57637 8.96041 4.56029C8.90093 4.5442 8.83849 4.54257 8.77826 4.55552H8.78484ZM4.496 7.2846C3.94638 8.08937 3.57822 9.00495 3.41722 9.96741C3.40669 10.029 3.40947 10.0922 3.42536 10.1526C3.44125 10.213 3.46988 10.2693 3.50931 10.3176C3.54943 10.3659 3.59977 10.4047 3.65667 10.431C3.71356 10.4572 3.77558 10.4705 3.83821 10.4696H7.364C7.4488 10.4714 7.53212 10.4471 7.6027 10.3998C7.67329 10.3525 7.72773 10.2846 7.75867 10.2053C7.79134 10.1267 7.80003 10.0402 7.78363 9.95665C7.76724 9.87312 7.7265 9.79636 7.66658 9.73614L5.16696 7.23173C5.12453 7.18614 5.07214 7.15108 5.01393 7.12929C4.95571 7.1075 4.89326 7.09959 4.83148 7.10618C4.76917 7.11133 4.70869 7.12993 4.6542 7.16072C4.5997 7.19152 4.55247 7.23377 4.51574 7.2846H4.496ZM3.41722 12.2604C3.58617 13.225 3.96337 14.1407 4.52232 14.9432C4.55905 14.994 4.60628 15.0363 4.66078 15.0671C4.71527 15.0978 4.77574 15.1165 4.83806 15.1216C4.8998 15.1277 4.96211 15.1195 5.02024 15.0978C5.07838 15.076 5.13081 15.0412 5.17353 14.996L7.67316 12.4916C7.73307 12.4314 7.77382 12.3547 7.79021 12.2711C7.80661 12.1876 7.79792 12.101 7.76525 12.0225C7.73081 11.9458 7.67403 11.8813 7.6024 11.8377C7.53076 11.794 7.44764 11.7732 7.364 11.778H3.8119C3.74927 11.7771 3.68725 11.7904 3.63035 11.8167C3.57346 11.8429 3.52311 11.8817 3.483 11.93C3.44394 11.9785 3.41554 12.0348 3.39967 12.0952C3.38379 12.1555 3.38081 12.2186 3.39091 12.2802L3.41722 12.2604ZM6.11418 16.5621C6.91146 17.1265 7.8237 17.5057 8.78484 17.6723C8.84507 17.6852 8.90751 17.6836 8.96698 17.6675C9.02646 17.6514 9.08128 17.6213 9.12689 17.5798C9.17413 17.5402 9.21215 17.4907 9.23829 17.4347C9.26443 17.3788 9.27805 17.3178 9.27818 17.256V13.7075C9.2802 13.6224 9.25661 13.5387 9.2105 13.4673C9.16439 13.3959 9.0979 13.3401 9.01973 13.3073C8.94157 13.2744 8.85536 13.2661 8.77237 13.2832C8.68939 13.3004 8.61349 13.3423 8.55461 13.4035L6.0484 15.9079C6.00367 15.9522 5.96971 16.0062 5.94918 16.0658C5.92864 16.1254 5.92208 16.189 5.93 16.2516C5.93377 16.3136 5.95177 16.3739 5.98258 16.4277C6.01339 16.4816 6.05618 16.5276 6.10761 16.5621H6.11418ZM11.0674 17.6723C12.0148 17.5001 12.913 17.1211 13.6986 16.5621C13.7499 16.5269 13.793 16.4809 13.8248 16.4273C13.8566 16.3736 13.8764 16.3137 13.8828 16.2516C13.8879 16.1886 13.8794 16.1253 13.8579 16.0659C13.8363 16.0066 13.8021 15.9527 13.7578 15.9079L11.3108 13.4035C11.2519 13.3423 11.176 13.3004 11.093 13.2832C11.01 13.2661 10.9238 13.2744 10.8456 13.3073C10.7675 13.3401 10.701 13.3959 10.6549 13.4673C10.6088 13.5387 10.5852 13.6224 10.5872 13.7075V17.256C10.5873 17.3178 10.601 17.3788 10.6271 17.4347C10.6532 17.4907 10.6913 17.5402 10.7385 17.5798C10.7829 17.6189 10.8355 17.6476 10.8925 17.6636C10.9494 17.6796 11.0092 17.6826 11.0674 17.6723Z'
          fill='#1E24C0'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M36.9648 7.37717C37.1424 7.2384 37.32 7.09964 37.5042 6.97408C38.8021 6.03168 40.3247 5.4504 41.918 5.28906C43.4178 5.28906 44.1151 6.26043 44.4637 7.60845C44.7368 8.98264 44.8472 10.3844 44.7926 11.7847C44.8472 13.1849 44.7368 14.5867 44.4637 15.9609C44.1151 17.2825 43.4178 18.2803 41.918 18.2803C40.3247 18.1189 38.8021 17.5376 37.5042 16.5952L36.9648 16.1921C36.8469 16.0998 36.7518 15.9815 36.6868 15.8462C36.6217 15.711 36.5886 15.5626 36.5899 15.4124V8.14369C36.5906 7.99575 36.6247 7.84991 36.6897 7.71714C36.7546 7.58437 36.8487 7.46813 36.9648 7.37717Z'
          fill='#1E24C0'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7525'>
          <rect
            width='44'
            height='45'
            fill='white'
            transform='translate(0.786133 0.544922)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconXEPCActive = () => {
  return (
    <svg
      width='26'
      height='52'
      viewBox='0 0 26 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7532)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.1407 29.2602L18.1463 6.07284H3.47119L6.47679 29.2602H15.1407ZM4.86447 30.981L1.31738 4.53516H20.3123L19.138 12.4982L20.58 12.5531C23.0137 12.6507 24.3157 14.1945 24.9545 16.5499C25.5021 18.5635 25.5143 21.1812 25.3074 23.9271C25.1066 26.5509 23.6038 27.7164 22.0645 28.9185C21.8516 29.0833 21.6325 29.248 21.4561 29.4189C21.2141 29.6139 20.9047 29.7045 20.596 29.6707C20.2874 29.6369 20.0048 29.4816 19.8103 29.2389C19.6159 28.9961 19.5256 28.6858 19.5592 28.3763C19.5929 28.0667 19.7478 27.7833 19.9898 27.5883L20.6652 27.0513C21.7968 26.1726 22.892 25.3245 23.0137 23.7258C23.2023 21.2057 23.2084 18.8442 22.746 17.1357C22.3322 15.8115 21.6691 14.9268 20.507 14.8779L18.8521 14.8108L16.7408 30.981H4.86447Z'
          fill='#1E24C0'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.0933 3.41914H1.53652C1.42849 3.42064 1.32171 3.3959 1.2253 3.34702C1.12888 3.29814 1.0457 3.22658 0.982854 3.13845C0.920548 3.05125 0.879784 2.95046 0.863917 2.84438C0.848051 2.73829 0.857535 2.62994 0.891591 2.52825C0.990043 2.22549 1.16151 1.95178 1.39077 1.73144C1.62002 1.51109 1.89998 1.35092 2.20578 1.26515C7.83113 -0.357916 13.7987 -0.357916 19.4241 1.26515C19.7296 1.35141 20.0093 1.51175 20.2385 1.73203C20.4677 1.9523 20.6393 2.22575 20.7383 2.52825C20.7739 2.62971 20.7841 2.73836 20.7682 2.84472C20.7523 2.95109 20.7107 3.05193 20.647 3.13845C20.5842 3.22658 20.501 3.29814 20.4046 3.34702C20.3081 3.3959 20.2014 3.42064 20.0933 3.41914Z'
          fill='#1E24C0'
        />
        <path
          d='M20.3971 48.4639H1.18924C0.76921 48.4639 0.428711 48.8054 0.428711 49.2266V50.2822C0.428711 50.7035 0.76921 51.045 1.18924 51.045H20.3971C20.8171 51.045 21.1576 50.7035 21.1576 50.2822V49.2266C21.1576 48.8054 20.8171 48.4639 20.3971 48.4639Z'
          fill='#1E24C0'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.3891 34.1794C18.3803 33.6342 18.1646 33.1129 17.7859 32.7217C17.4072 32.3306 16.8939 32.099 16.3509 32.0742H5.24717C4.70507 32.1019 4.1935 32.3343 3.81536 32.7249C3.43722 33.1154 3.22057 33.6351 3.20897 34.1794L2.12598 47.3474H19.4781L18.3891 34.1794ZM10.8021 43.8449C9.98619 43.8449 9.18864 43.6022 8.51028 43.1476C7.83191 42.693 7.30318 42.0469 6.99097 41.2909C6.67875 40.535 6.59706 39.7032 6.75623 38.9006C6.91539 38.0981 7.30827 37.3609 7.88517 36.7824C8.46208 36.2038 9.1971 35.8098 9.99729 35.6501C10.7975 35.4905 11.6269 35.5724 12.3807 35.8855C13.1344 36.1987 13.7787 36.7289 14.2319 37.4093C14.6852 38.0896 14.9271 38.8895 14.9271 39.7077C14.9255 40.8045 14.4904 41.8558 13.7172 42.6313C12.9439 43.4068 11.8956 43.8432 10.8021 43.8449Z'
          fill='#1E24C0'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.8023 42.4781C11.3486 42.4781 11.8826 42.3156 12.3369 42.0112C12.7911 41.7068 13.1452 41.2741 13.3542 40.7679C13.5633 40.2617 13.618 39.7047 13.5114 39.1673C13.4048 38.6299 13.1418 38.1363 12.7555 37.7489C12.3692 37.3615 11.877 37.0976 11.3412 36.9907C10.8053 36.8838 10.2499 36.9387 9.74521 37.1484C9.24048 37.3581 8.80908 37.7131 8.50556 38.1687C8.20204 38.6243 8.04004 39.1599 8.04004 39.7078C8.04004 40.0716 8.11149 40.4318 8.2503 40.7679C8.38912 41.104 8.59258 41.4094 8.84908 41.6667C9.10557 41.9239 9.41008 42.128 9.74521 42.2672C10.0803 42.4064 10.4395 42.4781 10.8023 42.4781Z'
          fill='#1E24C0'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7532'>
          <rect
            width='25'
            height='51'
            fill='white'
            transform='translate(0.428711 0.0449219)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconCSMBActive = () => {
  return (
    <svg
      width='51'
      height='51'
      viewBox='0 0 51 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7542)'>
        <path
          d='M10.5957 50.5545L10.7849 50.3923C12.3348 48.8379 12.0329 45.9185 10.2398 43.3099L21.8365 31.7042L18.9125 28.7803L7.31584 40.377C4.70275 38.5748 1.78781 38.282 0.23348 39.8318C0.174911 39.8904 0.125353 39.958 0.0712891 40.021C1.00056 40.3289 1.84464 40.8505 2.5357 41.5438C4.04498 43.0576 4.62616 45.04 4.11706 46.4997C5.55876 45.9906 7.54561 46.5673 9.07291 48.0811C9.76868 48.7737 10.2905 49.6213 10.5957 50.5545Z'
          fill='#1E24C0'
        />
        <path
          d='M39.8708 2.07249C38.7895 4.44679 39.3662 5.16764 36.5639 6.96526C33.7616 8.76288 30.0177 11.0651 25.7512 16.1696C21.4846 21.2741 19.5879 27.6807 19.5879 27.6807L21.2458 29.3792L22.9218 31.0507C22.9218 31.0507 29.3554 29.0864 34.4464 24.8424C39.5374 20.5983 41.8532 16.8589 43.6508 14.0611C45.4484 11.2633 46.1693 11.831 48.5436 10.7542C50.9179 9.67746 50.6791 7.85731 46.7414 3.90165C42.8038 -0.0540211 40.9476 -0.301814 39.8708 2.07249ZM38.1678 16.6202C37.5731 17.2149 36.1675 16.7733 35.0141 15.6335C33.8607 14.4936 33.4327 13.088 34.0274 12.4798C34.6221 11.8716 36.0278 12.3266 37.1812 13.4664C38.3345 14.6063 38.7625 16.0255 38.1678 16.6202ZM42.1685 12.6194C41.5738 13.2141 40.1682 12.7726 39.0148 11.6328C37.8615 10.4929 37.4334 9.08727 38.0236 8.47905C38.6138 7.87083 40.024 8.33037 41.1774 9.47022C42.3307 10.6101 42.7632 12.0292 42.1685 12.6194Z'
          fill='#1E24C0'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7542'>
          <rect
            width='50'
            height='50'
            fill='white'
            transform='translate(0.0712891 0.544922)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconDCBAActive = () => {
  return (
    <svg
      width='51'
      height='34'
      viewBox='0 0 51 34'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7557)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.09001 0.544922H47.91C48.729 0.54647 49.5141 0.869656 50.0932 1.44371C50.6724 2.01777 50.9984 2.79591 51 3.60774V30.4821C50.9984 31.2939 50.6724 32.0721 50.0932 32.6461C49.5141 33.2202 48.729 33.5434 47.91 33.5449H3.09001C2.27097 33.5434 1.48592 33.2202 0.906769 32.6461C0.327617 32.0721 0.00156157 31.2939 0 30.4821V3.60774C0.00156157 2.79591 0.327617 2.01777 0.906769 1.44371C1.48592 0.869656 2.27097 0.54647 3.09001 0.544922V0.544922ZM48.0754 29.1469C48.2811 29.1469 48.4821 29.0864 48.6531 28.9732C48.8241 28.8599 48.9574 28.6989 49.0361 28.5106C49.1148 28.3223 49.1354 28.115 49.0953 27.9151C49.0552 27.7152 48.9561 27.5315 48.8107 27.3874C48.6653 27.2432 48.48 27.145 48.2783 27.1053C48.0766 27.0655 47.8675 27.0859 47.6775 27.1639C47.4875 27.2419 47.3251 27.3741 47.2108 27.5435C47.0966 27.713 47.0356 27.9123 47.0356 28.1162C47.0356 28.2515 47.0625 28.3856 47.1147 28.5106C47.167 28.6357 47.2436 28.7493 47.3401 28.845C47.4367 28.9407 47.5513 29.0166 47.6775 29.0684C47.8036 29.1202 47.9389 29.1469 48.0754 29.1469ZM45.1567 29.0473C45.3622 29.0462 45.5626 28.9847 45.7328 28.8708C45.9031 28.7568 46.0354 28.5954 46.1132 28.407C46.191 28.2186 46.2108 28.0115 46.17 27.812C46.1292 27.6124 46.0297 27.4293 45.884 27.2858C45.7384 27.1422 45.5531 27.0446 45.3515 27.0053C45.15 26.966 44.9412 26.9868 44.7515 27.0649C44.5619 27.1431 44.3998 27.2752 44.2858 27.4446C44.1718 27.614 44.111 27.813 44.111 28.0166C44.111 28.1525 44.1381 28.287 44.1907 28.4124C44.2433 28.5378 44.3204 28.6517 44.4176 28.7475C44.5148 28.8433 44.6301 28.9191 44.757 28.9705C44.8838 29.022 45.0197 29.0481 45.1567 29.0473ZM42.2381 29.0473C42.4435 29.0462 42.6439 28.9847 42.8142 28.8708C42.9844 28.7568 43.1167 28.5954 43.1945 28.407C43.2723 28.2186 43.2921 28.0115 43.2513 27.812C43.2105 27.6124 43.111 27.4293 42.9654 27.2858C42.8197 27.1422 42.6344 27.0446 42.4329 27.0053C42.2313 26.966 42.0225 26.9868 41.8329 27.0649C41.6432 27.1431 41.4812 27.2752 41.3671 27.4446C41.2532 27.614 41.1923 27.813 41.1923 28.0166C41.1923 28.1525 41.2194 28.287 41.272 28.4124C41.3246 28.5378 41.4018 28.6517 41.499 28.7475C41.5961 28.8433 41.7115 28.9191 41.8383 28.9705C41.9652 29.022 42.101 29.0481 42.2381 29.0473ZM40.1406 5.14208V9.01307H49.1094V5.14208H40.1406ZM45.7535 21.727C46.7413 21.7239 47.6877 21.3336 48.3862 20.6413C49.0847 19.9489 49.4785 19.0108 49.4816 18.0317C49.4785 17.0531 49.0845 16.1156 48.3858 15.4242C47.6872 14.7328 46.7407 14.3438 45.7535 14.3423C44.7662 14.3454 43.8204 14.7359 43.1228 15.4284C42.4253 16.1209 42.0328 17.059 42.0313 18.0376C42.0344 19.0167 42.4282 19.9548 43.1267 20.6471C43.8251 21.3395 44.7716 21.7298 45.7594 21.7329L45.7535 21.727ZM45.7535 20.1458C46.3187 20.1443 46.8603 19.921 47.2599 19.5249C47.6596 19.1288 47.8848 18.5919 47.8864 18.0317C47.8832 17.4725 47.6573 16.9372 47.2579 16.5423C46.8584 16.1474 46.3177 15.925 45.7535 15.9234C45.1884 15.9256 44.647 16.1486 44.2469 16.5442C43.8586 16.945 43.6461 17.4819 43.656 18.0376C43.6576 18.5978 43.8828 19.1346 44.2825 19.5308C44.6821 19.9269 45.2237 20.1501 45.7889 20.1517L45.7535 20.1458ZM38.1614 26.5877H39.1953C39.6395 26.562 40.0553 26.3625 40.3511 26.0331C40.647 25.7036 40.7986 25.2711 40.7728 24.8308V13.0656C40.7971 12.6257 40.6448 12.1941 40.3493 11.865C40.0538 11.5358 39.639 11.3359 39.1953 11.3087H36.832C36.1171 11.3087 35.5263 12.0935 35.5263 13.0656V24.8718C35.5263 25.8322 36.1171 26.6287 36.832 26.6287L38.1614 26.5877ZM38.1614 11.3029V4.79071H6.59361C5.99184 4.79843 5.41754 5.0416 4.99589 5.46722C4.57423 5.89285 4.33939 6.46642 4.34256 7.06293V27.0269C4.33938 27.624 4.57402 28.1982 4.99552 28.6247C5.41701 29.0513 5.9913 29.2957 6.59361 29.305H38.1614V11.3263V11.3029Z'
          fill='#1E24C0'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M45.7597 20.5091C46.2494 20.5091 46.728 20.3652 47.1351 20.0956C47.5422 19.8259 47.8595 19.4427 48.0468 18.9944C48.2342 18.546 48.2832 18.0526 48.1877 17.5766C48.0922 17.1006 47.8564 16.6634 47.5102 16.3203C47.164 15.9771 46.7229 15.7434 46.2427 15.6487C45.7625 15.554 45.2647 15.6026 44.8124 15.7883C44.36 15.9741 43.9734 16.2886 43.7014 16.6921C43.4294 17.0956 43.2842 17.57 43.2842 18.0553C43.2857 18.7056 43.5471 19.3289 44.011 19.7887C44.4749 20.2485 45.1037 20.5076 45.7597 20.5091Z'
          fill='#1E24C0'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7557'>
          <rect
            width='51'
            height='33'
            fill='white'
            transform='translate(0 0.544922)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconDCSCActive = () => {
  return (
    <svg
      width='49'
      height='36'
      viewBox='0 0 49 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7512)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M47.941 2.64849V6.54984C48.4695 10.1913 48.5008 13.8872 48.034 17.537C47.7058 20.6659 47.068 23.7549 46.1301 26.7588H43.536V35.0492H41.8034V26.7588H38.573C38.2011 26.7588 37.8976 26.2419 37.8976 25.6177C37.8976 24.9935 38.2011 24.4766 38.573 24.4766H39.2583C39.704 22.7085 40.0537 20.9178 40.3057 19.1122L40.4427 18.0686L40.4917 17.5224C40.6777 15.8643 40.7804 14.2696 40.8049 12.7676H33.3996C29.812 12.7676 26.0579 11.5582 25.079 8.59805H22.4605C22.3549 8.59299 22.2555 8.54661 22.1841 8.469C22.1126 8.39138 22.0747 8.2888 22.0787 8.18353V7.96408H17.7324V3.60432H22.0787V3.38487C22.0747 3.2796 22.1126 3.17702 22.1841 3.09941C22.2555 3.02179 22.3549 2.97541 22.4605 2.97035H24.8588C26.0285 -1.12607 47.941 -0.628646 47.941 2.64849Z'
          fill='#1E24C0'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.0329 6.61802H15.0408C14.5954 5.67682 13.7976 5.472 12.4125 5.23792C12.3586 5.23792 13.9298 5.72559 13.9102 6.61802H11.6392C11.1938 5.67682 10.396 5.472 9.01083 5.23792C8.96189 5.23792 10.533 5.72559 10.5085 6.61802H8.2473C7.8019 5.67682 7.0041 5.472 5.61408 5.23792C5.56513 5.23792 7.13625 5.72559 7.11668 6.61802H5.03653C4.59113 5.67682 3.78355 5.472 2.40331 5.23792C2.35436 5.23792 3.92549 5.72559 3.90591 6.61802H1.98238C1.82937 6.30367 1.60114 6.03161 1.31777 5.82582C1.03441 5.62002 0.704616 5.48679 0.357422 5.43786L0.357422 4.9502H17.0329V6.61802Z'
          fill='#1E24C0'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M39.8262 18.8641H38.2208C38.0551 18.8641 37.8909 18.8313 37.7379 18.7676C37.5849 18.704 37.4462 18.6107 37.3296 18.4932C37.2131 18.3758 37.1211 18.2364 37.059 18.0832C36.9969 17.9301 36.9659 17.7662 36.9679 17.601V13.2607H40.2423C40.2423 14.7628 40.115 16.3623 39.929 18.0155L39.8703 18.5763L39.8262 18.8641Z'
          fill='#1E24C0'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7512'>
          <rect
            width='48'
            height='35'
            fill='white'
            transform='translate(0.357422 0.0449219)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconBVTPActive = () => {
  return (
    <svg
      width='51'
      height='34'
      viewBox='0 0 51 34'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_320_7557)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.09001 0.544922H47.91C48.729 0.54647 49.5141 0.869656 50.0932 1.44371C50.6724 2.01777 50.9984 2.79591 51 3.60774V30.4821C50.9984 31.2939 50.6724 32.0721 50.0932 32.6461C49.5141 33.2202 48.729 33.5434 47.91 33.5449H3.09001C2.27097 33.5434 1.48592 33.2202 0.906769 32.6461C0.327617 32.0721 0.00156157 31.2939 0 30.4821V3.60774C0.00156157 2.79591 0.327617 2.01777 0.906769 1.44371C1.48592 0.869656 2.27097 0.54647 3.09001 0.544922V0.544922ZM48.0754 29.1469C48.2811 29.1469 48.4821 29.0864 48.6531 28.9732C48.8241 28.8599 48.9574 28.6989 49.0361 28.5106C49.1148 28.3223 49.1354 28.115 49.0953 27.9151C49.0552 27.7152 48.9561 27.5315 48.8107 27.3874C48.6653 27.2432 48.48 27.145 48.2783 27.1053C48.0766 27.0655 47.8675 27.0859 47.6775 27.1639C47.4875 27.2419 47.3251 27.3741 47.2108 27.5435C47.0966 27.713 47.0356 27.9123 47.0356 28.1162C47.0356 28.2515 47.0625 28.3856 47.1147 28.5106C47.167 28.6357 47.2436 28.7493 47.3401 28.845C47.4367 28.9407 47.5513 29.0166 47.6775 29.0684C47.8036 29.1202 47.9389 29.1469 48.0754 29.1469ZM45.1567 29.0473C45.3622 29.0462 45.5626 28.9847 45.7328 28.8708C45.9031 28.7568 46.0354 28.5954 46.1132 28.407C46.191 28.2186 46.2108 28.0115 46.17 27.812C46.1292 27.6124 46.0297 27.4293 45.884 27.2858C45.7384 27.1422 45.5531 27.0446 45.3515 27.0053C45.15 26.966 44.9412 26.9868 44.7515 27.0649C44.5619 27.1431 44.3998 27.2752 44.2858 27.4446C44.1718 27.614 44.111 27.813 44.111 28.0166C44.111 28.1525 44.1381 28.287 44.1907 28.4124C44.2433 28.5378 44.3204 28.6517 44.4176 28.7475C44.5148 28.8433 44.6301 28.9191 44.757 28.9705C44.8838 29.022 45.0197 29.0481 45.1567 29.0473ZM42.2381 29.0473C42.4435 29.0462 42.6439 28.9847 42.8142 28.8708C42.9844 28.7568 43.1167 28.5954 43.1945 28.407C43.2723 28.2186 43.2921 28.0115 43.2513 27.812C43.2105 27.6124 43.111 27.4293 42.9654 27.2858C42.8197 27.1422 42.6344 27.0446 42.4329 27.0053C42.2313 26.966 42.0225 26.9868 41.8329 27.0649C41.6432 27.1431 41.4812 27.2752 41.3671 27.4446C41.2532 27.614 41.1923 27.813 41.1923 28.0166C41.1923 28.1525 41.2194 28.287 41.272 28.4124C41.3246 28.5378 41.4018 28.6517 41.499 28.7475C41.5961 28.8433 41.7115 28.9191 41.8383 28.9705C41.9652 29.022 42.101 29.0481 42.2381 29.0473ZM40.1406 5.14208V9.01307H49.1094V5.14208H40.1406ZM45.7535 21.727C46.7413 21.7239 47.6877 21.3336 48.3862 20.6413C49.0847 19.9489 49.4785 19.0108 49.4816 18.0317C49.4785 17.0531 49.0845 16.1156 48.3858 15.4242C47.6872 14.7328 46.7407 14.3438 45.7535 14.3423C44.7662 14.3454 43.8204 14.7359 43.1228 15.4284C42.4253 16.1209 42.0328 17.059 42.0313 18.0376C42.0344 19.0167 42.4282 19.9548 43.1267 20.6471C43.8251 21.3395 44.7716 21.7298 45.7594 21.7329L45.7535 21.727ZM45.7535 20.1458C46.3187 20.1443 46.8603 19.921 47.2599 19.5249C47.6596 19.1288 47.8848 18.5919 47.8864 18.0317C47.8832 17.4725 47.6573 16.9372 47.2579 16.5423C46.8584 16.1474 46.3177 15.925 45.7535 15.9234C45.1884 15.9256 44.647 16.1486 44.2469 16.5442C43.8586 16.945 43.6461 17.4819 43.656 18.0376C43.6576 18.5978 43.8828 19.1346 44.2825 19.5308C44.6821 19.9269 45.2237 20.1501 45.7889 20.1517L45.7535 20.1458ZM38.1614 26.5877H39.1953C39.6395 26.562 40.0553 26.3625 40.3511 26.0331C40.647 25.7036 40.7986 25.2711 40.7728 24.8308V13.0656C40.7971 12.6257 40.6448 12.1941 40.3493 11.865C40.0538 11.5358 39.639 11.3359 39.1953 11.3087H36.832C36.1171 11.3087 35.5263 12.0935 35.5263 13.0656V24.8718C35.5263 25.8322 36.1171 26.6287 36.832 26.6287L38.1614 26.5877ZM38.1614 11.3029V4.79071H6.59361C5.99184 4.79843 5.41754 5.0416 4.99589 5.46722C4.57423 5.89285 4.33939 6.46642 4.34256 7.06293V27.0269C4.33938 27.624 4.57402 28.1982 4.99552 28.6247C5.41701 29.0513 5.9913 29.2957 6.59361 29.305H38.1614V11.3263V11.3029Z'
          fill='#1E24C0'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M45.7597 20.5091C46.2494 20.5091 46.728 20.3652 47.1351 20.0956C47.5422 19.8259 47.8595 19.4427 48.0468 18.9944C48.2342 18.546 48.2832 18.0526 48.1877 17.5766C48.0922 17.1006 47.8564 16.6634 47.5102 16.3203C47.164 15.9771 46.7229 15.7434 46.2427 15.6487C45.7625 15.554 45.2647 15.6026 44.8124 15.7883C44.36 15.9741 43.9734 16.2886 43.7014 16.6921C43.4294 17.0956 43.2842 17.57 43.2842 18.0553C43.2857 18.7056 43.5471 19.3289 44.011 19.7887C44.4749 20.2485 45.1037 20.5076 45.7597 20.5091Z'
          fill='#1E24C0'
        />
      </g>
      <defs>
        <clipPath id='clip0_320_7557'>
          <rect
            width='51'
            height='33'
            fill='white'
            transform='translate(0 0.544922)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconShips = () => {
  return (
    <svg
      width='148'
      height='149'
      viewBox='0 0 148 149'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M117 69.2326L114.41 58.8742C115.118 58.7238 115.649 58.0957 115.649 57.3432V55.673C115.649 52.0469 112.699 49.0969 109.073 49.0969H97.2777V45.652C97.2777 43.8676 95.8262 42.416 94.0418 42.416H33.9164C32.132 42.416 30.6805 43.8676 30.6805 45.652V74.0445C30.6805 74.9092 31.3814 75.6104 32.2463 75.6104C33.1109 75.6104 33.8121 74.9094 33.8121 74.0445V45.652C33.8121 45.5943 33.8588 45.5477 33.9164 45.5477H94.0416C94.0992 45.5477 94.1459 45.5943 94.1459 45.652V74.0449C94.1459 74.9096 94.8469 75.6107 95.7117 75.6107C96.5764 75.6107 97.2775 74.9098 97.2775 74.0449V72.2699H115.748C115.75 72.2699 115.751 72.2703 115.752 72.2703C115.754 72.2703 115.755 72.2701 115.756 72.2701C118.029 72.2717 119.959 73.7635 120.622 75.8191H115.753C114.889 75.8191 114.187 76.5201 114.187 77.385V80.7252C114.187 83.4305 116.388 85.6313 119.094 85.6313H120.868V92.5205H116.774C115.429 88.6371 111.737 85.8398 107.403 85.8398C103.068 85.8398 99.3758 88.6371 98.0311 92.5205H97.2771V80.725C97.2771 79.8604 96.5762 79.1592 95.7113 79.1592C94.8467 79.1592 94.1455 79.8602 94.1455 80.725V92.5201H61.6596C60.3146 88.6367 56.623 85.8395 52.2881 85.8395C47.9531 85.8395 44.2613 88.6367 42.9166 92.5201H33.9164C33.8588 92.5201 33.8121 92.4734 33.8121 92.4158V88.9711H40.5971C41.4617 88.9711 42.1629 88.2701 42.1629 87.4053C42.1629 86.5404 41.4619 85.8395 40.5971 85.8395H25.5658C24.7012 85.8395 24 86.5404 24 87.4053C24 88.2701 24.701 88.9711 25.5658 88.9711H30.6807V92.4158C30.6807 94.2002 32.1322 95.6518 33.9166 95.6518H42.3744C42.374 95.6865 42.3717 95.7211 42.3717 95.7561C42.3717 101.224 46.8203 105.672 52.2881 105.672C57.7559 105.672 62.2045 101.224 62.2045 95.7561C62.2045 95.7209 62.2021 95.6865 62.2018 95.6518H97.4889C97.4885 95.6865 97.4861 95.7211 97.4861 95.7561C97.4861 101.224 101.935 105.672 107.403 105.672C112.87 105.672 117.319 101.224 117.319 95.7561C117.319 95.7209 117.317 95.6865 117.316 95.6518H122.434C123.299 95.6518 124 94.9508 124 94.0859V77.3846C124 73.2611 120.958 69.8352 117 69.2326ZM97.2777 52.2283H109.073C110.972 52.2283 112.518 53.7736 112.518 55.673V55.7773H97.2777V52.2283ZM97.2777 69.1385V58.9088H111.191L113.748 69.1385H97.2777ZM52.2881 102.541C48.5469 102.541 45.5031 99.4979 45.5031 95.7565C45.5031 92.015 48.5469 88.9715 52.2881 88.9715C56.0293 88.9715 59.073 92.015 59.073 95.7565C59.073 99.4979 56.0293 102.541 52.2881 102.541ZM107.403 102.541C103.662 102.541 100.618 99.4979 100.618 95.7565C100.618 92.015 103.662 88.9715 107.403 88.9715C111.144 88.9715 114.188 92.015 114.188 95.7565C114.188 99.4979 111.144 102.541 107.403 102.541ZM120.869 82.4996H119.094C118.115 82.4996 117.319 81.7035 117.319 80.725V78.9504H120.868V82.4996H120.869Z'
        fill='black'
      />
      <path
        d='M52.2877 92.5205C50.5033 92.5205 49.0518 93.9721 49.0518 95.7564C49.0518 97.5408 50.5033 98.9924 52.2877 98.9924C54.0721 98.9924 55.5236 97.5408 55.5236 95.7564C55.5236 93.9721 54.0721 92.5205 52.2877 92.5205Z'
        fill='black'
      />
      <path
        d='M107.404 92.5205C105.62 92.5205 104.168 93.9721 104.168 95.7564C104.168 97.5408 105.62 98.9924 107.404 98.9924C109.188 98.9924 110.64 97.5408 110.64 95.7564C110.64 93.9721 109.188 92.5205 107.404 92.5205Z'
        fill='black'
      />
      <path
        d='M89.0318 85.8398H65.6498C64.7852 85.8398 64.084 86.5408 64.084 87.4057C64.084 88.2705 64.785 88.9715 65.6498 88.9715H89.0318C89.8965 88.9715 90.5977 88.2705 90.5977 87.4057C90.5977 86.5408 89.8967 85.8398 89.0318 85.8398Z'
        fill='black'
      />
      <path
        d='M48.9484 79.1602H28.9066C28.042 79.1602 27.3408 79.8611 27.3408 80.726C27.3408 81.5908 28.0418 82.2918 28.9066 82.2918H48.9484C49.8131 82.2918 50.5143 81.5908 50.5143 80.726C50.5143 79.8611 49.8131 79.1602 48.9484 79.1602Z'
        fill='black'
      />
      <path
        d='M78.4465 57.9057C77.8352 57.2944 76.8436 57.2944 76.2323 57.9059L62.3081 71.83L55.0645 64.5864C54.453 63.9749 53.4616 63.9749 52.8502 64.5864C52.2387 65.1979 52.2387 66.1891 52.8502 66.8007L61.201 75.1514C61.5067 75.4573 61.9075 75.61 62.3081 75.61C62.7086 75.61 63.1096 75.4573 63.4151 75.1514L78.4463 60.1202C79.0579 59.5085 79.0579 58.5173 78.4465 57.9057Z'
        fill='black'
      />
    </svg>
  )
}
export const FeedBackGoodIconSelected = () => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M33.3327 30.0013H26.666M53.3327 30.0013H46.666M6.66602 40.0013C6.66602 58.4113 21.5894 73.3346 39.9994 73.3346C58.4094 73.3346 73.3327 58.4113 73.3327 40.0013C73.3327 21.5913 58.4094 6.66797 39.9994 6.66797C21.5894 6.66797 6.66602 21.5913 6.66602 40.0013ZM46.666 43.3346H33.3327V53.3346C33.3327 55.558 34.666 60.0013 39.9994 60.0013C45.3327 60.0013 46.666 55.558 46.666 53.3346V43.3346Z'
        stroke='#64C77A'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const FeedBackGoodIcon = () => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M33.3327 30.0013H26.666M53.3327 30.0013H46.666M6.66602 40.0013C6.66602 58.4113 21.5894 73.3346 39.9994 73.3346C58.4094 73.3346 73.3327 58.4113 73.3327 40.0013C73.3327 21.5913 58.4094 6.66797 39.9994 6.66797C21.5894 6.66797 6.66602 21.5913 6.66602 40.0013ZM46.666 43.3346H33.3327V53.3346C33.3327 55.558 34.666 60.0013 39.9994 60.0013C45.3327 60.0013 46.666 55.558 46.666 53.3346V43.3346Z'
        stroke='black'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const FeedBackNotGoodIcon = () => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.3327 46.6693C27.8907 46.6693 27.4667 46.4937 27.1542 46.1811C26.8416 45.8686 26.666 45.4446 26.666 45.0026C26.666 44.5606 26.8416 44.1367 27.1542 43.8241C27.4667 43.5115 27.8907 43.3359 28.3327 43.3359C28.7747 43.3359 29.1986 43.5115 29.5112 43.8241C29.8238 44.1367 29.9993 44.5606 29.9993 45.0026C29.9993 45.4446 29.8238 45.8686 29.5112 46.1811C29.1986 46.4937 28.7747 46.6693 28.3327 46.6693ZM51.666 46.6693C51.224 46.6693 50.8001 46.4937 50.4875 46.1811C50.1749 45.8686 49.9993 45.4446 49.9993 45.0026C49.9993 44.5606 50.1749 44.1367 50.4875 43.8241C50.8001 43.5115 51.224 43.3359 51.666 43.3359C52.108 43.3359 52.532 43.5115 52.8445 43.8241C53.1571 44.1367 53.3327 44.5606 53.3327 45.0026C53.3327 45.4446 53.1571 45.8686 52.8445 46.1811C52.532 46.4937 52.108 46.6693 51.666 46.6693Z'
        fill='black'
        stroke='black'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M33.3327 60.0013H46.666H33.3327ZM73.3327 40.0013C73.3327 58.4113 58.4094 73.3346 39.9994 73.3346C21.5894 73.3346 6.66602 58.4113 6.66602 40.0013C6.66602 21.5913 21.5894 6.66797 39.9994 6.66797C58.4094 6.66797 73.3327 21.5913 73.3327 40.0013Z'
        stroke='black'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const FeedBackNotGoodIconSelected = () => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.3327 46.6693C27.8907 46.6693 27.4667 46.4937 27.1542 46.1811C26.8416 45.8686 26.666 45.4446 26.666 45.0026C26.666 44.5606 26.8416 44.1367 27.1542 43.8241C27.4667 43.5115 27.8907 43.3359 28.3327 43.3359C28.7747 43.3359 29.1986 43.5115 29.5112 43.8241C29.8238 44.1367 29.9993 44.5606 29.9993 45.0026C29.9993 45.4446 29.8238 45.8686 29.5112 46.1811C29.1986 46.4937 28.7747 46.6693 28.3327 46.6693ZM51.666 46.6693C51.224 46.6693 50.8001 46.4937 50.4875 46.1811C50.1749 45.8686 49.9993 45.4446 49.9993 45.0026C49.9993 44.5606 50.1749 44.1367 50.4875 43.8241C50.8001 43.5115 51.224 43.3359 51.666 43.3359C52.108 43.3359 52.532 43.5115 52.8445 43.8241C53.1571 44.1367 53.3327 44.5606 53.3327 45.0026C53.3327 45.4446 53.1571 45.8686 52.8445 46.1811C52.532 46.4937 52.108 46.6693 51.666 46.6693Z'
        fill='#64C77A'
        stroke='#64C77A'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M33.3327 60.0013H46.666H33.3327ZM73.3327 40.0013C73.3327 58.4113 58.4094 73.3346 39.9994 73.3346C21.5894 73.3346 6.66602 58.4113 6.66602 40.0013C6.66602 21.5913 21.5894 6.66797 39.9994 6.66797C58.4094 6.66797 73.3327 21.5913 73.3327 40.0013Z'
        stroke='#64C77A'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const ScanIcon = () => {
  return (
    <svg
      width='25'
      height='26'
      viewBox='0 0 25 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.32031 9.875H4.6875C4.79492 9.875 4.88281 9.78711 4.88281 9.67969V5.38281H9.17969C9.28711 5.38281 9.375 5.29492 9.375 5.1875V3.82031C9.375 3.71289 9.28711 3.625 9.17969 3.625H4.78516C3.86719 3.625 3.125 4.36719 3.125 5.28516V9.67969C3.125 9.78711 3.21289 9.875 3.32031 9.875ZM15.8203 5.38281H20.1172V9.67969C20.1172 9.78711 20.2051 9.875 20.3125 9.875H21.6797C21.7871 9.875 21.875 9.78711 21.875 9.67969V5.28516C21.875 4.36719 21.1328 3.625 20.2148 3.625H15.8203C15.7129 3.625 15.625 3.71289 15.625 3.82031V5.1875C15.625 5.29492 15.7129 5.38281 15.8203 5.38281ZM9.17969 20.6172H4.88281V16.3203C4.88281 16.2129 4.79492 16.125 4.6875 16.125H3.32031C3.21289 16.125 3.125 16.2129 3.125 16.3203V20.7148C3.125 21.6328 3.86719 22.375 4.78516 22.375H9.17969C9.28711 22.375 9.375 22.2871 9.375 22.1797V20.8125C9.375 20.7051 9.28711 20.6172 9.17969 20.6172ZM21.6797 16.125H20.3125C20.2051 16.125 20.1172 16.2129 20.1172 16.3203V20.6172H15.8203C15.7129 20.6172 15.625 20.7051 15.625 20.8125V22.1797C15.625 22.2871 15.7129 22.375 15.8203 22.375H20.2148C21.1328 22.375 21.875 21.6328 21.875 20.7148V16.3203C21.875 16.2129 21.7871 16.125 21.6797 16.125ZM22.0703 12.1211H2.92969C2.82227 12.1211 2.73438 12.209 2.73438 12.3164V13.6836C2.73438 13.791 2.82227 13.8789 2.92969 13.8789H22.0703C22.1777 13.8789 22.2656 13.791 22.2656 13.6836V12.3164C22.2656 12.209 22.1777 12.1211 22.0703 12.1211Z'
        fill='#1E24C0'
      />
    </svg>
  )
}
export const IconOrderNote = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 1H3V23H21V1Z'
        stroke='#E89313'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M7 7H17'
        stroke='#E89313'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M7 12H17'
        stroke='#E89313'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M7 17H11'
        stroke='#E89313'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export const IconCloseBtn = () => {
  return (
    <svg
      width='11'
      height='11'
      viewBox='0 0 11 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.7071 0.292786C10.5196 0.105315 10.2652 0 10.0001 0C9.73492 0 9.48061 0.105315 9.29308 0.292786L6.00008 3.58579L2.70708 0.292786C2.51848 0.110628 2.26588 0.00983408 2.00368 0.0121125C1.74148 0.0143909 1.49067 0.11956 1.30526 0.304968C1.11985 0.490376 1.01469 0.741188 1.01241 1.00339C1.01013 1.26558 1.11092 1.51818 1.29308 1.70679L4.58608 4.99979L1.29308 8.29279C1.19757 8.38503 1.12139 8.49538 1.06898 8.61738C1.01657 8.73939 0.988985 8.87061 0.987831 9.00339C0.986677 9.13616 1.01198 9.26784 1.06226 9.39074C1.11254 9.51364 1.18679 9.62529 1.28069 9.71918C1.37458 9.81307 1.48623 9.88733 1.60913 9.93761C1.73202 9.98789 1.8637 10.0132 1.99648 10.012C2.12926 10.0109 2.26048 9.9833 2.38249 9.93089C2.50449 9.87848 2.61483 9.8023 2.70708 9.70679L6.00008 6.41379L9.29308 9.70679C9.48168 9.88894 9.73429 9.98974 9.99648 9.98746C10.2587 9.98518 10.5095 9.88001 10.6949 9.6946C10.8803 9.5092 10.9855 9.25838 10.9878 8.99619C10.99 8.73399 10.8892 8.48139 10.7071 8.29279L7.41408 4.99979L10.7071 1.70679C10.8946 1.51926 10.9999 1.26495 10.9999 0.999786C10.9999 0.734622 10.8946 0.480314 10.7071 0.292786Z'
        fill='white'
      />
    </svg>
  )
}

export const IconInfo = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346625 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9937 5.88022 15.1488 3.84906 13.6499 2.35014C12.1509 0.851219 10.1198 0.00633091 8 0V0ZM8.5 13H7.5C7.3674 13 7.24022 12.9473 7.14645 12.8536C7.05268 12.7598 7 12.6326 7 12.5V7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24022 7.05268 7.3674 7 7.5 7H8.5C8.63261 7 8.75979 7.05268 8.85356 7.14645C8.94733 7.24021 9 7.36739 9 7.5V12.5C9 12.6326 8.94733 12.7598 8.85356 12.8536C8.75979 12.9473 8.63261 13 8.5 13ZM8 5C7.86659 5.00802 7.73299 4.98765 7.60803 4.94023C7.48307 4.89281 7.36959 4.81943 7.27508 4.72492C7.18058 4.63041 7.10719 4.51693 7.05977 4.39197C7.01236 4.26701 6.99198 4.13341 7 4C6.99198 3.86659 7.01236 3.73299 7.05977 3.60803C7.10719 3.48307 7.18058 3.36959 7.27508 3.27508C7.36959 3.18057 7.48307 3.10719 7.60803 3.05977C7.73299 3.01235 7.86659 2.99198 8 3C8.13342 2.99198 8.26701 3.01235 8.39197 3.05977C8.51693 3.10719 8.63041 3.18057 8.72492 3.27508C8.81943 3.36959 8.89282 3.48307 8.94023 3.60803C8.98765 3.73299 9.00802 3.86659 9 4C9.00802 4.13341 8.98765 4.26701 8.94023 4.39197C8.89282 4.51693 8.81943 4.63041 8.72492 4.72492C8.63041 4.81943 8.51693 4.89281 8.39197 4.94023C8.26701 4.98765 8.13342 5.00802 8 5Z'
        fill='#6F6F6F'
      />
    </svg>
  )
}

export const IconFrames = () => {
  return (
    <svg
      width='148'
      height='149'
      viewBox='0 0 148 149'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M117 69.2326L114.41 58.8742C115.118 58.7238 115.649 58.0957 115.649 57.3432V55.673C115.649 52.0469 112.699 49.0969 109.073 49.0969H97.2777V45.652C97.2777 43.8676 95.8262 42.416 94.0418 42.416H33.9164C32.132 42.416 30.6805 43.8676 30.6805 45.652V74.0445C30.6805 74.9092 31.3814 75.6104 32.2463 75.6104C33.1109 75.6104 33.8121 74.9094 33.8121 74.0445V45.652C33.8121 45.5943 33.8588 45.5477 33.9164 45.5477H94.0416C94.0992 45.5477 94.1459 45.5943 94.1459 45.652V74.0449C94.1459 74.9096 94.8469 75.6107 95.7117 75.6107C96.5764 75.6107 97.2775 74.9098 97.2775 74.0449V72.2699H115.748C115.75 72.2699 115.751 72.2703 115.752 72.2703C115.754 72.2703 115.755 72.2701 115.756 72.2701C118.029 72.2717 119.959 73.7635 120.622 75.8191H115.753C114.889 75.8191 114.187 76.5201 114.187 77.385V80.7252C114.187 83.4305 116.388 85.6313 119.094 85.6313H120.868V92.5205H116.774C115.429 88.6371 111.737 85.8398 107.403 85.8398C103.068 85.8398 99.3758 88.6371 98.0311 92.5205H97.2771V80.725C97.2771 79.8604 96.5762 79.1592 95.7113 79.1592C94.8467 79.1592 94.1455 79.8602 94.1455 80.725V92.5201H61.6596C60.3146 88.6367 56.623 85.8395 52.2881 85.8395C47.9531 85.8395 44.2613 88.6367 42.9166 92.5201H33.9164C33.8588 92.5201 33.8121 92.4734 33.8121 92.4158V88.9711H40.5971C41.4617 88.9711 42.1629 88.2701 42.1629 87.4053C42.1629 86.5404 41.4619 85.8395 40.5971 85.8395H25.5658C24.7012 85.8395 24 86.5404 24 87.4053C24 88.2701 24.701 88.9711 25.5658 88.9711H30.6807V92.4158C30.6807 94.2002 32.1322 95.6518 33.9166 95.6518H42.3744C42.374 95.6865 42.3717 95.7211 42.3717 95.7561C42.3717 101.224 46.8203 105.672 52.2881 105.672C57.7559 105.672 62.2045 101.224 62.2045 95.7561C62.2045 95.7209 62.2021 95.6865 62.2018 95.6518H97.4889C97.4885 95.6865 97.4861 95.7211 97.4861 95.7561C97.4861 101.224 101.935 105.672 107.403 105.672C112.87 105.672 117.319 101.224 117.319 95.7561C117.319 95.7209 117.317 95.6865 117.316 95.6518H122.434C123.299 95.6518 124 94.9508 124 94.0859V77.3846C124 73.2611 120.958 69.8352 117 69.2326ZM97.2777 52.2283H109.073C110.972 52.2283 112.518 53.7736 112.518 55.673V55.7773H97.2777V52.2283ZM97.2777 69.1385V58.9088H111.191L113.748 69.1385H97.2777ZM52.2881 102.541C48.5469 102.541 45.5031 99.4979 45.5031 95.7565C45.5031 92.015 48.5469 88.9715 52.2881 88.9715C56.0293 88.9715 59.073 92.015 59.073 95.7565C59.073 99.4979 56.0293 102.541 52.2881 102.541ZM107.403 102.541C103.662 102.541 100.618 99.4979 100.618 95.7565C100.618 92.015 103.662 88.9715 107.403 88.9715C111.144 88.9715 114.188 92.015 114.188 95.7565C114.188 99.4979 111.144 102.541 107.403 102.541ZM120.869 82.4996H119.094C118.115 82.4996 117.319 81.7035 117.319 80.725V78.9504H120.868V82.4996H120.869Z'
        fill='black'
      />
      <path
        d='M52.2877 92.5205C50.5033 92.5205 49.0518 93.9721 49.0518 95.7564C49.0518 97.5408 50.5033 98.9924 52.2877 98.9924C54.0721 98.9924 55.5236 97.5408 55.5236 95.7564C55.5236 93.9721 54.0721 92.5205 52.2877 92.5205Z'
        fill='black'
      />
      <path
        d='M107.404 92.5205C105.62 92.5205 104.168 93.9721 104.168 95.7564C104.168 97.5408 105.62 98.9924 107.404 98.9924C109.188 98.9924 110.64 97.5408 110.64 95.7564C110.64 93.9721 109.188 92.5205 107.404 92.5205Z'
        fill='black'
      />
      <path
        d='M89.0318 85.8398H65.6498C64.7852 85.8398 64.084 86.5408 64.084 87.4057C64.084 88.2705 64.785 88.9715 65.6498 88.9715H89.0318C89.8965 88.9715 90.5977 88.2705 90.5977 87.4057C90.5977 86.5408 89.8967 85.8398 89.0318 85.8398Z'
        fill='black'
      />
      <path
        d='M48.9484 79.1602H28.9066C28.042 79.1602 27.3408 79.8611 27.3408 80.726C27.3408 81.5908 28.0418 82.2918 28.9066 82.2918H48.9484C49.8131 82.2918 50.5143 81.5908 50.5143 80.726C50.5143 79.8611 49.8131 79.1602 48.9484 79.1602Z'
        fill='black'
      />
      <path
        d='M78.4465 57.9057C77.8352 57.2944 76.8436 57.2944 76.2323 57.9059L62.3081 71.83L55.0645 64.5864C54.453 63.9749 53.4616 63.9749 52.8502 64.5864C52.2387 65.1979 52.2387 66.1891 52.8502 66.8007L61.201 75.1514C61.5067 75.4573 61.9075 75.61 62.3081 75.61C62.7086 75.61 63.1096 75.4573 63.4151 75.1514L78.4463 60.1202C79.0579 59.5085 79.0579 58.5173 78.4465 57.9057Z'
        fill='black'
      />
    </svg>
  )
}

export const IconInstallment = () => {
  return (
    <svg
      width='149'
      height='149'
      viewBox='0 0 149 149'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M86.9995 89.1865H83.7198C83.073 89.1865 82.5479 88.6617 82.5479 88.0147C82.5479 87.3676 83.0728 86.8428 83.7197 86.8428L86.9995 86.8428C87.6465 86.8428 88.1712 87.3677 88.1712 88.0147C88.1714 88.6615 87.6464 89.1866 86.9995 89.1865V89.1865Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M65.2797 88.7831H61.9982C61.3512 88.7831 60.8262 88.2603 60.8262 87.6133C60.8263 86.9643 61.3511 86.4415 61.998 86.4415L65.2797 86.4414C65.9268 86.4414 66.4516 86.9643 66.4516 87.6133C66.4516 88.2602 65.9267 88.7831 65.2797 88.7831H65.2797Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M79.1426 93.7038C79.0594 93.7038 78.9717 93.7017 78.8862 93.6977C78.2395 93.6752 77.7327 93.132 77.7571 92.4851C77.7797 91.838 78.3309 91.3315 78.9697 91.356C81.1182 91.425 82.2941 89.9786 82.5098 88.5056C82.7256 87.0387 82.0642 85.0876 79.4966 84.4182C78.3919 84.1314 77.0857 84.3226 75.7775 87.9237C75.2771 89.297 73.4074 93.5634 69.5255 93.5654C69.2978 93.5653 69.0657 93.5491 68.8236 93.5186C65.8229 93.2296 63.9631 89.9339 64.1096 87.0265C64.2278 84.6644 65.8207 81.9219 69.91 81.9219C69.9407 81.9218 69.969 81.9219 69.9995 81.9219C70.6465 81.928 71.1653 82.459 71.1592 83.106C71.1533 83.7489 70.6303 84.2657 69.9873 84.2657C69.9631 84.2656 69.9344 84.2657 69.908 84.2657C67.0273 84.2656 66.5042 86.0663 66.4514 87.1445C66.3598 88.9329 67.4585 91.0426 69.0596 91.187C69.076 91.1891 69.0901 91.1911 69.1064 91.1932C71.7534 91.539 73.1958 88.1638 73.5741 87.1221C73.9528 86.0784 74.5751 84.5647 75.5944 83.4723C76.8193 82.1599 78.3716 81.7043 80.0866 82.1498C83.875 83.1385 85.1994 86.3124 84.829 88.8454C84.4813 91.2136 82.5585 93.7038 79.1426 93.7038L79.1426 93.7038Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M57.1457 116.625H91.8523V58.9999H57.1457V116.625ZM93.0242 118.969H55.9739C55.3268 118.969 54.8018 118.446 54.8018 117.797L54.802 57.8281C54.802 57.1812 55.3267 56.6563 55.9736 56.6563L93.0241 56.6562C93.6712 56.6562 94.1959 57.1812 94.1959 57.8282L94.196 117.797C94.196 118.446 93.671 118.969 93.0241 118.969L93.0242 118.969Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M93.0242 66.0664H55.9739C55.3268 66.0664 54.8018 65.5416 54.8018 64.8946C54.802 64.2476 55.3267 63.7227 55.9736 63.7227L93.0241 63.7227C93.6712 63.7227 94.1959 64.2476 94.1959 64.8946C94.196 65.5416 93.671 66.0665 93.0241 66.0664H93.0242Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M93.0242 111.905H55.9739C55.3268 111.905 54.8018 111.38 54.8018 110.733C54.802 110.084 55.3267 109.562 55.9736 109.562L93.0241 109.562C93.6712 109.562 94.1959 110.084 94.1959 110.733C94.196 111.38 93.671 111.905 93.0241 111.905H93.0242Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M81.1686 75.166H67.8282C67.1813 75.166 66.6562 74.6412 66.6562 73.9942C66.6563 73.3472 67.1812 72.8223 67.8281 72.8223L81.1686 72.8223C81.8154 72.8223 82.3402 73.3472 82.3402 73.9942C82.3405 74.6412 81.8153 75.1661 81.1686 75.166H81.1686Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M81.1686 102.803H67.8282C67.1813 102.803 66.6562 102.28 66.6562 101.633C66.6563 100.984 67.1812 100.461 67.8281 100.461L81.1686 100.461C81.8154 100.461 82.3402 100.984 82.3402 101.633C82.3405 102.28 81.8153 102.803 81.1686 102.803H81.1686Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M63.3099 35.6357H55.3936C54.7467 35.6357 54.2216 35.1109 54.2216 34.4639C54.2217 33.8169 54.7466 33.292 55.3935 33.292L63.3099 33.292C63.957 33.292 64.4817 33.817 64.4817 34.4639C64.4818 35.1108 63.9567 35.6358 63.3099 35.6357V35.6357ZM78.4568 35.6357H70.5405C69.8934 35.6357 69.3685 35.1109 69.3685 34.4639C69.3686 33.8169 69.8934 33.292 70.5404 33.292L78.4568 33.292C79.1037 33.292 79.6286 33.817 79.6286 34.4639C79.6287 35.1108 79.1037 35.6358 78.4568 35.6357V35.6357ZM93.6038 35.6357H85.6875C85.0404 35.6357 84.5154 35.1109 84.5154 34.4639C84.5156 33.8169 85.0403 33.292 85.6873 33.292L93.6038 33.292C94.2506 33.292 94.7754 33.817 94.7754 34.4639C94.7757 35.1108 94.2506 35.6358 93.6038 35.6357V35.6357ZM55.9735 107.161H41.8336C38.3404 107.161 35.498 104.319 35.498 100.823L35.4982 39.6275C35.4982 36.1343 38.3403 33.2921 41.8335 33.2921L48.1629 33.292C48.8121 33.292 49.3347 33.817 49.3347 34.464C49.3348 35.1109 48.8119 35.6358 48.1628 35.6358L41.8336 35.6358C39.6322 35.6358 37.8418 37.4262 37.8418 39.6275L37.8419 100.824C37.8419 103.025 39.6321 104.817 41.8335 104.817H55.9735C56.6203 104.817 57.1452 105.342 57.1452 105.989C57.1454 106.636 56.6203 107.161 55.9735 107.161L55.9735 107.161ZM107.164 107.161H93.0238C92.3768 107.161 91.8519 106.636 91.8519 105.989C91.8519 105.342 92.3768 104.817 93.0238 104.817H107.164C109.367 104.817 111.157 103.025 111.157 100.823L111.157 39.6275C111.157 37.4261 109.367 35.6358 107.164 35.6358L100.834 35.6358C100.187 35.6358 99.6623 35.1109 99.6623 34.464C99.6625 33.8169 100.187 33.2921 100.834 33.2921L107.164 33.292C110.659 33.292 113.501 36.1343 113.501 39.6275L113.501 100.824C113.501 104.319 110.659 107.161 107.164 107.161L107.164 107.161Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M112.329 50.5507H36.67C36.023 50.5507 35.498 50.0279 35.498 49.3809C35.4982 48.7319 36.023 48.209 36.6699 48.209L112.329 48.209C112.976 48.209 113.501 48.7319 113.501 49.3809C113.501 50.0278 112.976 50.5507 112.329 50.5507H112.329Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M49.335 41.8937H54.2219V31.4648H49.335V41.8937ZM55.3938 44.2375H48.1631C47.5161 44.2375 46.9912 43.7126 46.9912 43.0656L46.9913 30.293C46.9913 29.646 47.5161 29.1211 48.1631 29.1211H55.3938C56.0429 29.1211 56.5656 29.646 56.5656 30.293L56.5656 43.0656C56.5656 43.7126 56.0427 44.2375 55.3938 44.2375H55.3938Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M64.4816 41.8937H69.3684V31.4648H64.4816V41.8937ZM70.5403 44.2375H63.3097C62.6626 44.2375 62.1377 43.7126 62.1377 43.0656L62.1378 30.293C62.1378 29.646 62.6626 29.1211 63.3096 29.1211H70.5403C71.1874 29.1211 71.7121 29.646 71.7121 30.293L71.7122 43.0656C71.7122 43.7126 71.1872 44.2375 70.5403 44.2375V44.2375Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M79.6291 41.8937H84.5159V31.4648H79.6291V41.8937ZM85.6878 44.2375H78.4572C77.8101 44.2375 77.2852 43.7126 77.2852 43.0656L77.2853 30.293C77.2853 29.646 77.8101 29.1211 78.457 29.1211H85.6878C86.3347 29.1211 86.8595 29.646 86.8595 30.293L86.8597 43.0656C86.8597 43.7126 86.3347 44.2375 85.6878 44.2375V44.2375Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M94.7756 41.8937H99.6625V31.4648H94.7756V41.8937ZM100.834 44.2375H93.6038C92.9567 44.2375 92.4316 43.7126 92.4316 43.0656L92.4319 30.293C92.4319 29.646 92.9566 29.1211 93.6035 29.1211H100.834C101.481 29.1211 102.006 29.646 102.006 30.293L102.006 43.0656C102.006 43.7126 101.481 44.2375 100.834 44.2375H100.834Z'
        fill='black'
      />
    </svg>
  )
}

export const IconTime = () => {
  return (
    <svg
      width='149'
      height='149'
      viewBox='0 0 149 149'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_641_22491)'>
        <path
          d='M108.244 99.1953C107.435 99.1953 106.779 99.8512 106.779 100.66C106.779 101.469 107.435 102.125 108.244 102.125H108.26C109.069 102.125 109.717 101.469 109.717 100.66C109.717 99.8512 109.053 99.1953 108.244 99.1953V99.1953Z'
          fill='black'
        />
        <path
          d='M59.709 99.1953C58.9 99.1953 58.2441 99.8512 58.2441 100.66C58.2441 101.469 58.9 102.125 59.709 102.125H59.7246C60.5336 102.125 61.1816 101.469 61.1816 100.66C61.1816 99.8512 60.5182 99.1953 59.709 99.1953V99.1953Z'
          fill='black'
        />
        <path
          d='M122.975 82.9015L118.291 79.5523L118.223 65.3866C118.213 63.205 116.586 61.6214 114.356 61.6214H102.984C103.118 60.8492 102.947 60.0898 102.496 59.5027C102.003 58.8594 101.225 58.4902 100.364 58.4902H90.1562C89.3473 58.4902 88.6914 59.1461 88.6914 59.9551C88.6914 60.764 89.3473 61.4199 90.1562 61.4199L100.021 61.4201L89.8984 99.1966H67.6524C67.6825 97.7294 67.2657 96.3544 66.4296 95.2648C65.2763 93.7619 63.4859 92.934 61.388 92.934C57.6178 92.934 53.8752 95.6087 52.401 99.1966L45.9626 99.1964L48.8247 88.5151C49.0341 87.7336 48.5704 86.9305 47.7888 86.721C47.0087 86.5124 46.2042 86.9753 45.9947 87.7569L43.0582 98.7167C42.8261 99.5823 42.9826 100.456 43.4873 101.114C43.981 101.757 44.7581 102.126 45.6193 102.126H51.7676C51.7376 103.593 52.1542 104.968 52.9903 106.058C54.1436 107.561 55.934 108.389 58.0318 108.389C61.8021 108.389 65.5446 105.714 67.0188 102.126H100.302C100.272 103.593 100.689 104.968 101.525 106.058C102.678 107.561 104.469 108.389 106.566 108.389C110.337 108.389 114.079 105.714 115.553 102.126H116.073C118.459 102.126 120.824 100.274 121.458 97.9091L124.339 87.1571C124.794 85.4587 124.271 83.828 122.975 82.9015V82.9015ZM64.5575 100.282C63.8056 103.088 60.8173 105.459 58.0318 105.459C56.8658 105.459 55.9008 105.038 55.3145 104.274C54.684 103.453 54.5235 102.305 54.8623 101.041C55.6141 98.2343 58.6025 95.8636 61.388 95.8636C62.554 95.8636 63.5191 96.2843 64.1054 97.0482C64.7356 97.8699 64.8964 99.0183 64.5575 100.282ZM115.358 78.8433H105.87C105.622 78.8433 105.286 78.7904 105.092 78.5377C104.922 78.315 104.885 77.9572 104.993 77.556L106.251 72.8592C106.543 71.7696 107.737 70.8137 108.806 70.8137H115.319L115.358 78.8433ZM113.092 100.282C112.34 103.088 109.352 105.459 106.566 105.459C105.4 105.459 104.435 105.038 103.849 104.274C103.219 103.453 103.058 102.305 103.397 101.041C104.149 98.2343 107.137 95.8636 109.923 95.8636C111.089 95.8636 112.054 96.2843 112.64 97.0482C113.27 97.8699 113.431 99.0183 113.092 100.282ZM118.628 97.1511C118.346 98.2021 117.226 99.1261 116.187 99.1905C116.216 97.7257 115.799 96.3531 114.964 95.265C113.811 93.7621 112.02 92.9342 109.922 92.9342C106.152 92.9342 102.41 95.6089 100.935 99.1968H92.9314L95.5025 89.6014H113.166C113.975 89.6014 114.631 88.9455 114.631 88.1366C114.631 87.3276 113.975 86.6717 113.166 86.6717H96.2874L102.215 64.5513H114.355C114.781 64.5513 115.29 64.6988 115.293 65.4009L115.305 67.8843H108.806C106.42 67.8843 104.055 69.7366 103.421 72.1012L102.163 76.798C101.817 78.0859 102.038 79.3701 102.768 80.3212C103.476 81.2441 104.607 81.7732 105.87 81.7732H116.359L121.271 85.2848C121.689 85.5833 121.559 86.2132 121.509 86.3991L121.436 86.6717H119.429C118.62 86.6717 117.964 87.3276 117.964 88.1366C117.964 88.9455 118.62 89.6014 119.429 89.6014H120.651L118.628 97.1511Z'
          fill='black'
        />
        <path
          d='M61.9745 86.4686C74.8683 86.4686 85.3582 75.9789 85.3582 63.0849C85.3582 50.1909 74.8683 39.7012 61.9745 39.7012C49.0807 39.7012 38.5908 50.1911 38.5908 63.0849C38.5908 75.9787 49.0807 86.4686 61.9745 86.4686V86.4686ZM61.9745 42.6308C73.2529 42.6308 82.4286 51.8065 82.4286 63.0849C82.4286 74.3633 73.2531 83.5389 61.9745 83.5389C50.696 83.5389 41.5205 74.3633 41.5205 63.0849C41.5205 51.8065 50.6961 42.6308 61.9745 42.6308V42.6308Z'
          fill='black'
        />
        <path
          d='M55.712 70.8125C56.0868 70.8125 56.4618 70.6695 56.7478 70.3834L59.9309 67.2002C60.5469 67.5074 61.2407 67.6813 61.9745 67.6813C64.5088 67.6813 66.5705 65.6194 66.5705 63.0852C66.5705 62.3514 66.3967 61.6577 66.0895 61.0417L73.9696 53.1617C74.5417 52.5896 74.5417 51.6621 73.9696 51.0903C73.3976 50.518 72.47 50.5182 71.8982 51.0903L64.018 58.9702C63.402 58.663 62.7082 58.4894 61.9745 58.4894C59.4401 58.4894 57.3784 60.5513 57.3784 63.0854C57.3784 63.8192 57.5523 64.5129 57.8593 65.129L54.6761 68.3121C54.1041 68.8842 54.1041 69.8117 54.6761 70.3836C54.9622 70.6695 55.337 70.8125 55.712 70.8125ZM61.9745 61.4188C62.8934 61.4188 63.6409 62.1665 63.6409 63.0852C63.6409 64.004 62.8932 64.7516 61.9745 64.7516C61.0557 64.7516 60.3081 64.004 60.3081 63.0852C60.3081 62.1665 61.0557 61.4188 61.9745 61.4188Z'
          fill='black'
        />
        <path
          d='M61.9736 50.4602C62.7826 50.4602 63.4385 49.8043 63.4385 48.9953V47.4297C63.4385 46.6207 62.7826 45.9648 61.9736 45.9648C61.1646 45.9648 60.5088 46.6207 60.5088 47.4297V48.9953C60.5088 49.8045 61.1646 50.4602 61.9736 50.4602Z'
          fill='black'
        />
        <path
          d='M61.9746 75.7119C61.1656 75.7119 60.5098 76.3678 60.5098 77.1768V78.7424C60.5098 79.5514 61.1656 80.2072 61.9746 80.2072C62.7836 80.2072 63.4395 79.5514 63.4395 78.7424V77.1768C63.4395 76.3678 62.7836 75.7119 61.9746 75.7119Z'
          fill='black'
        />
        <path
          d='M76.0654 64.5508H77.6311C78.44 64.5508 79.0959 63.8949 79.0959 63.0859C79.0959 62.277 78.44 61.6211 77.6311 61.6211H76.0654C75.2564 61.6211 74.6006 62.277 74.6006 63.0859C74.6006 63.8949 75.2564 64.5508 76.0654 64.5508Z'
          fill='black'
        />
        <path
          d='M49.3488 63.0859C49.3488 62.277 48.693 61.6211 47.884 61.6211H46.3184C45.5094 61.6211 44.8535 62.277 44.8535 63.0859C44.8535 63.8949 45.5094 64.5508 46.3184 64.5508H47.884C48.693 64.5508 49.3488 63.8949 49.3488 63.0859Z'
          fill='black'
        />
        <path
          d='M41.6211 81.9736H25.9648C25.1559 81.9736 24.5 82.6295 24.5 83.4385C24.5 84.2474 25.1559 84.9033 25.9648 84.9033H41.6211C42.4301 84.9033 43.0859 84.2474 43.0859 83.4385C43.0859 82.6295 42.4301 81.9736 41.6211 81.9736Z'
          fill='black'
        />
        <path
          d='M40.0551 88.2363H30.6611C29.8521 88.2363 29.1963 88.8922 29.1963 89.7012C29.1963 90.5102 29.8521 91.166 30.6611 91.166H40.0551C40.8641 91.166 41.5199 90.5102 41.5199 89.7012C41.5199 88.8922 40.8641 88.2363 40.0551 88.2363Z'
          fill='black'
        />
        <path
          d='M38.4896 94.499H35.3584C34.5494 94.499 33.8936 95.1549 33.8936 95.9639C33.8936 96.7729 34.5494 97.4287 35.3584 97.4287H38.4896C39.2986 97.4287 39.9545 96.7729 39.9545 95.9639C39.9545 95.1549 39.2986 94.499 38.4896 94.499Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_641_22491'>
          <rect
            width='100'
            height='100'
            fill='white'
            transform='translate(24.5 24.0449)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconPurchase = () => {
  return (
    <svg
      width='149'
      height='149'
      viewBox='0 0 149 149'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_641_22446)'>
        <path
          d='M74.5007 120.139C53.8146 120.139 35.7697 106.167 30.616 86.1597C30.4009 85.3251 30.9052 84.4721 31.7414 84.2562C32.5692 84.0472 33.429 84.5454 33.6441 85.3816C38.4399 104.006 55.2412 117.014 74.5007 117.014C97.7626 117.014 116.688 98.089 116.688 74.8271C116.688 73.9627 117.386 73.2646 118.25 73.2646C119.114 73.2646 119.813 73.9627 119.813 74.8271C119.813 99.8109 99.4845 120.139 74.5007 120.139V120.139Z'
          fill='black'
        />
        <path
          d='M30.751 74.8268C29.8866 74.8268 29.1885 74.1279 29.1885 73.2643C29.1885 48.2797 49.5161 27.9521 74.5006 27.9521C95.186 27.9521 113.231 41.9237 118.385 61.9309C118.6 62.7656 118.095 63.6185 117.259 63.8344C116.436 64.0519 115.573 63.5453 115.356 62.7091C110.561 44.0844 93.7593 31.0771 74.5006 31.0771C51.238 31.0771 32.3135 50.0017 32.3135 73.2643C32.3135 74.1279 31.6146 74.8268 30.751 74.8268V74.8268Z'
          fill='black'
        />
        <path
          d='M30.7505 74.8267C30.35 74.8267 29.9502 74.6733 29.6458 74.3682L24.9583 69.6807C24.3472 69.0703 24.3472 68.0824 24.9583 67.472C25.5687 66.8609 26.5567 66.8609 27.167 67.472L31.8545 72.1595C32.4656 72.7698 32.4656 73.7578 31.8545 74.3682C31.5501 74.6733 31.1503 74.8267 30.7505 74.8267Z'
          fill='black'
        />
        <path
          d='M30.7506 74.8267C30.35 74.8267 29.9502 74.6733 29.6458 74.3682C29.0347 73.7578 29.0347 72.7698 29.6458 72.1595L34.3333 67.472C34.9436 66.8609 35.9316 66.8609 36.542 67.472C37.1531 68.0824 37.1531 69.0703 36.542 69.6807L31.8545 74.3682C31.5501 74.6733 31.1503 74.8267 30.7506 74.8267Z'
          fill='black'
        />
        <path
          d='M122.937 79.5142C122.537 79.5142 122.137 79.3608 121.832 79.0557L117.145 74.3682C116.534 73.7578 116.534 72.7699 117.145 72.1595C117.755 71.5484 118.743 71.5484 119.354 72.1595L124.041 76.847C124.652 77.4573 124.652 78.4453 124.041 79.0557C123.737 79.3608 123.337 79.5142 122.937 79.5142Z'
          fill='black'
        />
        <path
          d='M113.562 79.5142C113.162 79.5142 112.762 79.3608 112.457 79.0557C111.846 78.4453 111.846 77.4573 112.457 76.847L117.145 72.1595C117.755 71.5484 118.743 71.5484 119.354 72.1595C119.965 72.7699 119.965 73.7578 119.354 74.3682L114.666 79.0557C114.362 79.3608 113.962 79.5142 113.562 79.5142Z'
          fill='black'
        />
        <path
          d='M46.3721 109.896C45.5084 109.896 44.8096 109.197 44.8096 108.334V68.5605C44.8096 67.6961 45.5084 66.998 46.3721 66.998C47.2365 66.998 47.9345 67.6961 47.9345 68.5605V108.334C47.9345 109.197 47.2365 109.896 46.3721 109.896Z'
          fill='black'
        />
        <path
          d='M102.628 109.899C101.764 109.899 101.065 109.201 101.065 108.337V68.5605C101.065 67.6961 101.764 66.998 102.628 66.998C103.492 66.998 104.19 67.6961 104.19 68.5605V108.337C104.19 109.201 103.492 109.899 102.628 109.899Z'
          fill='black'
        />
        <path
          d='M102.628 70.123H46.3721C45.5084 70.123 44.8096 69.4249 44.8096 68.5605C44.8096 67.6961 45.5084 66.998 46.3721 66.998H102.628C103.492 66.998 104.191 67.6961 104.191 68.5605C104.191 69.4249 103.492 70.123 102.628 70.123Z'
          fill='black'
        />
        <path
          d='M46.3712 70.1238C46.0981 70.1238 45.8196 70.052 45.5686 69.9002C44.8278 69.457 44.589 68.4972 45.0322 67.7564L49.7197 59.9409C50.1622 59.2024 51.1212 58.9613 51.8635 59.4053C52.6044 59.8486 52.8432 60.8083 52.3999 61.5491L47.7124 69.3646C47.4202 69.8537 46.903 70.1238 46.3712 70.1238Z'
          fill='black'
        />
        <path
          d='M102.629 70.1232C102.098 70.1232 101.58 69.8531 101.288 69.3656L96.6006 61.5501C96.1573 60.8093 96.3961 59.8495 97.1369 59.4063C97.8777 58.9623 98.8368 59.2033 99.2808 59.9419L103.968 67.7574C104.412 68.4982 104.173 69.4579 103.432 69.9012C103.179 70.0515 102.902 70.1232 102.629 70.1232V70.1232Z'
          fill='black'
        />
        <path
          d='M97.9411 62.3086H51.0596C50.1959 62.3086 49.4971 61.6097 49.4971 60.7461C49.4971 59.8817 50.1959 59.1836 51.0596 59.1836H97.9411C98.8047 59.1836 99.5035 59.8817 99.5035 60.7461C99.5035 61.6097 98.8047 62.3086 97.9411 62.3086Z'
          fill='black'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M71.3435 61.0512L69.8095 68.7238V75.935L74.0399 74.878C74.1546 74.8427 74.2741 74.8205 74.3962 74.8127C74.5937 74.7985 74.7879 74.8229 74.9701 74.8806L79.1885 75.9352V68.714L77.6566 61.0516C77.488 60.2047 78.0365 59.383 78.8819 59.2129C79.7394 59.0374 80.5519 59.5928 80.7213 60.4374L82.2838 68.2537C82.3077 68.3737 82.3172 68.4932 82.3135 68.6104V77.9364C82.3135 78.8008 81.6146 79.4989 80.751 79.4989C80.601 79.4989 80.4561 79.4779 80.3189 79.4387L74.4997 77.9839L68.6879 79.4362C68.5481 79.477 68.4002 79.4989 68.2471 79.4989C67.3834 79.4989 66.6846 78.8008 66.6846 77.9364V77.932V68.5615C66.6846 68.4329 66.7 68.308 66.7292 68.1885L68.2788 60.437C68.4466 59.5925 69.2622 59.0355 70.1182 59.2125C70.9635 59.3811 71.5136 60.2043 71.3435 61.0512Z'
          fill='black'
        />
        <path
          d='M88.5684 98.2519H60.4307C59.567 98.2519 58.8682 97.5538 58.8682 96.6894C58.8682 95.8258 59.567 95.127 60.4307 95.127H88.5684C89.432 95.127 90.1309 95.8258 90.1309 96.6894C90.1309 97.5538 89.432 98.2519 88.5684 98.2519Z'
          fill='black'
        />
        <path
          d='M88.5684 92.0146H60.4307C59.567 92.0146 58.8682 91.3158 58.8682 90.4521C58.8682 89.5877 59.567 88.8896 60.4307 88.8896H88.5684C89.432 88.8896 90.1309 89.5877 90.1309 90.4521C90.1309 91.3158 89.432 92.0146 88.5684 92.0146Z'
          fill='black'
        />
        <path
          d='M80.7538 104.505H68.2471C67.3834 104.505 66.6846 103.807 66.6846 102.942C66.6846 102.079 67.3834 101.38 68.2471 101.38H80.7538C81.6175 101.38 82.3163 102.079 82.3163 102.942C82.3163 103.807 81.6175 104.505 80.7538 104.505Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_641_22446'>
          <rect
            width='100'
            height='100'
            fill='white'
            transform='translate(24.5 24.0449)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconCarts = () => {
  return (
    <svg
      width='40'
      height='30'
      viewBox='0 0 40 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M29.1176 22.6382H12.2408C11.9863 22.6388 11.7386 22.5571 11.5358 22.4058C11.333 22.2545 11.1863 22.042 11.1183 21.8008L5.97519 3.61458C5.91853 3.40925 5.80418 3.22378 5.64522 3.07943C5.48627 2.93507 5.28916 2.83768 5.07649 2.79842L0.832031 2'
        stroke='white'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M10.3059 18.5934H27.8034C27.9823 18.5932 28.1568 18.5385 28.3029 18.4369C28.449 18.3352 28.5594 18.1916 28.6191 18.0257L32.5892 7.16007C32.6245 7.0627 32.6351 6.95834 32.62 6.85603C32.605 6.75373 32.5648 6.65658 32.5029 6.57302C32.441 6.48945 32.3594 6.422 32.265 6.3765C32.1706 6.33101 32.0663 6.30886 31.9612 6.31197L6.73633 6.07422'
        stroke='white'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M15.2019 26.9823C15.2055 27.4183 15.0773 27.8454 14.8336 28.2096C14.5899 28.5737 14.2417 28.8585 13.8331 29.0278C13.4246 29.197 12.9741 29.2431 12.5388 29.1602C12.1036 29.0774 11.7032 28.8692 11.3884 28.5622C11.0736 28.2552 10.8587 27.8632 10.7709 27.4359C10.6831 27.0086 10.7263 26.5653 10.8952 26.1622C11.064 25.7591 11.3508 25.4145 11.7191 25.1719C12.0875 24.9293 12.5209 24.7998 12.9642 24.7998C13.5543 24.8007 14.1202 25.0304 14.5391 25.439C14.9581 25.8476 15.1962 26.4022 15.2019 26.9823V26.9823Z'
        stroke='white'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M29.075 26.9824C29.0785 27.4176 28.9508 27.844 28.7079 28.2077C28.4649 28.5715 28.1178 28.8563 27.7103 29.026C27.3028 29.1958 26.8532 29.2429 26.4185 29.1615C25.9837 29.08 25.5833 28.8736 25.2678 28.5684C24.9524 28.2632 24.736 27.8728 24.6462 27.4467C24.5564 27.0206 24.597 26.5779 24.7631 26.1745C24.9291 25.7711 25.2131 25.4252 25.5791 25.1805C25.9451 24.9359 26.3767 24.8034 26.8192 24.7999C27.4124 24.7961 27.9829 25.0237 28.4058 25.4328C28.8286 25.8419 29.0693 26.3991 29.075 26.9824Z'
        stroke='white'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <circle cx='30' cy='6' r='6' fill='#EC4040' />
    </svg>
  )
}

export const IconCloseWhite = () => {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.7768 2.00644C14.1673 1.61592 14.1673 0.982754 13.7768 0.592229C13.3863 0.201705 12.7531 0.201705 12.3626 0.592229L7.18457 5.77024L2.00655 0.592229C1.61603 0.201705 0.982866 0.201704 0.592341 0.592229C0.201817 0.982754 0.201817 1.61592 0.592341 2.00644L5.77036 7.18446L0.591947 12.3629C0.201422 12.7534 0.201422 13.3866 0.591946 13.7771C0.982471 14.1676 1.61564 14.1676 2.00616 13.7771L7.18457 8.59867L12.363 13.7771C12.7535 14.1676 13.3867 14.1676 13.7772 13.7771C14.1677 13.3866 14.1677 12.7534 13.7772 12.3629L8.59878 7.18446L13.7768 2.00644Z'
        fill='white'
      />
    </svg>
  )
}

export const TrashIcon = () => {
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3 6.5H5H21'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19 6.5V20.5C19 21.0304 18.7893 21.5391 18.4142 21.9142C18.0391 22.2893 17.5304 22.5 17 22.5H7C6.46957 22.5 5.96086 22.2893 5.58579 21.9142C5.21071 21.5391 5 21.0304 5 20.5V6.5M8 6.5V4.5C8 3.96957 8.21071 3.46086 8.58579 3.08579C8.96086 2.71071 9.46957 2.5 10 2.5H14C14.5304 2.5 15.0391 2.71071 15.4142 3.08579C15.7893 3.46086 16 3.96957 16 4.5V6.5'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 11.5V17.5'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14 11.5V17.5'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const IconLeft = () => {
  return (
    <svg
      width='16'
      height='24'
      viewBox='0 0 16 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 4L4 12L12 20'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const IconPrevBlack = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20 24L12 16L20 8'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const IconCloseBlack = () => {
  return (
    <svg
      width='34'
      height='34'
      viewBox='0 0 34 34'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.7758 12.0064C24.1663 11.6159 24.1663 10.9828 23.7758 10.5922C23.3853 10.2017 22.7521 10.2017 22.3616 10.5922L17.1836 15.7702L12.0056 10.5922C11.6151 10.2017 10.9819 10.2017 10.5914 10.5922C10.2008 10.9828 10.2008 11.6159 10.5914 12.0064L15.7694 17.1845L10.591 22.3629C10.2004 22.7534 10.2004 23.3866 10.591 23.7771C10.9815 24.1676 11.6147 24.1676 12.0052 23.7771L17.1836 18.5987L22.362 23.7771C22.7525 24.1676 23.3857 24.1676 23.7762 23.7771C24.1667 23.3866 24.1667 22.7534 23.7762 22.3629L18.5978 17.1845L23.7758 12.0064Z'
        fill='black'
      />
    </svg>
  )
}
export const IconFilter = ({color='#1E24C0'}: {color?:string}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M22.2591 1.80715e-06H1.24063C0.869919 -0.00071205 0.530063 0.210113 0.360602 0.545862C0.188804 0.886132 0.218956 1.29588 0.438437 1.60665L8.13873 12.6495C8.1413 12.6533 8.14411 12.6569 8.14668 12.6607C8.42647 13.0452 8.57769 13.5109 8.57863 13.9896V22.9928C8.57699 23.2595 8.67984 23.5155 8.86449 23.7047C9.04915 23.8939 9.30018 24 9.56197 24C9.6952 24 9.8268 23.9729 9.94974 23.921L14.2767 22.2413C14.6645 22.1209 14.9218 21.7485 14.9218 21.3V13.9896C14.9225 13.5111 15.074 13.0452 15.3536 12.6607C15.3561 12.6569 15.3589 12.6533 15.3615 12.6495L23.0616 1.60617C23.281 1.29565 23.3112 0.886132 23.1394 0.545862C22.9699 0.210113 22.6301 -0.00071205 22.2591 1.80715e-06ZM14.3887 11.939C13.9586 12.5331 13.726 13.2515 13.7246 13.9896V21.152L9.77537 22.6848V13.9896C9.77397 13.2515 9.5414 12.5331 9.11109 11.939L1.63541 1.21831H21.8646L14.3887 11.939Z'
        fill={color}
      />
    </svg>
  )
}
export const IconHaveBuyed = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1564_48986)'>
        <path
          d='M14.6673 7.38625V7.99958C14.6665 9.4372 14.201 10.836 13.3402 11.9875C12.4794 13.1389 11.2695 13.9812 9.89089 14.3889C8.51227 14.7965 7.03882 14.7475 5.6903 14.2493C4.34177 13.7511 3.19042 12.8303 2.40796 11.6243C1.6255 10.4183 1.25385 8.99163 1.34844 7.55713C1.44303 6.12263 1.99879 4.75714 2.93284 3.6643C3.86689 2.57146 5.12917 1.80984 6.53144 1.49301C7.93371 1.17619 9.40083 1.32114 10.714 1.90625'
          stroke='#2DC471'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.6667 2.66699L8 9.34033L6 7.34033'
          stroke='#2DC471'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1564_48986'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconCamera = () => {
  return (
    <svg
      width='32'
      height='33'
      viewBox='0 0 32 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M30.6654 25.8333C30.6654 26.5406 30.3844 27.2189 29.8843 27.719C29.3842 28.219 28.7059 28.5 27.9987 28.5H3.9987C3.29145 28.5 2.61318 28.219 2.11308 27.719C1.61298 27.2189 1.33203 26.5406 1.33203 25.8333V11.1667C1.33203 10.4594 1.61298 9.78115 2.11308 9.28105C2.61318 8.78095 3.29145 8.5 3.9987 8.5H9.33203L11.9987 4.5H19.9987L22.6654 8.5H27.9987C28.7059 8.5 29.3842 8.78095 29.8843 9.28105C30.3844 9.78115 30.6654 10.4594 30.6654 11.1667V25.8333Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.0013 23.1667C18.9468 23.1667 21.3346 20.7789 21.3346 17.8333C21.3346 14.8878 18.9468 12.5 16.0013 12.5C13.0558 12.5 10.668 14.8878 10.668 17.8333C10.668 20.7789 13.0558 23.1667 16.0013 23.1667Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const IconRemoveImage = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle opacity='0.3' cx='16' cy='16' r='16' fill='#161616' />
      <path
        d='M20.7071 11.2928C20.5196 11.1053 20.2652 11 20.0001 11C19.7349 11 19.4806 11.1053 19.2931 11.2928L16.0001 14.5858L12.7071 11.2928C12.5185 11.1106 12.2659 11.0098 12.0037 11.0121C11.7415 11.0144 11.4907 11.1196 11.3053 11.305C11.1199 11.4904 11.0147 11.7412 11.0124 12.0034C11.0101 12.2656 11.1109 12.5182 11.2931 12.7068L14.5861 15.9998L11.2931 19.2928C11.1976 19.385 11.1214 19.4954 11.069 19.6174C11.0166 19.7394 10.989 19.8706 10.9878 20.0034C10.9867 20.1362 11.012 20.2678 11.0623 20.3907C11.1125 20.5136 11.1868 20.6253 11.2807 20.7192C11.3746 20.8131 11.4862 20.8873 11.6091 20.9376C11.732 20.9879 11.8637 21.0132 11.9965 21.012C12.1293 21.0109 12.2605 20.9833 12.3825 20.9309C12.5045 20.8785 12.6148 20.8023 12.7071 20.7068L16.0001 17.4138L19.2931 20.7068C19.4817 20.8889 19.7343 20.9897 19.9965 20.9875C20.2587 20.9852 20.5095 20.88 20.6949 20.6946C20.8803 20.5092 20.9855 20.2584 20.9878 19.9962C20.99 19.734 20.8892 19.4814 20.7071 19.2928L17.4141 15.9998L20.7071 12.7068C20.8946 12.5193 20.9999 12.265 20.9999 11.9998C20.9999 11.7346 20.8946 11.4803 20.7071 11.2928Z'
        fill='white'
      />
    </svg>
  )
}
export const NotificationBellHaveNoti = () => {
  return (
    <svg
      width='27'
      height='30'
      viewBox='0 0 27 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5 9.66602C21.5 7.54428 20.6571 5.50945 19.1569 4.00916C17.6566 2.50887 15.6217 1.66602 13.5 1.66602C11.3783 1.66602 9.34344 2.50887 7.84315 4.00916C6.34286 5.50945 5.5 7.54428 5.5 9.66602C5.5 18.9993 1.5 21.666 1.5 21.666H25.5C25.5 21.666 21.5 18.9993 21.5 9.66602Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.8067 27C15.5723 27.4041 15.2358 27.7395 14.831 27.9727C14.4262 28.2059 13.9672 28.3286 13.5 28.3286C13.0329 28.3286 12.5739 28.2059 12.1691 27.9727C11.7642 27.7395 11.4278 27.4041 11.1934 27'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='21.1666' cy='7' r='5' fill='#EC4040' />
    </svg>
  )
}
export const NotificationBellHaveNotiActive = () => {
  return (
    <svg
      width='27'
      height='30'
      viewBox='0 0 27 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5 9.66602C21.5 7.54428 20.6571 5.50945 19.1569 4.00916C17.6566 2.50887 15.6217 1.66602 13.5 1.66602C11.3783 1.66602 9.34344 2.50887 7.84315 4.00916C6.34286 5.50945 5.5 7.54428 5.5 9.66602C5.5 18.9993 1.5 21.666 1.5 21.666H25.5C25.5 21.666 21.5 18.9993 21.5 9.66602Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.8067 27C15.5723 27.4041 15.2358 27.7395 14.831 27.9727C14.4262 28.2059 13.9672 28.3286 13.5 28.3286C13.0329 28.3286 12.5739 28.2059 12.1691 27.9727C11.7642 27.7395 11.4278 27.4041 11.1934 27'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='21.1666' cy='7' r='5' fill='#EC4040' />
    </svg>
  )
}
export const NotificationBellNotNoti = () => {
  return (
    <svg
      width='27'
      height='30'
      viewBox='0 0 27 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5 9.66602C21.5 7.54428 20.6571 5.50945 19.1569 4.00916C17.6566 2.50887 15.6217 1.66602 13.5 1.66602C11.3783 1.66602 9.34344 2.50887 7.84315 4.00916C6.34286 5.50945 5.5 7.54428 5.5 9.66602C5.5 18.9993 1.5 21.666 1.5 21.666H25.5C25.5 21.666 21.5 18.9993 21.5 9.66602Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.8067 27C15.5723 27.4041 15.2358 27.7395 14.831 27.9727C14.4262 28.2059 13.9672 28.3286 13.5 28.3286C13.0329 28.3286 12.5739 28.2059 12.1691 27.9727C11.7642 27.7395 11.4278 27.4041 11.1934 27'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const NotificationBellNotNotiActive = () => {
  return (
    <svg
      width='27'
      height='30'
      viewBox='0 0 27 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5 9.66602C21.5 7.54428 20.6571 5.50945 19.1569 4.00916C17.6566 2.50887 15.6217 1.66602 13.5 1.66602C11.3783 1.66602 9.34344 2.50887 7.84315 4.00916C6.34286 5.50945 5.5 7.54428 5.5 9.66602C5.5 18.9993 1.5 21.666 1.5 21.666H25.5C25.5 21.666 21.5 18.9993 21.5 9.66602Z'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.8067 27C15.5723 27.4041 15.2358 27.7395 14.831 27.9727C14.4262 28.2059 13.9672 28.3286 13.5 28.3286C13.0329 28.3286 12.5739 28.2059 12.1691 27.9727C11.7642 27.7395 11.4278 27.4041 11.1934 27'
        stroke='#1E24C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const IconMoreOption = () => {
  return (
    <svg
      width='32'
      height='8'
      viewBox='0 0 32 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='4' cy='4' r='4' fill='#818181' />
      <circle cx='16' cy='4' r='4' fill='#818181' />
      <circle cx='28' cy='4' r='4' fill='#818181' />
    </svg>
  )
}
export const CompareIcon = () => {
  return (
    <svg
      width='23'
      height='22'
      viewBox='0 0 23 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.5 5.66699C11.7404 5.66699 11.9709 5.76247 12.1408 5.93243C12.3108 6.10238 12.4062 6.33289 12.4062 6.57324V10.1982H16.0312C16.2716 10.1982 16.5021 10.2937 16.6721 10.4637C16.842 10.6336 16.9375 10.8641 16.9375 11.1045C16.9375 11.3448 16.842 11.5754 16.6721 11.7453C16.5021 11.9153 16.2716 12.0107 16.0312 12.0107H12.4062V15.6357C12.4062 15.8761 12.3108 16.1066 12.1408 16.2766C11.9709 16.4465 11.7404 16.542 11.5 16.542C11.2596 16.542 11.0291 16.4465 10.8592 16.2766C10.6892 16.1066 10.5938 15.8761 10.5938 15.6357V12.0107H6.96875C6.7284 12.0107 6.49789 11.9153 6.32793 11.7453C6.15798 11.5754 6.0625 11.3448 6.0625 11.1045C6.0625 10.8641 6.15798 10.6336 6.32793 10.4637C6.49789 10.2937 6.7284 10.1982 6.96875 10.1982H10.5938V6.57324C10.5938 6.33289 10.6892 6.10238 10.8592 5.93243C11.0291 5.76247 11.2596 5.66699 11.5 5.66699Z'
        fill='black'
      />
      <path
        d='M0.625 11.1045C0.625 9.67637 0.90629 8.26223 1.45281 6.94281C1.99933 5.62339 2.80038 4.42454 3.81021 3.41471C4.82005 2.40487 6.0189 1.60382 7.33832 1.0573C8.65773 0.510782 10.0719 0.229492 11.5 0.229492C12.9281 0.229492 14.3423 0.510782 15.6617 1.0573C16.9811 1.60382 18.1799 2.40487 19.1898 3.41471C20.1996 4.42454 21.0007 5.62339 21.5472 6.94281C22.0937 8.26223 22.375 9.67637 22.375 11.1045C22.375 13.9887 21.2292 16.7548 19.1898 18.7943C17.1503 20.8337 14.3842 21.9795 11.5 21.9795C8.61577 21.9795 5.84967 20.8337 3.81021 18.7943C1.77076 16.7548 0.625 13.9887 0.625 11.1045ZM11.5 2.04199C9.09648 2.04199 6.79139 2.99679 5.09184 4.69634C3.3923 6.39589 2.4375 8.70097 2.4375 11.1045C2.4375 13.508 3.3923 15.8131 5.09184 17.5126C6.79139 19.2122 9.09648 20.167 11.5 20.167C13.9035 20.167 16.2086 19.2122 17.9082 17.5126C19.6077 15.8131 20.5625 13.508 20.5625 11.1045C20.5625 8.70097 19.6077 6.39589 17.9082 4.69634C16.2086 2.99679 13.9035 2.04199 11.5 2.04199Z'
        fill='black'
      />
    </svg>
  )
}

export const IconCheckedSuccess = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={27}
      height={27}
      viewBox='0 0 27 27'
      fill='none'
    >
      <circle cx='13.5' cy='13.5' r='13.5' fill='#00E9A1' />
      <path
        d='M11.8129 18.5629C11.3809 18.5629 10.9489 18.3975 10.6199 18.0685L7.24486 14.6935C6.58505 14.0337 6.58505 12.9672 7.24486 12.3074C7.90467 11.6475 8.97117 11.6475 9.63098 12.3074L11.8129 14.4893L17.3699 8.93236C18.0297 8.27255 19.0962 8.27255 19.756 8.93236C20.4158 9.59217 20.4158 10.6587 19.756 11.3185L13.006 18.0685C12.6769 18.3975 12.2449 18.5629 11.8129 18.5629Z'
        fill='white'
      />
    </svg>
  )
}

export const IconNotiInfo = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='28'
      fill='none'
      viewBox='0 0 28 28'
    >
      <path
        fill='#000'
        d='M14 1.75C7.235 1.75 1.75 7.235 1.75 14S7.235 26.25 14 26.25 26.25 20.765 26.25 14 20.765 1.75 14 1.75zm0 22.422C8.384 24.172 3.828 19.616 3.828 14 3.828 8.384 8.384 3.828 14 3.828c5.616 0 10.172 4.556 10.172 10.172 0 5.616-4.556 10.172-10.172 10.172z'
      />
      <path
        fill='#000'
        d='M12.688 9.188a1.313 1.313 0 102.625 0 1.313 1.313 0 00-2.626 0zm1.968 3.062h-1.312a.22.22 0 00-.219.219v7.437c0 .12.098.219.219.219h1.312a.22.22 0 00.219-.219V12.47a.22.22 0 00-.219-.219z'
      />
    </svg>
  )
}

export const RadioUnChecked = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='27'
      height='27'
      fill='none'
      viewBox='0 0 27 27'
    >
      <circle cx='13.5' cy='13.5' r='12.5' stroke='#C4C4C4' strokeWidth='2' />
    </svg>
  )
}

export const RadioChecked = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='27'
      height='27'
      fill='none'
      viewBox='0 0 27 27'
    >
      <circle cx='13.5' cy='13.5' r='12.5' stroke='#C4C4C4' strokeWidth='2' />
      <circle cx='13.5' cy='13.5' r='7.5' fill='#1E24C0' />
    </svg>
  )
}

export const Installment = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        stroke='#1E24C0'
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M1 7h22M1 11h22'
      />
      <path
        stroke='#161616'
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M21 21H3a2 2 0 01-2-2V5a2 2 0 012-2h18a2 2 0 012 2v14a2 2 0 01-2 2z'
      />
      <path
        stroke='#1E24C0'
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M5 16h5M18 16h1'
      />
    </svg>
  )
}

export const Pay = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        stroke='#161616'
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M20.182 12V5.637H3.818A1.818 1.818 0 012 3.818v15.455A2.727 2.727 0 004.727 22h15.455v-6.364'
      />
      <path
        stroke='#161616'
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M16.546 2.91V2H3.818a1.818 1.818 0 100 3.636'
      />
      <path
        stroke='#1E24C0'
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M22 15.636h-4.545a1.818 1.818 0 110-3.636H22v3.636z'
      />
    </svg>
  )
}

export const IconWarning = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      fill='none'
      viewBox='0 0 32 32'
    >
      <path fill='#ED9315' d='M0 4a4 4 0 014-4h28v32H4a4 4 0 01-4-4V4z' />
      <path
        fill='#fff'
        d='M16 8c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3h-2v-5h2v5z'
      />
    </svg>
  )
}

export const IconPlus = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={13}
      height={14}
      viewBox='0 0 13 14'
      fill='none'
    >
      <path
        d='M7.02285 0.674805H5.97634C5.88331 0.674805 5.8368 0.721316 5.8368 0.81434V6.29108H0.639535C0.546512 6.29108 0.5 6.33759 0.5 6.43062V7.47713C0.5 7.57015 0.546512 7.61667 0.639535 7.61667H5.8368V13.0934C5.8368 13.1864 5.88331 13.2329 5.97634 13.2329H7.02285C7.11587 13.2329 7.16238 13.1864 7.16238 13.0934V7.61667H12.3605C12.4535 7.61667 12.5 7.57015 12.5 7.47713V6.43062C12.5 6.33759 12.4535 6.29108 12.3605 6.29108H7.16238V0.81434C7.16238 0.721316 7.11587 0.674805 7.02285 0.674805Z'
        fill='black'
        fillOpacity='0.85'
      />
    </svg>
  )
}

export const IconLogout = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={22}
      height={22}
      viewBox='0 0 25 25'
      fill='none'
    >
      <mask
        id='mask0_3468_12711'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={25}
        height={25}
      >
        <path d='M24.5 0.5H0.5V24.5H24.5V0.5Z' fill='white' />
      </mask>
      <g mask='url(#mask0_3468_12711)'>
        <mask
          id='mask1_3468_12711'
          style={{ maskType: 'luminance' }}
          maskUnits='userSpaceOnUse'
          x={0}
          y={0}
          width={25}
          height={25}
        >
          <path d='M0.5 0.500002H24.5V24.5H0.5V0.500002Z' fill='white' />
        </mask>
        <g mask='url(#mask1_3468_12711)'>
          <path
            d='M16.4844 18.875V20.75C16.4844 22.3033 15.2252 23.5625 13.6719 23.5625H4.25C2.6967 23.5625 1.4375 22.3033 1.4375 20.75V4.25C1.4375 2.6967 2.6967 1.4375 4.25 1.4375H13.6719C15.2252 1.4375 16.4844 2.6967 16.4844 4.25V6.125'
            stroke='white'
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M23.3281 12.5469H10.625'
            stroke='white'
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M21.0518 15.6406L23.1511 13.5412C23.7003 12.992 23.7003 12.1017 23.1511 11.5525L21.0518 9.45312'
            stroke='white'
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}
export const CouponIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={30}
      height={31}
      viewBox='0 0 30 31'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 0.5C23.2843 0.5 30 7.21572 30 15.5C30 23.7843 23.2843 30.5 15 30.5C6.71572 30.5 0 23.7843 0 15.5C0 7.21572 6.71572 0.5 15 0.5ZM7.01543 20.6554H9.07207V10.3445H7.01543C6.70884 10.3451 6.41499 10.4673 6.19836 10.6842C5.98172 10.9012 5.85998 11.1952 5.85984 11.5018V13.7506C5.85963 13.8066 5.88141 13.8603 5.92049 13.9004C5.95957 13.9404 6.01281 13.9634 6.06873 13.9646C6.47027 13.9731 6.85246 14.1387 7.1334 14.4257C7.41434 14.7127 7.57167 15.0984 7.57167 15.5C7.57167 15.9016 7.41434 16.2873 7.1334 16.5743C6.85246 16.8613 6.47027 17.0269 6.06873 17.0354C6.01281 17.0366 5.95957 17.0596 5.92049 17.0996C5.88141 17.1397 5.85963 17.1934 5.85984 17.2494V19.4982C5.85998 19.8048 5.98172 20.0988 6.19836 20.3158C6.415 20.5327 6.70884 20.6549 7.01543 20.6554ZM9.49981 20.6554H22.9829C23.2898 20.6552 23.584 20.5332 23.801 20.3162C24.0179 20.0993 24.1399 19.805 24.1402 19.4982V17.2494C24.1401 17.1927 24.1175 17.1383 24.0774 17.0982C24.0373 17.0581 23.9829 17.0355 23.9262 17.0354C23.519 17.0354 23.1285 16.8737 22.8405 16.5857C22.5526 16.2978 22.3908 15.9072 22.3908 15.5C22.3908 15.0928 22.5526 14.7022 22.8405 14.4143C23.1285 14.1263 23.519 13.9646 23.9262 13.9646C23.9829 13.9645 24.0373 13.9419 24.0774 13.9018C24.1175 13.8617 24.1401 13.8073 24.1402 13.7506V11.5018C24.1399 11.1949 24.0179 10.9007 23.801 10.6838C23.584 10.4668 23.2898 10.3448 22.9829 10.3445H9.50004V20.6554H9.49981ZM7.199 11.0586C7.07533 11.0583 6.95434 11.0946 6.85135 11.1631C6.74836 11.2315 6.66799 11.329 6.62042 11.4432C6.57285 11.5573 6.56023 11.683 6.58413 11.8044C6.60804 11.9257 6.66741 12.0372 6.75473 12.1248C6.84204 12.2124 6.95338 12.2721 7.07465 12.2964C7.19591 12.3206 7.32165 12.3084 7.43595 12.2612C7.55025 12.2139 7.64797 12.1339 7.71674 12.0311C7.7855 11.9283 7.82223 11.8074 7.82227 11.6837C7.82237 11.5182 7.7568 11.3594 7.63995 11.2422C7.5231 11.125 7.36451 11.059 7.199 11.0586ZM7.199 11.8807C7.23799 11.8807 7.27611 11.8691 7.30853 11.8475C7.34095 11.8258 7.36622 11.795 7.38115 11.759C7.39608 11.723 7.39999 11.6834 7.39239 11.6451C7.38479 11.6069 7.36602 11.5718 7.33846 11.5442C7.3109 11.5166 7.27578 11.4978 7.23754 11.4902C7.1993 11.4826 7.15967 11.4865 7.12365 11.5014C7.08763 11.5164 7.05684 11.5416 7.03518 11.574C7.01351 11.6065 7.00195 11.6446 7.00195 11.6836C7.00194 11.7094 7.00702 11.7351 7.01692 11.759C7.02682 11.7829 7.04133 11.8046 7.05963 11.8229C7.07793 11.8413 7.09966 11.8558 7.12357 11.8657C7.14749 11.8756 7.17312 11.8807 7.199 11.8807ZM22.801 12.3084C22.9246 12.3084 23.0454 12.2717 23.1482 12.2031C23.251 12.1344 23.3311 12.0368 23.3784 11.9226C23.4257 11.8084 23.4381 11.6827 23.4139 11.5615C23.3898 11.4403 23.3303 11.3289 23.2429 11.2415C23.1555 11.1541 23.0442 11.0946 22.9229 11.0705C22.8017 11.0464 22.676 11.0587 22.5618 11.106C22.4476 11.1534 22.35 11.2335 22.2814 11.3362C22.2127 11.439 22.176 11.5598 22.176 11.6834C22.176 11.7655 22.1922 11.8468 22.2236 11.9226C22.255 11.9985 22.301 12.0674 22.359 12.1254C22.4171 12.1834 22.486 12.2295 22.5618 12.2609C22.6376 12.2923 22.7189 12.3084 22.801 12.3084ZM22.801 11.4863C22.762 11.4863 22.7239 11.4979 22.6915 11.5195C22.659 11.5412 22.6338 11.5719 22.6188 11.608C22.6039 11.644 22.6 11.6836 22.6076 11.7219C22.6152 11.7601 22.634 11.7952 22.6615 11.8228C22.6891 11.8504 22.7242 11.8691 22.7625 11.8768C22.8007 11.8844 22.8403 11.8805 22.8764 11.8655C22.9124 11.8506 22.9432 11.8254 22.9648 11.793C22.9865 11.7605 22.998 11.7224 22.998 11.6834C22.9981 11.6576 22.993 11.6319 22.9831 11.608C22.9732 11.5841 22.9587 11.5624 22.9404 11.544C22.9221 11.5257 22.9003 11.5112 22.8764 11.5013C22.8525 11.4914 22.8269 11.4863 22.801 11.4863ZM7.199 19.9414C7.32261 19.9414 7.44345 19.9048 7.54624 19.8362C7.64904 19.7675 7.72917 19.67 7.7765 19.5558C7.82383 19.4416 7.83625 19.3159 7.81217 19.1947C7.78809 19.0735 7.7286 18.9621 7.64122 18.8747C7.55384 18.7872 7.4425 18.7277 7.32128 18.7035C7.20005 18.6794 7.07439 18.6917 6.96018 18.739C6.84597 18.7863 6.74834 18.8663 6.67964 18.9691C6.61094 19.0718 6.57425 19.1927 6.57422 19.3163C6.57431 19.482 6.64016 19.6409 6.7573 19.7581C6.87443 19.8753 7.0333 19.9412 7.199 19.9414ZM7.199 19.1193C7.15995 19.119 7.12167 19.1303 7.08904 19.1517C7.0564 19.1732 7.03087 19.2038 7.01569 19.2398C7.00051 19.2758 6.99637 19.3155 7.00378 19.3538C7.01119 19.3922 7.02983 19.4275 7.05732 19.4552C7.08482 19.4829 7.11994 19.5019 7.15822 19.5096C7.1965 19.5174 7.23622 19.5136 7.27234 19.4987C7.30845 19.4838 7.33934 19.4586 7.36107 19.4261C7.38281 19.3937 7.39441 19.3555 7.39441 19.3164C7.39435 19.2645 7.3738 19.2146 7.33722 19.1777C7.30063 19.1408 7.25097 19.1198 7.199 19.1193ZM22.801 19.9414C22.9246 19.9414 23.0454 19.9048 23.1482 19.8361C23.251 19.7674 23.3311 19.6698 23.3784 19.5556C23.4257 19.4414 23.4381 19.3158 23.4139 19.1945C23.3898 19.0733 23.3303 18.9619 23.2429 18.8745C23.1555 18.7871 23.0442 18.7276 22.9229 18.7035C22.8017 18.6794 22.676 18.6918 22.5618 18.7391C22.4476 18.7864 22.35 18.8665 22.2814 18.9692C22.2127 19.072 22.176 19.1928 22.176 19.3164C22.1763 19.4821 22.2422 19.641 22.3593 19.7581C22.4765 19.8753 22.6353 19.9412 22.801 19.9414ZM22.801 19.1193C22.762 19.1193 22.7239 19.1309 22.6915 19.1525C22.659 19.1742 22.6338 19.205 22.6188 19.241C22.6039 19.277 22.6 19.3166 22.6076 19.3549C22.6152 19.3931 22.634 19.4282 22.6615 19.4558C22.6891 19.4834 22.7242 19.5022 22.7625 19.5098C22.8007 19.5174 22.8403 19.5135 22.8764 19.4986C22.9124 19.4836 22.9432 19.4584 22.9648 19.426C22.9865 19.3935 22.998 19.3554 22.998 19.3164C22.9981 19.2906 22.993 19.2649 22.9831 19.241C22.9732 19.2171 22.9587 19.1954 22.9404 19.1771C22.9221 19.1587 22.9003 19.1442 22.8764 19.1343C22.8525 19.1244 22.8269 19.1193 22.801 19.1193ZM13.8798 17.9248C13.8502 17.9549 13.83 17.9931 13.822 18.0345C13.8139 18.076 13.8182 18.1189 13.8344 18.1579C13.8506 18.1969 13.8779 18.2303 13.9129 18.2538C13.948 18.2774 13.9892 18.2901 14.0314 18.2904C14.0884 18.2899 14.1429 18.2669 14.183 18.2264L19.3342 13.0752C19.3734 13.0348 19.395 12.9806 19.3945 12.9244C19.3939 12.8682 19.3713 12.8144 19.3314 12.7748C19.2916 12.7351 19.2377 12.7128 19.1815 12.7126C19.1253 12.7124 19.0712 12.7343 19.0311 12.7736L13.8798 17.9248ZM18.2494 15.7299C17.9227 15.7297 17.606 15.8429 17.3533 16.05C17.1005 16.2572 16.9275 16.5455 16.8635 16.8659C16.7996 17.1864 16.8487 17.5191 17.0025 17.8074C17.1564 18.0956 17.4054 18.3217 17.7072 18.4469C18.009 18.5722 18.3449 18.589 18.6576 18.4943C18.9704 18.3997 19.2407 18.1996 19.4224 17.9281C19.6042 17.6565 19.6862 17.3304 19.6544 17.0052C19.6227 16.6799 19.4792 16.3758 19.2483 16.1445C19.1177 16.0126 18.9621 15.908 18.7906 15.8369C18.6191 15.7657 18.4351 15.7295 18.2494 15.7302V15.7299ZM18.9451 17.8389C19.0827 17.7014 19.1764 17.5261 19.2144 17.3352C19.2524 17.1444 19.2329 16.9465 19.1584 16.7668C19.0839 16.587 18.9578 16.4333 18.796 16.3252C18.6342 16.2171 18.444 16.1595 18.2494 16.1595C18.1202 16.1594 17.9923 16.1849 17.8729 16.2343C17.7535 16.2837 17.6451 16.3562 17.5537 16.4475C17.4624 16.5389 17.3899 16.6474 17.3405 16.7667C17.291 16.8861 17.2656 17.0141 17.2656 17.1433C17.2657 17.3378 17.3234 17.528 17.4315 17.6898C17.5396 17.8515 17.6933 17.9776 17.873 18.0521C18.0528 18.1265 18.2506 18.146 18.4414 18.1081C18.6322 18.0701 18.8075 17.9765 18.9451 17.8389ZM13.9657 14.8555C14.1632 15.0527 14.4148 15.1869 14.6885 15.2411C14.9623 15.2954 15.246 15.2673 15.5038 15.1604C15.7616 15.0535 15.9819 14.8726 16.1369 14.6405C16.292 14.4084 16.3747 14.1355 16.3747 13.8564C16.3747 13.5774 16.292 13.3045 16.1369 13.0724C15.9819 12.8403 15.7616 12.6594 15.5038 12.5525C15.246 12.4456 14.9623 12.4175 14.6885 12.4718C14.4148 12.526 14.1632 12.6602 13.9657 12.8574C13.8337 12.9881 13.7288 13.1437 13.6573 13.3152C13.5857 13.4867 13.5489 13.6706 13.5489 13.8564C13.5489 14.0422 13.5857 14.2262 13.6573 14.3977C13.7288 14.5692 13.8337 14.7248 13.9657 14.8555ZM14.2689 13.1609C14.0845 13.3455 13.981 13.5957 13.981 13.8566C13.981 14.1175 14.0845 14.3677 14.2689 14.5523C14.3601 14.6436 14.4685 14.7161 14.5877 14.7655C14.7069 14.8149 14.8347 14.8403 14.9638 14.8403C15.0929 14.8403 15.2207 14.8149 15.3399 14.7655C15.4591 14.7161 15.5674 14.6436 15.6587 14.5523C15.75 14.4611 15.8225 14.3527 15.872 14.2334C15.9215 14.1142 15.947 13.9863 15.9471 13.8572C15.9472 13.7281 15.9218 13.6002 15.8725 13.4809C15.8231 13.3615 15.7508 13.2531 15.6595 13.1617C15.5683 13.0704 15.4599 12.9979 15.3406 12.9484C15.2214 12.8989 15.0935 12.8734 14.9644 12.8733C14.8353 12.8732 14.7074 12.8986 14.5881 12.9479C14.4687 12.9973 14.3603 13.0696 14.2689 13.1609Z'
        fill='#ED1C24'
      />
    </svg>
  )
}
export const CouponIconSimple = () => {
  return (
    <svg
      width={28}
      height={20}
      viewBox='0 0 28 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24.7708 19.8594H2.56252C1.14948 19.8594 0 18.7459 0 17.377V13.2396C0 12.7822 0.382028 12.4121 0.854172 12.4121C2.26721 12.4121 3.41669 11.2986 3.41669 9.9297C3.41669 8.56081 2.26721 7.44726 0.854172 7.44726C0.382028 7.44731 0 7.07722 0 6.61983V2.48244C0 1.11356 1.14948 0 2.56252 0H24.7709C26.1839 0 27.3334 1.11356 27.3334 2.48244V6.61983C27.3334 7.07722 26.9514 7.44731 26.4792 7.44731C25.0662 7.44731 23.9167 8.56087 23.9167 9.92975C23.9167 11.2986 25.0662 12.4122 26.4792 12.4122C26.9514 12.4122 27.3334 12.7823 27.3334 13.2397V17.3771C27.3333 18.7459 26.1839 19.8594 24.7708 19.8594ZM1.70834 13.9839V17.377C1.70834 17.8336 2.09123 18.2045 2.56252 18.2045H24.7709C25.2422 18.2045 25.625 17.8336 25.625 17.377V13.9839C23.6782 13.5992 22.2084 11.9281 22.2084 9.9297C22.2084 7.93128 23.6781 6.26022 25.625 5.87553V2.48244C25.625 2.02588 25.2422 1.65496 24.7709 1.65496H2.56252C2.09123 1.65496 1.70834 2.02588 1.70834 2.48244V5.87559C3.65523 6.26022 5.12503 7.93133 5.12503 9.92975C5.12503 11.9282 3.65523 13.5992 1.70834 13.9839Z'
        fill='black'
      />
      <path
        d='M10.3047 16.248L15.4279 3.01315L17.0274 3.59423L11.9042 16.8291L10.3047 16.248Z'
        fill='black'
      />
      <path
        d='M9.62502 10.2071C8.21198 10.2071 7.0625 9.09351 7.0625 7.72462C7.0625 6.35574 8.21198 5.24219 9.62502 5.24219C11.0381 5.24219 12.1875 6.35574 12.1875 7.72462C12.1875 9.09351 11.0381 10.2071 9.62502 10.2071ZM9.62502 6.89715C9.15374 6.89715 8.77084 7.26807 8.77084 7.72462C8.77084 8.18118 9.15374 8.5521 9.62502 8.5521C10.0963 8.5521 10.4792 8.18118 10.4792 7.72462C10.4792 7.26807 10.0963 6.89715 9.62502 6.89715Z'
        fill='black'
      />
      <path
        d='M18.4551 15.3399C17.0421 15.3399 15.8926 14.2263 15.8926 12.8574C15.8926 11.4886 17.0421 10.375 18.4551 10.375C19.8681 10.375 21.0176 11.4886 21.0176 12.8574C21.0176 14.2263 19.8681 15.3399 18.4551 15.3399ZM18.4551 12.03C17.9838 12.03 17.6009 12.4009 17.6009 12.8574C17.6009 13.314 17.9838 13.6849 18.4551 13.6849C18.9264 13.6849 19.3093 13.314 19.3093 12.8574C19.3093 12.4009 18.9264 12.03 18.4551 12.03Z'
        fill='black'
      />
    </svg>
  )
}

export const EditIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_14020_34080)'>
        <path
          d='M3.59931 16.8401C3.79931 16.8401 3.83931 16.8201 4.01931 16.7801L7.61931 16.0601C7.99931 15.9601 8.37931 15.7801 8.67931 15.4801L17.3993 6.76012C18.7393 5.42012 18.7393 3.12012 17.3993 1.78012L16.6593 1.00012C15.3193 -0.339883 12.9993 -0.339883 11.6593 1.00012L2.93931 9.74012C2.65931 10.0201 2.45931 10.4201 2.35931 10.8001L1.59931 14.4401C1.49931 15.1201 1.69931 15.7801 2.17931 16.2601C2.55931 16.6401 3.11931 16.8401 3.59931 16.8401ZM4.27931 11.1801L12.9993 2.44012C13.5793 1.86012 14.6393 1.86012 15.1993 2.44012L15.9593 3.20012C16.6393 3.88012 16.6393 4.84012 15.9593 5.50012L7.25931 14.2401L3.55931 14.8601L4.27931 11.1801Z'
          fill='white'
        />
        <path
          d='M17.3196 18.0801H2.55961C1.97961 18.0801 1.59961 18.4601 1.59961 19.0401C1.59961 19.6201 2.07961 20.0001 2.55961 20.0001H17.2396C17.8196 20.0001 18.2996 19.6201 18.2996 19.0401C18.2796 18.4601 17.7996 18.0801 17.3196 18.0801Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_14020_34080'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const CouponArrowDown = ({ className = '' }) => {
  return (
    <svg
      className={`${className}`}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.00041 11.0006C7.73521 11.0005 7.4809 10.8951 7.29341 10.7076L3.29341 6.70757C3.11125 6.51897 3.01045 6.26636 3.01273 6.00417C3.01501 5.74197 3.12018 5.49116 3.30559 5.30575C3.491 5.12034 3.74181 5.01517 4.00401 5.0129C4.2662 5.01062 4.5188 5.11141 4.70741 5.29357L8.00041 8.58657L11.2934 5.29357C11.3857 5.19806 11.496 5.12188 11.618 5.06947C11.74 5.01706 11.8712 4.98947 12.004 4.98832C12.1368 4.98717 12.2685 5.01247 12.3914 5.06275C12.5143 5.11303 12.6259 5.18728 12.7198 5.28117C12.8137 5.37507 12.8879 5.48672 12.9382 5.60962C12.9885 5.73251 13.0138 5.86419 13.0127 5.99697C13.0115 6.12975 12.9839 6.26097 12.9315 6.38297C12.8791 6.50498 12.8029 6.61532 12.7074 6.70757L8.70741 10.7076C8.51991 10.8951 8.2656 11.0005 8.00041 11.0006Z'
        fill='#303538'
      />
    </svg>
  )
}

export const CouponArrow = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={7}
      height={13}
      viewBox='0 0 7 13'
      fill='none'
    >
      <path
        d='M1.06125 1.21051C0.693124 1.60051 0.693124 2.23051 1.06125 2.62051L4.72368 6.50051L1.06125 10.3805C0.693124 10.7705 0.693124 11.4005 1.06125 11.7905C1.42939 12.1805 2.02406 12.1805 2.39219 11.7905L6.72481 7.20051C7.09294 6.81051 7.09294 6.18051 6.72481 5.79051L2.39219 1.20051C2.0335 0.82051 1.42939 0.82051 1.06125 1.21051Z'
        fill='#1E42C0'
      />
    </svg>
  )
}
export const Star = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={11}
      height={10}
      viewBox='0 0 11 10'
      fill='none'
    >
      <path
        d='M5.5 0.0310059L6.96946 3.16517L10.2553 3.66776L7.87764 6.10737L8.43893 9.55215L5.5 7.92574L2.56107 9.55215L3.12236 6.10737L0.744718 3.66776L4.03054 3.16517L5.5 0.0310059Z'
        fill='#555555'
      />
    </svg>
  )
}
export const StarRate = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_590_6315)'>
        <path
          d='M15.1441 5.43918L10.8271 4.81118L8.90008 0.900179C8.80851 0.742644 8.67719 0.611904 8.51925 0.521028C8.36132 0.430153 8.18229 0.382324 8.00008 0.382324C7.81786 0.382324 7.63884 0.430153 7.4809 0.521028C7.32297 0.611904 7.19165 0.742644 7.10008 0.900179L5.17308 4.81218L0.856079 5.43918C0.671214 5.46569 0.497468 5.54344 0.354521 5.66363C0.211573 5.78381 0.105137 5.94162 0.0472671 6.11918C-0.0106025 6.29675 -0.0175924 6.48697 0.0270889 6.6683C0.0717703 6.84963 0.166337 7.01483 0.300079 7.14518L3.42308 10.1902L2.68608 14.4902C2.65457 14.6741 2.67514 14.8631 2.74546 15.036C2.81578 15.2088 2.93305 15.3585 3.08401 15.4681C3.23497 15.5778 3.41359 15.643 3.59969 15.6565C3.78579 15.6699 3.97193 15.631 4.13708 15.5442L8.00008 13.5132L11.8611 15.5422C12.0262 15.629 12.2124 15.6679 12.3985 15.6545C12.5846 15.641 12.7632 15.5758 12.9142 15.4661C13.0651 15.3565 13.1824 15.2068 13.2527 15.034C13.323 14.8611 13.3436 14.6721 13.3121 14.4882L12.5751 10.1882L15.7001 7.14518C15.8335 7.01492 15.9278 6.84996 15.9724 6.66892C16.017 6.48788 16.0102 6.29797 15.9525 6.12065C15.8949 5.94332 15.7889 5.78563 15.6464 5.66539C15.5039 5.54515 15.3306 5.46714 15.1461 5.44018L15.1441 5.43918Z'
          fill='#F2A41C'
        />
      </g>
      <defs>
        <clipPath id='clip0_590_6315'>
          <rect width={16} height={16} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconCheckBlue = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={12}
      height={10}
      viewBox='0 0 15 13'
      fill='none'
    >
      <path
        d='M13.2375 0.808838L5 9.20374L1.7625 5.91712L0 7.7133L5 12.8088L15 2.61776L13.2375 0.808838Z'
        fill='#1E42C0'
      />
    </svg>
  )
}
export const IconCheckRed = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={17}
      viewBox='0 0 17 17'
      fill='none'
    >
      <path
        d='M8.5 0.404053C4.084 0.404053 0.5 3.98805 0.5 8.40405C0.5 12.8201 4.084 16.4041 8.5 16.4041C12.916 16.4041 16.5 12.8201 16.5 8.40405C16.5 3.98805 12.916 0.404053 8.5 0.404053ZM8.5 14.8041C4.972 14.8041 2.1 11.9321 2.1 8.40405C2.1 4.87605 4.972 2.00405 8.5 2.00405C12.028 2.00405 14.9 4.87605 14.9 8.40405C14.9 11.9321 12.028 14.8041 8.5 14.8041ZM12.172 4.86805L6.9 10.1401L4.828 8.07605L3.7 9.20405L6.9 12.4041L13.3 6.00405L12.172 4.86805Z'
        fill='#EE2E24'
      />
    </svg>
  )
}
export const IconPrivacy = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={21}
      viewBox='0 0 20 21'
      fill='none'
    >
      <g clipPath='url(#clip0_1673_12440)'>
        <path
          d='M18.3811 5.39964C18.3708 4.85966 18.361 4.34956 18.361 3.85607C18.361 3.46945 18.0477 3.15602 17.661 3.15602C14.6671 3.15602 12.3877 2.29561 10.4876 0.44822C10.2158 0.18388 9.78327 0.183973 9.51156 0.44822C7.61171 2.29561 5.33263 3.15602 2.33893 3.15602C1.95231 3.15602 1.63888 3.46945 1.63888 3.85607C1.63888 4.34965 1.62917 4.85994 1.61881 5.40001C1.52285 10.4251 1.39143 17.3071 9.7703 20.2114C9.8446 20.2372 9.92207 20.2501 9.99954 20.2501C10.077 20.2501 10.1546 20.2372 10.2288 20.2114C18.6083 17.307 18.4771 10.4248 18.3811 5.39964ZM9.99963 18.8071C2.81365 16.1967 2.9223 10.4782 3.01872 5.4267C3.02451 5.12354 3.03011 4.8297 3.03403 4.54165C5.83797 4.4233 8.08019 3.57362 9.99963 1.90153C11.9193 3.57362 14.1619 4.42339 16.966 4.54165C16.9699 4.82961 16.9755 5.12326 16.9813 5.42624C17.0776 10.4779 17.1862 16.1966 9.99963 18.8071Z'
          fill='black'
        />
        <path
          d='M12.4103 7.81828L9.03149 11.1969L7.58966 9.75509C7.31627 9.48179 6.873 9.48179 6.5997 9.75509C6.3263 10.0286 6.3263 10.4718 6.5997 10.7451L8.53651 12.682C8.67316 12.8186 8.85237 12.8869 9.03149 12.8869C9.21061 12.8869 9.38982 12.8186 9.52647 12.682L13.4002 8.80834C13.6737 8.53495 13.6737 8.09167 13.4003 7.81837C13.127 7.54498 12.6837 7.54489 12.4103 7.81828Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_1673_12440'>
          <rect
            width={20}
            height={20}
            fill='white'
            transform='translate(0 0.25)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconAccount = ({ color = 'black' }: { color?: string }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={28}
      height={29}
      viewBox='0 0 30 31'
      fill='none'
      className='w-full'
    >
      <path
        d='M25.6066 4.71834C22.7735 1.88524 19.0066 0.324951 15 0.324951C10.9934 0.324951 7.22649 1.88524 4.39339 4.71834C1.56029 7.55144 0 11.3184 0 15.325C0 19.3315 1.56029 23.0985 4.39339 25.9316C7.22649 28.7647 10.9934 30.325 15 30.325C19.0066 30.325 22.7735 28.7647 25.6066 25.9316C28.4397 23.0985 30 19.3315 30 15.325C30 11.3184 28.4397 7.55144 25.6066 4.71834ZM6.51009 25.4791C7.00539 21.2173 10.6696 17.9269 15 17.9269C17.2829 17.9269 19.4296 18.8163 21.0443 20.4308C22.4084 21.7952 23.2688 23.5766 23.4901 25.4788C21.1899 27.4053 18.2281 28.5671 15 28.5671C11.7719 28.5671 8.81035 27.4056 6.51009 25.4791ZM15 16.1164C12.488 16.1164 10.4441 14.0725 10.4441 11.5605C10.4441 9.04832 12.488 7.00464 15 7.00464C17.512 7.00464 19.5559 9.04832 19.5559 11.5605C19.5559 14.0725 17.512 16.1164 15 16.1164ZM25.0031 23.9929C24.5551 22.1871 23.6211 20.5219 22.2871 19.188C21.2068 18.1077 19.9287 17.2972 18.5349 16.7893C20.2105 15.6529 21.3137 13.7331 21.3137 11.5605C21.3137 8.07924 18.4813 5.24683 15 5.24683C11.5187 5.24683 8.68629 8.07924 8.68629 11.5605C8.68629 13.7342 9.79042 15.6548 11.4674 16.7909C10.185 17.2583 8.99826 17.9809 7.97722 18.9321C6.49864 20.3091 5.47188 22.0648 4.9958 23.9916C2.97958 21.6673 1.75781 18.6362 1.75781 15.325C1.75781 8.02316 7.69821 2.08276 15 2.08276C22.3018 2.08276 28.2422 8.02316 28.2422 15.325C28.2422 18.6369 27.02 21.6686 25.0031 23.9929Z'
        fill={color}
      />
    </svg>
  )
}
export const IconAccountDefault = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='none'
      className=''
    >
      <g clipPath='url(#clip0_3347_15057)'>
        <path
          d='M14.6747 4.81723C14.6747 6.14093 14.2 7.28671 13.2635 8.2233C12.3271 9.15973 11.1812 9.63443 9.85748 9.63443H9.85519C8.53317 9.63397 7.388 9.15927 6.45157 8.2233C5.51498 7.28671 5.04044 6.14093 5.04044 4.81723C5.04044 3.49399 5.51498 2.34805 6.45157 1.41162C7.38754 0.475494 8.53271 0.000946047 9.85519 0.000488281H9.85748C11.1807 0.000488281 12.3267 0.475189 13.2635 1.41162C14.2 2.34805 14.6747 3.49399 14.6747 4.81723Z'
          fill='#FFF'
        />
        <path
          d='M18.3269 16.5608C18.3269 17.6051 17.9947 18.4506 17.3404 19.0733C16.6937 19.6887 15.8385 20.0004 14.7986 20.0004H5.16846C4.12857 20.0004 3.27332 19.6887 2.62711 19.0733C1.97235 18.4501 1.64062 17.6048 1.64062 16.5608C1.64062 16.1592 1.6539 15.7618 1.68045 15.3798C1.70746 14.9891 1.76208 14.564 1.84265 14.1156C1.92383 13.6635 2.0282 13.2361 2.15317 12.8454C2.28287 12.4411 2.45834 12.0422 2.67548 11.6601C2.901 11.2635 3.16589 10.9181 3.46283 10.6337C3.77411 10.336 4.15466 10.0969 4.59457 9.92261C5.03296 9.74927 5.51895 9.66138 6.03897 9.66138C6.24298 9.66138 6.44058 9.74484 6.82144 9.99295C7.05978 10.1484 7.33444 10.3254 7.63763 10.5192C7.89948 10.6862 8.25409 10.8427 8.69247 10.9842C9.07776 11.1088 9.46884 11.1784 9.85519 11.1905C9.89777 11.192 9.94034 11.1927 9.98291 11.1927C10.412 11.1927 10.8459 11.1224 11.2738 10.9842C11.7122 10.8427 12.0673 10.6862 12.3289 10.5192C12.6353 10.3235 12.91 10.1466 13.1448 9.99341C13.526 9.74484 13.7233 9.66138 13.9278 9.66138C14.4473 9.66138 14.9333 9.74927 15.372 9.92261C15.8119 10.0969 16.1925 10.3364 16.5034 10.6337C16.8008 10.9181 17.0657 11.2635 17.2911 11.6601C17.5084 12.0425 17.6842 12.4411 17.8134 12.845C17.9385 13.2361 18.0432 13.6635 18.1244 14.1159C18.2045 14.5648 18.2593 14.9899 18.2861 15.3795C18.3131 15.7603 18.3264 16.1577 18.3269 16.5608Z'
          fill='#FFF'
        />
        <path
          d='M9.85748 9.63443H9.85519V0.000488281H9.85748C11.1807 0.000488281 12.3267 0.475189 13.2635 1.41162C14.2 2.34805 14.6747 3.49399 14.6747 4.81723C14.6747 6.14093 14.2 7.28671 13.2635 8.2233C12.3271 9.15973 11.1812 9.63443 9.85748 9.63443Z'
          fill='#FFF'
        />
        <path
          d='M18.3269 16.5608C18.3269 17.6051 17.9947 18.4506 17.3404 19.0733C16.6937 19.6887 15.8385 20.0004 14.7986 20.0004H9.85519V11.1905C9.89777 11.192 9.94034 11.1927 9.98291 11.1927C10.412 11.1927 10.8459 11.1224 11.2738 10.9842C11.7122 10.8427 12.0673 10.6862 12.3289 10.5192C12.6353 10.3235 12.91 10.1466 13.1448 9.99341C13.526 9.74484 13.7233 9.66138 13.9278 9.66138C14.4473 9.66138 14.9333 9.74927 15.372 9.92261C15.8119 10.0969 16.1925 10.3364 16.5034 10.6337C16.8008 10.9181 17.0657 11.2635 17.2911 11.6601C17.5084 12.0425 17.6842 12.4411 17.8134 12.845C17.9385 13.2361 18.0432 13.6635 18.1244 14.1159C18.2045 14.5648 18.2593 14.9899 18.2861 15.3795C18.3131 15.7603 18.3264 16.1577 18.3269 16.5608Z'
          fill='#FFF'
        />
      </g>
      <defs>
        <clipPath id='clip0_3347_15057'>
          <rect
            width={20}
            height={20}
            fill='white'
            transform='translate(0 0.000488281)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconAboutUs = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={22}
      height={23}
      viewBox='0 0 22 23'
      fill='none'
    >
      <g clipPath='url(#clip0_1673_12495)'>
        <path
          d='M10.8929 22.8335H2.98979C2.29666 22.8335 1.63192 22.5582 1.1418 22.068C0.651687 21.5779 0.376343 20.9132 0.376343 20.22L0.376343 3.44694C0.376343 2.75381 0.651687 2.08907 1.1418 1.59896C1.63192 1.10884 2.29666 0.833496 2.98979 0.833496L15.0901 0.833496C15.7832 0.833496 16.4479 1.10884 16.938 1.59896C17.4282 2.08907 17.7035 2.75381 17.7035 3.44694V9.71922C17.7112 9.8011 17.7018 9.88369 17.6757 9.9617C17.6497 10.0397 17.6077 10.1114 17.5523 10.1723C17.4969 10.2331 17.4295 10.2817 17.3543 10.3149C17.2791 10.3482 17.1977 10.3654 17.1155 10.3654C17.0332 10.3654 16.9519 10.3482 16.8767 10.3149C16.8014 10.2817 16.734 10.2331 16.6786 10.1723C16.6233 10.1114 16.5812 10.0397 16.5552 9.9617C16.5292 9.88369 16.5197 9.8011 16.5274 9.71922V3.44694C16.5274 3.26049 16.4906 3.07586 16.4191 2.90367C16.3476 2.73147 16.2428 2.57508 16.1107 2.44348C15.9786 2.31188 15.8219 2.20765 15.6494 2.13677C15.4769 2.0659 15.2922 2.02977 15.1057 2.03045H2.98979C2.80246 2.02838 2.61658 2.06349 2.44291 2.13374C2.26924 2.204 2.11123 2.30801 1.97803 2.43975C1.84483 2.57149 1.73909 2.72834 1.66692 2.90123C1.59476 3.07412 1.55761 3.2596 1.55762 3.44694V20.2357C1.55761 20.4231 1.59476 20.6086 1.66692 20.7814C1.73909 20.9543 1.84483 21.1112 1.97803 21.2429C2.11123 21.3747 2.26924 21.4787 2.44291 21.5489C2.61658 21.6192 2.80246 21.6543 2.98979 21.6522H10.8929C11.0495 21.6522 11.1997 21.7144 11.3105 21.8252C11.4213 21.936 11.4835 22.0862 11.4835 22.2429C11.4835 22.3995 11.4213 22.5497 11.3105 22.6605C11.1997 22.7713 11.0495 22.8335 10.8929 22.8335Z'
          fill='black'
        />
        <path
          d='M13.9924 7.14766H4.0613C3.97942 7.15539 3.89683 7.14593 3.81882 7.11989C3.7408 7.09386 3.66909 7.05182 3.60826 6.99646C3.54744 6.94111 3.49884 6.87366 3.46559 6.79844C3.43234 6.72321 3.41516 6.64188 3.41516 6.55963C3.41516 6.47739 3.43234 6.39605 3.46559 6.32083C3.49884 6.24561 3.54744 6.17816 3.60826 6.12281C3.66909 6.06745 3.7408 6.02541 3.81882 5.99937C3.89683 5.97334 3.97942 5.96388 4.0613 5.97161H13.9924C14.1388 5.98542 14.2748 6.05335 14.3737 6.1621C14.4727 6.27084 14.5275 6.41259 14.5275 6.55963C14.5275 6.70667 14.4727 6.84842 14.3737 6.95717C14.2748 7.06592 14.1388 7.13384 13.9924 7.14766Z'
          fill='black'
        />
        <path
          d='M9.53907 11.7367H4.07697C3.92032 11.7367 3.77009 11.6745 3.65932 11.5637C3.54856 11.4529 3.48633 11.3027 3.48633 11.1461C3.48633 10.9894 3.54856 10.8392 3.65932 10.7284C3.77009 10.6176 3.92032 10.5554 4.07697 10.5554H9.53907C9.69572 10.5554 9.84595 10.6176 9.95672 10.7284C10.0675 10.8392 10.1297 10.9894 10.1297 11.1461C10.1297 11.3027 10.0675 11.4529 9.95672 11.5637C9.84595 11.6745 9.69572 11.7367 9.53907 11.7367Z'
          fill='black'
        />
        <path
          d='M17.4788 21.0092C16.4334 21.0092 16.3288 21.0092 16.2034 20.8576C15.111 19.9899 13.3338 18.0455 13.3338 16.028C13.3191 15.4524 13.4234 14.8801 13.6402 14.3467C13.8569 13.8134 14.1815 13.3305 14.5935 12.9284C15.3701 12.1932 16.3989 11.7834 17.4683 11.7834C18.5377 11.7834 19.5665 12.1932 20.3431 12.9284C20.7561 13.3301 21.0816 13.8127 21.2993 14.3461C21.5169 14.8795 21.622 15.4521 21.608 16.028C21.608 18.0455 19.8256 19.9899 18.7332 20.8576C18.6234 21.0092 18.5189 21.0092 17.4788 21.0092ZM16.7522 19.9638H18.2001C19.3813 19.0021 20.5992 17.3922 20.5992 16.0071C20.6113 15.5683 20.5331 15.1317 20.3694 14.7244C20.2058 14.3171 19.9602 13.9477 19.6479 13.6393C19.0639 13.0787 18.2857 12.7656 17.4761 12.7656C16.6666 12.7656 15.8884 13.0787 15.3044 13.6393C14.9921 13.9477 14.7465 14.3171 14.5828 14.7244C14.4192 15.1317 14.341 15.5683 14.3531 16.0071C14.3531 17.4131 15.5709 19.023 16.7522 19.9847V19.9638Z'
          fill='black'
        />
        <path
          d='M18.5032 22.823H16.4543C16.3156 22.823 16.1827 22.7679 16.0847 22.6699C15.9866 22.5719 15.9316 22.4389 15.9316 22.3003C15.9316 22.1617 15.9866 22.0287 16.0847 21.9307C16.1827 21.8327 16.3156 21.7776 16.4543 21.7776H18.5032C18.6418 21.7776 18.7748 21.8327 18.8728 21.9307C18.9708 22.0287 19.0259 22.1617 19.0259 22.3003C19.0259 22.4389 18.9708 22.5719 18.8728 22.6699C18.7748 22.7679 18.6418 22.823 18.5032 22.823Z'
          fill='black'
        />
        <path
          d='M17.4787 19.4726C17.3401 19.4726 17.2072 19.4175 17.1091 19.3195C17.0111 19.2214 16.9561 19.0885 16.9561 18.9499V17.6797C16.9824 17.5643 17.0471 17.4611 17.1397 17.3873C17.2323 17.3134 17.3472 17.2732 17.4657 17.2732C17.5841 17.2732 17.699 17.3134 17.7916 17.3873C17.8842 17.4611 17.949 17.5643 17.9753 17.6797V18.9603C17.9728 19.0927 17.9202 19.2192 17.828 19.3143C17.7358 19.4094 17.611 19.466 17.4787 19.4726Z'
          fill='black'
        />
        <path
          d='M18.1164 16.8435H16.8359C16.6972 16.8435 16.5643 16.7884 16.4663 16.6904C16.3682 16.5924 16.3132 16.4594 16.3132 16.3208C16.3132 16.1822 16.3682 16.0492 16.4663 15.9512C16.5643 15.8532 16.6972 15.7981 16.8359 15.7981H18.1164C18.2551 15.7981 18.388 15.8532 18.486 15.9512C18.5841 16.0492 18.6391 16.1822 18.6391 16.3208C18.6391 16.4594 18.5841 16.5924 18.486 16.6904C18.388 16.7884 18.2551 16.8435 18.1164 16.8435Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_1673_12495'>
          <rect
            width={22}
            height={22}
            fill='white'
            transform='translate(0 0.833496)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
